import { useField as ws, useForm as Vl, revalidateLogic as ka } from "@tanstack/vue-form";
import { computed as b, toValue as _, shallowRef as mt, defineComponent as ue, openBlock as h, createElementBlock as $, normalizeClass as Ke, createElementVNode as be, createVNode as V, unref as f, renderSlot as pe, createBlock as R, withCtx as S, createTextVNode as H, toDisplayString as U, createCommentVNode as B, ref as Y, onErrorCaptured as ks, watch as oe, resolveDynamicComponent as lt, mergeProps as Ve, Fragment as se, renderList as Pe, useSlots as xl, nextTick as ot, onBeforeUnmount as Zt, normalizeStyle as et, createSlots as St, useModel as Wn, mergeModels as nn, useId as Ss, normalizeProps as Ge, withModifiers as tt, useTemplateRef as Cs, onMounted as Kl, h as ll, markRaw as co, onUnmounted as Is, onScopeDispose as Rs, withDirectives as Tn, withKeys as En, resolveComponent as Ps } from "vue";
import { useUiText as Ce, Select as Mn, Button as we, ChartSeriesEditorLayout as Ts, InputGroup as Cn, InputGroupLabel as In, ChartColorSwatches as Es, ChartCard as Ms, Scroller as Sa, ChartLegend as Vs, ChartLegendItem as xs, Anchor as Ca, AnchorTrigger as Ia, PlusIcon as Ks, AnchorContent as Ra, ButtonMenu as Pa, CogIcon as zs, DropdownMenu as Os, DropdownMenuDivider as As, DropdownMenuItem as $s, InfoBadge as pl, LabelBadgeChip as Zn, InputGroupError as Ls, Checkbox as Fs, DateSinglePicker as Ds, Textarea as Ta, Text as Me, Input as Ct, LockIcon as wl, Switch as qn, TagsInput as fo, Chip as Mt, ChipSuffix as Ns, ListItem as Xt, TreeConnector as Ea, ListItemCheckbox as Bs, ListItemText as kl, ListItemRight as Ma, Badge as Xe, useVirtualScroll as js, AlphabetIndex as Us, IncludeExcludeSwitch as Va, LayoutGrid as Hs, FieldLabel as xa, Dialog as un, DialogHeader as cn, DialogTitle as dn, DialogClose as Ka, DialogBody as It, useFormActions as Ws, useFormErrorsBanner as Zs, useAlert as qs, SmartLayout as zl, SmartLayoutHeader as Ol, SmartLayoutAlerts as za, SmartAlert as Js, SmartLayoutBody as Oa, SmartFormErrorsBanner as Gs, SmartLayoutFooter as Al, SmartFormActions as _s, Alert as Aa, useBulkDialog as Ys, EditRowDialogFooter as Qs, useSubmitDialog as Xs, Tooltip as Jn, ButtonText as ei, HoverCard as ti, HoverCardTrigger as ni, ImageSquaredIcon as ol, HoverCardContent as li, DialogFooter as fn, SmartLayoutSectionPart as Ot, useReorderDrag as oi, List as ai, ListHeader as ri, Toolbar as si, DragHandleIcon as ii, DialogFooterActions as ui, emptyTableRangeState as ci, useTableRangeSelection as di, getTableRangeCellAttrs as vo, useTableGridContext as fi, SpinningLoader as vi, TableConfigIcon as mo, HamburgerIcon as al, ResponsiveHeaderActions as mi, SmartLayoutToolbar as ho, TableGridProvider as hi, DataTable as bi, DataTableHeaderLabel as gi, DataTableHeaderMenu as yi, DataTableSummaryRow as pi, Pagination as $a, ArrowUpIcon as wi, ArrowDownIcon as ki, SpanThirdIcon as Si, RadioGroup as Ci, SmartCellEditable as Ii, Card as Ri, CardBody as Pi, SideMenuNew as Ti, MenuItem as La, MenuLabel as Fa, vResizable as bo, Heading as Ei, ChipList as Mi, MenuChipItem as Vi, MenuSubItem as xi, MenuIcon as Ki, Skeleton as zi, MenuDivider as Oi, NavigationDrawer as Ai } from "@hprofits/ui";
import { hasValue as Ht } from "@hprofits/utils/fp/optional";
import { isVideoUrl as $i, runDetached as Rn } from "@hprofits/utils";
const Da = (e) => {
  const t = e?.[0];
  if (t != null) {
    if (typeof t == "string")
      return t;
    if (typeof t == "object" && "message" in t && typeof t.message == "string")
      return t.message;
  }
}, Li = (e) => {
  const { api: t } = ws({
    form: e.form,
    name: e.name
  });
  return { state: b(() => ({
    // fieldApi.state is a live getter; reading inside computed registers the dep.
    value: t.state.value,
    error: Da(t.state.meta.errors),
    disabled: _(e.disabled) ?? !1,
    readonly: _(e.readonly) ?? !1,
    // `isDefaultValue`, not `isDirty`: TanStack's `isDirty` stays true once touched, while a value
    // typed back to the baseline should read clean again; `form.reset(next)` moves the baseline.
    dirty: !t.state.meta.isDefaultValue
  })), setValue: (a) => {
    t.handleChange(a);
  }, blur: () => {
    t.handleBlur();
  } };
};
function fe(e, t, n) {
  function l(s, i) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: i,
        constr: r,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, i);
    const c = r.prototype, u = Object.keys(c);
    for (let d = 0; d < u.length; d++) {
      const v = u[d];
      v in s || (s[v] = c[v].bind(s));
    }
  }
  const o = n?.Parent ?? Object;
  class a extends o {
  }
  Object.defineProperty(a, "name", { value: e });
  function r(s) {
    var i;
    const c = n?.Parent ? new a() : this;
    l(c, s), (i = c._zod).deferred ?? (i.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(r, "init", { value: l }), Object.defineProperty(r, Symbol.hasInstance, {
    value: (s) => n?.Parent && s instanceof n.Parent ? !0 : s?._zod?.traits?.has(e)
  }), Object.defineProperty(r, "name", { value: e }), r;
}
class Wt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Na extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Ba = {};
function At(e) {
  return Ba;
}
function ja(e) {
  const t = Object.values(e).filter((l) => typeof l == "number");
  return Object.entries(e).filter(([l, o]) => t.indexOf(+l) === -1).map(([l, o]) => o);
}
function Sl(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function $l(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ll(e) {
  return e == null;
}
function Fl(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const go = /* @__PURE__ */ Symbol("evaluating");
function Ee(e, t, n) {
  let l;
  Object.defineProperty(e, t, {
    get() {
      if (l !== go)
        return l === void 0 && (l = go, l = n()), l;
    },
    set(o) {
      Object.defineProperty(e, t, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Nt(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function xt(...e) {
  const t = {};
  for (const n of e) {
    const l = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, l);
  }
  return Object.defineProperties({}, t);
}
function yo(e) {
  return JSON.stringify(e);
}
const Ua = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Vn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Fi = $l(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function ln(e) {
  if (Vn(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Vn(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function Ha(e) {
  return ln(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Di = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Ni(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Kt(e, t, n) {
  const l = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (l._zod.parent = e), l;
}
function nt(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Bi(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function ji(e, t) {
  const n = e._zod.def, l = n.checks;
  if (l && l.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const a = xt(e._zod.def, {
    get shape() {
      const r = {};
      for (const s in t) {
        if (!(s in n.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && (r[s] = n.shape[s]);
      }
      return Nt(this, "shape", r), r;
    },
    checks: []
  });
  return Kt(e, a);
}
function Ui(e, t) {
  const n = e._zod.def, l = n.checks;
  if (l && l.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const a = xt(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape };
      for (const s in t) {
        if (!(s in n.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && delete r[s];
      }
      return Nt(this, "shape", r), r;
    },
    checks: []
  });
  return Kt(e, a);
}
function Hi(e, t) {
  if (!ln(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const a = e._zod.def.shape;
    for (const r in t)
      if (Object.getOwnPropertyDescriptor(a, r) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const o = xt(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t };
      return Nt(this, "shape", a), a;
    }
  });
  return Kt(e, o);
}
function Wi(e, t) {
  if (!ln(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = xt(e._zod.def, {
    get shape() {
      const l = { ...e._zod.def.shape, ...t };
      return Nt(this, "shape", l), l;
    }
  });
  return Kt(e, n);
}
function Zi(e, t) {
  const n = xt(e._zod.def, {
    get shape() {
      const l = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Nt(this, "shape", l), l;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Kt(e, n);
}
function qi(e, t, n) {
  const o = t._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const r = xt(t._zod.def, {
    get shape() {
      const s = t._zod.def.shape, i = { ...s };
      if (n)
        for (const c in n) {
          if (!(c in s))
            throw new Error(`Unrecognized key: "${c}"`);
          n[c] && (i[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c]);
        }
      else
        for (const c in s)
          i[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c];
      return Nt(this, "shape", i), i;
    },
    checks: []
  });
  return Kt(t, r);
}
function Ji(e, t, n) {
  const l = xt(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const r in n) {
          if (!(r in a))
            throw new Error(`Unrecognized key: "${r}"`);
          n[r] && (a[r] = new e({
            type: "nonoptional",
            innerType: o[r]
          }));
        }
      else
        for (const r in o)
          a[r] = new e({
            type: "nonoptional",
            innerType: o[r]
          });
      return Nt(this, "shape", a), a;
    }
  });
  return Kt(t, l);
}
function Ut(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function Wa(e, t) {
  return t.map((n) => {
    var l;
    return (l = n).path ?? (l.path = []), n.path.unshift(e), n;
  });
}
function bn(e) {
  return typeof e == "string" ? e : e?.message;
}
function $t(e, t, n) {
  const l = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const o = bn(e.inst?._zod.def?.error?.(e)) ?? bn(t?.error?.(e)) ?? bn(n.customError?.(e)) ?? bn(n.localeError?.(e)) ?? "Invalid input";
    l.message = o;
  }
  return delete l.inst, delete l.continue, t?.reportInput || delete l.input, l;
}
function Dl(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function on(...e) {
  const [t, n, l] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: l
  } : { ...t };
}
const Za = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Sl, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, qa = fe("$ZodError", Za), Ja = fe("$ZodError", Za, { Parent: Error });
function Gi(e, t = (n) => n.message) {
  const n = {}, l = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : l.push(t(o));
  return { formErrors: l, fieldErrors: n };
}
function _i(e, t = (n) => n.message) {
  const n = { _errors: [] }, l = (o) => {
    for (const a of o.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((r) => l({ issues: r }));
      else if (a.code === "invalid_key")
        l({ issues: a.issues });
      else if (a.code === "invalid_element")
        l({ issues: a.issues });
      else if (a.path.length === 0)
        n._errors.push(t(a));
      else {
        let r = n, s = 0;
        for (; s < a.path.length; ) {
          const i = a.path[s];
          s === a.path.length - 1 ? (r[i] = r[i] || { _errors: [] }, r[i]._errors.push(t(a))) : r[i] = r[i] || { _errors: [] }, r = r[i], s++;
        }
      }
  };
  return l(e), n;
}
const Nl = (e) => (t, n, l, o) => {
  const a = l ? Object.assign(l, { async: !1 }) : { async: !1 }, r = t._zod.run({ value: n, issues: [] }, a);
  if (r instanceof Promise)
    throw new Wt();
  if (r.issues.length) {
    const s = new (o?.Err ?? e)(r.issues.map((i) => $t(i, a, At())));
    throw Ua(s, o?.callee), s;
  }
  return r.value;
}, Bl = (e) => async (t, n, l, o) => {
  const a = l ? Object.assign(l, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: n, issues: [] }, a);
  if (r instanceof Promise && (r = await r), r.issues.length) {
    const s = new (o?.Err ?? e)(r.issues.map((i) => $t(i, a, At())));
    throw Ua(s, o?.callee), s;
  }
  return r.value;
}, Gn = (e) => (t, n, l) => {
  const o = l ? { ...l, async: !1 } : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new Wt();
  return a.issues.length ? {
    success: !1,
    error: new (e ?? qa)(a.issues.map((r) => $t(r, o, At())))
  } : { success: !0, data: a.value };
}, Yi = /* @__PURE__ */ Gn(Ja), _n = (e) => async (t, n, l) => {
  const o = l ? Object.assign(l, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  return a instanceof Promise && (a = await a), a.issues.length ? {
    success: !1,
    error: new e(a.issues.map((r) => $t(r, o, At())))
  } : { success: !0, data: a.value };
}, Qi = /* @__PURE__ */ _n(Ja), Xi = (e) => (t, n, l) => {
  const o = l ? Object.assign(l, { direction: "backward" }) : { direction: "backward" };
  return Nl(e)(t, n, o);
}, eu = (e) => (t, n, l) => Nl(e)(t, n, l), tu = (e) => async (t, n, l) => {
  const o = l ? Object.assign(l, { direction: "backward" }) : { direction: "backward" };
  return Bl(e)(t, n, o);
}, nu = (e) => async (t, n, l) => Bl(e)(t, n, l), lu = (e) => (t, n, l) => {
  const o = l ? Object.assign(l, { direction: "backward" }) : { direction: "backward" };
  return Gn(e)(t, n, o);
}, ou = (e) => (t, n, l) => Gn(e)(t, n, l), au = (e) => async (t, n, l) => {
  const o = l ? Object.assign(l, { direction: "backward" }) : { direction: "backward" };
  return _n(e)(t, n, o);
}, ru = (e) => async (t, n, l) => _n(e)(t, n, l), Jt = /* @__PURE__ */ fe("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), su = /* @__PURE__ */ fe("$ZodCheckMaxLength", (e, t) => {
  var n;
  Jt.init(e, t), (n = e._zod.def).when ?? (n.when = (l) => {
    const o = l.value;
    return !Ll(o) && o.length !== void 0;
  }), e._zod.onattach.push((l) => {
    const o = l._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < o && (l._zod.bag.maximum = t.maximum);
  }), e._zod.check = (l) => {
    const o = l.value;
    if (o.length <= t.maximum)
      return;
    const r = Dl(o);
    l.issues.push({
      origin: r,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), iu = /* @__PURE__ */ fe("$ZodCheckMinLength", (e, t) => {
  var n;
  Jt.init(e, t), (n = e._zod.def).when ?? (n.when = (l) => {
    const o = l.value;
    return !Ll(o) && o.length !== void 0;
  }), e._zod.onattach.push((l) => {
    const o = l._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > o && (l._zod.bag.minimum = t.minimum);
  }), e._zod.check = (l) => {
    const o = l.value;
    if (o.length >= t.minimum)
      return;
    const r = Dl(o);
    l.issues.push({
      origin: r,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), uu = /* @__PURE__ */ fe("$ZodCheckLengthEquals", (e, t) => {
  var n;
  Jt.init(e, t), (n = e._zod.def).when ?? (n.when = (l) => {
    const o = l.value;
    return !Ll(o) && o.length !== void 0;
  }), e._zod.onattach.push((l) => {
    const o = l._zod.bag;
    o.minimum = t.length, o.maximum = t.length, o.length = t.length;
  }), e._zod.check = (l) => {
    const o = l.value, a = o.length;
    if (a === t.length)
      return;
    const r = Dl(o), s = a > t.length;
    l.issues.push({
      origin: r,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: l.value,
      inst: e,
      continue: !t.abort
    });
  };
}), cu = /* @__PURE__ */ fe("$ZodCheckOverwrite", (e, t) => {
  Jt.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class du {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const l = t.split(`
`).filter((r) => r), o = Math.min(...l.map((r) => r.length - r.trimStart().length)), a = l.map((r) => r.slice(o)).map((r) => " ".repeat(this.indent * 2) + r);
    for (const r of a)
      this.content.push(r);
  }
  compile() {
    const t = Function, n = this?.args, o = [...(this?.content ?? [""]).map((a) => `  ${a}`)];
    return new t(...n, o.join(`
`));
  }
}
const fu = {
  major: 4,
  minor: 3,
  patch: 6
}, je = /* @__PURE__ */ fe("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = fu;
  const l = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && l.unshift(e);
  for (const o of l)
    for (const a of o._zod.onattach)
      a(e);
  if (l.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (r, s, i) => {
      let c = Ut(r), u;
      for (const d of s) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(r))
            continue;
        } else if (c)
          continue;
        const v = r.issues.length, m = d._zod.check(r);
        if (m instanceof Promise && i?.async === !1)
          throw new Wt();
        if (u || m instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await m, r.issues.length !== v && (c || (c = Ut(r, v)));
          });
        else {
          if (r.issues.length === v)
            continue;
          c || (c = Ut(r, v));
        }
      }
      return u ? u.then(() => r) : r;
    }, a = (r, s, i) => {
      if (Ut(r))
        return r.aborted = !0, r;
      const c = o(s, l, i);
      if (c instanceof Promise) {
        if (i.async === !1)
          throw new Wt();
        return c.then((u) => e._zod.parse(u, i));
      }
      return e._zod.parse(c, i);
    };
    e._zod.run = (r, s) => {
      if (s.skipChecks)
        return e._zod.parse(r, s);
      if (s.direction === "backward") {
        const c = e._zod.parse({ value: r.value, issues: [] }, { ...s, skipChecks: !0 });
        return c instanceof Promise ? c.then((u) => a(u, r, s)) : a(c, r, s);
      }
      const i = e._zod.parse(r, s);
      if (i instanceof Promise) {
        if (s.async === !1)
          throw new Wt();
        return i.then((c) => o(c, l, s));
      }
      return o(i, l, s);
    };
  }
  Ee(e, "~standard", () => ({
    validate: (o) => {
      try {
        const a = Yi(e, o);
        return a.success ? { value: a.data } : { issues: a.error?.issues };
      } catch {
        return Qi(e, o).then((r) => r.success ? { value: r.data } : { issues: r.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), vu = /* @__PURE__ */ fe("$ZodUnknown", (e, t) => {
  je.init(e, t), e._zod.parse = (n) => n;
}), mu = /* @__PURE__ */ fe("$ZodNever", (e, t) => {
  je.init(e, t), e._zod.parse = (n, l) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function po(e, t, n) {
  e.issues.length && t.issues.push(...Wa(n, e.issues)), t.value[n] = e.value;
}
const hu = /* @__PURE__ */ fe("$ZodArray", (e, t) => {
  je.init(e, t), e._zod.parse = (n, l) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const a = [];
    for (let r = 0; r < o.length; r++) {
      const s = o[r], i = t.element._zod.run({
        value: s,
        issues: []
      }, l);
      i instanceof Promise ? a.push(i.then((c) => po(c, n, r))) : po(i, n, r);
    }
    return a.length ? Promise.all(a).then(() => n) : n;
  };
});
function xn(e, t, n, l, o) {
  if (e.issues.length) {
    if (o && !(n in l))
      return;
    t.issues.push(...Wa(n, e.issues));
  }
  e.value === void 0 ? n in l && (t.value[n] = void 0) : t.value[n] = e.value;
}
function Ga(e) {
  const t = Object.keys(e.shape);
  for (const l of t)
    if (!e.shape?.[l]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${l}": expected a Zod schema`);
  const n = Bi(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function _a(e, t, n, l, o, a) {
  const r = [], s = o.keySet, i = o.catchall._zod, c = i.def.type, u = i.optout === "optional";
  for (const d in t) {
    if (s.has(d))
      continue;
    if (c === "never") {
      r.push(d);
      continue;
    }
    const v = i.run({ value: t[d], issues: [] }, l);
    v instanceof Promise ? e.push(v.then((m) => xn(m, n, d, t, u))) : xn(v, n, d, t, u);
  }
  return r.length && n.issues.push({
    code: "unrecognized_keys",
    keys: r,
    input: t,
    inst: a
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const bu = /* @__PURE__ */ fe("$ZodObject", (e, t) => {
  if (je.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const i = { ...s };
        return Object.defineProperty(t, "shape", {
          value: i
        }), i;
      }
    });
  }
  const l = $l(() => Ga(t));
  Ee(e._zod, "propValues", () => {
    const s = t.shape, i = {};
    for (const c in s) {
      const u = s[c]._zod;
      if (u.values) {
        i[c] ?? (i[c] = /* @__PURE__ */ new Set());
        for (const d of u.values)
          i[c].add(d);
      }
    }
    return i;
  });
  const o = Vn, a = t.catchall;
  let r;
  e._zod.parse = (s, i) => {
    r ?? (r = l.value);
    const c = s.value;
    if (!o(c))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), s;
    s.value = {};
    const u = [], d = r.shape;
    for (const v of r.keys) {
      const m = d[v], p = m._zod.optout === "optional", g = m._zod.run({ value: c[v], issues: [] }, i);
      g instanceof Promise ? u.push(g.then((y) => xn(y, s, v, c, p))) : xn(g, s, v, c, p);
    }
    return a ? _a(u, c, s, i, l.value, e) : u.length ? Promise.all(u).then(() => s) : s;
  };
}), gu = /* @__PURE__ */ fe("$ZodObjectJIT", (e, t) => {
  bu.init(e, t);
  const n = e._zod.parse, l = $l(() => Ga(t)), o = (v) => {
    const m = new du(["shape", "payload", "ctx"]), p = l.value, g = (w) => {
      const C = yo(w);
      return `shape[${C}]._zod.run({ value: input[${C}], issues: [] }, ctx)`;
    };
    m.write("const input = payload.value;");
    const y = /* @__PURE__ */ Object.create(null);
    let P = 0;
    for (const w of p.keys)
      y[w] = `key_${P++}`;
    m.write("const newResult = {};");
    for (const w of p.keys) {
      const C = y[w], x = yo(w), N = v[w]?._zod?.optout === "optional";
      m.write(`const ${C} = ${g(w)};`), N ? m.write(`
        if (${C}.issues.length) {
          if (${x} in input) {
            payload.issues = payload.issues.concat(${C}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${x}, ...iss.path] : [${x}]
            })));
          }
        }
        
        if (${C}.value === undefined) {
          if (${x} in input) {
            newResult[${x}] = undefined;
          }
        } else {
          newResult[${x}] = ${C}.value;
        }
        
      `) : m.write(`
        if (${C}.issues.length) {
          payload.issues = payload.issues.concat(${C}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${x}, ...iss.path] : [${x}]
          })));
        }
        
        if (${C}.value === undefined) {
          if (${x} in input) {
            newResult[${x}] = undefined;
          }
        } else {
          newResult[${x}] = ${C}.value;
        }
        
      `);
    }
    m.write("payload.value = newResult;"), m.write("return payload;");
    const I = m.compile();
    return (w, C) => I(v, w, C);
  };
  let a;
  const r = Vn, s = !Ba.jitless, c = s && Fi.value, u = t.catchall;
  let d;
  e._zod.parse = (v, m) => {
    d ?? (d = l.value);
    const p = v.value;
    return r(p) ? s && c && m?.async === !1 && m.jitless !== !0 ? (a || (a = o(t.shape)), v = a(v, m), u ? _a([], p, v, m, d, e) : v) : n(v, m) : (v.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), v);
  };
});
function wo(e, t, n, l) {
  for (const a of e)
    if (a.issues.length === 0)
      return t.value = a.value, t;
  const o = e.filter((a) => !Ut(a));
  return o.length === 1 ? (t.value = o[0].value, o[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((a) => a.issues.map((r) => $t(r, l, At())))
  }), t);
}
const yu = /* @__PURE__ */ fe("$ZodUnion", (e, t) => {
  je.init(e, t), Ee(e._zod, "optin", () => t.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0), Ee(e._zod, "optout", () => t.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0), Ee(e._zod, "values", () => {
    if (t.options.every((o) => o._zod.values))
      return new Set(t.options.flatMap((o) => Array.from(o._zod.values)));
  }), Ee(e._zod, "pattern", () => {
    if (t.options.every((o) => o._zod.pattern)) {
      const o = t.options.map((a) => a._zod.pattern);
      return new RegExp(`^(${o.map((a) => Fl(a.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, l = t.options[0]._zod.run;
  e._zod.parse = (o, a) => {
    if (n)
      return l(o, a);
    let r = !1;
    const s = [];
    for (const i of t.options) {
      const c = i._zod.run({
        value: o.value,
        issues: []
      }, a);
      if (c instanceof Promise)
        s.push(c), r = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return r ? Promise.all(s).then((i) => wo(i, o, e, a)) : wo(s, o, e, a);
  };
}), pu = /* @__PURE__ */ fe("$ZodIntersection", (e, t) => {
  je.init(e, t), e._zod.parse = (n, l) => {
    const o = n.value, a = t.left._zod.run({ value: o, issues: [] }, l), r = t.right._zod.run({ value: o, issues: [] }, l);
    return a instanceof Promise || r instanceof Promise ? Promise.all([a, r]).then(([i, c]) => ko(n, i, c)) : ko(n, a, r);
  };
});
function Cl(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (ln(e) && ln(t)) {
    const n = Object.keys(t), l = Object.keys(e).filter((a) => n.indexOf(a) !== -1), o = { ...e, ...t };
    for (const a of l) {
      const r = Cl(e[a], t[a]);
      if (!r.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...r.mergeErrorPath]
        };
      o[a] = r.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let l = 0; l < e.length; l++) {
      const o = e[l], a = t[l], r = Cl(o, a);
      if (!r.valid)
        return {
          valid: !1,
          mergeErrorPath: [l, ...r.mergeErrorPath]
        };
      n.push(r.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function ko(e, t, n) {
  const l = /* @__PURE__ */ new Map();
  let o;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      o ?? (o = s);
      for (const i of s.keys)
        l.has(i) || l.set(i, {}), l.get(i).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const i of s.keys)
        l.has(i) || l.set(i, {}), l.get(i).r = !0;
    else
      e.issues.push(s);
  const a = [...l].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (a.length && o && e.issues.push({ ...o, keys: a }), Ut(e))
    return e;
  const r = Cl(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const wu = /* @__PURE__ */ fe("$ZodEnum", (e, t) => {
  je.init(e, t);
  const n = ja(t.entries), l = new Set(n);
  e._zod.values = l, e._zod.pattern = new RegExp(`^(${n.filter((o) => Di.has(typeof o)).map((o) => typeof o == "string" ? Ni(o) : o.toString()).join("|")})$`), e._zod.parse = (o, a) => {
    const r = o.value;
    return l.has(r) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: r,
      inst: e
    }), o;
  };
}), ku = /* @__PURE__ */ fe("$ZodTransform", (e, t) => {
  je.init(e, t), e._zod.parse = (n, l) => {
    if (l.direction === "backward")
      throw new Na(e.constructor.name);
    const o = t.transform(n.value, n);
    if (l.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((r) => (n.value = r, n));
    if (o instanceof Promise)
      throw new Wt();
    return n.value = o, n;
  };
});
function So(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ya = /* @__PURE__ */ fe("$ZodOptional", (e, t) => {
  je.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Ee(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Ee(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Fl(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, l) => {
    if (t.innerType._zod.optin === "optional") {
      const o = t.innerType._zod.run(n, l);
      return o instanceof Promise ? o.then((a) => So(a, n.value)) : So(o, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, l);
  };
}), Su = /* @__PURE__ */ fe("$ZodExactOptional", (e, t) => {
  Ya.init(e, t), Ee(e._zod, "values", () => t.innerType._zod.values), Ee(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, l) => t.innerType._zod.run(n, l);
}), Cu = /* @__PURE__ */ fe("$ZodNullable", (e, t) => {
  je.init(e, t), Ee(e._zod, "optin", () => t.innerType._zod.optin), Ee(e._zod, "optout", () => t.innerType._zod.optout), Ee(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Fl(n.source)}|null)$`) : void 0;
  }), Ee(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, l) => n.value === null ? n : t.innerType._zod.run(n, l);
}), Iu = /* @__PURE__ */ fe("$ZodDefault", (e, t) => {
  je.init(e, t), e._zod.optin = "optional", Ee(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, l) => {
    if (l.direction === "backward")
      return t.innerType._zod.run(n, l);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, l);
    return o instanceof Promise ? o.then((a) => Co(a, t)) : Co(o, t);
  };
});
function Co(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Ru = /* @__PURE__ */ fe("$ZodPrefault", (e, t) => {
  je.init(e, t), e._zod.optin = "optional", Ee(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, l) => (l.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, l));
}), Pu = /* @__PURE__ */ fe("$ZodNonOptional", (e, t) => {
  je.init(e, t), Ee(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((l) => l !== void 0)) : void 0;
  }), e._zod.parse = (n, l) => {
    const o = t.innerType._zod.run(n, l);
    return o instanceof Promise ? o.then((a) => Io(a, e)) : Io(o, e);
  };
});
function Io(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Tu = /* @__PURE__ */ fe("$ZodCatch", (e, t) => {
  je.init(e, t), Ee(e._zod, "optin", () => t.innerType._zod.optin), Ee(e._zod, "optout", () => t.innerType._zod.optout), Ee(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, l) => {
    if (l.direction === "backward")
      return t.innerType._zod.run(n, l);
    const o = t.innerType._zod.run(n, l);
    return o instanceof Promise ? o.then((a) => (n.value = a.value, a.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: a.issues.map((r) => $t(r, l, At()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => $t(a, l, At()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Eu = /* @__PURE__ */ fe("$ZodPipe", (e, t) => {
  je.init(e, t), Ee(e._zod, "values", () => t.in._zod.values), Ee(e._zod, "optin", () => t.in._zod.optin), Ee(e._zod, "optout", () => t.out._zod.optout), Ee(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, l) => {
    if (l.direction === "backward") {
      const a = t.out._zod.run(n, l);
      return a instanceof Promise ? a.then((r) => gn(r, t.in, l)) : gn(a, t.in, l);
    }
    const o = t.in._zod.run(n, l);
    return o instanceof Promise ? o.then((a) => gn(a, t.out, l)) : gn(o, t.out, l);
  };
});
function gn(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Mu = /* @__PURE__ */ fe("$ZodReadonly", (e, t) => {
  je.init(e, t), Ee(e._zod, "propValues", () => t.innerType._zod.propValues), Ee(e._zod, "values", () => t.innerType._zod.values), Ee(e._zod, "optin", () => t.innerType?._zod?.optin), Ee(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (n, l) => {
    if (l.direction === "backward")
      return t.innerType._zod.run(n, l);
    const o = t.innerType._zod.run(n, l);
    return o instanceof Promise ? o.then(Ro) : Ro(o);
  };
});
function Ro(e) {
  return e.value = Object.freeze(e.value), e;
}
const Vu = /* @__PURE__ */ fe("$ZodCustom", (e, t) => {
  Jt.init(e, t), je.init(e, t), e._zod.parse = (n, l) => n, e._zod.check = (n) => {
    const l = n.value, o = t.fn(l);
    if (o instanceof Promise)
      return o.then((a) => Po(a, n, l, e));
    Po(o, n, l, e);
  };
});
function Po(e, t, n, l) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: l,
      // incorporates params.error into issue reporting
      path: [...l._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !l._zod.def.abort
      // params: inst._zod.def.params,
    };
    l._zod.def.params && (o.params = l._zod.def.params), t.issues.push(on(o));
  }
}
var To;
class xu {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const l = n[0];
    return this._map.set(t, l), l && typeof l == "object" && "id" in l && this._idmap.set(l.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const l = { ...this.get(n) ?? {} };
      delete l.id;
      const o = { ...l, ...this._map.get(t) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Ku() {
  return new xu();
}
(To = globalThis).__zod_globalRegistry ?? (To.__zod_globalRegistry = Ku());
const en = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function zu(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Ou(e, t) {
  return new e({
    type: "never",
    ...nt(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Au(e, t) {
  return new su({
    check: "max_length",
    ...nt(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Eo(e, t) {
  return new iu({
    check: "min_length",
    ...nt(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function $u(e, t) {
  return new uu({
    check: "length_equals",
    ...nt(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Lu(e) {
  return new cu({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function Fu(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...nt(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Du(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...nt(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Nu(e) {
  const t = /* @__PURE__ */ Bu((n) => (n.addIssue = (l) => {
    if (typeof l == "string")
      n.issues.push(on(l, n.value, t._zod.def));
    else {
      const o = l;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = t), o.continue ?? (o.continue = !t._zod.def.abort), n.issues.push(on(o));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Bu(e, t) {
  const n = new Jt({
    check: "custom",
    ...nt(t)
  });
  return n._zod.check = e, n;
}
function Qa(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? en,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function Ze(e, t, n = { path: [], schemaPath: [] }) {
  var l;
  const o = e._zod.def, a = t.seen.get(e);
  if (a)
    return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
  const r = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, r);
  const s = e._zod.toJSONSchema?.();
  if (s)
    r.schema = s;
  else {
    const u = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, r.schema, u);
    else {
      const v = r.schema, m = t.processors[o.type];
      if (!m)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${o.type}`);
      m(e, t, v, u);
    }
    const d = e._zod.parent;
    d && (r.ref || (r.ref = d), Ze(d, t, u), t.seen.get(d).isParent = !0);
  }
  const i = t.metadataRegistry.get(e);
  return i && Object.assign(r.schema, i), t.io === "input" && Je(e) && (delete r.schema.examples, delete r.schema.default), t.io === "input" && r.schema._prefault && ((l = r.schema).default ?? (l.default = r.schema._prefault)), delete r.schema._prefault, t.seen.get(e).schema;
}
function Xa(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const l = /* @__PURE__ */ new Map();
  for (const r of e.seen.entries()) {
    const s = e.metadataRegistry.get(r[0])?.id;
    if (s) {
      const i = l.get(s);
      if (i && i !== r[0])
        throw new Error(`Duplicate schema id "${s}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      l.set(s, r[0]);
    }
  }
  const o = (r) => {
    const s = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const d = e.external.registry.get(r[0])?.id, v = e.external.uri ?? ((p) => p);
      if (d)
        return { ref: v(d) };
      const m = r[1].defId ?? r[1].schema.id ?? `schema${e.counter++}`;
      return r[1].defId = m, { defId: m, ref: `${v("__shared")}#/${s}/${m}` };
    }
    if (r[1] === n)
      return { ref: "#" };
    const c = `#/${s}/`, u = r[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: u, ref: c + u };
  }, a = (r) => {
    if (r[1].schema.$ref)
      return;
    const s = r[1], { ref: i, defId: c } = o(r);
    s.def = { ...s.schema }, c && (s.defId = c);
    const u = s.schema;
    for (const d in u)
      delete u[d];
    u.$ref = i;
  };
  if (e.cycles === "throw")
    for (const r of e.seen.entries()) {
      const s = r[1];
      if (s.cycle)
        throw new Error(`Cycle detected: #/${s.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const r of e.seen.entries()) {
    const s = r[1];
    if (t === r[0]) {
      a(r);
      continue;
    }
    if (e.external) {
      const c = e.external.registry.get(r[0])?.id;
      if (t !== r[0] && c) {
        a(r);
        continue;
      }
    }
    if (e.metadataRegistry.get(r[0])?.id) {
      a(r);
      continue;
    }
    if (s.cycle) {
      a(r);
      continue;
    }
    if (s.count > 1 && e.reused === "ref") {
      a(r);
      continue;
    }
  }
}
function er(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const l = (r) => {
    const s = e.seen.get(r);
    if (s.ref === null)
      return;
    const i = s.def ?? s.schema, c = { ...i }, u = s.ref;
    if (s.ref = null, u) {
      l(u);
      const v = e.seen.get(u), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(m)) : Object.assign(i, m), Object.assign(i, c), r._zod.parent === u)
        for (const g in i)
          g === "$ref" || g === "allOf" || g in c || delete i[g];
      if (m.$ref && v.def)
        for (const g in i)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(i[g]) === JSON.stringify(v.def[g]) && delete i[g];
    }
    const d = r._zod.parent;
    if (d && d !== u) {
      l(d);
      const v = e.seen.get(d);
      if (v?.schema.$ref && (i.$ref = v.schema.$ref, v.def))
        for (const m in i)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(i[m]) === JSON.stringify(v.def[m]) && delete i[m];
    }
    e.override({
      zodSchema: r,
      jsonSchema: i,
      path: s.path ?? []
    });
  };
  for (const r of [...e.seen.entries()].reverse())
    l(r[0]);
  const o = {};
  if (e.target === "draft-2020-12" ? o.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? o.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? o.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
    const r = e.external.registry.get(t)?.id;
    if (!r)
      throw new Error("Schema is missing an `id` property");
    o.$id = e.external.uri(r);
  }
  Object.assign(o, n.def ?? n.schema);
  const a = e.external?.defs ?? {};
  for (const r of e.seen.entries()) {
    const s = r[1];
    s.def && s.defId && (a[s.defId] = s.def);
  }
  e.external || Object.keys(a).length > 0 && (e.target === "draft-2020-12" ? o.$defs = a : o.definitions = a);
  try {
    const r = JSON.parse(JSON.stringify(o));
    return Object.defineProperty(r, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Kn(t, "input", e.processors),
          output: Kn(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), r;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Je(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const l = e._zod.def;
  if (l.type === "transform")
    return !0;
  if (l.type === "array")
    return Je(l.element, n);
  if (l.type === "set")
    return Je(l.valueType, n);
  if (l.type === "lazy")
    return Je(l.getter(), n);
  if (l.type === "promise" || l.type === "optional" || l.type === "nonoptional" || l.type === "nullable" || l.type === "readonly" || l.type === "default" || l.type === "prefault")
    return Je(l.innerType, n);
  if (l.type === "intersection")
    return Je(l.left, n) || Je(l.right, n);
  if (l.type === "record" || l.type === "map")
    return Je(l.keyType, n) || Je(l.valueType, n);
  if (l.type === "pipe")
    return Je(l.in, n) || Je(l.out, n);
  if (l.type === "object") {
    for (const o in l.shape)
      if (Je(l.shape[o], n))
        return !0;
    return !1;
  }
  if (l.type === "union") {
    for (const o of l.options)
      if (Je(o, n))
        return !0;
    return !1;
  }
  if (l.type === "tuple") {
    for (const o of l.items)
      if (Je(o, n))
        return !0;
    return !!(l.rest && Je(l.rest, n));
  }
  return !1;
}
const ju = (e, t = {}) => (n) => {
  const l = Qa({ ...n, processors: t });
  return Ze(e, l), Xa(l, e), er(l, e);
}, Kn = (e, t, n = {}) => (l) => {
  const { libraryOptions: o, target: a } = l ?? {}, r = Qa({ ...o ?? {}, target: a, io: t, processors: n });
  return Ze(e, r), Xa(r, e), er(r, e);
}, Uu = (e, t, n, l) => {
  n.not = {};
}, Hu = (e, t, n, l) => {
}, Wu = (e, t, n, l) => {
  const o = e._zod.def, a = ja(o.entries);
  a.every((r) => typeof r == "number") && (n.type = "number"), a.every((r) => typeof r == "string") && (n.type = "string"), n.enum = a;
}, Zu = (e, t, n, l) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, qu = (e, t, n, l) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Ju = (e, t, n, l) => {
  const o = n, a = e._zod.def, { minimum: r, maximum: s } = e._zod.bag;
  typeof r == "number" && (o.minItems = r), typeof s == "number" && (o.maxItems = s), o.type = "array", o.items = Ze(a.element, t, { ...l, path: [...l.path, "items"] });
}, Gu = (e, t, n, l) => {
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const r = a.shape;
  for (const c in r)
    o.properties[c] = Ze(r[c], t, {
      ...l,
      path: [...l.path, "properties", c]
    });
  const s = new Set(Object.keys(r)), i = new Set([...s].filter((c) => {
    const u = a.shape[c]._zod;
    return t.io === "input" ? u.optin === void 0 : u.optout === void 0;
  }));
  i.size > 0 && (o.required = Array.from(i)), a.catchall?._zod.def.type === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = Ze(a.catchall, t, {
    ...l,
    path: [...l.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, _u = (e, t, n, l) => {
  const o = e._zod.def, a = o.inclusive === !1, r = o.options.map((s, i) => Ze(s, t, {
    ...l,
    path: [...l.path, a ? "oneOf" : "anyOf", i]
  }));
  a ? n.oneOf = r : n.anyOf = r;
}, Yu = (e, t, n, l) => {
  const o = e._zod.def, a = Ze(o.left, t, {
    ...l,
    path: [...l.path, "allOf", 0]
  }), r = Ze(o.right, t, {
    ...l,
    path: [...l.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, i = [
    ...s(a) ? a.allOf : [a],
    ...s(r) ? r.allOf : [r]
  ];
  n.allOf = i;
}, Qu = (e, t, n, l) => {
  const o = e._zod.def, a = Ze(o.innerType, t, l), r = t.seen.get(e);
  t.target === "openapi-3.0" ? (r.ref = o.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, Xu = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType;
}, ec = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType, n.default = JSON.parse(JSON.stringify(o.defaultValue));
}, tc = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(o.defaultValue)));
}, nc = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType;
  let r;
  try {
    r = o.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = r;
}, lc = (e, t, n, l) => {
  const o = e._zod.def, a = t.io === "input" ? o.in._zod.def.type === "transform" ? o.out : o.in : o.out;
  Ze(a, t, l);
  const r = t.seen.get(e);
  r.ref = a;
}, oc = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType, n.readOnly = !0;
}, tr = (e, t, n, l) => {
  const o = e._zod.def;
  Ze(o.innerType, t, l);
  const a = t.seen.get(e);
  a.ref = o.innerType;
}, ac = (e, t) => {
  qa.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => _i(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Gi(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Sl, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Sl, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, ut = fe("ZodError", ac, {
  Parent: Error
}), rc = /* @__PURE__ */ Nl(ut), sc = /* @__PURE__ */ Bl(ut), ic = /* @__PURE__ */ Gn(ut), uc = /* @__PURE__ */ _n(ut), cc = /* @__PURE__ */ Xi(ut), dc = /* @__PURE__ */ eu(ut), fc = /* @__PURE__ */ tu(ut), vc = /* @__PURE__ */ nu(ut), mc = /* @__PURE__ */ lu(ut), hc = /* @__PURE__ */ ou(ut), bc = /* @__PURE__ */ au(ut), gc = /* @__PURE__ */ ru(ut), Ue = /* @__PURE__ */ fe("ZodType", (e, t) => (je.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Kn(e, "input"),
    output: Kn(e, "output")
  }
}), e.toJSONSchema = ju(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(xt(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((l) => typeof l == "function" ? { _zod: { check: l, def: { check: "custom" }, onattach: [] } } : l)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, l) => Kt(e, n, l), e.brand = () => e, e.register = ((n, l) => (n.add(e, l), e)), e.parse = (n, l) => rc(e, n, l, { callee: e.parse }), e.safeParse = (n, l) => ic(e, n, l), e.parseAsync = async (n, l) => sc(e, n, l, { callee: e.parseAsync }), e.safeParseAsync = async (n, l) => uc(e, n, l), e.spa = e.safeParseAsync, e.encode = (n, l) => cc(e, n, l), e.decode = (n, l) => dc(e, n, l), e.encodeAsync = async (n, l) => fc(e, n, l), e.decodeAsync = async (n, l) => vc(e, n, l), e.safeEncode = (n, l) => mc(e, n, l), e.safeDecode = (n, l) => hc(e, n, l), e.safeEncodeAsync = async (n, l) => bc(e, n, l), e.safeDecodeAsync = async (n, l) => gc(e, n, l), e.refine = (n, l) => e.check(Zc(n, l)), e.superRefine = (n) => e.check(qc(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ Lu(n)), e.optional = () => Vo(e), e.exactOptional = () => zc(e), e.nullable = () => xo(e), e.nullish = () => Vo(xo(e)), e.nonoptional = (n) => Dc(e, n), e.array = () => Sc(e), e.or = (n) => Pc([e, n]), e.and = (n) => Ec(e, n), e.transform = (n) => Ko(e, xc(n)), e.default = (n) => $c(e, n), e.prefault = (n) => Fc(e, n), e.catch = (n) => Bc(e, n), e.pipe = (n) => Ko(e, n), e.readonly = () => Hc(e), e.describe = (n) => {
  const l = e.clone();
  return en.add(l, { description: n }), l;
}, Object.defineProperty(e, "description", {
  get() {
    return en.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return en.get(e);
  const l = e.clone();
  return en.add(l, n[0]), l;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), yc = /* @__PURE__ */ fe("ZodUnknown", (e, t) => {
  vu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Hu();
});
function Mo() {
  return /* @__PURE__ */ zu(yc);
}
const pc = /* @__PURE__ */ fe("ZodNever", (e, t) => {
  mu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Uu(e, n, l);
});
function wc(e) {
  return /* @__PURE__ */ Ou(pc, e);
}
const kc = /* @__PURE__ */ fe("ZodArray", (e, t) => {
  hu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Ju(e, n, l, o), e.element = t.element, e.min = (n, l) => e.check(/* @__PURE__ */ Eo(n, l)), e.nonempty = (n) => e.check(/* @__PURE__ */ Eo(1, n)), e.max = (n, l) => e.check(/* @__PURE__ */ Au(n, l)), e.length = (n, l) => e.check(/* @__PURE__ */ $u(n, l)), e.unwrap = () => e.element;
});
function Sc(e, t) {
  return /* @__PURE__ */ Fu(kc, e, t);
}
const Cc = /* @__PURE__ */ fe("ZodObject", (e, t) => {
  gu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Gu(e, n, l, o), Ee(e, "shape", () => t.shape), e.keyof = () => Mc(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Mo() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Mo() }), e.strict = () => e.clone({ ...e._zod.def, catchall: wc() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Hi(e, n), e.safeExtend = (n) => Wi(e, n), e.merge = (n) => Zi(e, n), e.pick = (n) => ji(e, n), e.omit = (n) => Ui(e, n), e.partial = (...n) => qi(nr, e, n[0]), e.required = (...n) => Ji(lr, e, n[0]);
});
function Ic(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...nt(t)
  };
  return new Cc(n);
}
const Rc = /* @__PURE__ */ fe("ZodUnion", (e, t) => {
  yu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => _u(e, n, l, o), e.options = t.options;
});
function Pc(e, t) {
  return new Rc({
    type: "union",
    options: e,
    ...nt(t)
  });
}
const Tc = /* @__PURE__ */ fe("ZodIntersection", (e, t) => {
  pu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Yu(e, n, l, o);
});
function Ec(e, t) {
  return new Tc({
    type: "intersection",
    left: e,
    right: t
  });
}
const Il = /* @__PURE__ */ fe("ZodEnum", (e, t) => {
  wu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (l, o, a) => Wu(e, l, o), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (l, o) => {
    const a = {};
    for (const r of l)
      if (n.has(r))
        a[r] = t.entries[r];
      else
        throw new Error(`Key ${r} not found in enum`);
    return new Il({
      ...t,
      checks: [],
      ...nt(o),
      entries: a
    });
  }, e.exclude = (l, o) => {
    const a = { ...t.entries };
    for (const r of l)
      if (n.has(r))
        delete a[r];
      else
        throw new Error(`Key ${r} not found in enum`);
    return new Il({
      ...t,
      checks: [],
      ...nt(o),
      entries: a
    });
  };
});
function Mc(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((l) => [l, l])) : e;
  return new Il({
    type: "enum",
    entries: n,
    ...nt(t)
  });
}
const Vc = /* @__PURE__ */ fe("ZodTransform", (e, t) => {
  ku.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => qu(e, n), e._zod.parse = (n, l) => {
    if (l.direction === "backward")
      throw new Na(e.constructor.name);
    n.addIssue = (a) => {
      if (typeof a == "string")
        n.issues.push(on(a, n.value, t));
      else {
        const r = a;
        r.fatal && (r.continue = !1), r.code ?? (r.code = "custom"), r.input ?? (r.input = n.value), r.inst ?? (r.inst = e), n.issues.push(on(r));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((a) => (n.value = a, n)) : (n.value = o, n);
  };
});
function xc(e) {
  return new Vc({
    type: "transform",
    transform: e
  });
}
const nr = /* @__PURE__ */ fe("ZodOptional", (e, t) => {
  Ya.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => tr(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function Vo(e) {
  return new nr({
    type: "optional",
    innerType: e
  });
}
const Kc = /* @__PURE__ */ fe("ZodExactOptional", (e, t) => {
  Su.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => tr(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function zc(e) {
  return new Kc({
    type: "optional",
    innerType: e
  });
}
const Oc = /* @__PURE__ */ fe("ZodNullable", (e, t) => {
  Cu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Qu(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function xo(e) {
  return new Oc({
    type: "nullable",
    innerType: e
  });
}
const Ac = /* @__PURE__ */ fe("ZodDefault", (e, t) => {
  Iu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => ec(e, n, l, o), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function $c(e, t) {
  return new Ac({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ha(t);
    }
  });
}
const Lc = /* @__PURE__ */ fe("ZodPrefault", (e, t) => {
  Ru.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => tc(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function Fc(e, t) {
  return new Lc({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ha(t);
    }
  });
}
const lr = /* @__PURE__ */ fe("ZodNonOptional", (e, t) => {
  Pu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Xu(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function Dc(e, t) {
  return new lr({
    type: "nonoptional",
    innerType: e,
    ...nt(t)
  });
}
const Nc = /* @__PURE__ */ fe("ZodCatch", (e, t) => {
  Tu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => nc(e, n, l, o), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Bc(e, t) {
  return new Nc({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const jc = /* @__PURE__ */ fe("ZodPipe", (e, t) => {
  Eu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => lc(e, n, l, o), e.in = t.in, e.out = t.out;
});
function Ko(e, t) {
  return new jc({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Uc = /* @__PURE__ */ fe("ZodReadonly", (e, t) => {
  Mu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => oc(e, n, l, o), e.unwrap = () => e._zod.def.innerType;
});
function Hc(e) {
  return new Uc({
    type: "readonly",
    innerType: e
  });
}
const Wc = /* @__PURE__ */ fe("ZodCustom", (e, t) => {
  Vu.init(e, t), Ue.init(e, t), e._zod.processJSONSchema = (n, l, o) => Zu(e, n);
});
function Zc(e, t = {}) {
  return /* @__PURE__ */ Du(Wc, e, t);
}
function qc(e) {
  return /* @__PURE__ */ Nu(e);
}
const or = (e) => {
  const t = e.schema ? Ic({ value: e.schema }) : void 0, n = Vl({
    defaultValues: { value: e.initialValue },
    validators: t ? { onChange: t } : void 0
  }), l = n.useStore((s) => ({ values: s.values, fieldMeta: s.fieldMeta }));
  return { state: b(() => {
    const { values: s, fieldMeta: i } = l.value;
    return {
      // Narrow `unknown` → `V`: seeded with `V`, only written via `setValue(value: V)`.
      value: s.value,
      error: Da(i?.value?.errors),
      disabled: _(e.disabled) ?? !1,
      readonly: _(e.readonly) ?? !1
    };
  }), setValue: (s) => {
    n.setFieldValue("value", s);
  }, blur: () => {
  } };
}, Rl = [0, 1, 2, 3, 4, 5, 6, 7], ar = (e) => typeof e == "number" && Rl.includes(e), yn = "__smart-chart-add-draft__", Jc = [
  "blue",
  "green",
  "purple",
  "orange",
  "red",
  "yellow",
  "dark-blue",
  "green"
], zt = (e) => ({
  ...e,
  removable: e.automatic ? !1 : e.removable
}), Gc = () => `custom:${globalThis.crypto.randomUUID()}`, zo = (e) => [...new Set(e)], $p = (e) => {
  const t = mt(null), n = /* @__PURE__ */ new Map();
  let l = 0;
  const o = b(() => e.catalog()), a = b(() => {
    const k = o.value.metrics.map(({ key: E }) => E), K = new Set(k), W = e.config().metricKeys.filter((E) => K.has(E)), G = e.config().series.filter(({ enabled: E }) => E).map(({ metricKey: E }) => E).filter((E) => K.has(E)), A = zo([...W, ...G]).slice(0, o.value.maximumMetricCount);
    return A.length > 0 ? A : k.slice(0, 1);
  }), r = b(() => {
    const k = new Set(a.value), K = a.value[0], W = new Set(o.value.dimensions.map(({ key: A }) => A)), G = new Set(o.value.views);
    return K === void 0 ? [] : e.config().series.filter(({ dimensionKey: A, view: E }) => W.has(A) && G.has(E)).map((A) => {
      const E = zt(A);
      return k.has(E.metricKey) ? E : { ...E, metricKey: K };
    });
  }), s = b(() => e.loadState()), i = b(() => t.value !== null), c = (k) => t.value?.id === k || r.value.some(({ id: W }) => W === k) ? o.value.metrics.filter(({ key: W }) => a.value.includes(W)) : [], u = (k) => {
    const K = a.value[k === 0 ? 1 : 0];
    return o.value.metrics.filter(({ key: W }) => W !== K);
  }, d = b(
    () => o.value.metrics.length > 0 && o.value.dimensions.length > 0 && o.value.views.length > 0
  ), v = (k) => {
    const K = r.value.find(({ id: A }) => A === k)?.colorIndex;
    if (K !== void 0)
      return K;
    const W = n.get(k);
    if (W !== void 0)
      return W;
    const G = Rl[l % Rl.length] ?? 0;
    return l += 1, n.set(k, G), G;
  }, m = (k) => Jc[v(k)] ?? "blue", p = b(() => {
    const k = e.data(), K = new Map(o.value.metrics.map((E) => [E.key, E])), W = new Map(k.series.map((E) => [E.seriesId, E.values])), G = new Map(
      a.value.map((E, D) => [E, D === 0 ? 0 : 1])
    ), A = [];
    for (const E of r.value) {
      const D = K.get(E.metricKey), X = W.get(E.id);
      if (!E.enabled || D === void 0 || X === void 0)
        continue;
      const z = G.get(E.metricKey) ?? 0;
      A.push({ ...E, colorIndex: v(E.id), metric: D, axisIndex: z, values: X });
    }
    return { buckets: k.buckets, series: A };
  }), g = (k) => {
    const K = r.value.find(({ id: W }) => W === k);
    t.value = K === void 0 ? null : { ...K };
  }, y = () => {
    const k = new Set(r.value.filter(({ enabled: E }) => E).map(({ metricKey: E }) => E)), K = k.size >= o.value.maximumMetricCount ? k.values().next().value : void 0, W = o.value.metrics.find(({ key: E }) => E === K) ?? o.value.metrics[0], G = o.value.dimensions[0], A = o.value.views[0];
    if (!d.value || W === void 0 || G === void 0 || A === void 0) {
      t.value = null;
      return;
    }
    t.value = {
      id: yn,
      label: W.label,
      metricKey: W.key,
      dimensionKey: G.key,
      view: A,
      filled: !1,
      colorIndex: v(yn),
      enabled: !0,
      automatic: !1,
      removable: !0
    };
  }, P = (k) => {
    const K = t.value;
    K !== null && (t.value = {
      ...K,
      ...k.label === void 0 ? {} : { label: k.label },
      ...k.metricKey === void 0 ? {} : { metricKey: k.metricKey },
      ...k.dimensionKey === void 0 ? {} : { dimensionKey: k.dimensionKey },
      ...k.view === void 0 ? {} : { view: k.view },
      ...k.filled === void 0 ? {} : { filled: k.filled },
      ...ar(k.colorIndex) ? { colorIndex: k.colorIndex } : {},
      ...k.enabled === void 0 ? {} : { enabled: k.enabled }
    });
  }, I = () => {
    t.value = null;
  }, w = (k) => o.value.metrics.some(({ key: K }) => K === k.metricKey) && o.value.dimensions.some(({ key: K }) => K === k.dimensionKey) && o.value.views.includes(k.view), C = (k) => k.every(({ metricKey: K }) => a.value.includes(K));
  return {
    catalog: o,
    metricKeys: a,
    series: r,
    renderModel: p,
    loadState: s,
    draft: t,
    editorOpen: i,
    canAdd: d,
    metricOptionsFor: c,
    metricOptionsForSlot: u,
    colorIndexForSeries: v,
    colorForSeries: m,
    openEditor: g,
    openAdd: y,
    updateDraft: P,
    cancelDraft: I,
    applyDraft: () => {
      const k = t.value;
      if (k === null || !w(k))
        return;
      const K = { ...e.config(), series: r.value }, W = k.id === yn, G = W ? { ...k, id: (e.createSeriesId ?? Gc)() } : k, E = K.series.some(({ id: D }) => D === k.id) ? K.series.map((D) => D.id === k.id ? G : D) : [...K.series, G];
      C(E) && (e.onConfigUpdate({ metricKeys: a.value, series: E.map(zt) }), W && n.delete(yn), t.value = null);
    },
    deleteDraft: () => {
      const k = t.value;
      k === null || k.automatic || !k.removable || (e.onConfigUpdate({
        metricKeys: a.value,
        series: e.config().series.filter(({ id: K }) => K !== k.id).map(zt)
      }), t.value = null);
    },
    toggleSeries: (k) => {
      const K = { ...e.config(), series: r.value };
      if (K.series.find(({ id: A }) => A === k) === void 0)
        return;
      const G = K.series.map(
        (A) => A.id === k ? zt({ ...A, enabled: !A.enabled }) : zt(A)
      );
      C(G) && e.onConfigUpdate({ metricKeys: a.value, series: G });
    },
    setMetricKeys: (k) => {
      const K = new Set(o.value.metrics.map(({ key: E }) => E)), W = zo(k.filter((E) => K.has(E))).slice(
        0,
        o.value.maximumMetricCount
      ), G = W[0];
      if (G === void 0)
        return;
      const A = r.value.map(
        (E) => W.includes(E.metricKey) ? E : { ...E, metricKey: G }
      );
      e.onConfigUpdate({ metricKeys: W, series: A.map(zt) });
    },
    setMetricKey: (k, K) => {
      const W = a.value[k];
      if (W === void 0 || W === K || !u(k).some(({ key: A }) => A === K))
        return;
      const G = a.value.map((A, E) => E === k ? K : A);
      e.onConfigUpdate({
        metricKeys: G,
        series: r.value.map(
          (A) => zt(A.metricKey === W ? { ...A, metricKey: K } : A)
        )
      });
    }
  };
}, Lp = (e) => e, _c = {
  class: "hp-chart-card__metric-controls",
  "data-chart-metric-menu": ""
}, Oo = /* @__PURE__ */ ue({
  __name: "SmartChartHeaderControls",
  props: {
    chart: {},
    header: {},
    layout: {}
  },
  setup(e) {
    const t = Ce(), n = e, l = b(() => n.header?.metricKeys.value ?? n.chart.metricKeys.value), o = b(() => n.chart.catalog.value.maximumMetricCount), a = b(
      () => new Set(n.chart.renderModel.value.series.map(({ metricKey: c }) => c)).size
    ), r = (c) => {
      const u = l.value.indexOf(c);
      if (!(u < 0 || a.value < 2))
        return u === 0 ? { text: "L", round: !0, tooltip: t("ui.smartChart.leftAxis", "Left axis") } : { text: "R", round: !0, tooltip: t("ui.smartChart.rightAxis", "Right axis") };
    }, s = b(
      () => n.chart.catalog.value.metrics.map((c) => ({
        value: c.key,
        label: c.label,
        icon: c.icon,
        labelBadge: r(c.key)
      }))
    ), i = (c) => {
      const u = (Array.isArray(c) ? c : []).map(String);
      u.length !== 0 && (n.header?.setMetricKeys ?? n.chart.setMetricKeys)(u);
    };
    return (c, u) => (h(), $("div", {
      class: Ke(["hp-chart-card__settings", `hp-chart-card__settings--${e.layout}`])
    }, [
      be("div", _c, [
        V(f(Mn), {
          multiple: "",
          "trigger-mode": "inline",
          size: "2",
          options: s.value,
          "model-value": [...l.value],
          "max-selected": o.value,
          clearable: !1,
          placeholder: f(t)("ui.smartChart.metrics", "Metrics"),
          class: "hp-chart-card__metric-select",
          "onUpdate:modelValue": i
        }, null, 8, ["options", "model-value", "max-selected", "placeholder"])
      ]),
      pe(c.$slots, "default"),
      e.header ? (h(), R(f(we), {
        key: 0,
        size: "2",
        variant: "filled",
        disabled: !e.header.dirty.value,
        onClick: e.header.apply
      }, {
        default: S(() => [
          H(U(f(t)("ui.common.apply", "Apply")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])) : B("", !0)
    ], 2));
  }
}), Ao = /* @__PURE__ */ ue({
  __name: "SmartChartSeriesEditor",
  props: {
    chart: {}
  },
  setup(e) {
    const t = Ce(), n = e, l = b(() => n.chart.draft.value), o = b(
      () => l.value === null ? [] : n.chart.metricOptionsFor(l.value.id).map(({ key: m, label: p, icon: g }) => ({
        value: m,
        label: p,
        icon: g,
        iconSize: "1"
      }))
    ), a = b(
      () => n.chart.catalog.value.dimensions.map(({ key: m, label: p }) => ({ value: m, label: p }))
    ), r = b(
      () => l.value?.removable === !0 && n.chart.series.value.some(({ id: m }) => m === l.value?.id)
    ), s = (m) => {
      typeof m == "string" && n.chart.updateDraft({ metricKey: m });
    }, i = (m) => {
      if (typeof m != "string")
        return;
      const p = n.chart.catalog.value.dimensions.find(({ key: g }) => g === m);
      p !== void 0 && n.chart.updateDraft({ dimensionKey: p.key, label: p.label });
    }, c = (m) => {
      n.chart.updateDraft({ view: m });
    }, u = (m) => {
      n.chart.updateDraft({ filled: m });
    }, d = b(
      () => l.value === null ? 0 : l.value.colorIndex ?? n.chart.colorIndexForSeries(l.value.id)
    ), v = (m) => {
      ar(m) && n.chart.updateDraft({ colorIndex: m });
    };
    return (m, p) => l.value ? (h(), R(f(Ts), {
      key: 0,
      view: l.value.view,
      views: e.chart.catalog.value.views,
      filled: l.value.filled,
      removable: r.value,
      "onUpdate:view": c,
      "onUpdate:filled": u,
      onDelete: p[0] || (p[0] = (g) => e.chart.deleteDraft()),
      onCancel: p[1] || (p[1] = (g) => e.chart.cancelDraft()),
      onApply: p[2] || (p[2] = (g) => e.chart.applyDraft())
    }, {
      metric: S(() => [
        V(f(Cn), { size: "2" }, {
          default: S(() => [
            V(f(In), null, {
              default: S(() => [
                H(U(f(t)("ui.smartChart.metric", "Metric")), 1)
              ]),
              _: 1
            }),
            V(f(Mn), {
              "model-value": l.value.metricKey,
              options: o.value,
              size: "3",
              clearable: !1,
              "onUpdate:modelValue": s
            }, null, 8, ["model-value", "options"])
          ]),
          _: 1
        })
      ]),
      dimension: S(() => [
        V(f(Cn), { size: "2" }, {
          default: S(() => [
            V(f(In), null, {
              default: S(() => [
                H(U(e.chart.catalog.value.dimensionLabel ?? f(t)("ui.smartChart.dimension", "Dimension")), 1)
              ]),
              _: 1
            }),
            V(f(Mn), {
              "model-value": l.value.dimensionKey,
              options: a.value,
              size: "3",
              clearable: !1,
              "onUpdate:modelValue": i
            }, null, 8, ["model-value", "options"])
          ]),
          _: 1
        })
      ]),
      color: S(() => [
        V(f(Cn), { size: "2" }, {
          default: S(() => [
            V(f(In), null, {
              default: S(() => [
                H(U(f(t)("ui.smartChart.color", "Color")), 1)
              ]),
              _: 1
            }),
            V(f(Es), {
              "model-value": d.value,
              "onUpdate:modelValue": v
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["view", "views", "filled", "removable"])) : B("", !0);
  }
}), Yc = { class: "hp-chart-card__settings-trigger" }, Qc = { class: "hp-chart-card__settings-compact-controls" }, Xc = { class: "hp-chart-series-editor-popover" }, Fp = /* @__PURE__ */ ue({
  __name: "SmartChart",
  props: {
    chart: {},
    header: { default: void 0 },
    renderer: {},
    rendererProps: { default: () => ({}) },
    title: {},
    icon: { default: void 0 },
    showClose: { type: Boolean, default: !1 },
    settingsItems: { default: () => [] },
    allowSeriesAdd: { type: Boolean, default: !0 }
  },
  emits: ["close", "hover-change"],
  setup(e, { emit: t }) {
    const n = Ce(), l = e, o = t, a = mt(null), r = Y(0);
    ks((g) => (a.value = g instanceof Error ? g : new Error(String(g)), !1)), oe(
      () => l.renderer,
      () => {
        a.value = null, r.value += 1;
      }
    );
    const s = b(() => {
      if (a.value !== null)
        return n("ui.smartChart.rendererFailed", "Chart renderer failed");
      const g = l.chart.loadState.value;
      return "message" in g ? g.message : void 0;
    }), i = b(() => {
      if (a.value !== null)
        return () => {
          a.value = null, r.value += 1;
        };
      const g = l.chart.loadState.value;
      return g.status === "error" ? g.retry : void 0;
    }), c = b(() => a.value === null ? l.chart.loadState.value.status : "error"), u = b({
      get: () => {
        const g = l.chart.draft.value;
        return g !== null && !l.chart.series.value.some(({ id: y }) => y === g.id);
      },
      set: (g) => {
        g || l.chart.cancelDraft();
      }
    }), d = (g, y) => {
      y ? l.chart.openEditor(g) : l.chart.draft.value?.id === g && l.chart.cancelDraft();
    }, v = (g) => l.chart.catalog.value.metrics.find(({ key: y }) => y === g)?.label ?? g, m = (g) => l.chart.catalog.value.metrics.find(({ key: y }) => y === g)?.icon, p = (g, y) => {
      if (!(g.disabled || g.toggle))
        return y(), g.onClick?.();
    };
    return (g, y) => (h(), R(f(Ms), {
      title: e.title,
      icon: e.icon,
      state: c.value,
      message: s.value,
      retry: i.value,
      "show-close": e.showClose,
      onClose: y[3] || (y[3] = (P) => o("close"))
    }, {
      actions: S(() => [
        V(Oo, {
          chart: e.chart,
          header: e.header,
          layout: "inline"
        }, {
          default: S(() => [
            pe(g.$slots, "actions")
          ]),
          _: 3
        }, 8, ["chart", "header"]),
        be("div", Yc, [
          V(f(Pa), {
            items: [],
            icon: f(zs),
            variant: "outline",
            size: "2",
            square: "",
            "aria-label": f(n)("ui.smartChart.chartSettings", "Chart settings"),
            "menu-width": "280px",
            placement: "bottom-end"
          }, {
            dropdown: S(({ close: P }) => [
              be("div", Qc, [
                V(Oo, {
                  chart: e.chart,
                  header: e.header,
                  layout: "compact"
                }, {
                  default: S(() => [
                    pe(g.$slots, "actions")
                  ]),
                  _: 3
                }, 8, ["chart", "header"])
              ]),
              e.settingsItems.length > 0 ? (h(), R(f(Os), {
                key: 0,
                bordered: "",
                size: "2"
              }, {
                default: S(() => [
                  (h(!0), $(se, null, Pe(e.settingsItems, (I, w) => (h(), $(se, { key: w }, [
                    I.divider ? (h(), R(f(As), { key: 0 })) : B("", !0),
                    V(f($s), {
                      label: I.label,
                      "label-badge": I.labelBadge,
                      icon: I.icon,
                      "icon-color": I.iconColor,
                      prefix: I.prefix,
                      suffix: I.suffix,
                      badge: I.badge,
                      variant: I.variant,
                      disabled: I.disabled,
                      selected: I.selected,
                      tooltip: I.tooltip,
                      toggle: I.toggle,
                      weight: I.weight,
                      onClick: (C) => p(I, P)
                    }, null, 8, ["label", "label-badge", "icon", "icon-color", "prefix", "suffix", "badge", "variant", "disabled", "selected", "tooltip", "toggle", "weight", "onClick"])
                  ], 64))), 128))
                ]),
                _: 2
              }, 1024)) : B("", !0)
            ]),
            _: 3
          }, 8, ["icon", "aria-label"])
        ])
      ]),
      legend: S(() => [
        V(f(Sa), { class: "hp-chart-legend-scroller hp-chart-legend-scroller--focus-safe" }, {
          default: S(() => [
            V(f(Vs), { class: "hp-chart-legend--slider" }, {
              default: S(() => [
                (h(!0), $(se, null, Pe(e.chart.series.value, (P) => (h(), R(f(xs), {
                  key: P.id,
                  "configure-label": P.label,
                  label: P.label,
                  icon: m(P.metricKey),
                  "icon-label": `${v(P.metricKey)} metric`,
                  enabled: P.enabled,
                  color: e.chart.colorForSeries(P.id),
                  "editor-open": e.chart.draft.value?.id === P.id,
                  onToggle: (I) => e.chart.toggleSeries(P.id),
                  "onUpdate:editorOpen": (I) => d(P.id, I)
                }, {
                  editor: S(() => [
                    be("div", Xc, [
                      V(Ao, { chart: e.chart }, null, 8, ["chart"])
                    ])
                  ]),
                  _: 1
                }, 8, ["configure-label", "label", "icon", "icon-label", "enabled", "color", "editor-open", "onToggle", "onUpdate:editorOpen"]))), 128)),
                V(f(Ca), {
                  open: u.value,
                  "onUpdate:open": y[1] || (y[1] = (P) => u.value = P),
                  type: "popover"
                }, {
                  default: S(() => [
                    V(f(Ia), null, {
                      default: S(() => [
                        e.allowSeriesAdd && e.chart.canAdd.value ? (h(), R(f(we), {
                          key: 0,
                          icon: f(Ks),
                          square: "",
                          size: "2",
                          variant: "outline",
                          "aria-label": f(n)("ui.smartChart.addChartSeries", "Add chart series"),
                          onClick: y[0] || (y[0] = (P) => e.chart.openAdd())
                        }, null, 8, ["icon", "aria-label"])) : B("", !0)
                      ]),
                      _: 1
                    }),
                    V(f(Ra), { class: "hp-chart-series-editor-popover" }, {
                      default: S(() => [
                        V(Ao, { chart: e.chart }, null, 8, ["chart"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["open"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: S(() => [
        pe(g.$slots, "before-chart"),
        (h(), R(lt(e.renderer), Ve({ key: r.value }, l.rendererProps, {
          model: e.chart.renderModel.value,
          onHoverChange: y[2] || (y[2] = (P) => o("hover-change", P))
        }), null, 16, ["model"])),
        pe(g.$slots, "after-chart")
      ]),
      _: 3
    }, 8, ["title", "icon", "state", "message", "retry", "show-close"]));
  }
}), ed = 24, td = 2.5, nd = 50, ld = 100, od = (e) => {
  const t = [];
  for (const n of e) {
    const l = t.at(-1), o = l?.at(-1);
    l !== void 0 && o !== void 0 && n.leftPercent - o.leftPercent <= td ? l.push(n) : t.push([n]);
  }
  return t.flatMap(
    (n) => n.map(({ event: l, presentation: o, leftPercent: a }, r) => ({
      id: l.id,
      timestamp: l.timestamp,
      type: l.type,
      leftPercent: a,
      offsetX: (r - (n.length - 1) / 2) * ed,
      label: o.label,
      color: o.color,
      ...o.icon === void 0 ? {} : { icon: o.icon },
      timeLabel: l.timeLabel,
      details: l.details
    }))
  );
}, Dp = (e) => {
  const t = b(() => e.catalog()), n = b(() => e.events()), l = b(() => new Set(e.selectedTypes())), o = b(() => new Map(t.value.types.map((u) => [u.type, u]))), a = b(() => {
    const u = e.referenceBuckets().map(({ start: g }) => g);
    if (u.length === 0)
      return [];
    const d = Math.min(...u), v = Math.max(...u), m = v - d, p = n.value.filter(({ type: g, timestamp: y }) => l.value.has(g) && y >= d && y <= v).flatMap((g) => {
      const y = o.value.get(g.type);
      return y === void 0 ? [] : [{ event: g, presentation: y }];
    }).sort((g, y) => g.event.timestamp - y.event.timestamp).map(({ event: g, presentation: y }) => ({
      event: g,
      presentation: y,
      leftPercent: m === 0 ? nd : (g.timestamp - d) / m * ld
    }));
    return od(p);
  }), r = b(() => {
    const u = /* @__PURE__ */ new Map();
    for (const { type: d } of n.value)
      u.set(d, (u.get(d) ?? 0) + 1);
    return u;
  }), s = b(
    () => t.value.types.map((u) => ({
      ...u,
      count: r.value.get(u.type) ?? 0,
      selected: l.value.has(u.type)
    }))
  );
  return { markers: a, typeOptions: s, isTypeSelected: (u) => l.value.has(u), toggleType: (u) => {
    const d = t.value.types.map(({ type: v }) => v).filter((v) => v === u ? !l.value.has(v) : l.value.has(v));
    e.onSelectedTypesUpdate(d);
  } };
}, Np = (e) => e, rr = (e) => "get" in e || "set" in e, jl = (e) => rr(e) ? { ...e, configurable: !0 } : { ...e, writable: !0, configurable: !0 }, ad = (e) => {
  const t = {};
  for (const [n, l] of Object.entries(Object.getOwnPropertyDescriptors(e)))
    t[n] = jl(l);
  return t;
}, st = (e, t) => (
  // `Object.defineProperties`'s lib signature returns exactly the type it was given (`TTarget`); the
  // merged shape is true by construction — every defined key comes from `source`'s own descriptors —
  // not something the type checker can observe through this call. Single cast point.
  Object.defineProperties(e, ad(t))
), Yn = (e, t, n) => {
  for (const l of n) {
    const o = Object.getOwnPropertyDescriptor(t, l);
    o !== void 0 && Object.defineProperty(e, l, jl(o));
  }
  return e;
}, sr = (e, t, n) => {
  for (const l of n) {
    const o = Object.getOwnPropertyDescriptor(t, l);
    o !== void 0 && (rr(o) || o.value !== void 0) && Object.defineProperty(e, l, jl(o));
  }
  return e;
}, rd = (e = {}) => st({ shape: "value", source: "field", kind: "text" }, e), sd = (e = {}) => st({ shape: "value", source: "field", kind: "number" }, e), id = (e = {}) => st({ shape: "value", source: "field", kind: "date" }, e), ud = (e) => st({ shape: "value", source: "field", kind: "boolean" }, e), cd = (e = {}) => st({ shape: "value", source: "field", kind: "tags" }, e), dd = (e = {}) => st({ shape: "value", source: "field", kind: "multiline" }, e), Ne = { text: rd, number: sd, date: id, boolean: ud, tags: cd, multiline: dd }, fd = (e) => st({ shape: "value", source: "list" }, e), vd = (e) => st({ shape: "value", source: "list", multi: !0 }, e), md = (e) => st({ shape: "value", source: "tree" }, e), gt = { list: fd, multi: vd, tree: md }, ir = "–", $o = (e) => Yn(
  {
    shape: "value",
    source: "field",
    kind: "number",
    min: e.min,
    max: e.max,
    step: e.step
  },
  e,
  ["placeholder"]
), hd = (e = {}) => Yn(
  {
    shape: "composite",
    layout: "row",
    separator: e.separator ?? ir,
    parts: [
      { key: "min", config: $o(e) },
      { key: "max", config: $o(e) }
    ]
  },
  e,
  ["label"]
), bd = (e = {}) => Yn(
  {
    shape: "composite",
    layout: "row",
    separator: e.separator ?? ir,
    parts: [
      { key: "start", config: { shape: "value", source: "field", kind: "date", picker: e.picker } },
      { key: "end", config: { shape: "value", source: "field", kind: "date", picker: e.picker } }
    ]
  },
  e,
  ["label"]
), qt = { range: hd, dateRange: bd }, Ul = /* @__PURE__ */ ue({
  __name: "ControlHint",
  props: {
    text: {}
  },
  setup(e) {
    const t = e, n = xl(), l = () => t.text !== void 0 || n.default !== void 0;
    return (o, a) => n.default ? (h(), R(f(pl), {
      key: 0,
      size: "1",
      "popover-size": "1"
    }, {
      default: S(() => [
        pe(o.$slots, "default")
      ]),
      _: 3
    })) : l() ? (h(), R(f(pl), {
      key: 1,
      size: "1",
      "popover-size": "1",
      content: e.text
    }, null, 8, ["content"])) : B("", !0);
  }
}), yt = /* @__PURE__ */ ue({
  __name: "ControlInputGroup",
  props: {
    label: {},
    alignToLabelled: { type: Boolean },
    labelHint: {},
    labelBadge: {},
    error: {},
    disabled: { type: Boolean },
    dirty: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (h(), R(f(Cn), {
      invalid: e.error !== void 0,
      disabled: e.disabled ?? !1,
      dirty: e.dirty ?? !1,
      "align-to-labelled": e.alignToLabelled ?? !1
    }, {
      default: S(() => [
        e.label !== void 0 ? (h(), R(f(In), { key: 0 }, {
          default: S(() => [
            H(U(e.label) + " ", 1),
            V(Ul, { text: e.labelHint }, null, 8, ["text"]),
            V(f(Zn), { badge: e.labelBadge }, null, 8, ["badge"])
          ]),
          _: 1
        })) : B("", !0),
        pe(t.$slots, "default"),
        e.error !== void 0 ? (h(), R(f(Ls), { key: 1 }, {
          default: S(() => [
            H(U(e.error), 1)
          ]),
          _: 1
        })) : B("", !0)
      ]),
      _: 3
    }, 8, ["invalid", "disabled", "dirty", "align-to-labelled"]));
  }
}), gd = /* @__PURE__ */ ue({
  __name: "CheckboxControl",
  props: {
    config: {},
    state: {},
    alignToLabelled: { type: Boolean, default: !0 }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t;
    return (l, o) => (h(), R(yt, {
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty,
      "align-to-labelled": e.alignToLabelled
    }, {
      default: S(() => [
        V(f(Fs), {
          "model-value": e.state.value,
          disabled: (e.state.disabled ?? !1) || (e.state.readonly ?? !1),
          "onUpdate:modelValue": o[0] || (o[0] = (a) => n("update:value", a))
        }, {
          default: S(() => [
            H(U(e.config.label), 1),
            V(Ul, {
              text: e.config.labelHint
            }, null, 8, ["text"]),
            V(f(Zn), {
              badge: e.config.labelBadge
            }, null, 8, ["badge"])
          ]),
          _: 1
        }, 8, ["model-value", "disabled"])
      ]),
      _: 1
    }, 8, ["error", "disabled", "dirty", "align-to-labelled"]));
  }
}), yd = /* @__PURE__ */ ue({
  __name: "DateControl",
  props: {
    config: {},
    state: {},
    cell: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const l = e, o = n, a = b(() => l.cell === !0 ? "cell" : void 0), r = (s) => {
      if (s === null) {
        o("update:value", null);
        return;
      }
      s instanceof Date && o("update:value", s);
    };
    return t({ onUpdate: r }), (s, i) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        V(f(Ds), {
          "model-value": e.state.value,
          variant: a.value,
          "with-time": e.config.picker === "datetime",
          disabled: (e.state.disabled ?? !1) || (e.state.readonly ?? !1),
          clearable: !0,
          "onUpdate:modelValue": r
        }, null, 8, ["model-value", "variant", "with-time", "disabled"])
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), pd = {
  key: 0,
  class: "hint"
}, wd = /* @__PURE__ */ ue({
  __name: "MultilineControl",
  props: {
    config: {},
    state: {}
  },
  emits: ["update:value", "blur"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = b(() => {
      switch (n.config.delimiter) {
        case ",":
          return /,/;
        case ";":
          return /;/;
        default:
          return /\r?\n/;
      }
    }), a = b(() => {
      switch (n.config.delimiter) {
        case ",":
          return ", ";
        case ";":
          return "; ";
        default:
          return `
`;
      }
    }), r = (d) => d.split(o.value).map((v) => v.trim()).filter((v) => v.length > 0), s = (d) => d.join(a.value), i = (d, v) => d.length === v.length && d.every((m, p) => m === v[p]), c = Y(s(n.state.value ?? []));
    oe(
      () => n.state.value,
      (d) => {
        const v = d ?? [];
        i(r(c.value), v) || (c.value = s(v));
      }
    );
    const u = (d) => {
      const v = d ?? "";
      c.value = v, l("update:value", r(v));
    };
    return (d, v) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        V(f(Ta), {
          "model-value": c.value,
          placeholder: e.config.placeholder,
          rows: e.config.rows,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          invalid: e.state.error !== void 0,
          "onUpdate:modelValue": u,
          onBlur: v[0] || (v[0] = (m) => l("blur"))
        }, null, 8, ["model-value", "placeholder", "rows", "disabled", "read-only", "invalid"]),
        e.config.hint ? (h(), $("div", pd, [
          typeof e.config.hint == "string" ? (h(), R(f(Me), {
            key: 0,
            class: "hint-body",
            size: "1",
            variant: "soft"
          }, {
            default: S(() => [
              H(U(e.config.hint), 1)
            ]),
            _: 1
          })) : (h(), $(se, { key: 1 }, [
            V(f(Me), {
              class: "hint-note",
              size: "1",
              weight: "semibold"
            }, {
              default: S(() => [
                H(U(e.config.hint.note), 1)
              ]),
              _: 1
            }),
            e.config.hint.body ? (h(), R(f(Me), {
              key: 0,
              class: "hint-body",
              size: "1",
              variant: "soft"
            }, {
              default: S(() => [
                H(U(e.config.hint.body), 1)
              ]),
              _: 1
            })) : B("", !0)
          ], 64))
        ])) : B("", !0)
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), Ae = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [l, o] of t)
    n[l] = o;
  return n;
}, kd = /* @__PURE__ */ Ae(wd, [["__scopeId", "data-v-3d22a58a"]]), Sd = /* @__PURE__ */ ue({
  __name: "NumberControl",
  props: {
    config: {},
    state: {},
    cell: { type: Boolean }
  },
  emits: ["update:value", "blur"],
  setup(e, { expose: t, emit: n }) {
    const l = e, o = n, a = b(() => l.cell === !0 ? "cell" : void 0), r = /^-?\d+(?:\.\d+)?$/, s = (m) => {
      if (m === void 0 || m === "")
        return null;
      if (typeof m == "number")
        return Number.isFinite(m) ? m : null;
      const p = String(m).trim();
      if (!r.test(p))
        return null;
      const g = Number(p);
      return Number.isFinite(g) ? g : null;
    }, i = Y("");
    oe(
      () => l.state.value,
      (m) => {
        s(i.value) !== (m ?? null) && (i.value = m == null ? "" : String(m));
      },
      { immediate: !0 }
    );
    const c = (m) => {
      i.value = m == null ? "" : String(m), o("update:value", s(m));
    }, u = /\D/, d = (m) => {
      l.config.integer === !0 && m.data !== null && u.test(m.data) && m.preventDefault();
    }, v = () => {
      i.value = "", o("update:value", null);
    };
    return t({ onInput: c }), (m, p) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        V(f(Ct), {
          "model-value": i.value,
          variant: a.value,
          type: "number",
          placeholder: e.config.placeholder,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          invalid: e.state.error !== void 0,
          min: e.config.min,
          max: e.config.max,
          step: e.config.step,
          clearable: e.config.clearable ?? !0,
          "onUpdate:modelValue": c,
          onBeforeinput: d,
          onClear: v,
          onBlur: p[0] || (p[0] = (g) => o("blur"))
        }, null, 8, ["model-value", "variant", "placeholder", "disabled", "read-only", "invalid", "min", "max", "step", "clearable"])
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), ur = /* @__PURE__ */ ue({
  __name: "SelectedCount",
  props: {
    count: {},
    total: { default: void 0 },
    format: { type: Function, default: void 0 },
    showTotal: { type: Boolean, default: !1 },
    alwaysVisible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = b(() => t.alwaysVisible || t.count > 0), l = b(() => t.format ? t.format(t.count, t.total) : t.showTotal && t.total !== void 0 ? `Selected: ${t.count} of ${t.total}` : `Selected: ${t.count}`);
    return (o, a) => n.value ? (h(), R(f(Me), {
      key: 0,
      class: "sc-selected-count",
      size: "1",
      variant: "soft"
    }, {
      default: S(() => [
        H(U(l.value), 1)
      ]),
      _: 1
    })) : B("", !0);
  }
}), Cd = {
  key: 0,
  class: "sc-select-count"
}, Id = /* @__PURE__ */ ue({
  __name: "SelectControl",
  props: {
    config: {},
    state: {},
    cell: { type: Boolean }
  },
  emits: ["update:value", "blur"],
  setup(e, { expose: t, emit: n }) {
    const l = e, o = n, a = b(() => l.cell === !0 ? "cell" : void 0), r = b(
      () => l.config.multi === !0 ? l.config.selectedCount : void 0
    ), s = b(() => {
      const m = r.value;
      return m === !0 || typeof m == "object" && m !== null;
    }), i = b(
      () => typeof r.value == "object" ? r.value : void 0
    ), c = b(() => Array.isArray(l.state.value) ? l.state.value.length : 0), u = b(() => l.config.options.length), d = (m) => {
      if (l.config.multi === !0) {
        o("update:value", Array.isArray(m) ? m : []);
        return;
      }
      if (!Array.isArray(m)) {
        if (m === "" || m === void 0) {
          o("update:value", null);
          return;
        }
        o("update:value", m);
      }
    }, v = () => {
      o("blur");
    };
    return t({ onUpdate: d }), (m, p) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        V(f(Mn), {
          "model-value": e.state.value ?? void 0,
          variant: a.value,
          options: [...e.config.options],
          placeholder: e.config.placeholder,
          "dropdown-width": e.config.dropdownWidth,
          "selected-icon": e.config.selectedIcon ?? e.config.selectedChip ?? !1,
          "selected-chip": e.config.selectedChip ?? !1,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          prefix: e.state.readonly ? f(wl) : void 0,
          class: Ke(e.state.highlighted ? "hp-highlight-ring hp-highlight-ring--input" : void 0),
          multiple: e.config.multi ?? !1,
          "show-select-all": e.config.multi === !0 && e.config.showSelectAll,
          searchable: e.config.multi !== !0 && e.config.searchable,
          clearable: e.config.clearable ?? !0,
          invalid: e.state.error !== void 0,
          "onUpdate:modelValue": d,
          onBlur: v
        }, null, 8, ["model-value", "variant", "options", "placeholder", "dropdown-width", "selected-icon", "selected-chip", "disabled", "read-only", "prefix", "class", "multiple", "show-select-all", "searchable", "clearable", "invalid"]),
        s.value ? (h(), $("div", Cd, [
          V(ur, {
            count: c.value,
            total: u.value,
            format: i.value?.format,
            "show-total": i.value?.showTotal ?? !1,
            "always-visible": i.value?.alwaysVisible ?? !1
          }, null, 8, ["count", "total", "format", "show-total", "always-visible"])
        ])) : B("", !0)
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), Rd = /* @__PURE__ */ Ae(Id, [["__scopeId", "data-v-7de03caf"]]), Pd = /* @__PURE__ */ ue({
  __name: "SwitchControl",
  props: {
    config: {},
    state: {},
    alignToLabelled: { type: Boolean, default: !0 }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t;
    return (l, o) => (h(), R(yt, {
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty,
      "align-to-labelled": e.alignToLabelled
    }, {
      default: S(() => [
        V(f(qn), {
          "model-value": e.state.value,
          disabled: (e.state.disabled ?? !1) || (e.state.readonly ?? !1),
          variant: e.config.variant,
          "onUpdate:modelValue": o[0] || (o[0] = (a) => n("update:value", a))
        }, {
          default: S(() => [
            H(U(e.config.label), 1),
            V(Ul, {
              text: e.config.labelHint
            }, null, 8, ["text"]),
            V(f(Zn), {
              badge: e.config.labelBadge
            }, null, 8, ["badge"])
          ]),
          _: 1
        }, 8, ["model-value", "disabled", "variant"])
      ]),
      _: 1
    }, 8, ["error", "disabled", "dirty", "align-to-labelled"]));
  }
}), Td = /* @__PURE__ */ ue({
  __name: "TagsControl",
  props: {
    config: {},
    state: {},
    cell: { type: Boolean }
  },
  emits: ["update:value", "blur"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = b(() => (n.config.options?.length ?? 0) > 0), a = b(() => n.cell === !0 ? "cell" : void 0), r = b(
      () => (n.config.options ?? []).map((u) => ({ value: u.value, label: u.label, color: u.color }))
    ), s = b(() => {
      const u = n.config.options ?? [];
      return (n.state.value ?? []).map((d) => u.find((v) => v.value === d) ?? { value: d, label: d });
    }), i = (u) => {
      l(
        "update:value",
        u.map((d) => String(d))
      );
    }, c = (u) => {
      l(
        "update:value",
        u.map((d) => typeof d == "string" ? d : String(d.value))
      );
    };
    return (u, d) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        o.value ? (h(), R(f(fo), {
          key: 0,
          "model-value": s.value,
          variant: a.value,
          options: r.value,
          "option-label": "label",
          "option-value": "value",
          "option-color": "color",
          "show-option-color-dot": e.config.showColorDot ?? !0,
          "toggle-select": !0,
          placeholder: e.config.placeholder,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          invalid: e.state.error !== void 0,
          "onUpdate:modelValue": c,
          onBlur: d[0] || (d[0] = (v) => l("blur"))
        }, null, 8, ["model-value", "variant", "options", "show-option-color-dot", "placeholder", "disabled", "read-only", "invalid"])) : (h(), R(f(fo), {
          key: 1,
          "model-value": e.state.value,
          variant: a.value,
          placeholder: e.config.placeholder,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          "allow-duplicates": e.config.allowDuplicates ?? !1,
          invalid: e.state.error !== void 0,
          "onUpdate:modelValue": i,
          onBlur: d[1] || (d[1] = (v) => l("blur"))
        }, null, 8, ["model-value", "variant", "placeholder", "disabled", "read-only", "allow-duplicates", "invalid"]))
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), Ed = /* @__PURE__ */ ue({
  __name: "TextControl",
  props: {
    config: {},
    state: {},
    cell: { type: Boolean }
  },
  emits: ["update:value", "blur"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = b(() => n.cell === !0 ? "cell" : void 0), a = (s) => {
      l("update:value", s === void 0 ? "" : String(s));
    }, r = (s) => {
      l("update:value", s ?? "");
    };
    return (s, i) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        e.config.view === "textarea" ? (h(), R(f(Ta), {
          key: 0,
          "model-value": e.state.value,
          variant: o.value,
          placeholder: e.config.placeholder,
          "aria-label": e.config.label,
          rows: e.config.rows,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          invalid: e.state.error !== void 0,
          "onUpdate:modelValue": r,
          onBlur: i[0] || (i[0] = (c) => l("blur"))
        }, null, 8, ["model-value", "variant", "placeholder", "aria-label", "rows", "disabled", "read-only", "invalid"])) : (h(), R(f(Ct), {
          key: 1,
          "model-value": e.state.value,
          variant: o.value,
          type: "text",
          placeholder: e.config.placeholder,
          "aria-label": e.config.label,
          disabled: e.state.disabled ?? !1,
          "read-only": e.state.readonly ?? !1,
          invalid: e.state.error !== void 0,
          clearable: e.config.clearable ?? !0,
          "onUpdate:modelValue": a,
          onClear: i[1] || (i[1] = (c) => l("update:value", "")),
          onBlur: i[2] || (i[2] = (c) => l("blur"))
        }, null, 8, ["model-value", "variant", "placeholder", "aria-label", "disabled", "read-only", "invalid", "clearable"]))
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), an = (e) => `${typeof e}:${String(e)}`, Md = (e) => {
  const t = e.indexOf(":"), n = e.slice(0, t), l = e.slice(t + 1);
  return n === "number" ? Number(l) : l;
}, zn = (e) => e.trim().toLowerCase(), Vd = (e, t, n) => zn(n?.(e) ?? t(e)), xd = (e) => ({
  id: an(e.key),
  key: e.key,
  item: e.item,
  label: e.label,
  disabled: e.disabled,
  searchText: e.searchText,
  children: e.children?.length ? e.children : void 0
}), Kd = (e) => {
  const { items: t, getKey: n, getLabel: l, getSearchText: o, isDisabled: a, getChildren: r } = e, s = (i) => {
    const c = n(i), u = l(i), d = zn(o ? o(i) : u), v = a?.(i) ?? !1, m = r?.(i), p = m?.length ? m.map(s) : void 0;
    return xd({ key: c, item: i, label: u, searchText: d, disabled: v, children: p });
  };
  return t.map(s);
}, zd = (e) => {
  const t = [], n = [], l = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), c = [], u = /* @__PURE__ */ new Set(), d = (v, m, p) => {
    if (u.has(v.id))
      return { descendants: [], leafIds: [v.id], selectableLeafCount: v.disabled ? 0 : 1 };
    u.add(v.id), t.push(v.id), l.set(v.id, v), o.set(v.id, m), p && n.push(v.id);
    const g = v.children ?? [], y = g.map((C) => C.id);
    a.set(v.id, y), y.length > 0 && c.push(v.id);
    const P = [], I = g.length === 0 ? [v.id] : [];
    let w = g.length === 0 && !v.disabled ? 1 : 0;
    return g.forEach((C) => {
      const x = d(C, v.id, !1);
      P.push(C.id, ...x.descendants), I.push(...x.leafIds), w += x.selectableLeafCount;
    }), r.set(v.id, P), s.set(v.id, I), i.set(v.id, w), { descendants: P, leafIds: I, selectableLeafCount: w };
  };
  return e.forEach((v) => {
    d(v, null, !0);
  }), {
    orderedIds: t,
    rootIds: n,
    nodeMap: l,
    parentMap: o,
    childMap: a,
    descendantMap: r,
    leafMap: s,
    selectableLeafCountMap: i,
    expandableIds: c
  };
}, Lo = (e, t, n) => {
  const l = e.nodeMap.get(t);
  if (!l || l.disabled)
    return [];
  switch (n) {
    case "self":
      return [t];
    case "subtree":
      return [t, ...e.descendantMap.get(t) ?? []].filter((o) => !e.nodeMap.get(o)?.disabled);
    case "leaves":
      return [...e.leafMap.get(t) ?? []].filter((o) => !e.nodeMap.get(o)?.disabled);
  }
}, cr = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((l) => {
    const o = e.nodeMap.get(l);
    if (!o || o.disabled)
      return;
    (e.leafMap.get(l) ?? []).forEach((r) => {
      const s = e.nodeMap.get(r);
      s && !s.disabled && n.add(r);
    });
  }), n;
}, Fo = (e, t) => e.size !== t.size ? !1 : [...e].every((n) => t.has(n)), Od = (e, t) => {
  const n = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), o = (i) => {
    const c = n.get(i);
    if (c !== void 0)
      return c;
    if (l.has(i))
      return !1;
    l.add(i);
    const u = e.nodeMap.get(i), d = e.childMap.get(i) ?? [], v = d.length === 0 ? !u || u.disabled || t.has(i) : d.every((m) => o(m));
    return l.delete(i), n.set(i, v), v;
  }, a = [], r = /* @__PURE__ */ new Set(), s = (i) => {
    if (r.has(i))
      return;
    r.add(i);
    const c = e.nodeMap.get(i);
    if (!c)
      return;
    const u = e.childMap.get(i) ?? [], d = !c.disabled && t.has(i);
    if (u.length === 0) {
      d && a.push(i);
      return;
    }
    if (!c.disabled && o(i)) {
      a.push(i);
      return;
    }
    d && a.push(i), u.forEach((v) => {
      s(v);
    });
  };
  return e.rootIds.forEach((i) => {
    s(i);
  }), a;
}, Do = (e, t, n) => {
  const l = e.split(/\s+/);
  return t.split(/\s+/).every((o) => l.some((a) => n(a, o)));
}, rl = (e, t, n, l) => {
  if (typeof l == "object" && "custom" in l)
    return l.custom(e, n);
  switch (l) {
    case "substring":
      return t.includes(n);
    case "startsWith":
      return Do(t, n, (o, a) => o.startsWith(a));
    case "equals":
      return Do(t, n, (o, a) => o === a);
  }
}, Ad = (e, t, n) => {
  const l = e?.mode ?? "startsWith", o = e?.terms, a = o?.enabled ?? !1, r = o?.delimiter ?? ",", s = o?.combine ?? "any", i = o?.mode;
  return (c, u) => {
    if (u.length === 0)
      return !0;
    const d = Vd(c, t, n);
    if (!a || !u.includes(r))
      return rl(c, d, u, l);
    const v = u.split(r).map((p) => p.trim()).filter((p) => p.length > 0);
    if (v.length === 0)
      return !0;
    const m = i ?? l;
    return s === "all" ? v.every((p) => rl(c, d, p, m)) : v.some((p) => rl(c, d, p, m));
  };
}, $d = (e) => {
  const { nodeIndex: t, draftIds: n } = e, l = b(() => n.value.size), o = b(() => t.value.orderedIds.length), a = b(() => n.value.size > 0), r = b(() => t.value.expandableIds.length > 0);
  return {
    selectedCount: l,
    totalCount: o,
    hasSelection: a,
    hasExpandable: r
  };
}, Ld = (e) => {
  const { nodeIndex: t, defaultExpanded: n, query: l, autoExpandOnSearch: o, subtreeVisibleIds: a } = e, r = Y(/* @__PURE__ */ new Set()), s = Y(/* @__PURE__ */ new Set()), i = Y(!1), c = b(() => l.value.length > 0), u = (g) => (t.value.childMap.get(g) ?? []).some((P) => a.value.has(P)), d = (g) => r.value.has(g) ? !0 : !c.value || !o.value || s.value.has(g) ? !1 : u(g);
  return oe(
    t,
    (g) => {
      const y = new Set(g.expandableIds);
      i.value ? (r.value = new Set([...r.value].filter((P) => y.has(P))), s.value = new Set(
        [...s.value].filter((P) => y.has(P))
      )) : (r.value = n.value ? new Set(g.expandableIds) : /* @__PURE__ */ new Set(), s.value = /* @__PURE__ */ new Set(), i.value = !0);
    },
    { immediate: !0 }
  ), oe(c, (g, y) => {
    y && !g && (s.value = /* @__PURE__ */ new Set());
  }), { expandedIds: r, explicitlyCollapsedIds: s, toggleExpand: (g) => {
    if (!t.value.expandableIds.includes(g))
      return;
    const y = new Set(r.value), P = new Set(s.value);
    d(g) ? (y.delete(g), c.value && o.value && u(g) && P.add(g)) : (y.add(g), P.delete(g)), r.value = y, s.value = P;
  }, expandAll: () => {
    r.value = new Set(t.value.expandableIds), s.value = /* @__PURE__ */ new Set();
  }, collapseAll: () => {
    r.value = /* @__PURE__ */ new Set(), c.value && o.value && (s.value = new Set(t.value.expandableIds));
  } };
}, Fd = (e, t, n, l, o, a, r) => t ? !!(a.has(e) || n && l && o && !r.has(e)) : !1, Dd = (e, t, n, l, o) => e ? t ? n && (!l || o) : o : !1, dr = (e) => {
  const {
    levelNodes: t,
    depth: n,
    ancestorLines: l,
    rows: o,
    matchedIds: a,
    visibleIds: r,
    subtreeVisibleIds: s,
    hasSearchQuery: i,
    autoExpandOnSearch: c,
    expandedIds: u,
    explicitlyCollapsedIds: d,
    shrink: v,
    flat: m,
    visited: p
  } = e;
  t.forEach((g, y) => {
    if (p.has(g.id))
      return;
    p.add(g.id);
    const P = g.children ?? [], I = P.length > 0, w = P.some((O) => s.has(O.id)), C = r.has(g.id), x = Fd(
      g.id,
      I,
      i,
      c,
      w,
      u,
      d
    );
    C && o.push({
      nodeId: g.id,
      key: g.key,
      item: g.item,
      label: g.label,
      disabled: g.disabled,
      matched: a.has(g.id),
      tree: {
        depth: n,
        // In flat mode children are structurally hidden, so the chevron must
        // also be suppressed — otherwise clicks on it would do nothing.
        expandable: m ? !1 : I,
        expanded: x,
        last: y === t.length - 1,
        lines: l,
        showLines: !0,
        shrink: v
      }
    }), !m && Dd(I, i, w, C, x) && dr({
      levelNodes: P,
      depth: n + 1,
      ancestorLines: [...l, y !== t.length - 1],
      rows: o,
      matchedIds: a,
      visibleIds: r,
      subtreeVisibleIds: s,
      hasSearchQuery: i,
      autoExpandOnSearch: c,
      expandedIds: u,
      explicitlyCollapsedIds: d,
      shrink: v,
      flat: m,
      visited: p
    });
  });
}, Nd = (e) => b(() => {
  const t = [];
  return dr({
    levelNodes: _(e.nodes),
    depth: 0,
    ancestorLines: [],
    rows: t,
    matchedIds: e.matchedIds.value,
    visibleIds: e.visibleIds.value,
    subtreeVisibleIds: e.subtreeVisibleIds.value,
    hasSearchQuery: e.normalizedQuery.value.length > 0,
    autoExpandOnSearch: e.autoExpandOnSearch.value,
    expandedIds: e.expandedIds.value,
    explicitlyCollapsedIds: e.explicitlyCollapsedIds.value,
    shrink: e.shrink.value,
    flat: e.flat.value,
    visited: /* @__PURE__ */ new Set()
  }), t;
}), Bd = (e) => {
  const t = e.normalize ?? ((v) => v), n = e.equals ?? Object.is, l = Y(), o = Y();
  let a = !1;
  const r = (v) => {
    const m = t(v);
    if (!a) {
      l.value = m, o.value = m, a = !0;
      return;
    }
    const p = !n(o.value, l.value);
    l.value = m, p || (o.value = m);
  };
  oe(
    () => _(e.source),
    (v, m) => {
      m !== void 0 && n(v, m) || r(v);
    },
    { immediate: !0 }
  );
  const s = (v) => {
    o.value = t(v);
  }, i = (v) => {
    l.value = t(v);
  }, c = () => {
    const v = t(o.value);
    return l.value = v, o.value = v, v;
  }, u = () => {
    o.value = t(l.value);
  }, d = b(() => !n(o.value, l.value));
  return { draft: o, committed: l, isDirty: d, setDraft: s, setCommitted: i, commit: c, cancel: u, hydrate: r };
}, jd = (e) => {
  const { nodeIndex: t, modelValue: n, selectionMode: l, collapseToParent: o, preserveUnknownKeys: a, onChange: r } = e, s = (C) => {
    if (!a.value)
      return /* @__PURE__ */ new Set();
    const x = new Set(t.value.orderedIds);
    return new Set([...C].filter((O) => !x.has(O)));
  }, i = (C) => {
    const x = new Set(t.value.orderedIds);
    return new Set([...C].filter((O) => x.has(O)));
  }, c = (C) => o.value ? new Set(Od(t.value, C)) : C, d = Bd({
    source: () => new Set(n.value.map((C) => an(C))),
    normalize: (C) => /* @__PURE__ */ new Set([...c(i(C)), ...s(C)]),
    equals: Fo
  }), v = d.draft, m = (C) => {
    const x = t.value.orderedIds.filter((N) => C.has(N)).map((N) => t.value.nodeMap.get(N)).filter((N) => !!N).map((N) => N.key), O = [...s(C)].map(Md);
    return [...x, ...O];
  }, p = (C) => {
    d.setDraft(C), r?.(m(d.draft.value));
  };
  return oe(
    t,
    () => {
      const C = d.draft.value;
      d.setDraft(C), d.setCommitted(d.committed.value);
      const x = d.draft.value;
      Fo(C, x) || r?.(m(x));
    },
    { immediate: !1 }
  ), {
    draftIds: v,
    toPayload: (C) => {
      const x = t.value.orderedIds.filter((O) => C.has(O)).map((O) => t.value.nodeMap.get(O)).filter((O) => !!O);
      return {
        keys: x.map((O) => O.key),
        items: x.map((O) => O.item)
      };
    },
    toggleNode: (C) => {
      const x = o.value ? "leaves" : l.value, O = Lo(t.value, C, x);
      if (O.length === 0)
        return;
      const N = s(v.value), T = o.value ? cr(t.value, v.value) : new Set(v.value), L = !O.every((k) => T.has(k));
      O.forEach((k) => {
        L ? T.add(k) : T.delete(k);
      }), p(/* @__PURE__ */ new Set([...T, ...N]));
    },
    clearSelection: () => {
      p(/* @__PURE__ */ new Set());
    },
    setSelectionKeys: (C) => {
      p(new Set(C.map((x) => an(x))));
    },
    selectAllVisibleFromRows: (C) => {
      const x = new Set(v.value);
      C.filter((O) => !O.disabled).flatMap((O) => Lo(t.value, O.nodeId, l.value)).forEach((O) => {
        x.add(O);
      }), p(x);
    }
  };
}, Ud = (e) => e.childIds.reduce((t, n) => {
  const l = e.resolveCounts(n);
  return t.selectedCount += l.selectedCount, t.selectableCount += l.selectableCount, t;
}, e.initialCounts), Hd = (e) => {
  const t = e.isDisabled ? 0 : 1;
  return {
    selectableCount: t,
    selectedCount: t > 0 && e.isSelected ? 1 : 0
  };
}, Wd = (e) => {
  if (e.selectionMode !== "subtree")
    return { selectedCount: 0, selectableCount: 0 };
  const t = e.isDisabled ? 0 : 1;
  return {
    selectableCount: t,
    selectedCount: t > 0 && e.isSelected ? 1 : 0
  };
}, Zd = (e, t) => {
  const n = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
  for (let o = e.orderedIds.length - 1; o >= 0; o--) {
    const a = e.orderedIds[o], r = e.childMap.get(a) ?? [];
    let s;
    r.length === 0 ? s = t.has(a) ? 1 : 0 : s = r.reduce((c, u) => c + (l.get(u) ?? 0), 0), l.set(a, s);
    const i = e.selectableLeafCountMap.get(a) ?? 0;
    n.set(a, {
      selected: i > 0 && s === i,
      indeterminate: s > 0 && s < i
    });
  }
  return n;
}, qd = (e, t, n, l) => b(() => {
  const o = l.value ? cr(e.value, t.value) : t.value;
  if (l.value || n.value === "leaves")
    return Zd(e.value, o);
  const a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set(), i = (d) => {
    const v = r.get(d);
    if (v)
      return v;
    if (s.has(d))
      return { selectedCount: 0, selectableCount: 0 };
    s.add(d);
    const m = e.value.nodeMap.get(d), p = e.value.childMap.get(d) ?? [], g = o.has(d), y = n.value === "leaves" && p.length === 0 ? Hd({
      isDisabled: m?.disabled ?? !1,
      isSelected: g
    }) : Ud({
      childIds: p,
      resolveCounts: i,
      initialCounts: Wd({
        selectionMode: n.value,
        isDisabled: m?.disabled ?? !1,
        isSelected: g
      })
    });
    return s.delete(d), r.set(d, y), y;
  }, c = /* @__PURE__ */ new Set(), u = (d) => {
    const v = a.get(d);
    if (v)
      return v;
    if (n.value === "self") {
      if (c.has(d))
        return { selected: !1, indeterminate: !1 };
      c.add(d);
      const y = e.value.childMap.get(d) ?? [], P = o.has(d), I = y.some((C) => {
        const x = u(C);
        return x.selected || x.indeterminate;
      });
      c.delete(d);
      const w = {
        selected: P,
        indeterminate: !P && I
      };
      return a.set(d, w), w;
    }
    const { selectedCount: m, selectableCount: p } = i(d), g = {
      selected: p > 0 && m === p,
      indeterminate: m > 0 && m < p
    };
    return a.set(d, g), g;
  };
  return e.value.orderedIds.forEach((d) => {
    u(d);
  }), a;
}), Jd = (e, t, n, l) => e ? t === "with-ancestors" ? n || l : n : !0, Gd = (e, t, n, l, o) => {
  const a = b(() => zn(t.value)), r = b(() => {
    const s = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), u = a.value, d = u.length > 0, v = _(n), m = _(o), p = _(l), g = /* @__PURE__ */ new Set(), y = (P) => {
      if (g.has(P.id))
        return !1;
      g.add(P.id);
      const I = p ? [] : P.children ?? [], w = d ? m(P.item, u) : !1;
      let C = !1;
      I.forEach((O) => {
        C = y(O) || C;
      });
      const x = Jd(d, v, w, C);
      return w && s.add(P.id), x && i.add(P.id), (x || C) && c.add(P.id), x || C;
    };
    return _(e).forEach((P) => {
      y(P);
    }), {
      matchedIds: s,
      visibleIds: i,
      subtreeVisibleIds: c
    };
  });
  return {
    normalizedQuery: a,
    matchedIds: b(() => r.value.matchedIds),
    visibleIds: b(() => r.value.visibleIds),
    subtreeVisibleIds: b(() => r.value.subtreeVisibleIds)
  };
}, _d = (e) => {
  const t = b(() => _(e.nodes)), n = b(() => _(e.modelValue) ?? []), l = b(() => _(e.selectionMode) ?? "self"), o = b(() => _(e.searchMode) ?? "with-ancestors"), a = b(() => _(e.autoExpandOnSearch) ?? !0), r = b(() => _(e.defaultExpanded) ?? !1), s = b(() => _(e.shrink) ?? !1), i = b(() => _(e.flat) ?? !1), c = b(() => _(e.collapseToParent) ?? !1), u = b(() => {
    const W = c.value;
    return W && l.value === "self" ? !1 : W;
  });
  oe(l, (W) => {
  });
  const d = b(() => _(e.query) ?? ""), v = b(() => zd(t.value)), m = b(() => _(e.searchConfig)), p = b(() => _(e.getLabel)), g = b(() => _(e.getSearchText)), y = b(() => {
    const W = /* @__PURE__ */ new Map();
    for (const G of v.value.orderedIds) {
      const A = v.value.nodeMap.get(G);
      A && W.set(A.item, A.searchText);
    }
    return W;
  }), P = b(() => {
    const W = p.value ?? ((G) => y.value.get(G) ?? "");
    return Ad(m.value, W, g.value);
  }), { normalizedQuery: I, matchedIds: w, visibleIds: C, subtreeVisibleIds: x } = Gd(
    t,
    d,
    o,
    i,
    P
  ), O = Ld({
    nodeIndex: v,
    defaultExpanded: r,
    query: d,
    autoExpandOnSearch: a,
    subtreeVisibleIds: x
  }), N = jd({
    nodeIndex: v,
    modelValue: n,
    selectionMode: l,
    collapseToParent: u,
    preserveUnknownKeys: b(() => _(e.preserveUnknownKeys) ?? !1),
    onChange: e.onChange
  }), T = qd(v, N.draftIds, l, u), L = Nd({
    nodes: t,
    subtreeVisibleIds: x,
    visibleIds: C,
    matchedIds: w,
    expandedIds: O.expandedIds,
    explicitlyCollapsedIds: O.explicitlyCollapsedIds,
    normalizedQuery: I,
    autoExpandOnSearch: a,
    shrink: s,
    flat: i
  }), k = $d({
    nodeIndex: v,
    draftIds: N.draftIds
  }), K = () => N.selectAllVisibleFromRows(L.value);
  return {
    rows: L,
    selectionStateMap: T,
    selectedCount: k.selectedCount,
    totalCount: k.totalCount,
    hasSelection: k.hasSelection,
    hasExpandable: k.hasExpandable,
    toggleNode: N.toggleNode,
    toggleExpand: O.toggleExpand,
    expandAll: O.expandAll,
    collapseAll: O.collapseAll,
    selectAllVisible: K,
    clearSelection: N.clearSelection,
    setSelectionKeys: N.setSelectionKeys
  };
}, No = " / ", Yd = {
  key: 0,
  class: "sc-chip-label"
}, Qd = { class: "sc-chip-label__parent" }, Xd = {
  class: "sc-chip-label__separator",
  "aria-hidden": "true"
}, ef = { class: "sc-chip-label__own" }, tf = /* @__PURE__ */ ue({
  name: "SelectedChipLabel",
  __name: "SelectedChipLabel",
  props: {
    label: {}
  },
  setup(e) {
    const t = e, n = No, l = b(() => {
      const o = t.label.indexOf(No);
      return o <= 0 ? null : { parent: t.label.slice(0, o), own: t.label.slice(o + n.length) };
    });
    return (o, a) => l.value ? (h(), $("span", Yd, [
      be("span", Qd, U(l.value.parent), 1),
      be("span", Xd, U(f(n)), 1),
      be("span", ef, U(l.value.own), 1)
    ])) : (h(), $(se, { key: 1 }, [
      H(U(e.label), 1)
    ], 64));
  }
}), nf = /* @__PURE__ */ Ae(tf, [["__scopeId", "data-v-78aa66a5"]]), lf = { class: "sc-selected-panel__chips d-flex flex-wrap gap-1" }, of = /* @__PURE__ */ ue({
  __name: "SelectedPanel",
  props: {
    items: {},
    removable: { type: Boolean, default: !0 },
    emptyText: { default: void 0 },
    groupBy: { type: Function, default: void 0 },
    getItemColor: { type: Function, default: void 0 },
    getItemBadge: { type: Function, default: void 0 },
    getChipLabel: { type: Function, default: void 0 },
    includeMode: { type: Boolean, default: void 0 },
    includeColor: { default: "green" },
    excludeColor: { default: "red" },
    depthColors: { default: void 0 },
    depthVariants: { default: void 0 }
  },
  emits: ["focus", "remove"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = b(() => {
      if (!n.groupBy)
        return [{ key: "", label: "", items: n.items }];
      const d = /* @__PURE__ */ new Map();
      for (const v of n.items) {
        const m = n.groupBy(v.node), p = d.get(m);
        p ? p.push(v) : d.set(m, [v]);
      }
      return Array.from(d, ([v, m]) => ({ key: v, label: v, items: m }));
    }), a = (d) => n.getChipLabel ? n.getChipLabel(d.node) : d.label, r = () => {
      if (n.includeMode !== void 0)
        return n.includeMode ? n.includeColor : n.excludeColor;
    }, s = (d) => {
      const v = n.depthColors;
      if (!v)
        return;
      const m = n.includeMode === !1;
      return (d.depth ?? 0) === 0 ? m ? v.rootExclude ?? v.root : v.root : m ? v.leafExclude ?? v.leaf : v.leaf;
    }, i = (d) => n.getItemColor?.(d.node) ?? s(d) ?? r(), c = (d) => {
      const v = n.depthVariants;
      return (d.depth ?? 0) === 0 ? v?.root ?? "soft" : v?.leaf ?? "soft";
    }, u = (d) => n.getItemBadge?.(d.node);
    return (d, v) => e.items.length > 0 || e.emptyText !== void 0 ? (h(), $("div", {
      key: 0,
      class: Ke(["sc-selected-panel", { "sc-selected-panel--empty": e.items.length === 0 }])
    }, [
      e.items.length === 0 ? (h(), R(f(Me), {
        key: 0,
        size: "1",
        variant: "soft"
      }, {
        default: S(() => [
          H(U(e.emptyText), 1)
        ]),
        _: 1
      })) : (h(!0), $(se, { key: 1 }, Pe(o.value, (m) => (h(), $("div", {
        key: m.key,
        class: "sc-selected-panel__group gap-2"
      }, [
        m.label ? (h(), R(f(Me), {
          key: 0,
          size: "2",
          weight: "medium",
          variant: "soft",
          class: "sc-selected-panel__group-label"
        }, {
          default: S(() => [
            H(U(m.label), 1)
          ]),
          _: 2
        }, 1024)) : B("", !0),
        be("div", lf, [
          (h(!0), $(se, null, Pe(m.items, (p) => (h(), R(f(Mt), {
            key: String(p.key),
            size: "2",
            variant: c(p),
            color: i(p),
            clickable: !0,
            dismissible: e.removable,
            onClick: (g) => l("focus", p.key),
            onDismiss: (g) => l("remove", p.key)
          }, {
            default: S(() => [
              V(nf, {
                label: a(p)
              }, null, 8, ["label"]),
              u(p) !== void 0 ? (h(), R(f(Ns), { key: 0 }, {
                default: S(() => [
                  H(U(u(p)), 1)
                ]),
                _: 2
              }, 1024)) : B("", !0)
            ]),
            _: 2
          }, 1032, ["variant", "color", "dismissible", "onClick", "onDismiss"]))), 128))
        ])
      ]))), 128))
    ], 2)) : B("", !0);
  }
}), Bo = /* @__PURE__ */ Ae(of, [["__scopeId", "data-v-e21bb1ac"]]), af = {
  key: 0,
  class: "sc-toolbar-actions"
}, rf = /* @__PURE__ */ ue({
  __name: "ToolbarActions",
  props: {
    actions: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => e.actions.length > 0 ? (h(), $("div", af, [
      (h(!0), $(se, null, Pe(e.actions, (l) => (h(), R(f(we), {
        key: l.id,
        variant: "outline",
        size: "1",
        disabled: e.disabled || (l.disabled ?? !1),
        onClick: l.onClick
      }, {
        default: S(() => [
          H(U(l.label), 1)
        ]),
        _: 2
      }, 1032, ["disabled", "onClick"]))), 128))
    ])) : B("", !0);
  }
}), sf = /* @__PURE__ */ Ae(rf, [["__scopeId", "data-v-98f97fc9"]]), uf = {
  key: 0,
  class: "sc-tree-empty"
}, cf = /* @__PURE__ */ ue({
  __name: "TreeOptionsView",
  props: {
    rows: {},
    selectionStateMap: {},
    query: {},
    disabled: { type: Boolean },
    getRowBadge: { type: Function },
    noResultsText: {},
    showTreeConnectors: { type: Boolean },
    includeMode: { type: Boolean }
  },
  emits: ["toggle:node", "toggle:expand"],
  setup(e, { emit: t }) {
    const n = Ce(), l = e, o = (s) => {
      const i = l.getRowBadge?.(s.item);
      if (i !== void 0)
        return typeof i == "string" ? { text: i } : i;
    }, a = t, r = (s) => {
      const i = s.charAt(0).toUpperCase();
      return i >= "A" && i <= "Z" ? i : "#";
    };
    return (s, i) => (h(), $("div", null, [
      e.rows.length === 0 ? (h(), $("div", uf, [
        V(f(Me), {
          size: "2",
          variant: "soft"
        }, {
          default: S(() => [
            H(U(e.noResultsText ?? f(n)("ui.treeControl.noResults", "No results")), 1)
          ]),
          _: 1
        })
      ])) : B("", !0),
      (h(!0), $(se, null, Pe(e.rows, (c) => (h(), R(f(Xt), {
        key: c.nodeId,
        "data-letter": r(c.label),
        checked: e.selectionStateMap.get(c.nodeId)?.selected ?? !1,
        indeterminate: e.selectionStateMap.get(c.nodeId)?.indeterminate ?? !1,
        excluded: e.includeMode === !1,
        disabled: e.disabled || c.disabled,
        interactive: !(e.disabled || c.disabled),
        active: !!e.query && c.matched && !(e.selectionStateMap.get(c.nodeId)?.selected ?? !1),
        onClick: (u) => a("toggle:node", c.nodeId)
      }, {
        default: S(() => [
          e.showTreeConnectors ? (h(), R(f(Ea), {
            key: 0,
            depth: c.tree.depth,
            expandable: c.tree.expandable,
            expanded: c.tree.expanded,
            last: c.tree.last,
            lines: c.tree.lines,
            "show-lines": c.tree.showLines,
            shrink: c.tree.shrink,
            onExpand: (u) => a("toggle:expand", c.nodeId)
          }, null, 8, ["depth", "expandable", "expanded", "last", "lines", "show-lines", "shrink", "onExpand"])) : B("", !0),
          V(f(Bs)),
          V(f(kl), null, {
            default: S(() => [
              H(U(c.label), 1)
            ]),
            _: 2
          }, 1024),
          o(c) !== void 0 ? (h(), R(f(Ma), { key: 1 }, {
            default: S(() => [
              V(f(Xe), {
                size: "1",
                variant: "soft",
                color: o(c)?.color
              }, {
                default: S(() => [
                  H(U(o(c)?.text), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _: 2
          }, 1024)) : B("", !0)
        ]),
        _: 2
      }, 1032, ["data-letter", "checked", "indeterminate", "excluded", "disabled", "interactive", "active", "onClick"]))), 128))
    ]));
  }
}), df = /* @__PURE__ */ Ae(cf, [["__scopeId", "data-v-2ecbe82d"]]), ff = {
  key: 0,
  class: "sc-tree-search"
}, vf = {
  key: 1,
  class: "sc-tree-toolbar"
}, mf = {
  key: 0,
  class: "sc-tree-toolbar-prefix"
}, hf = { class: "sc-tree-toolbar-left" }, bf = {
  key: 2,
  class: "sc-tree-presets"
}, gf = {
  key: 3,
  class: "sc-tree-count"
}, yf = {
  key: 0,
  class: "sc-tree-side hp-scrollbar"
}, pf = {
  key: 0,
  class: "sc-tree-side-presets gap-2"
}, wf = { class: "sc-tree-side-presets-buttons gap-1" }, kf = 80, Sf = /* @__PURE__ */ ue({
  __name: "TreeControl",
  props: {
    config: {},
    state: {},
    includeMode: { type: Boolean }
  },
  emits: ["update:value", "blur"],
  setup(e, { expose: t, emit: n }) {
    const l = Ce(), o = e, a = n, r = Y(""), s = Y(""), i = Y(o.config.defaultFlat ?? !1);
    oe(
      () => o.config.defaultFlat,
      (Z) => {
        i.value = Z ?? !1;
      }
    );
    const c = b(
      () => Kd({
        items: o.config.options,
        getKey: (Z) => Z.value,
        getLabel: (Z) => Z.label,
        getSearchText: o.config.getSearchText,
        getChildren: (Z) => Z.children,
        isDisabled: (Z) => Z.disabled ?? !1
      })
    ), u = b(
      () => typeof o.config.search == "object" ? o.config.search : void 0
    ), d = _d({
      nodes: c,
      modelValue: () => o.state.value ?? [],
      onChange: (Z) => a("update:value", [...Z]),
      selectionMode: () => o.config.selectionMode,
      collapseToParent: () => o.config.collapseToParent ?? !1,
      preserveUnknownKeys: () => o.config.preserveUnknownKeys ?? !1,
      defaultExpanded: () => o.config.defaultExpanded,
      shrink: () => o.config.shrink,
      autoExpandOnSearch: () => o.config.autoExpandOnSearch,
      flat: () => i.value,
      query: () => r.value,
      searchMode: () => u.value?.mode,
      searchConfig: () => {
        const Z = u.value;
        if (!(Z === void 0 || Z.match === void 0 && Z.terms === void 0))
          return { mode: Z.match, terms: Z.terms };
      }
    }), v = b(() => o.config.search !== void 0 && o.config.search !== !1), m = b(() => u.value?.placeholder), p = Y(null), g = b(() => d.rows.value.length), y = js({
      getListEl: () => p.value,
      totalItems: g
    }), P = b(
      () => `min(16rem, ${Math.max(d.totalCount.value, 1) * y.ITEM_HEIGHT}px)`
    ), I = b(() => g.value > kf), w = b(() => {
      if (!I.value)
        return d.rows.value;
      const { startIndex: Z, endIndex: ie } = y.windowRange.value;
      return d.rows.value.slice(Z, ie);
    }), C = b(
      () => I.value ? y.listViewportStyle.value : void 0
    ), x = b(
      () => I.value ? { transform: y.listContentTransform.value, willChange: "transform" } : void 0
    ), O = () => {
      I.value && y.handleScroll();
    };
    oe([r, i], async () => {
      await ot(), y.resetScroll();
    }), oe(g, async (Z, ie) => {
      Z < ie && (await ot(), y.resetScroll());
    }), Zt(() => {
      y.cleanup();
    });
    const N = (Z) => {
      const ie = d.rows.value.findIndex(
        (Se) => (Se.tree.depth ?? 0) === 0 && Se.label.charAt(0).toUpperCase() === Z
      );
      ie < 0 || ae(ie);
    }, T = b(() => o.config.alphabetRail === !0), L = b(() => {
      const Z = /* @__PURE__ */ new Set();
      for (const ie of d.rows.value) {
        if ((ie.tree.depth ?? 0) !== 0)
          continue;
        const Se = ie.label.charAt(0).toUpperCase();
        Se >= "A" && Se <= "Z" && Z.add(Se);
      }
      return Z;
    });
    let k;
    const K = (Z) => {
      const ie = Z === void 0 ? "" : String(Z);
      s.value = ie;
      const Se = u.value?.debounceMs ?? 0;
      if (k !== void 0 && (clearTimeout(k), k = void 0), Se <= 0) {
        r.value = ie;
        return;
      }
      k = setTimeout(() => {
        k = void 0, r.value = ie;
      }, Se);
    };
    Zt(() => {
      k !== void 0 && clearTimeout(k);
    });
    const W = (Z, ie, Se, Oe) => {
      for (const M of Z)
        Oe.set(M.value, { node: M, depth: ie, parentKey: Se }), M.children && W(M.children, ie + 1, M.value, Oe);
      return Oe;
    }, G = b(
      () => W(o.config.options, 0, void 0, /* @__PURE__ */ new Map())
    ), A = b(
      () => (o.state.value ?? []).map((Z) => {
        const ie = G.value.get(Z), Se = ie?.node ?? { value: Z, label: String(Z) };
        return { key: Z, label: Se.label, node: Se, depth: ie?.depth ?? 0 };
      })
    ), E = b(() => {
      const Z = o.config.selectedPanel;
      return Z === !0 || typeof Z == "object" && Z !== null;
    }), D = b(
      () => typeof o.config.selectedPanel == "object" ? o.config.selectedPanel : void 0
    ), X = b(() => D.value?.removable ?? !0), z = b(() => D.value?.placement === "side"), Q = b(() => ({
      items: A.value,
      removable: X.value,
      emptyText: D.value?.emptyText,
      groupBy: D.value?.groupBy,
      getItemColor: D.value?.getItemColor,
      getItemBadge: D.value?.getItemBadge,
      getChipLabel: D.value?.getChipLabel,
      includeMode: o.includeMode,
      includeColor: D.value?.includeColor,
      excludeColor: D.value?.excludeColor,
      depthColors: D.value?.depthColors,
      depthVariants: D.value?.depthVariants
    })), ne = (Z) => {
      d.setSelectionKeys((o.state.value ?? []).filter((ie) => ie !== Z));
    }, ae = (Z) => {
      const ie = p.value;
      ie && (ie.scrollTop = Z * y.ITEM_HEIGHT);
    }, Ie = (Z) => {
      const ie = [];
      let Se = Z.parentKey;
      for (; Se !== void 0; )
        ie.unshift(Se), Se = G.value.get(Se)?.parentKey;
      return ie;
    }, ke = (Z) => {
      let ie = !1;
      for (const Se of Z) {
        const Oe = an(Se), M = d.rows.value.find((he) => he.nodeId === Oe);
        (!M || M.tree.expandable && !M.tree.expanded) && (d.toggleExpand(Oe), ie = !0);
      }
      return ie;
    }, $e = async (Z) => {
      const ie = G.value.get(Z);
      if (!ie)
        return;
      ie.depth > 0 && i.value && (i.value = !1, await ot()), ke(Ie(ie)) && await ot();
      const Oe = d.rows.value.findIndex((M) => M.nodeId === an(Z));
      Oe >= 0 && ae(Oe);
    }, He = b(() => {
      const Z = o.config.presets;
      return Z === void 0 ? [] : "items" in Z ? Z.items : Z;
    }), qe = b(() => {
      const Z = o.config.presets;
      return Z !== void 0 && "items" in Z ? Z.placement ?? "top" : "top";
    }), Ye = b(() => {
      const Z = o.config.presets;
      return Z !== void 0 && "items" in Z ? Z.heading : void 0;
    }), j = b(() => He.value.length > 0), q = (Z) => {
      const ie = Array.from(/* @__PURE__ */ new Set([...o.state.value ?? [], ...Z.keys]));
      d.setSelectionKeys(ie);
    }, J = b(
      () => j.value && qe.value === "side" || z.value && A.value.length > 0
    ), ee = b(() => {
      const Z = o.config.selectedCount;
      return Z === !0 || typeof Z == "object" && Z !== null;
    }), de = b(
      () => typeof o.config.selectedCount == "object" ? o.config.selectedCount : void 0
    ), ve = {
      get "select-all"() {
        return l("ui.treeControl.selectAll", "Select all");
      },
      get clear() {
        return l("ui.treeControl.clear", "Clear");
      },
      get "expand-all"() {
        return l("ui.treeControl.expandAll", "Expand all");
      },
      get "collapse-all"() {
        return l("ui.treeControl.collapseAll", "Collapse all");
      }
    }, me = (Z) => {
      switch (Z) {
        case "select-all":
          return {
            id: "select-all",
            label: ve["select-all"],
            disabled: d.rows.value.length === 0,
            onClick: d.selectAllVisible
          };
        case "clear":
          return {
            id: "clear",
            label: ve.clear,
            disabled: !d.hasSelection.value,
            onClick: d.clearSelection
          };
        case "expand-all":
          return {
            id: "expand-all",
            label: ve["expand-all"],
            disabled: !d.hasExpandable.value,
            onClick: d.expandAll
          };
        case "collapse-all":
          return {
            id: "collapse-all",
            label: ve["collapse-all"],
            disabled: !d.hasExpandable.value,
            onClick: d.collapseAll
          };
      }
    }, xe = b(() => {
      const Z = [];
      for (const ie of o.config.toolbar ?? [])
        if (typeof ie == "string") {
          if ((ie === "expand-all" || ie === "collapse-all") && (!d.hasExpandable.value || i.value))
            continue;
          Z.push(me(ie));
        } else
          Z.push({
            id: `custom:${ie.label}`,
            label: ie.label,
            disabled: ie.disabled,
            onClick: ie.onClick
          });
      return Z;
    }), Te = b(() => {
      const Z = o.config.flatToggle;
      return Z === !0 || typeof Z == "object" && Z !== null;
    }), We = b(
      () => typeof o.config.flatToggle == "object" ? o.config.flatToggle : void 0
    ), Le = b(
      () => i.value ? We.value?.flatLabel ?? l("ui.treeControl.showFlat", "Show flat") : We.value?.treeLabel ?? l("ui.treeControl.showTree", "Show tree")
    ), ht = () => {
      const Z = i.value;
      i.value = !Z, Z && d.expandAll();
    }, pt = b(() => xe.value.length > 0 || Te.value);
    return t({
      source: d,
      setQuery: K,
      onRemoveSelected: ne,
      onPreset: q,
      toolbarActions: xe,
      flat: i,
      toggleFlat: ht,
      flatToggleLabel: Le,
      availableLetters: L,
      onRailSelect: N
    }), (Z, ie) => (h(), R(yt, {
      class: "sc-tree-control",
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        v.value ? (h(), $("div", ff, [
          V(f(Ct), {
            "model-value": s.value,
            type: "text",
            placeholder: m.value,
            clearable: !0,
            disabled: e.state.disabled ?? !1,
            "onUpdate:modelValue": K
          }, null, 8, ["model-value", "placeholder", "disabled"])
        ])) : B("", !0),
        pt.value || Z.$slots["toolbar-prefix"] ? (h(), $("div", vf, [
          Z.$slots["toolbar-prefix"] ? (h(), $("div", mf, [
            pe(Z.$slots, "toolbar-prefix", {}, void 0, !0)
          ])) : B("", !0),
          be("div", hf, [
            V(sf, {
              actions: xe.value,
              disabled: e.state.disabled ?? !1
            }, null, 8, ["actions", "disabled"])
          ]),
          Te.value ? (h(), R(f(qn), {
            key: 1,
            "model-value": !i.value,
            size: "2",
            variant: i.value ? "soft" : "filled",
            color: i.value ? void 0 : "green",
            label: Le.value,
            "label-position": "left",
            disabled: e.state.disabled ?? !1,
            "onUpdate:modelValue": ie[0] || (ie[0] = (Se) => ht())
          }, null, 8, ["model-value", "variant", "color", "label", "disabled"])) : B("", !0)
        ])) : B("", !0),
        j.value && qe.value === "top" ? (h(), $("div", bf, [
          (h(!0), $(se, null, Pe(He.value, (Se) => (h(), R(f(we), {
            key: Se.label,
            variant: "outline",
            size: "1",
            disabled: e.state.disabled ?? !1,
            onClick: (Oe) => q(Se)
          }, {
            default: S(() => [
              H(U(Se.label), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))), 128))
        ])) : B("", !0),
        ee.value ? (h(), $("div", gf, [
          V(ur, {
            count: f(d).selectedCount.value,
            total: f(d).totalCount.value,
            format: de.value?.format,
            "show-total": de.value?.showTotal ?? !1,
            "always-visible": de.value?.alwaysVisible ?? !1
          }, null, 8, ["count", "total", "format", "show-total", "always-visible"])
        ])) : B("", !0),
        be("div", {
          class: Ke(["sc-tree-area", { "sc-tree-area--side": J.value }]),
          style: et({
            "--sc-tree-list-min-h": P.value,
            "--sc-tree-list-max-h": e.config.listMaxHeight ?? "16rem"
          })
        }, [
          be("div", {
            class: Ke(["sc-tree-body", { "sc-tree-body--rail": T.value }])
          }, [
            T.value ? (h(), R(f(Sa), {
              key: 0,
              class: "sc-tree-rail",
              direction: "vertical",
              "show-arrows": !1
            }, {
              default: S(() => [
                V(f(Us), {
                  class: "sc-tree-alphabet",
                  orientation: "vertical",
                  variant: "soft",
                  "active-variant": "filled",
                  "active-color": "blue",
                  "available-color": "blue",
                  "available-only": !0,
                  available: L.value,
                  size: "1",
                  onSelect: N
                }, null, 8, ["available"])
              ]),
              _: 1
            })) : B("", !0),
            be("div", {
              ref_key: "scrollEl",
              ref: p,
              class: "sc-tree-scroll hp-scrollbar",
              onScrollPassive: O
            }, [
              be("div", {
                class: "sc-tree-virtual",
                style: et(C.value)
              }, [
                be("div", {
                  class: "sc-tree-window",
                  style: et(x.value)
                }, [
                  V(df, {
                    rows: w.value,
                    "selection-state-map": f(d).selectionStateMap.value,
                    query: r.value,
                    disabled: e.state.disabled ?? !1,
                    "get-row-badge": e.config.getRowBadge,
                    "no-results-text": e.config.noResultsText,
                    "show-tree-connectors": !i.value && f(d).hasExpandable.value,
                    "include-mode": e.includeMode,
                    "onToggle:node": f(d).toggleNode,
                    "onToggle:expand": f(d).toggleExpand
                  }, null, 8, ["rows", "selection-state-map", "query", "disabled", "get-row-badge", "no-results-text", "show-tree-connectors", "include-mode", "onToggle:node", "onToggle:expand"])
                ], 4)
              ], 4)
            ], 544)
          ], 2),
          J.value ? (h(), $("div", yf, [
            j.value && qe.value === "side" ? (h(), $("div", pf, [
              Ye.value ? (h(), R(f(Me), {
                key: 0,
                size: "2",
                weight: "medium",
                variant: "soft"
              }, {
                default: S(() => [
                  H(U(Ye.value), 1)
                ]),
                _: 1
              })) : B("", !0),
              be("div", wf, [
                (h(!0), $(se, null, Pe(He.value, (Se) => (h(), R(f(we), {
                  key: Se.label,
                  variant: "outline",
                  size: "1",
                  disabled: e.state.disabled ?? !1,
                  onClick: (Oe) => q(Se)
                }, {
                  default: S(() => [
                    H(U(Se.label), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))), 128))
              ])
            ])) : B("", !0),
            E.value && z.value ? (h(), R(Bo, Ve({
              key: 1,
              class: "sc-tree-panel"
            }, Q.value, {
              onFocus: $e,
              onRemove: ne
            }), null, 16)) : B("", !0)
          ])) : B("", !0)
        ], 6),
        E.value && !z.value ? (h(), R(Bo, Ve({
          key: 4,
          class: "sc-tree-panel"
        }, Q.value, {
          onFocus: $e,
          onRemove: ne
        }), null, 16)) : B("", !0)
      ]),
      _: 3
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), Cf = /* @__PURE__ */ Ae(Sf, [["__scopeId", "data-v-d851fca1"]]), Lt = /* @__PURE__ */ ue({
  __name: "SmartControl",
  props: {
    config: {},
    state: {},
    includeMode: { type: Boolean },
    cell: { type: Boolean },
    alignInlineLabelToLabelled: { type: Boolean, default: !0 }
  },
  emits: ["update:value", "blur"],
  setup(e, { expose: t, emit: n }) {
    const l = n, o = Y(null);
    return t({ resetSearch: () => {
      o.value?.setQuery("");
    } }), (r, s) => e.config.shape === "composite" ? (h(), R(Tf, {
      key: 0,
      config: e.config,
      state: e.state,
      "onUpdate:value": s[0] || (s[0] = (i) => l("update:value", i)),
      onBlur: s[1] || (s[1] = (i) => l("blur"))
    }, null, 8, ["config", "state"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "text" ? (h(), R(Ed, {
      key: 1,
      config: e.config,
      state: e.state,
      cell: e.cell,
      "onUpdate:value": s[2] || (s[2] = (i) => l("update:value", i)),
      onBlur: s[3] || (s[3] = (i) => l("blur"))
    }, null, 8, ["config", "state", "cell"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "boolean" && e.config.view === "checkbox" ? (h(), R(gd, {
      key: 2,
      config: e.config,
      state: e.state,
      "align-to-labelled": e.alignInlineLabelToLabelled,
      "onUpdate:value": s[4] || (s[4] = (i) => l("update:value", i))
    }, null, 8, ["config", "state", "align-to-labelled"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "boolean" && e.config.view === "switch" ? (h(), R(Pd, {
      key: 3,
      config: e.config,
      state: e.state,
      "align-to-labelled": e.alignInlineLabelToLabelled,
      "onUpdate:value": s[5] || (s[5] = (i) => l("update:value", i))
    }, null, 8, ["config", "state", "align-to-labelled"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "number" ? (h(), R(Sd, {
      key: 4,
      config: e.config,
      state: e.state,
      cell: e.cell,
      "onUpdate:value": s[6] || (s[6] = (i) => l("update:value", i)),
      onBlur: s[7] || (s[7] = (i) => l("blur"))
    }, null, 8, ["config", "state", "cell"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "tags" ? (h(), R(Td, {
      key: 5,
      config: e.config,
      state: e.state,
      cell: e.cell,
      "onUpdate:value": s[8] || (s[8] = (i) => l("update:value", i)),
      onBlur: s[9] || (s[9] = (i) => l("blur"))
    }, null, 8, ["config", "state", "cell"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "multiline" ? (h(), R(kd, {
      key: 6,
      config: e.config,
      state: e.state,
      "onUpdate:value": s[10] || (s[10] = (i) => l("update:value", i)),
      onBlur: s[11] || (s[11] = (i) => l("blur"))
    }, null, 8, ["config", "state"])) : e.config.shape === "value" && e.config.source === "field" && e.config.kind === "date" ? (h(), R(yd, {
      key: 7,
      config: e.config,
      state: e.state,
      cell: e.cell,
      "onUpdate:value": s[12] || (s[12] = (i) => l("update:value", i))
    }, null, 8, ["config", "state", "cell"])) : e.config.shape === "value" && e.config.source === "list" ? (h(), R(Rd, {
      key: 8,
      config: e.config,
      state: e.state,
      cell: e.cell,
      "onUpdate:value": s[13] || (s[13] = (i) => l("update:value", i)),
      onBlur: s[14] || (s[14] = (i) => l("blur"))
    }, null, 8, ["config", "state", "cell"])) : e.config.shape === "value" && e.config.source === "tree" ? (h(), R(Cf, {
      key: 9,
      ref_key: "treeControlRef",
      ref: o,
      config: e.config,
      state: e.state,
      "include-mode": e.includeMode,
      "onUpdate:value": s[15] || (s[15] = (i) => l("update:value", i)),
      onBlur: s[16] || (s[16] = (i) => l("blur"))
    }, St({ _: 2 }, [
      r.$slots["toolbar-prefix"] ? {
        name: "toolbar-prefix",
        fn: S(() => [
          pe(r.$slots, "toolbar-prefix")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["config", "state", "include-mode"])) : B("", !0);
  }
}), If = {
  key: 0,
  class: "composite-control__separator",
  "aria-hidden": "true"
}, Rf = "row", Pf = /* @__PURE__ */ ue({
  __name: "CompositeControl",
  props: {
    config: {},
    state: {}
  },
  emits: ["update:value", "blur"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = b(() => n.config.layout ?? Rf), a = (s) => ({
      value: (n.state.value ?? {})[s.key] ?? null,
      disabled: n.state.disabled,
      readonly: n.state.readonly,
      // Part errors are intentionally suppressed: the composite owns all error chrome
      // at the composite level via `state.error`. Per-part error display would
      // require a part-error map from the caller — not warranted at this stage.
      error: void 0
    }), r = (s, i) => {
      l("update:value", { ...n.state.value ?? {}, [s]: i });
    };
    return (s, i) => (h(), R(yt, {
      label: e.config.label,
      "label-hint": e.config.labelHint,
      "label-badge": e.config.labelBadge,
      error: e.state.error,
      disabled: e.state.disabled,
      dirty: e.state.dirty
    }, {
      default: S(() => [
        be("div", {
          class: Ke(["composite-control", `composite-control--${o.value}`])
        }, [
          (h(!0), $(se, null, Pe(e.config.parts, (c, u) => (h(), $(se, {
            key: c.key
          }, [
            u > 0 && o.value === "row" && e.config.separator !== void 0 ? (h(), $("span", If, U(e.config.separator), 1)) : B("", !0),
            V(Lt, {
              config: c.config,
              state: a(c),
              "onUpdate:value": (d) => r(c.key, d),
              onBlur: i[0] || (i[0] = (d) => l("blur"))
            }, null, 8, ["config", "state", "onUpdate:value"])
          ], 64))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["label", "label-hint", "label-badge", "error", "disabled", "dirty"]));
  }
}), Tf = /* @__PURE__ */ Ae(Pf, [["__scopeId", "data-v-d191b385"]]), Ef = ["triggerLabel"], ft = (e, t, n) => {
  const l = sr(
    { key: t, config: e },
    n,
    Ef
  ), o = Mf(n);
  return o.badge !== void 0 && (l.badge = o.badge), l;
}, Mf = (e) => ({
  badge: e.badge
}), Bp = () => ({
  text: (e, t = {}) => ft(Ne.text(t), e, t),
  number: (e, t = {}) => ft(Ne.number(t), e, t),
  date: (e, t = {}) => ft(Ne.date(t), e, t),
  boolean: (e, t) => ft(Ne.boolean(t), e, t),
  tags: (e, t = {}) => ft(Ne.tags(t), e, t),
  multiline: (e, t = {}) => ft(Ne.multiline(t), e, t),
  select: {
    list: (e, t) => ft(gt.list(t), e, t),
    multi: (e, t) => ft(gt.multi(t), e, t),
    tree: (e, t) => ft(gt.tree(t), e, t)
  },
  composite: {
    range: (e, t = {}) => ft(qt.range(t), e, t),
    dateRange: (e, t = {}) => ft(qt.dateRange(t), e, t)
  }
}), jp = /* @__PURE__ */ ue({
  __name: "SmartControlField",
  props: /* @__PURE__ */ nn({
    config: {},
    schema: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    includeMode: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const n = e, l = Wn(e, "modelValue"), o = or({
      initialValue: void 0,
      schema: n.schema,
      disabled: () => n.disabled ?? !1,
      readonly: () => n.readonly ?? !1
    });
    return oe(
      l,
      (a) => {
        Object.is(a, o.state.value.value) || o.setValue(a);
      },
      { immediate: !0 }
    ), oe(
      () => o.state.value.value,
      (a) => {
        Object.is(a, l.value) || (l.value = a);
      }
    ), t({ controller: o }), (a, r) => (h(), R(Lt, {
      config: e.config,
      state: f(o).state.value,
      "include-mode": e.includeMode,
      "onUpdate:value": r[0] || (r[0] = (s) => f(o).setValue(s)),
      onBlur: f(o).blur
    }, null, 8, ["config", "state", "include-mode", "onBlur"]));
  }
}), Vf = {
  key: 0,
  class: "hp-smart-filter hp-smart-filter--inline"
}, xf = { class: "hp-smart-filter__content" }, Kf = {
  key: 0,
  class: "hp-smart-filter__header"
}, zf = {
  key: 1,
  class: "hp-smart-filter__footer"
}, Of = {
  key: 0,
  class: "hp-smart-filter__footer-meta"
}, Af = {
  key: 1,
  class: "hp-smart-filter__footer-actions"
}, Pl = /* @__PURE__ */ ue({
  __name: "SmartFilter",
  props: {
    config: {},
    disabled: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    includeMode: { type: Boolean, default: !0 },
    applyLabel: { default: void 0 },
    cancelLabel: { default: void 0 },
    includeLabel: { default: void 0 },
    excludeLabel: { default: void 0 },
    includeModeToggle: { type: Boolean, default: !0 },
    triggerLabel: { default: void 0 },
    title: { default: void 0 },
    immediate: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    popoverWidth: { default: void 0 },
    popoverMaxHeight: { default: void 0 },
    selectedCount: { type: Boolean, default: !1 },
    validateDraft: { type: Function, default: void 0 }
  },
  emits: ["update:modelValue", "update:includeMode", "apply", "cancel"],
  setup(e, { expose: t, emit: n }) {
    const l = e, o = Ce(), a = b(() => l.applyLabel ?? o("ui.common.apply", "Apply")), r = b(() => l.cancelLabel ?? o("ui.common.cancel", "Cancel")), s = b(() => l.includeLabel ?? o("ui.smartFilter.include", "Include")), i = b(() => l.excludeLabel ?? o("ui.smartFilter.exclude", "Exclude")), c = b(() => l.triggerLabel ?? o("ui.smartFilter.filter", "Filter")), u = n, d = Y(!1), v = Y(l.modelValue), m = Y(l.includeMode ?? !0);
    let p = !1;
    const g = Y(!1), y = Y(void 0), P = Y(null);
    oe(d, (A) => {
      if (A) {
        v.value = l.modelValue, m.value = l.includeMode ?? !0, p = !1, g.value = !1, y.value = void 0, P.value?.resetSearch(), document.addEventListener("keydown", K);
        return;
      }
      document.removeEventListener("keydown", K), p || u("cancel");
    }), oe(
      () => l.modelValue,
      (A) => {
        d.value && !g.value && (v.value = A);
      }
    ), oe(
      () => l.includeMode,
      (A) => {
        d.value && !g.value && (m.value = A ?? !0);
      }
    );
    const I = b(() => ({ value: v.value, error: y.value, disabled: l.disabled })), w = b(() => ({ value: l.modelValue, disabled: l.disabled })), C = b(() => Array.isArray(v.value) ? v.value.length : void 0), x = b(
      () => Array.isArray(v.value) ? v.value.length > 0 : v.value !== void 0 && v.value !== null && v.value !== ""
    ), O = b(() => {
      const A = [
        l.popoverWidth === void 0 ? void 0 : `hp-smart-filter--w-${l.popoverWidth}`,
        l.popoverMaxHeight === void 0 ? void 0 : `hp-smart-filter--max-h-${l.popoverMaxHeight}`
      ].filter(Boolean);
      return A.length > 0 ? A.join(" ") : void 0;
    }), N = b(() => l.config.shape === "value" && l.config.source === "tree"), T = (A) => {
      l.disabled || (u("update:modelValue", A), u("apply", { value: A, include: l.includeMode ?? !0 }));
    }, L = () => {
      if (l.disabled)
        return;
      const A = l.validateDraft?.(v.value);
      if (A !== void 0) {
        y.value = A;
        return;
      }
      y.value = void 0, u("update:modelValue", v.value), u("update:includeMode", m.value), u("apply", { value: v.value, include: m.value }), p = !0, d.value = !1;
    }, k = () => {
      d.value = !1;
    }, K = (A) => {
      if (!(A.key !== "Enter" || A.defaultPrevented || A.target?.tagName === "TEXTAREA" && !(A.ctrlKey || A.metaKey))) {
        if (A.preventDefault(), l.immediate) {
          p = !0, d.value = !1;
          return;
        }
        L();
      }
    }, W = (A) => {
      l.disabled || (v.value = A, g.value = !0, y.value = void 0, l.immediate && (u("update:modelValue", A), u("apply", { value: A, include: m.value })));
    }, G = (A) => {
      l.disabled || (m.value = A, g.value = !0, l.immediate && (u("update:includeMode", m.value), u("apply", { value: v.value, include: m.value })));
    };
    return Zt(() => {
      document.removeEventListener("keydown", K);
    }), t({ onApply: L, onCancel: k, open: d, draft: v, draftInclude: m, draftDirty: g }), (A, E) => e.inline ? (h(), $("div", Vf, [
      V(Lt, {
        config: e.config,
        state: w.value,
        "include-mode": e.includeMode,
        "onUpdate:value": T
      }, St({ _: 2 }, [
        A.$slots["toolbar-prefix"] ? {
          name: "toolbar-prefix",
          fn: S(() => [
            pe(A.$slots, "toolbar-prefix")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["config", "state", "include-mode"])
    ])) : (h(), R(f(Ca), {
      key: 1,
      type: "popover",
      open: d.value,
      "onUpdate:open": E[1] || (E[1] = (D) => d.value = D),
      "close-on-click-outside": !1,
      "close-on-escape": !0
    }, {
      default: S(() => [
        V(f(Ia), null, {
          default: S(({ toggle: D }) => [
            pe(A.$slots, "trigger", { toggle: D }, () => [
              V(f(we), {
                disabled: e.disabled,
                onClick: D
              }, {
                default: S(() => [
                  H(U(c.value), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 3
        }),
        V(f(Ra), {
          lazy: !1,
          class: Ke(O.value)
        }, {
          default: S(() => [
            be("div", xf, [
              e.title !== void 0 || A.$slots.header ? (h(), $("header", Kf, [
                pe(A.$slots, "header", {}, () => [
                  V(f(Me), {
                    size: "2",
                    weight: "medium"
                  }, {
                    default: S(() => [
                      H(U(e.title), 1)
                    ]),
                    _: 1
                  })
                ])
              ])) : B("", !0),
              be("div", {
                class: Ke(["hp-smart-filter__body hp-scrollbar", {
                  "hp-smart-filter__body--flush": N.value,
                  "hp-smart-filter__body--inset": !N.value
                }])
              }, [
                V(Lt, {
                  ref_key: "controlRef",
                  ref: P,
                  config: e.config,
                  state: I.value,
                  "include-mode": m.value,
                  "onUpdate:value": W
                }, St({ _: 2 }, [
                  A.$slots["toolbar-prefix"] ? {
                    name: "toolbar-prefix",
                    fn: S(() => [
                      pe(A.$slots, "toolbar-prefix")
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["config", "state", "include-mode"])
              ], 2),
              !e.immediate || e.includeModeToggle || e.selectedCount ? (h(), $("footer", zf, [
                e.includeModeToggle || e.selectedCount ? (h(), $("div", Of, [
                  e.includeModeToggle ? (h(), R(f(Va), {
                    key: 0,
                    disabled: e.disabled,
                    layout: "left",
                    size: "2",
                    exclude: !m.value,
                    empty: !x.value,
                    "include-label": s.value,
                    "exclude-label": i.value,
                    onToggle: E[0] || (E[0] = (D) => G(!m.value))
                  }, null, 8, ["disabled", "exclude", "empty", "include-label", "exclude-label"])) : B("", !0),
                  e.selectedCount && C.value !== void 0 ? (h(), R(f(Me), {
                    key: 1,
                    size: "2",
                    variant: "soft"
                  }, {
                    default: S(() => [
                      H(U(f(o)("ui.smartFilter.selectedCount", "Selected: {count}", { count: C.value })), 1)
                    ]),
                    _: 1
                  })) : B("", !0)
                ])) : B("", !0),
                e.immediate ? B("", !0) : (h(), $("div", Af, [
                  V(f(we), {
                    variant: "outline",
                    size: "3",
                    radius: "big",
                    onClick: k
                  }, {
                    default: S(() => [
                      H(U(r.value), 1)
                    ]),
                    _: 1
                  }),
                  V(f(we), {
                    variant: "filled",
                    size: "3",
                    radius: "big",
                    disabled: e.disabled || !g.value,
                    onClick: L
                  }, {
                    default: S(() => [
                      H(U(a.value), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              ])) : B("", !0)
            ])
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), $f = {
  key: 0,
  class: "hp-smart-filter-bar__extra-field"
}, Lf = {
  key: 1,
  class: "hp-smart-filter-bar"
}, Ff = /* @__PURE__ */ ue({
  __name: "SmartFilterBar",
  props: /* @__PURE__ */ nn({
    facets: {},
    modelValue: { default: () => ({}) },
    includeModes: { default: () => ({}) },
    immediate: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    clearAllLabel: { default: void 0 },
    clearButtonProps: {},
    layout: { default: "bar" },
    grid: {},
    containerResponsive: { type: Boolean, default: !1 },
    filtersLabel: { default: void 0 },
    showResponsiveToggle: { type: Boolean, default: !0 },
    commit: { default: "change" },
    applyLabel: { default: void 0 }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ nn(["update:modelValue", "update:includeModes", "apply", "apply-all", "draft-change", "clear-all"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = e, l = Ce(), o = b(() => n.applyLabel ?? l("ui.common.apply", "Apply")), a = b(() => n.clearAllLabel ?? l("ui.smartFilter.clearAll", "Clear all")), r = b(() => n.filtersLabel ?? l("ui.smartFilter.filters", "Filters")), s = t, i = Wn(e, "expanded"), c = `hp-smart-filter-bar-fields-${Ss()}`, u = (T) => n.modelValue[T], d = (T) => n.includeModes[T] ?? !0, v = (T) => Array.isArray(T) ? T.length > 0 : T != null && T !== "", m = (T) => {
      const L = u(T.key);
      return T.badge ? T.badge(L) : Array.isArray(L) && L.length > 0 ? L.length : void 0;
    }, p = b(() => n.layout === "inline" && n.commit === "apply"), g = Y({ ...n.modelValue }), y = Y({ ...n.includeModes }), P = Y(!1);
    oe(
      () => n.modelValue,
      (T) => {
        p.value && !P.value && (g.value = { ...T });
      }
    ), oe(
      () => n.includeModes,
      (T) => {
        p.value && !P.value && (y.value = { ...T });
      }
    ), oe(
      () => n.facets.map((T) => T.key),
      (T) => {
        if (!p.value)
          return;
        const L = (k) => T.includes(k);
        Object.keys(g.value).every(L) && Object.keys(y.value).every(L) || (g.value = Object.fromEntries(Object.entries(g.value).filter(([k]) => L(k))), y.value = Object.fromEntries(
          Object.entries(y.value).filter(([k]) => L(k))
        ));
      }
    );
    const I = (T) => p.value ? g.value[T] : u(T), w = (T) => p.value ? y.value[T] ?? !0 : d(T), C = b(
      () => p.value ? n.facets.some((T) => v(g.value[T.key])) : n.facets.some((T) => v(u(T.key)))
    ), x = (T, L) => {
      if (p.value) {
        g.value = { ...g.value, [T]: L.value }, y.value = { ...y.value, [T]: L.include }, P.value = !0, s("draft-change", { key: T, value: L.value, include: L.include });
        return;
      }
      s("update:modelValue", { ...n.modelValue, [T]: L.value }), s("update:includeModes", { ...n.includeModes, [T]: L.include }), s("apply", { key: T, value: L.value, include: L.include });
    }, O = () => {
      s("update:modelValue", {}), s("update:includeModes", {}), p.value && (g.value = {}, y.value = {}, P.value = !1), s("clear-all");
    }, N = () => {
      s("apply-all", { value: { ...g.value }, includeModes: { ...y.value } }), P.value = !1;
    };
    return (T, L) => e.layout === "inline" ? (h(), $("div", {
      key: 0,
      class: Ke(["hp-smart-filter-bar hp-smart-filter-bar--inline", {
        "hp-smart-filter-bar--container-responsive": e.containerResponsive,
        "hp-smart-filter-bar--self-collapsing": e.containerResponsive && e.showResponsiveToggle,
        "hp-smart-filter-bar--expanded": e.containerResponsive && i.value
      }])
    }, [
      e.containerResponsive && e.showResponsiveToggle ? (h(), R(f(we), {
        key: 0,
        class: "hp-smart-filter-bar__mobile-toggle",
        size: "2",
        variant: "outline",
        "aria-expanded": i.value,
        "aria-controls": c,
        onClick: L[0] || (L[0] = (k) => i.value = !i.value)
      }, {
        default: S(() => [
          H(U(r.value), 1)
        ]),
        _: 1
      }, 8, ["aria-expanded"])) : B("", !0),
      (h(), R(lt(e.grid ? f(Hs) : "div"), Ve({ id: c }, e.grid, {
        class: e.grid ? "hp-smart-filter-bar__grid" : "hp-smart-filter-bar__fields"
      }), {
        default: S(() => [
          (h(!0), $(se, null, Pe(e.facets, (k) => (h(), $("div", {
            key: k.key,
            class: "hp-smart-filter-bar__field",
            style: et({ "--sfb-field-width": e.grid ? "100%" : k.width })
          }, [
            V(f(xa), { class: "hp-smart-filter-bar__label" }, {
              default: S(() => [
                H(U(k.triggerLabel ?? k.key) + " ", 1),
                k.config.labelBadge ? (h(), R(f(Zn), {
                  key: 0,
                  badge: k.config.labelBadge
                }, null, 8, ["badge"])) : B("", !0),
                k.labelHint ? (h(), R(f(pl), {
                  key: 1,
                  size: "1",
                  "popover-size": "1",
                  content: k.labelHint
                }, null, 8, ["content"])) : B("", !0)
              ]),
              _: 2
            }, 1024),
            V(Pl, {
              inline: "",
              config: k.config,
              "model-value": I(k.key),
              "include-mode": w(k.key),
              onApply: (K) => x(k.key, K)
            }, null, 8, ["config", "model-value", "include-mode", "onApply"])
          ], 4))), 128)),
          be("div", {
            class: Ke(["hp-smart-filter-bar__actions", { "hp-smart-filter-bar__actions--grid": e.grid }])
          }, [
            e.clearable ? (h(), R(f(we), Ve({
              key: 0,
              class: "hp-smart-filter-bar__clear-all",
              size: "3",
              radius: "big",
              variant: "soft"
            }, e.clearButtonProps, {
              disabled: !C.value,
              onClick: O
            }), {
              default: S(() => [
                H(U(a.value), 1)
              ]),
              _: 1
            }, 16, ["disabled"])) : B("", !0),
            e.commit === "apply" ? (h(), R(f(we), {
              key: 1,
              class: "hp-smart-filter-bar__apply-all",
              size: e.clearButtonProps?.size ?? "3",
              radius: e.clearButtonProps?.radius ?? "big",
              variant: "filled",
              disabled: !P.value,
              onClick: N
            }, {
              default: S(() => [
                H(U(o.value), 1)
              ]),
              _: 1
            }, 8, ["size", "radius", "disabled"])) : B("", !0)
          ], 2),
          T.$slots["fields-end"] ? (h(), $("div", $f, [
            pe(T.$slots, "fields-end", {}, void 0, !0)
          ])) : B("", !0)
        ]),
        _: 3
      }, 16, ["class"]))
    ], 2)) : (h(), $("div", Lf, [
      (h(!0), $(se, null, Pe(e.facets, (k) => (h(), R(Pl, {
        key: k.key,
        config: k.config,
        "model-value": u(k.key),
        "include-mode": d(k.key),
        immediate: e.immediate,
        onApply: (K) => x(k.key, K)
      }, {
        trigger: S(({ toggle: K }) => [
          V(f(we), {
            class: "hp-smart-filter-bar__trigger",
            size: "2",
            variant: "soft",
            onClick: K
          }, {
            default: S(() => [
              H(U(k.triggerLabel ?? k.key) + " ", 1),
              m(k) !== void 0 ? (h(), R(f(Xe), {
                key: 0,
                size: "1",
                variant: "soft"
              }, {
                default: S(() => [
                  H(U(m(k)), 1)
                ]),
                _: 2
              }, 1024)) : B("", !0)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 2
      }, 1032, ["config", "model-value", "include-mode", "immediate", "onApply"]))), 128)),
      e.clearable ? (h(), R(f(we), Ve({
        key: 0,
        class: "hp-smart-filter-bar__clear-all",
        size: "2",
        variant: "soft"
      }, e.clearButtonProps, {
        disabled: !C.value,
        onClick: O
      }), {
        default: S(() => [
          H(U(a.value), 1)
        ]),
        _: 1
      }, 16, ["disabled"])) : B("", !0)
    ]));
  }
}), Up = /* @__PURE__ */ Ae(Ff, [["__scopeId", "data-v-167c8d8f"]]), Df = (e, t) => {
  const n = t.trim().toLocaleLowerCase();
  return n ? e.filter((l) => l.label.toLocaleLowerCase().includes(n)) : e;
}, Nf = {
  key: 0,
  class: "hp-smart-selection-drawer__list"
}, Bf = {
  key: 1,
  class: "hp-smart-selection-drawer__empty"
}, Hp = /* @__PURE__ */ ue({
  name: "SmartSelectionDrawer",
  __name: "SmartSelectionDrawer",
  props: /* @__PURE__ */ nn({
    title: {},
    items: {}
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const t = Ce(), n = e, l = Wn(e, "open"), o = Y(""), a = b(() => Df(n.items, o.value));
    return oe(l, (r) => {
      r || (o.value = "");
    }), (r, s) => (h(), R(f(un), {
      open: l.value,
      "onUpdate:open": s[1] || (s[1] = (i) => l.value = i),
      class: "hp-smart-selection-drawer",
      size: "2",
      "close-on-backdrop": !0,
      "show-close": !1
    }, {
      default: S(() => [
        V(f(cn), null, {
          default: S(() => [
            V(f(dn), null, {
              default: S(() => [
                H(U(e.title), 1)
              ]),
              _: 1
            }),
            V(f(Xe), {
              variant: "soft",
              size: "2",
              radius: "full"
            }, {
              default: S(() => [
                H(U(e.items.length), 1)
              ]),
              _: 1
            }),
            V(f(Ka))
          ]),
          _: 1
        }),
        V(f(It), { padded: "" }, {
          default: S(() => [
            V(f(Ct), {
              modelValue: o.value,
              "onUpdate:modelValue": s[0] || (s[0] = (i) => o.value = i),
              class: "hp-smart-selection-drawer__search",
              size: "2",
              type: "search",
              placeholder: f(t)("ui.smartControl.searchSelectedItems", "Search selected items"),
              "aria-label": f(t)("ui.smartControl.searchSelectedItems", "Search selected items"),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder", "aria-label"]),
            a.value.length ? (h(), $("div", Nf, [
              (h(!0), $(se, null, Pe(a.value, (i) => (h(), R(f(Mt), {
                key: i.key,
                size: "4",
                truncate: "",
                "max-width": "100%",
                title: i.label
              }, {
                default: S(() => [
                  H(U(i.label), 1)
                ]),
                _: 2
              }, 1032, ["title"]))), 128))
            ])) : (h(), $("div", Bf, U(f(t)("ui.smartControl.noSelectedItemsFound", "No selected items found")), 1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), Tl = (e) => Array.isArray(e) ? e.length > 0 : e != null && e !== "", jf = (e) => {
  const t = Y(_(e.modelValue) ?? {}), n = Y(_(e.includeModes) ?? {});
  oe(
    () => _(e.modelValue),
    (y) => {
      y !== void 0 && (t.value = y);
    }
  ), oe(
    () => _(e.includeModes),
    (y) => {
      y !== void 0 && (n.value = y);
    }
  );
  const l = b(() => _(e.facets)), o = b(() => {
    const y = {};
    for (const [P, I] of Object.entries(t.value))
      Tl(I) && (y[P] = I);
    return y;
  }), a = b(
    () => Object.keys(o.value)
  ), r = b(() => a.value.length > 0), s = (y) => t.value[y];
  return {
    facets: l,
    value: t,
    includeModes: n,
    normalizedValue: o,
    activeKeys: a,
    hasActiveFilters: r,
    isActive: (y) => Tl(s(y)),
    valueFor: s,
    includeFor: (y) => n.value[y] ?? !0,
    handleFacetApply: (y) => {
      const P = y.key;
      t.value = { ...t.value, [P]: y.value }, n.value = { ...n.value, [P]: y.include }, e.onChange?.(t.value, n.value), e.onApply?.(y);
    },
    handleApplyAll: (y) => {
      t.value = y.value, n.value = y.includeModes, e.onChange?.(t.value, n.value);
    },
    handleClearAll: () => {
      t.value = {}, n.value = {}, e.onChange?.(t.value, n.value), e.onClearAll?.();
    },
    setValue: (y, P) => {
      t.value = { ...t.value, [y]: P }, e.onChange?.(t.value, n.value);
    },
    setIncludeMode: (y, P) => {
      n.value = { ...n.value, [y]: P }, e.onChange?.(t.value, n.value);
    },
    reset: () => {
      t.value = {}, n.value = {}, e.onChange?.(t.value, n.value);
    }
  };
}, Wp = (e) => {
  const t = Y(_(e.modelValue)), n = Y(_(e.includeMode) ?? !0);
  oe(
    () => _(e.modelValue),
    (u) => {
      u !== void 0 && (t.value = u);
    }
  ), oe(
    () => _(e.includeMode),
    (u) => {
      u !== void 0 && (n.value = u);
    }
  );
  const l = b(() => _(e.config)), o = b(() => Tl(t.value)), a = b(() => ({
    value: t.value,
    include: n.value
  }));
  return {
    config: l,
    value: t,
    includeMode: n,
    isActive: o,
    applyPayload: a,
    handleApply: (u) => {
      t.value = u.value, n.value = u.include, e.onChange?.(u.value, u.include), e.onApply?.(u);
    },
    setValue: (u) => {
      t.value = u, e.onChange?.(u, n.value);
    },
    setIncludeMode: (u) => {
      n.value = u, e.onChange?.(t.value, u);
    },
    clear: () => {
      t.value = void 0, e.onClear?.();
    }
  };
}, Hl = (e) => Vl({
  defaultValues: e.defaultValues,
  // StandardSchemaV1<TFormData, TFormData> | undefined is the correct narrower type, but
  // TanStack's useForm() expects the 12-generic FormValidators shape which is structurally
  // incompatible with the StandardSchemaV1 interface (Zod .readonly() schemas widen the
  // Output type parameter). `as never` is the minimal suppression — see JSDoc above.
  validators: e.validators,
  ...e.validationLogic ? { validationLogic: e.validationLogic } : {}
  // Bridge: TanStack's 12-generic FormApi -> SmartFormApi alias; see JSDoc above.
}), Zp = (e) => {
  const { discriminator: t, label: n, options: l, variants: o, shared: a } = e, r = {
    key: t,
    label: n ?? t,
    ...gt.list({ options: l })
  }, s = [];
  for (const i of l)
    for (const c of o[i.value] ?? []) {
      const u = c.hiddenWhen;
      s.push({
        ...c,
        hiddenWhen: (d) => d[t] !== i.value || (u?.(d) ?? !1)
      });
    }
  return [r, ...a ?? [], ...s];
}, sl = (e) => e, Uf = ["label", "colSpan", "startsRow", "readonly"], vt = (e, t, n) => {
  const l = Hf(n), o = Yn(st({ key: t }, e), n, Uf);
  return l.disabledWhen !== void 0 && (o.disabledWhen = sl(l.disabledWhen)), l.hiddenWhen !== void 0 && (o.hiddenWhen = sl(l.hiddenWhen)), l.highlightWhen !== void 0 && (o.highlightWhen = sl(l.highlightWhen)), o;
}, Hf = (e) => ({
  disabledWhen: e.disabledWhen,
  hiddenWhen: e.hiddenWhen,
  highlightWhen: e.highlightWhen
}), qp = () => ({
  text: (e, t = {}) => vt(Ne.text(t), e, t),
  number: (e, t = {}) => vt(Ne.number(t), e, t),
  date: (e, t = {}) => vt(Ne.date(t), e, t),
  boolean: (e, t) => vt(Ne.boolean(t), e, t),
  tags: (e, t = {}) => vt(Ne.tags(t), e, t),
  multiline: (e, t = {}) => vt(Ne.multiline(t), e, t),
  select: {
    list: (e, t) => vt(gt.list(t), e, t),
    multi: (e, t) => vt(gt.multi(t), e, t),
    tree: (e, t) => vt(gt.tree(t), e, t)
  },
  composite: {
    range: (e, t = {}) => vt(qt.range(t), e, t),
    dateRange: (e, t = {}) => vt(qt.dateRange(t), e, t)
  }
}), Jp = (e, t) => {
  const n = e.parseValuesWithSchema(t);
  if (!n)
    return [];
  const l = (n.form ?? {})[""];
  return l ? l.flatMap((o) => o?.message ? [o.message] : []) : [];
}, fr = (e) => e === !0 || e === "bordered" ? "hp-smart-layout--card" : e === "borderless" ? "hp-smart-layout--card-no-border" : "", Wf = /* @__PURE__ */ ue({
  __name: "SmartFormField",
  props: {
    form: {},
    field: {},
    formDisabled: { type: Boolean },
    alignInlineLabelToLabelled: { type: Boolean },
    dirtyIndicator: { type: Boolean }
  },
  setup(e) {
    const t = e, n = t.form.useStore((d) => d.values), l = b(
      () => typeof t.field.hiddenWhen == "function" ? t.field.hiddenWhen(n.value) : !1
    ), o = b(
      () => t.formDisabled === !0 || (typeof t.field.disabledWhen == "function" ? t.field.disabledWhen(n.value) : t.field.disabled ?? !1)
    ), a = b(() => t.field.readonly ?? !1), r = b(
      () => typeof t.field.highlightWhen == "function" ? t.field.highlightWhen(n.value) : !1
    ), s = Li({
      form: t.form,
      name: t.field.key,
      disabled: () => o.value,
      readonly: () => a.value
    }), i = b(() => t.dirtyIndicator === !0 && (s.state.value.dirty ?? !1)), c = b(() => ({
      ...s.state.value,
      highlighted: r.value,
      dirty: i.value
    })), u = b(() => ({
      field: t.field,
      value: s.state.value.value,
      error: s.state.value.error,
      disabled: o.value,
      readonly: a.value,
      dirty: i.value,
      setValue: s.setValue,
      blur: s.blur
    }));
    return (d, v) => l.value ? B("", !0) : pe(d.$slots, "default", Ge(Ve({ key: 0 }, u.value)), () => [
      V(Lt, {
        config: e.field,
        state: c.value,
        "align-inline-label-to-labelled": e.alignInlineLabelToLabelled,
        "onUpdate:value": f(s).setValue,
        onBlur: f(s).blur
      }, null, 8, ["config", "state", "align-inline-label-to-labelled", "onUpdate:value", "onBlur"])
    ]);
  }
}), Zf = /* @__PURE__ */ ue({
  __name: "SmartForm",
  props: {
    form: {},
    fields: {},
    columns: { default: 1 },
    minColumnWidth: { default: "300px" },
    maxColumnWidth: { default: void 0 },
    columnGap: { default: "var(--space-4, 16px)" },
    rowGap: { default: "var(--space-4, 16px)" },
    errorsBanner: { type: Boolean, default: !1 },
    formErrors: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    card: { type: [Boolean, String], default: !1 },
    showClose: { type: Boolean, default: !1 },
    headerPaddingY: {},
    headerPaddingX: {},
    actions: { type: [Object, Boolean] },
    alert: {},
    stickyHeader: { type: [Object, Boolean] },
    readonly: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    noBodyPadding: { type: Boolean, default: !1 },
    layout: { default: "grid" },
    dirtyIndicator: { type: Boolean, default: !1 }
  },
  emits: ["submit", "cancel", "close"],
  setup(e, { emit: t }) {
    const n = e, l = t, o = xl(), a = b(() => ({
      display: "grid",
      // A SmartForm can live in a card stretched to match a taller sibling. Keep
      // the field rows packed at the top instead of distributing the extra card
      // height into large gaps between controls.
      alignContent: "start",
      gridTemplateColumns: n.columns === "auto" ? `repeat(auto-fit, minmax(min(100%, ${n.minColumnWidth}), ${n.maxColumnWidth ?? "1fr"}))` : `repeat(${n.columns}, minmax(0, 1fr))`,
      justifyContent: n.columns === "auto" && n.maxColumnWidth !== void 0 ? "start" : void 0,
      columnGap: n.columnGap,
      rowGap: n.rowGap
    })), r = (T) => {
      const L = T.colSpan !== void 0 && T.colSpan > 1 ? `span ${T.colSpan}` : void 0, k = T.startsRow === !0;
      return L && k ? { gridColumn: `1 / ${L}` } : L ? { gridColumn: L } : k ? { gridColumn: "1" } : void 0;
    }, s = (T) => T.shape === "value" && T.source === "field" && T.kind === "boolean" && (T.view === "switch" || T.view === "checkbox"), i = n.form.useStore((T) => T.values), c = b(
      () => n.fields.filter((T) => typeof T.hiddenWhen != "function" || !T.hiddenWhen(i.value))
    ), u = b(
      () => c.value.some((T) => !s(T))
    ), d = b(() => n.formErrors ?? []), v = b(() => fr(n.card)), m = async () => {
      if ((await n.form.validateAllFields("submit")).some((W) => W == null ? !1 : Array.isArray(W) ? W.length > 0 : !0))
        return;
      const k = await n.form.validate("submit");
      Object.values(k).some(
        (W) => W !== void 0 && Object.values(W).some((G) => G != null && G !== "")
      ) || d.value.length > 0 || l("submit", n.form.state.values);
    }, p = b(() => {
      if (!(n.actions === void 0 || n.actions === !1))
        return n.actions === !0 ? {} : n.actions;
    }), g = b(() => p.value !== void 0), y = n.form.useStore((T) => T.isDirty), P = n.form.useStore((T) => T.isValid), I = Ws(
      {
        isDirty: y,
        isValid: P,
        isSubmitting: !1,
        onSubmit: () => {
          m();
        },
        onCancel: () => {
          l("cancel");
        }
      },
      () => p.value ?? {}
    ), w = b(() => n.errorsBanner !== !1), C = Zs({
      errors: () => d.value
    }), x = qs({ alert: () => n.alert ?? null }), O = (T) => {
      if (!(T === !1 || T === void 0))
        return T === !0 ? { sticky: !0 } : {
          sticky: T.enabled !== !1,
          style: T.topOffset !== void 0 ? { top: T.topOffset } : void 0
        };
    }, N = b(() => O(n.stickyHeader));
    return (T, L) => (h(), $("form", {
      class: Ke(["smart-form-wrapper", { "smart-form-wrapper--inline": e.layout === "inline" }]),
      novalidate: "",
      onSubmit: tt(m, ["prevent"])
    }, [
      V(f(zl), {
        "layout-id": `smart-form-${T.$.uid}`,
        tone: "surface",
        "template-columns": "minmax(0, 1fr)",
        class: Ke(v.value)
      }, {
        default: S(() => [
          T.$slots.header ? (h(), R(f(Ol), {
            key: 0,
            "padding-x": e.headerPaddingX,
            "padding-y": e.headerPaddingY,
            "bottom-border": "",
            "show-close": e.showClose,
            sticky: N.value?.sticky,
            style: et(N.value?.style),
            onClose: L[0] || (L[0] = (k) => l("close"))
          }, {
            default: S(() => [
              pe(T.$slots, "header", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["padding-x", "padding-y", "show-close", "sticky", "style"])) : B("", !0),
          f(x).visible.value || T.$slots.alert ? (h(), R(f(za), { key: 1 }, {
            default: S(() => [
              T.$slots.alert ? pe(T.$slots, "alert", {
                key: 0,
                alert: f(x).alert.value
              }, void 0, !0) : (h(), R(f(Js), {
                key: 1,
                api: f(x)
              }, null, 8, ["api"]))
            ]),
            _: 3
          })) : B("", !0),
          V(f(Oa), {
            "padding-x": e.noBodyPadding ? void 0 : "3",
            "padding-y": e.noBodyPadding ? void 0 : "3"
          }, {
            default: S(() => [
              T.$slots["form-errors-prepend"] && d.value.length > 0 ? pe(T.$slots, "form-errors-prepend", {
                key: 0,
                errors: d.value
              }, void 0, !0) : B("", !0),
              w.value ? (h(), R(f(Gs), {
                key: 1,
                api: f(C)
              }, null, 8, ["api"])) : B("", !0),
              T.$slots["form-errors-append"] && d.value.length > 0 ? pe(T.$slots, "form-errors-append", {
                key: 2,
                errors: d.value
              }, void 0, !0) : B("", !0),
              be("div", {
                class: "smart-form",
                style: et(a.value)
              }, [
                (h(!0), $(se, null, Pe(c.value, (k) => (h(), $("div", {
                  key: k.key,
                  class: Ke(["smart-form__item", { "smart-form__item--align-end": s(k) }]),
                  style: et(r(k))
                }, [
                  V(Wf, {
                    form: e.form,
                    field: k,
                    "form-disabled": e.disabled,
                    "dirty-indicator": e.dirtyIndicator,
                    "align-inline-label-to-labelled": u.value
                  }, St({ _: 2 }, [
                    f(o)[`field-${k.key}`] ? {
                      name: "default",
                      fn: S((K) => [
                        pe(T.$slots, `field-${k.key}`, Ve({ ref_for: !0 }, K), void 0, !0)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["form", "field", "form-disabled", "dirty-indicator", "align-inline-label-to-labelled"])
                ], 6))), 128))
              ], 4)
            ]),
            _: 3
          }, 8, ["padding-x", "padding-y"]),
          g.value || T.$slots["actions-prepend"] || T.$slots["actions-append"] ? (h(), R(f(Al), {
            key: 2,
            "padding-x": "3",
            "padding-y": "2",
            "top-border": ""
          }, {
            default: S(() => [
              T.$slots["actions-prepend"] ? pe(T.$slots, "actions-prepend", { key: 0 }, void 0, !0) : B("", !0),
              g.value ? (h(), R(f(_s), {
                key: 1,
                api: f(I)
              }, null, 8, ["api"])) : B("", !0),
              T.$slots["actions-append"] ? pe(T.$slots, "actions-append", { key: 2 }, void 0, !0) : B("", !0)
            ]),
            _: 3
          })) : B("", !0)
        ]),
        _: 3
      }, 8, ["layout-id", "class"])
    ], 34));
  }
}), Wl = /* @__PURE__ */ Ae(Zf, [["__scopeId", "data-v-d8ecb075"]]), qf = /* @__PURE__ */ ue({
  __name: "SmartFormDialogBody",
  props: {
    form: {},
    fields: {},
    isLoading: { type: Boolean, default: !1 },
    error: { default: void 0 },
    errorColor: { default: void 0 },
    autofocusFirstField: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = b(() => {
      const a = _(t.error);
      return typeof a == "string" ? a : void 0;
    }), l = b(() => _(t.errorColor) ?? "red"), o = Cs("bodyRef");
    return Kl(async () => {
      if (!t.autofocusFirstField)
        return;
      await ot();
      const a = o.value;
      if (!a)
        return;
      const r = a.querySelector(
        'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])'
      );
      r && (r.focus(), "select" in r && typeof r.select == "function" && r.select());
    }), (a, r) => (h(), R(f(It), { padded: "" }, {
      default: S(() => [
        be("div", {
          ref_key: "bodyRef",
          ref: o
        }, [
          n.value ? (h(), R(f(Aa), {
            key: 0,
            variant: "soft",
            color: l.value,
            title: n.value,
            size: "1",
            "show-icon": !1,
            "show-close": !1,
            class: "mb-3"
          }, null, 8, ["color", "title"])) : B("", !0),
          V(Wl, {
            form: e.form,
            fields: e.fields,
            disabled: e.isLoading
          }, null, 8, ["form", "fields", "disabled"])
        ], 512)
      ]),
      _: 1
    }));
  }
}), Jf = (e, t) => {
  let n = null;
  const l = t.fields, o = ue({
    name: "BulkFormDialogBody",
    emits: ["update:confirm-close"],
    setup(a, { emit: r }) {
      const s = Vl({
        defaultValues: t.initialValues,
        // `onDynamic` + `revalidateLogic()` (defaults: mode='submit',
        // modeAfterSubmission='change') defers validation until the first
        // submit attempt — no error surfaces just from picking/typing a field
        // value — then revalidates live as the user edits, so a fixed field
        // clears its error without requiring another submit click. `as never`
        // mirrors createSmartForm — Zod's StandardSchema generics don't align
        // structurally with TanStack's 12-generic FormValidators shape.
        ...t.schema ? { validators: { onDynamic: t.schema }, validationLogic: ka() } : {},
        // Run the consumer's submit on the form's native onSubmit so handleSubmit
        // invokes it ONLY when validation passes; a throw here (server/mutation
        // failure) is rethrown by handleSubmit and surfaces as the dialog toast.
        onSubmit: ({ value: c }) => t.onSubmit(c)
      }), i = s;
      return n = i, oe(
        s.useStore((c) => c.isDirty),
        (c) => {
          r("update:confirm-close", c);
        }
      ), () => {
        const c = [];
        return t.previewBody && c.push(ll(t.previewBody, t.previewProps ?? {})), c.push(
          ll(Wl, {
            form: i,
            fields: l
          })
        ), c.length === 1 ? c[0] : ll("div", c);
      };
    }
  });
  return e({
    title: t.title,
    count: t.count,
    body: o,
    getResult: () => n?.state.values ?? t.initialValues,
    actions: [
      { label: t.cancelLabel ?? Ce()("ui.common.cancel", "Cancel"), role: "cancel" },
      {
        label: t.submitLabel ?? Ce()("ui.smartForm.submit", "Submit"),
        color: t.submitColor,
        variant: "filled",
        handler: async (a, r) => {
          if (!n) {
            r.keepOpen();
            return;
          }
          await n.handleSubmit(), n.state.isSubmitSuccessful || r.keepOpen();
        }
      }
    ],
    size: t.size,
    bodyPadded: t.bodyPadded,
    ...t.overrides
  });
}, Gf = (e) => (t) => Jf(e, t), Gp = () => {
  const e = Ys();
  return Gf(e);
}, il = () => Ce()("ui.smartForm.validationHint", "Check the highlighted fields below and try again."), _f = (e) => e !== void 0 && Object.values(e).some((t) => t != null && t !== ""), Yf = (e) => ({
  setFieldError: (t, n) => {
    e.setFieldMeta(t, (l) => ({
      ...l,
      errorMap: { ...l.errorMap, onSubmit: n },
      errors: [n],
      isTouched: !0
    }));
  }
}), Qf = (e) => async (t) => {
  const n = Hl({
    defaultValues: t.defaultValues,
    // `onDynamic` + `revalidateLogic()` (defaults: mode='submit',
    // modeAfterSubmission='change') defers validation until the first
    // submit attempt — no error surfaces just from picking/typing a field
    // value — then revalidates live as the user edits, so a fixed field
    // clears its error without requiring another submit click.
    validators: { onDynamic: t.schema },
    validationLogic: ka()
  });
  let l = null;
  const o = Yf(n);
  return await e({
    title: t.title,
    size: t.size,
    body: co(qf),
    bodyProps: {
      form: n,
      fields: t.fields
    },
    footer: co(Qs),
    footerProps: { submitText: t.submitText ?? Ce()("ui.smartForm.submit", "Submit") },
    errorToString: t.errorToString,
    errorToColor: t.errorToColor,
    onSubmit: async () => {
      if ((await n.validateAllFields("submit")).some((u) => u != null && (Array.isArray(u) ? u.length > 0 : !0)))
        throw new Error(il());
      const i = await n.validate("submit");
      if (Object.values(i).some(_f))
        throw new Error(il());
      try {
        l = t.schema.parse(n.state.values);
      } catch {
        throw new Error(il());
      }
      try {
        await t.onSubmit(l);
      } catch (u) {
        throw t.onSubmitError?.(u, o), u;
      }
    }
  }) ? l : null;
}, _p = () => Qf(Xs()), pn = 3600 * 1e3, Xf = 60 * 1e3, ev = 60, tv = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], nv = /^([+-])(\d{2}):(\d{2})$/, lv = (e) => {
  const t = new Date(e), n = tv[t.getMonth()] ?? "", l = String(t.getHours()).padStart(2, "0");
  return `${String(t.getDate())} ${n} ${l}:00`;
}, ov = (e) => {
  const t = nv.exec(e);
  return t === null ? 0 : (t[1] === "-" ? -1 : 1) * (Number(t[2]) * ev + Number(t[3]));
}, av = (e) => {
  const t = e[0], n = e.at(-1);
  if (t === void 0 || n === void 0)
    return [];
  const l = e.length > 1 ? (e[1]?.start ?? t.start + pn) - t.start : pn, o = n.start + Math.max(l, pn), a = [];
  for (let r = t.start; r < o; r += pn)
    a.push({ key: `schedule-${String(r)}`, label: lv(r), start: r });
  return a;
}, rv = (e) => new Map(e.days.map(({ day: t, hours: n }) => [t, new Set(n)])), sv = (e, t) => {
  if (e === void 0)
    return t.map(() => !0);
  const n = rv(e), l = ov(e.timezone) * Xf;
  return t.map(({ start: o }) => {
    const a = new Date(o + l);
    return n.get(a.getUTCDay())?.has(a.getUTCHours()) ?? !1;
  });
}, Yp = (e) => {
  const t = b(() => e.catalog()), n = b(() => av(e.referenceBuckets())), l = mt(/* @__PURE__ */ new Set()), o = Y(), a = b(
    () => t.value.targets.map((i) => ({
      id: i.id,
      label: i.label,
      values: sv(i.schedule, n.value)
    }))
  ), r = (i) => {
    const c = new Set(l.value);
    c.has(i) ? c.delete(i) : c.add(i), l.value = c;
  }, s = (i) => {
    o.value = i;
  };
  return {
    buckets: n,
    lanes: a,
    disabledLaneIds: b(() => l.value),
    toggleLane: r,
    hover: o,
    setHover: s
  };
}, Qp = (e) => e, iv = { class: "hp-smart-cell-badge-list d-inline-flex flex-wrap items-center gap-1" }, jo = /* @__PURE__ */ ue({
  __name: "SmartBadgeListCell",
  props: {
    items: {},
    size: {},
    maxVisible: {}
  },
  setup(e) {
    const t = e, n = b(() => t.items ?? []), l = b(() => t.maxVisible ?? n.value.length), o = b(() => n.value.slice(0, l.value)), a = b(() => Math.max(0, n.value.length - l.value)), r = b(
      () => n.value.slice(l.value).map((s) => s.label).join(", ")
    );
    return (s, i) => (h(), $("span", iv, [
      (h(!0), $(se, null, Pe(o.value, (c, u) => (h(), R(f(Mt), {
        key: `${String(c.value ?? c.label)}:${u}`,
        size: e.size ?? "1",
        variant: "soft",
        color: c.color,
        title: c.label
      }, {
        default: S(() => [
          H(U(c.label), 1)
        ]),
        _: 2
      }, 1032, ["size", "color", "title"]))), 128)),
      a.value > 0 ? (h(), R(f(Jn), {
        key: 0,
        text: r.value
      }, {
        default: S(() => [
          V(f(Mt), {
            size: e.size ?? "1",
            variant: "outline"
          }, {
            default: S(() => [
              H("+" + U(a.value), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        _: 1
      }, 8, ["text"])) : B("", !0)
    ]));
  }
}), uv = {
  "data-hp-flush-content": "true",
  class: "hp-smart-cell-buttons d-inline-flex items-center"
}, cv = /* @__PURE__ */ ue({
  __name: "SmartButtonsCell",
  props: {
    buttons: {}
  },
  setup(e) {
    return (t, n) => (h(), $("span", uv, [
      (h(!0), $(se, null, Pe(e.buttons, (l, o) => (h(), R(f(we), {
        key: l.label ?? String(o),
        variant: l.variant ?? "outline",
        size: l.size ?? "1",
        icon: l.icon,
        square: !l.label,
        disabled: l.disabled ?? !1,
        onClick: tt((a) => l.onClick(), ["stop"])
      }, {
        default: S(() => [
          l.label ? (h(), R(f(ei), { key: 0 }, {
            default: S(() => [
              H(U(l.label), 1)
            ]),
            _: 2
          }, 1024)) : B("", !0)
        ]),
        _: 2
      }, 1032, ["variant", "size", "icon", "square", "disabled", "onClick"]))), 128))
    ]));
  }
}), Uo = /* @__PURE__ */ Ae(cv, [["__scopeId", "data-v-fcd9307b"]]), vr = (e, t) => Ht(e.href) ? e.text ?? e.href : Ht(e.onEmptyAction) ? e.emptyActionLabel ?? t : Ht(e.text) ? e.text : "—", dv = ["href", "title", "data-theme"], fv = ["title"], vv = { key: 3 }, Ho = /* @__PURE__ */ ue({
  __name: "SmartLinkCell",
  props: {
    href: {},
    text: {},
    color: {},
    emptyActionLabel: {},
    onEmptyAction: { type: Function }
  },
  setup(e) {
    const t = Ce(), n = e, l = b(() => vr(n, t("ui.smartTable.add", "Add")));
    return (o, a) => f(Ht)(e.href) ? (h(), $("a", {
      key: 0,
      class: "hp-smart-link-cell",
      href: e.href,
      title: e.text ?? e.href,
      "data-theme": e.color,
      target: "_blank",
      rel: "noopener noreferrer",
      tabindex: "-1",
      onClick: a[0] || (a[0] = tt(() => {
      }, ["stop"]))
    }, U(l.value), 9, dv)) : f(Ht)(e.onEmptyAction) ? (h(), R(f(we), {
      key: 1,
      size: "1",
      variant: "outline",
      tabindex: "-1",
      onClick: a[1] || (a[1] = tt((r) => e.onEmptyAction(), ["stop"]))
    }, {
      default: S(() => [
        H(U(l.value), 1)
      ]),
      _: 1
    })) : f(Ht)(e.text) ? (h(), $("span", {
      key: 2,
      class: "hp-smart-link-cell hp-smart-link-cell--plain",
      title: e.text
    }, U(e.text), 9, fv)) : (h(), $("span", vv, "—"));
  }
}), mv = { class: "hp-smart-cell-text-icon__text" }, hv = {
  key: 1,
  class: "hp-smart-cell-text-icon__text"
}, Wo = /* @__PURE__ */ ue({
  __name: "SmartTextIconCell",
  props: {
    text: {},
    icon: {},
    iconPlacement: {},
    iconColor: {},
    iconTooltip: {},
    iconBadge: { type: Boolean },
    iconBadgeVariant: {}
  },
  setup(e) {
    const t = e, n = b(
      () => t.iconPlacement === "right" ? "hp-smart-cell-text-icon--right" : void 0
    ), l = b(() => {
      const a = t.iconColor;
      return a ? { color: `var(--${a}-9)` } : void 0;
    }), o = b(() => t.iconBadgeVariant ?? "filled");
    return (a, r) => e.icon ? (h(), $("span", {
      key: 0,
      class: Ke(["hp-smart-cell-text-icon d-inline-flex items-center gap-2", n.value])
    }, [
      e.iconTooltip ? (h(), R(f(Jn), {
        key: 0,
        text: e.iconTooltip
      }, {
        default: S(() => [
          e.iconBadge ? (h(), R(f(Xe), {
            key: 0,
            variant: o.value,
            size: "3",
            color: e.iconColor,
            icon: e.icon,
            square: "",
            radius: "full"
          }, null, 8, ["variant", "color", "icon"])) : (h(), R(lt(e.icon), {
            key: 1,
            class: "hp-smart-cell-text-icon__icon",
            style: et(l.value)
          }, null, 8, ["style"]))
        ]),
        _: 1
      }, 8, ["text"])) : (h(), $(se, { key: 1 }, [
        e.iconBadge ? (h(), R(f(Xe), {
          key: 0,
          variant: o.value,
          size: "3",
          color: e.iconColor,
          icon: e.icon,
          square: "",
          radius: "full"
        }, null, 8, ["variant", "color", "icon"])) : (h(), R(lt(e.icon), {
          key: 1,
          class: "hp-smart-cell-text-icon__icon",
          style: et(l.value)
        }, null, 8, ["style"]))
      ], 64)),
      be("span", mv, U(e.text ?? ""), 1)
    ], 2)) : (h(), $("span", hv, U(e.text ?? ""), 1));
  }
}), bv = { class: "hp-smart-cell-thumbnail__wrapper hp-smart-cell-thumbnail__wrapper--hoverable" }, gv = ["src"], yv = ["src", "alt"], pv = ["src", "alt"], wv = {
  key: 0,
  class: "hp-smart-cell-thumbnail__hover-title"
}, kv = { class: "hp-smart-cell-thumbnail__hover-body" }, Sv = ["src", "autoplay", "loop"], Cv = ["src", "alt"], Iv = ["src", "alt"], Rv = {
  key: 3,
  class: "hp-smart-cell-thumbnail__preview hp-smart-cell-thumbnail__preview--empty"
}, Pv = {
  key: 1,
  class: "hp-smart-cell-thumbnail__details"
}, Tv = { class: "hp-smart-cell-thumbnail__detail-label" }, Ev = {
  key: 0,
  class: "hp-smart-cell-badge-list d-inline-flex flex-wrap items-center gap-1"
}, Mv = {
  key: 0,
  class: "hp-smart-cell-thumbnail__detail-code"
}, Vv = {
  key: 1,
  class: "hp-smart-cell-thumbnail__wrapper"
}, xv = ["src"], Kv = ["src", "alt"], zv = ["src", "alt"], Zo = /* @__PURE__ */ ue({
  __name: "SmartThumbnailCell",
  props: {
    src: {},
    alt: {},
    hoverPreview: { type: Boolean },
    hoverTitle: {},
    hoverVideoAutoplay: { type: Boolean },
    fallbackImage: {},
    badge: {},
    hoverDetails: {}
  },
  setup(e) {
    const t = e, n = b(() => $i(t.src)), l = Y(null);
    let o = null;
    const a = () => {
      o && (o.onload = null, o.onerror = null, o.src = "", o = null);
    };
    return oe(
      () => ({ url: t.src, video: n.value }),
      ({ url: r, video: s }) => {
        if (a(), l.value = null, !r || s)
          return;
        const i = new Image();
        o = i, i.onload = () => {
          o === i && t.src === r && (l.value = r);
        }, i.onerror = () => {
          o === i && (o = null);
        }, i.src = r;
      },
      { immediate: !0 }
    ), Is(a), (r, s) => e.hoverPreview && (e.src || e.hoverTitle || e.hoverDetails?.length) ? (h(), R(f(ti), {
      key: 0,
      placement: "right"
    }, {
      default: S(() => [
        V(f(ni), null, {
          default: S(() => [
            be("span", bv, [
              n.value ? (h(), $("video", {
                key: 0,
                src: e.src + "#t=0.1",
                muted: "",
                preload: "metadata",
                class: "hp-smart-cell-thumbnail__media"
              }, null, 8, gv)) : l.value ? (h(), $("img", {
                key: 1,
                src: l.value,
                alt: e.alt,
                class: "hp-smart-cell-thumbnail__media"
              }, null, 8, yv)) : e.fallbackImage ? (h(), $("img", {
                key: 2,
                src: e.fallbackImage,
                alt: e.alt,
                class: "hp-smart-cell-thumbnail__media hp-smart-cell-thumbnail__media--fallback"
              }, null, 8, pv)) : (h(), R(f(ol), {
                key: 3,
                class: "hp-smart-cell-thumbnail__fallback-icon"
              })),
              e.badge ? (h(), R(f(Xe), {
                key: 4,
                class: "hp-smart-cell-thumbnail__badge",
                variant: e.badge.variant ?? "filled",
                size: "2",
                color: e.badge.color,
                icon: e.badge.icon,
                square: "",
                radius: "full"
              }, null, 8, ["variant", "color", "icon"])) : B("", !0)
            ])
          ]),
          _: 1
        }),
        V(f(li), { class: "hp-smart-cell-thumbnail__hover" }, {
          default: S(() => [
            e.hoverTitle ? (h(), $("div", wv, [
              V(f(Me), {
                size: "3",
                weight: "medium"
              }, {
                default: S(() => [
                  H(U(e.hoverTitle), 1)
                ]),
                _: 1
              })
            ])) : B("", !0),
            be("div", kv, [
              e.src || e.fallbackImage ? (h(), $(se, { key: 0 }, [
                n.value ? (h(), $("video", {
                  key: 0,
                  src: e.src + "#t=0.1",
                  controls: "",
                  muted: "",
                  autoplay: e.hoverVideoAutoplay,
                  loop: e.hoverVideoAutoplay,
                  preload: "metadata",
                  class: "hp-smart-cell-thumbnail__preview"
                }, null, 8, Sv)) : l.value ? (h(), $("img", {
                  key: 1,
                  src: l.value,
                  alt: e.alt,
                  class: "hp-smart-cell-thumbnail__preview"
                }, null, 8, Cv)) : e.fallbackImage ? (h(), $("img", {
                  key: 2,
                  src: e.fallbackImage,
                  alt: e.alt,
                  class: "hp-smart-cell-thumbnail__preview hp-smart-cell-thumbnail__preview--fallback"
                }, null, 8, Iv)) : (h(), $("div", Rv, [
                  V(f(ol), { class: "hp-smart-cell-thumbnail__preview-icon" })
                ]))
              ], 64)) : B("", !0),
              e.hoverDetails?.length ? (h(), $("dl", Pv, [
                (h(!0), $(se, null, Pe(e.hoverDetails, (i) => (h(), $(se, {
                  key: i.label
                }, [
                  be("dt", Tv, [
                    V(f(Me), {
                      size: "2",
                      variant: "soft"
                    }, {
                      default: S(() => [
                        H(U(i.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  be("dd", {
                    class: Ke(["hp-smart-cell-thumbnail__detail-value", { "hp-smart-cell-thumbnail__detail-value--wrap": i.type === "link" }])
                  }, [
                    !i.type || i.type === "text" ? (h(), R(f(Me), {
                      key: 0,
                      size: "2"
                    }, {
                      default: S(() => [
                        H(U(i.value ?? "—"), 1)
                      ]),
                      _: 2
                    }, 1024)) : i.type === "badge" ? (h(), $(se, { key: 1 }, [
                      i.value ? (h(), R(f(Xe), {
                        key: 0,
                        variant: "soft",
                        size: "1",
                        color: i.value.color
                      }, {
                        default: S(() => [
                          H(U(i.value.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])) : (h(), R(f(Me), {
                        key: 1,
                        size: "2"
                      }, {
                        default: S(() => [...s[0] || (s[0] = [
                          H("—", -1)
                        ])]),
                        _: 1
                      }))
                    ], 64)) : i.type === "badges" ? (h(), $(se, { key: 2 }, [
                      i.value?.length ? (h(), $("span", Ev, [
                        (h(!0), $(se, null, Pe(i.value, (c, u) => (h(), R(f(Xe), {
                          key: `${String(c.value ?? c.label)}:${u}`,
                          variant: "soft",
                          size: "1",
                          color: c.color
                        }, {
                          default: S(() => [
                            H(U(c.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))), 128))
                      ])) : (h(), R(f(Me), {
                        key: 1,
                        size: "2"
                      }, {
                        default: S(() => [...s[1] || (s[1] = [
                          H("—", -1)
                        ])]),
                        _: 1
                      }))
                    ], 64)) : i.type === "link" ? (h(), $(se, { key: 3 }, [
                      i.value ? (h(), R(f(Me), {
                        key: 0,
                        as: "a",
                        href: i.value.href,
                        target: "_blank",
                        rel: "noopener",
                        size: "2",
                        link: ""
                      }, {
                        default: S(() => [
                          H(U(i.value.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])) : (h(), R(f(Me), {
                        key: 1,
                        size: "2"
                      }, {
                        default: S(() => [...s[2] || (s[2] = [
                          H("—", -1)
                        ])]),
                        _: 1
                      }))
                    ], 64)) : i.type === "code" ? (h(), $(se, { key: 4 }, [
                      i.value ? (h(), $("pre", Mv, U(i.value), 1)) : (h(), R(f(Me), {
                        key: 1,
                        size: "2"
                      }, {
                        default: S(() => [...s[3] || (s[3] = [
                          H("—", -1)
                        ])]),
                        _: 1
                      }))
                    ], 64)) : B("", !0)
                  ], 2)
                ], 64))), 128))
              ])) : B("", !0)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : (h(), $("span", Vv, [
      e.src && n.value ? (h(), $("video", {
        key: 0,
        src: e.src + "#t=0.1",
        muted: "",
        preload: "metadata",
        class: "hp-smart-cell-thumbnail__media"
      }, null, 8, xv)) : l.value ? (h(), $("img", {
        key: 1,
        src: l.value,
        alt: e.alt,
        class: "hp-smart-cell-thumbnail__media"
      }, null, 8, Kv)) : e.fallbackImage ? (h(), $("img", {
        key: 2,
        src: e.fallbackImage,
        alt: e.alt,
        class: "hp-smart-cell-thumbnail__media hp-smart-cell-thumbnail__media--fallback"
      }, null, 8, zv)) : (h(), R(f(ol), {
        key: 3,
        class: "hp-smart-cell-thumbnail__fallback-icon"
      })),
      e.badge ? (h(), R(f(Xe), {
        key: 4,
        class: "hp-smart-cell-thumbnail__badge",
        variant: e.badge.variant ?? "filled",
        size: "2",
        color: e.badge.color,
        icon: e.badge.icon,
        square: "",
        radius: "full"
      }, null, 8, ["variant", "color", "icon"])) : B("", !0)
    ]));
  }
}), Ov = !0, Av = 128, qo = 136, mr = [
  "label",
  "editMode",
  "alwaysEdit",
  "rowEditPresentation",
  "sortable",
  "tooltip",
  "width",
  "mobileWidth",
  "minWidth",
  "maxWidth",
  "mono",
  "nowrap",
  "truncate",
  "align",
  "sticky",
  "resizable",
  "reorderable",
  "alwaysVisible",
  "disabled"
], Pt = (e, t) => {
  sr(e, t, mr);
}, Qt = (e) => {
  const t = new Set(mr), n = {};
  for (const l of Object.keys(e))
    t.has(l) || (n[l] = e[l]);
  return n;
}, wt = (e, t, n) => {
  const l = { key: t, editor: e };
  return n.format !== void 0 && (l.format = n.format), Pt(l, n), l;
}, Xp = () => {
  const e = (t, n, l) => {
    const o = {
      key: n,
      view: {
        kind: t,
        value: l.value,
        format: l.format !== void 0 ? (a) => l.format(a) : void 0
      }
    };
    return l.format !== void 0 && (o.format = l.format), l.editor !== void 0 && (o.editor = l.editor), Pt(o, l), o;
  };
  return {
    text: (t, n = {}) => e("text", t, n),
    number: (t, n = {}) => e("number", t, n),
    date: (t, n = {}) => {
      const l = { mono: Ov, minWidth: Av, ...n };
      return wt(Ne.date(n), t, l);
    },
    boolean: (t, n) => wt(Ne.boolean(n), t, n),
    tags: (t, n = {}) => {
      const l = { minWidth: qo, ...n };
      return wt(Ne.tags(n), t, l);
    },
    multiline: (t, n = {}) => wt(Ne.multiline(n), t, n),
    textIcon: (t, n = {}) => {
      const l = n, o = { key: t, view: { kind: "textIcon", ...Qt(l) } };
      return Pt(o, l), o;
    },
    thumbnail: (t, n) => {
      const l = n, o = { key: t, view: { kind: "thumbnail", ...Qt(l) } };
      return Pt(o, l), o;
    },
    link: (t, n = {}) => {
      const l = n, o = { key: t, view: { kind: "link", ...Qt(l) } };
      return Pt(o, l), o;
    },
    badges: (t, n) => {
      const l = n, o = { key: t, view: { kind: "badges", ...Qt(l) } };
      return Pt(o, l), o;
    },
    buttons: (t, n) => {
      const l = n, o = { key: t, view: { kind: "buttons", ...Qt(l) } };
      return Pt(o, l), o;
    },
    custom: (t, n) => {
      const l = n, o = { key: t };
      return l.view !== void 0 && (o.view = l.view), l.editor !== void 0 && (o.editor = l.editor), Pt(o, l), o;
    },
    select: {
      list: (t, n) => wt(gt.list(n), t, n),
      multi: (t, n) => {
        const l = { minWidth: qo, ...n };
        return wt(gt.multi(n), t, l);
      },
      tree: (t, n) => wt(gt.tree(n), t, n)
    },
    composite: {
      range: (t, n = {}) => wt(qt.range(n), t, n),
      // NOT given the `date()` builder's mono/minWidth defaults: `composite.dateRange` mounts
      // TWO `DateField` editors (start + end) side by side, so the single-field
      // `DATE_COLUMN_MIN_WIDTH` measurement does not apply, and `SmartTableCell.vue`'s
      // trigger-outside-the-cell CSS (keyed off the bare `.hp-date-field__trigger` class) would
      // pull BOTH triggers to the same spot, overlapping them. Left as a follow-up.
      dateRange: (t, n = {}) => wt(qt.dateRange(n), t, n)
    }
  };
}, ew = (e) => {
  const t = Y([]), n = Y(0), l = Y(!1), o = Y(!1), a = Y(void 0);
  let r = 0, s;
  const i = async (d) => {
    s = d;
    const v = ++r;
    l.value = !0;
    try {
      const m = await e(d);
      if (v !== r)
        return;
      t.value = m.rows, n.value = m.total, o.value = !1, a.value = void 0;
    } catch (m) {
      if (v !== r)
        return;
      o.value = !0, a.value = m;
    } finally {
      v === r && (l.value = !1);
    }
  };
  return { rows: t, total: n, isLoading: l, isError: o, error: a, load: i, bind: (d, v) => {
    oe(() => d.queryState.value, i, { deep: !0, immediate: v?.immediate ?? !0 });
  }, refetch: () => s === void 0 ? Promise.resolve() : i(s) };
}, $v = /* @__PURE__ */ new Set([
  "text",
  "number",
  "textIcon",
  "thumbnail",
  "link",
  "badges",
  "buttons"
]), On = (e) => typeof e == "object" && "kind" in e && $v.has(e.kind), ul = (e) => typeof e == "object" && "component" in e, cl = (e) => typeof e == "function", hr = (e) => typeof e == "object" && "component" in e, br = (e) => e.editor === void 0, gr = (e) => {
  const t = e.editor;
  if (!(t === void 0 || hr(t)))
    return t;
}, Lv = (e, t) => {
  const n = Y(null), l = Y(null), o = Y(null), a = (I, w) => {
    n.value = { rowKey: I, colKey: w };
  }, r = () => {
    n.value = null;
  }, s = (I, w) => b(() => {
    const C = _(t.disabled) ?? !1, x = w.disabled ?? !1;
    return {
      value: I[w.key],
      disabled: C || x,
      readonly: br(w)
    };
  }), i = (I, w) => {
    const C = t.onBeforeCommit?.(I) ?? { kind: "proceed" };
    switch (C.kind) {
      case "veto":
        return { short: { ok: !1, issues: [] } };
      case "handled":
        return w?.keepActive !== !0 && r(), { short: { ok: !0 } };
      case "replace":
        return { value: C.value };
      default:
        return { value: I.value };
    }
  }, c = (I, w, C) => {
    const x = I.safeParse(w);
    return x.success || _(t.commitPolicy) === "progressive" && C !== void 0 && !I.safeParse(C).success ? null : {
      ok: !1,
      issues: x.error.issues.map((O) => ({
        path: O.path.join("."),
        message: O.message
      }))
    };
  }, u = (I, w, C, x) => {
    const O = i({ rowKey: I, field: w, value: C }, x);
    if ("short" in O)
      return O.short;
    const N = O.value, T = _(t.data), L = T.find((G) => e.rowKeyOf(G) === I);
    if (L === void 0)
      return { ok: !1, issues: [{ path: "", message: `Row not found: ${I}` }] };
    const k = { ...L, [w]: N }, K = _(t.rowSchema);
    if (K !== void 0) {
      const G = c(K, k, L);
      if (G !== null)
        return G;
    }
    const W = T.map((G) => e.rowKeyOf(G) === I ? k : G);
    return t.onDataUpdate?.(W), x?.keepActive !== !0 && r(), { ok: !0 };
  }, d = (I) => {
    if (I.length === 0)
      return;
    const w = _(t.data), C = /* @__PURE__ */ new Map();
    for (const O of I) {
      const N = C.get(O.rowKey);
      N === void 0 ? C.set(O.rowKey, [O]) : N.push(O);
    }
    const x = w.map((O) => {
      const N = C.get(e.rowKeyOf(O));
      if (N === void 0)
        return O;
      const T = { ...O };
      for (const L of N)
        T[L.field] = L.value;
      return T;
    });
    t.onDataUpdate?.(x);
  }, v = (I) => {
    t.onDataUpdate?.(I);
  }, m = b(() => {
    const I = l.value;
    return I === null ? null : _(t.data).find((w) => e.rowKeyOf(w) === I) ?? null;
  }), p = (I, w = "dialog") => {
    l.value = I, o.value = w;
  }, g = () => {
    l.value = null, o.value = null;
  }, y = (I, w, C) => {
    const x = _(t.data), O = x.find((L) => e.rowKeyOf(L) === I), N = _(t.rowSchema);
    if (N !== void 0) {
      const L = c(N, w, O);
      if (L !== null)
        return L;
    }
    const T = x.map((L) => e.rowKeyOf(L) === I ? w : L);
    return t.onDataUpdate?.(T), C?.keepOpen !== !0 && g(), { ok: !0 };
  }, P = b(() => _(t.rowSchema));
  return {
    activeCell: n,
    handleActivateCell: a,
    handleDeactivateCell: r,
    cellStateFor: s,
    handleCellCommit: u,
    applyPatch: d,
    setRows: v,
    rowEditKey: l,
    rowEditPresentation: o,
    rowBeingEdited: m,
    handleOpenRowEdit: p,
    handleCloseRowEdit: g,
    handleRowCommit: y,
    rowSchema: P
  };
}, Fv = (e) => {
  if (e === null || typeof e != "object" || !("hiddenColumnKeys" in e))
    return !1;
  const t = e.hiddenColumnKeys;
  return Array.isArray(t) && t.every((n) => typeof n == "string");
}, Dv = (e) => {
  if (typeof localStorage > "u")
    return null;
  try {
    const t = localStorage.getItem(e);
    if (t === null)
      return null;
    const n = JSON.parse(t);
    return Fv(n) ? n.hiddenColumnKeys : null;
  } catch {
    return null;
  }
}, Nv = (e, t) => {
  if (!(typeof localStorage > "u"))
    try {
      const n = { hiddenColumnKeys: t };
      localStorage.setItem(e, JSON.stringify(n));
    } catch {
    }
}, Bv = (e, t) => {
  if (e === void 0)
    return t;
  const n = Dv(e);
  return n !== null ? n : t;
}, jv = (e, t) => {
  e !== void 0 && oe(
    t,
    (n) => {
      Nv(e, n);
    },
    { flush: "sync" }
  );
}, Uv = (e, t) => {
  const n = b(() => _(t.columnVisibility) ?? !1), l = _(t.storageKey), o = Y(
    Bv(l, [..._(t.defaultHiddenColumnKeys) ?? []])
  ), a = (r) => {
    o.value = [...r];
  };
  return jv(l, o), {
    columnVisibilityEnabled: n,
    hiddenColumnKeys: o,
    setHiddenColumnKeys: a
  };
}, Hv = (e, t) => e === t ? !0 : e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : e === null || t === null || typeof e != "object" || typeof t != "object" ? !1 : JSON.stringify(e) === JSON.stringify(t), yr = (e, t) => {
  const n = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), l = [];
  for (const o of n)
    Hv(e[o], t[o]) || l.push(o);
  return l;
}, Wv = (e, t) => yr(e, t).length === 0, Zv = (e, t) => {
  const n = b(() => t.features?.dirtyTracking ?? !1), l = (m) => {
    const p = /* @__PURE__ */ new Map();
    for (const g of m)
      p.set(e.rowKeyOf(g), { ...g });
    return p;
  }, o = mt(null);
  n.value && oe(
    e.rows,
    (m) => {
      o.value === null && m.length > 0 && (o.value = l(m));
    },
    { immediate: !0 }
  );
  const a = b(() => {
    const m = o.value;
    if (!n.value || m === null)
      return [];
    const p = [];
    for (const g of e.rows.value) {
      const y = e.rowKeyOf(g), P = m.get(y);
      (P === void 0 || !Wv(g, P)) && p.push(y);
    }
    return p;
  }), r = b(() => {
    const m = o.value;
    if (!n.value || m === null)
      return [];
    const p = new Set(e.rows.value.map((y) => e.rowKeyOf(y))), g = [];
    for (const y of m.keys())
      p.has(y) || g.push(y);
    return g;
  }), s = b(() => {
    const m = {};
    for (const g of a.value)
      m[g] = { dirty: !0 };
    const p = _(t.rowStates);
    if (p !== void 0)
      for (const [g, y] of Object.entries(p))
        m[g] = { ...m[g], ...y };
    return m;
  }), i = b(() => a.value.length > 0 || r.value.length > 0);
  return {
    rowStates: s,
    dirtyKeys: a,
    removedKeys: r,
    hasDirtyRows: i,
    resetBaseline: () => {
      o.value = l(e.rows.value);
    },
    dirtyFieldsFor: (m) => {
      const p = o.value;
      if (!n.value || p === null)
        return [];
      const g = e.rows.value.find((P) => e.rowKeyOf(P) === m);
      if (g === void 0)
        return [];
      const y = p.get(m);
      return y === void 0 ? Object.keys(g) : yr(g, y);
    },
    foldBaseline: (m) => {
      const p = o.value;
      if (p === null || m.length === 0)
        return;
      const g = new Map(p);
      let y = !1;
      for (const P of m) {
        const I = g.get(P.rowKey);
        if (I === void 0)
          continue;
        const w = { ...I };
        w[P.field] = P.value, g.set(P.rowKey, w), y = !0;
      }
      y && (o.value = g);
    },
    adoptBaseline: (m) => {
      o.value = m.length === 0 ? null : l(m);
    }
  };
}, Qn = 10, rn = 1, An = 1, qv = 25, Jv = 50, Gv = 100, _v = [
  Qn,
  qv,
  Jv,
  Gv
], Yv = (e, t, n) => {
  const l = b(() => {
    const i = _(t.pageSizeOptions);
    if (i !== void 0)
      return i;
    if (!e.paginationEnabled.value)
      return;
    const c = _v;
    return c.includes(e.pageSize.value) ? c : [...c, e.pageSize.value].sort((u, d) => u - d);
  }), o = b(() => {
    if (e.serverMode.value || !e.paginationEnabled.value || e.pageSize.value <= 0)
      return n.sortedRows.value;
    const i = e.pageSize.value, c = Math.ceil(n.sortedRows.value.length / i), d = (Math.max(An, Math.min(e.page.value, c === 0 ? An : c)) - rn) * i, v = d + i;
    return n.sortedRows.value.slice(d, v);
  }), a = b(() => e.serverMode.value ? _(t.total) ?? 0 : n.treeEnabled.value ? n.treeRootCount.value : n.sortedRows.value.length);
  oe(
    () => _(t.pageSize),
    (i) => {
      e.pageSize.value = i ?? Qn;
    }
  );
  const r = (i) => {
    e.page.value = i;
  }, s = (i) => {
    e.pageSize.value = i, e.resetPage();
  };
  return {
    page: e.page,
    pageSize: e.pageSize,
    pagedRows: o,
    total: a,
    pageSizeOptions: l,
    paginationEnabled: e.paginationEnabled,
    handlePageChange: r,
    handlePageSizeChange: s
  };
}, Qv = 0, Xv = "Search…", em = " ", pr = (e, t, n) => t !== void 0 ? t(e) : n.map((l) => {
  const o = e[l];
  return o == null ? "" : String(o);
}).join(em), Jo = (e) => typeof e == "object", tm = (e, t) => {
  const n = Y(t.defaultSearch ?? ""), l = Y(t.defaultSearch ?? "");
  let o;
  const a = b(() => {
    const d = _(t.searchable);
    return Jo(d) ? !0 : d ?? !1;
  }), r = b(() => {
    const d = _(t.searchable);
    return Jo(d) ? d : {};
  }), s = b(() => r.value.debounceMs ?? Qv), i = b(() => r.value.placeholder ?? Xv), c = b(() => {
    if (e.serverMode.value)
      return _(t.data);
    const d = _(t.data), v = l.value.trim();
    if (v === "")
      return d;
    const m = v.toLowerCase(), p = _(t.searchKeys);
    return t.searchText === void 0 && p === void 0 ? d : d.filter((g) => pr(g, t.searchText, p ?? []).toLowerCase().includes(m));
  });
  return oe(
    n,
    (d) => {
      const v = s.value;
      v > 0 ? (clearTimeout(o), o = setTimeout(() => {
        l.value = d;
      }, v)) : l.value = d;
    },
    { flush: "sync" }
  ), oe(l, () => {
    e.resetPage();
  }), Rs(() => {
    clearTimeout(o);
  }), {
    searchQuery: n,
    debouncedSearch: l,
    searchedRows: c,
    searchable: a,
    searchPlaceholder: i,
    handleSearchChange: (d) => {
      n.value = d, s.value === 0 && e.resetPage();
    }
  };
}, nm = (e, t) => {
  const n = Y([]), l = b(() => _(t.selectable) ?? !1), o = b(() => _(t.singleSelect) ?? !1), a = (i) => {
    const c = o.value && i.length > 1 ? [i[i.length - 1]] : i;
    n.value = c, t.onSelectionChange?.(c);
  };
  oe(o, (i) => {
    i && n.value.length > 1 && (n.value = [n.value[0]]);
  });
  const r = b(() => _(t.bulkActions) ?? []), s = b(() => {
    const i = new Set(n.value);
    return e.rows.value.filter((c) => i.has(e.rowKeyOf(c)));
  });
  return {
    selectedKeys: n,
    selectable: l,
    singleSelect: o,
    selectedRows: s,
    bulkActions: r,
    handleSelectionChange: a
  };
}, lm = (e, t) => _(e) ?? t ?? {}, om = (e, t, n) => {
  const l = Y(
    lm(t.filterValue, t.defaultFilterValue)
  ), o = b(() => ({
    page: e.page.value,
    pageSize: e.pageSize.value,
    sort: n.sortKey.value !== null && n.sortDirection.value !== null ? { key: n.sortKey.value, direction: n.sortDirection.value } : null,
    search: n.debouncedSearch.value,
    filterValue: l.value
  }));
  return oe(
    () => _(t.filterValue),
    (r) => {
      r !== void 0 && (l.value = r);
    }
  ), oe(l, () => {
    e.resetPage();
  }), {
    queryState: o,
    filterValue: l,
    setFilterValue: (r) => {
      l.value = r, e.resetPage();
    }
  };
}, am = (e, t) => e == null && t == null ? 0 : e == null ? 1 : t == null ? -1 : typeof e == "number" && typeof t == "number" ? e - t : e instanceof Date && t instanceof Date ? e.getTime() - t.getTime() : String(e).localeCompare(String(t)), El = (e, t) => (n, l) => {
  const o = n[e], a = l[e], r = am(o, a);
  return o == null || a == null ? r : t === "desc" ? -r : r;
}, rm = (e, t, n) => {
  const l = Y(t.defaultSort?.key ?? null), o = Y(t.defaultSort?.direction ?? null), a = b(() => {
    if (e.serverMode.value)
      return n.searchedRows.value;
    const i = l.value, c = o.value, u = n.searchedRows.value;
    if (i === null || c === null)
      return u;
    const d = [...u];
    return d.sort(El(i, c)), d;
  }), r = (i) => {
    l.value = i, e.resetPage();
  }, s = (i) => {
    o.value = i, e.resetPage();
  };
  return oe([l, o], ([i, c]) => {
    t.onSortChange?.(i, c);
  }), {
    sortKey: l,
    sortDirection: o,
    sortedRows: a,
    handleSortKey: r,
    handleSortDirection: s
  };
}, Zl = (e) => String(e), Go = (e, t, n) => {
  const l = e.get(t);
  l === void 0 ? e.set(t, [n]) : l.push(n);
}, sm = (e, t, n) => {
  const l = /* @__PURE__ */ new Set();
  for (const o of e) {
    const a = Zl(o[t]);
    if (n && l.has(a))
      throw new Error(`buildFlatTreeIndex: duplicate row key "${a}"`);
    l.add(a);
  }
  return l;
}, im = (e, t, n, l) => {
  if (e == null)
    return null;
  const o = Zl(e);
  if (l && o === t)
    throw new Error(`buildFlatTreeIndex: cycle detected at "${t}" (self-parent)`);
  return n.has(o) ? o : null;
}, um = (e, t) => {
  for (const n of e) {
    const l = /* @__PURE__ */ new Set();
    let o = n;
    for (; o !== null; ) {
      if (l.has(o))
        throw new Error(`buildFlatTreeIndex: cycle detected reaching "${n}"`);
      l.add(o), o = t.get(o) ?? null;
    }
  }
}, wr = (e, t, n, l = "lenient") => {
  const o = l === "strict", a = sm(e, t, o), r = [], s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
  for (const u of e) {
    const d = Zl(u[t]), v = im(u[n], d, a, o);
    s.set(d, v), v === null && r.push(d), Go(i, v, d), Go(c, v, u);
  }
  return o && um(a, s), { roots: r, parentOf: s, childKeysByParent: i, rowsByParent: c };
}, tn = (e, t) => String(e[t]), cm = (e) => {
  const { source: t, query: n, rowKeyField: l, searchText: o, searchKeys: a, parentOf: r } = e, s = /* @__PURE__ */ new Set();
  for (const c of t)
    pr(c, o, a).toLowerCase().includes(n) && s.add(tn(c, l));
  const i = new Set(s);
  for (const c of s) {
    let u = r.get(c) ?? null;
    for (; u !== null && !i.has(u); )
      i.add(u), u = r.get(u) ?? null;
  }
  return i;
}, dm = (e, t, n) => {
  const l = Y([...t.tree?.defaultExpandedKeys ?? []]), o = b(() => t.tree !== void 0), a = b(() => t.tree?.column ?? null), r = b(() => t.tree?.shrink === !0), s = b(() => t.tree === void 0 ? { roots: [], parentOf: /* @__PURE__ */ new Map(), childKeysByParent: /* @__PURE__ */ new Map(), rowsByParent: /* @__PURE__ */ new Map() } : wr(_(t.data), _(t.rowKey), t.tree.parentKey, "lenient")), i = b(() => s.value.rowsByParent), c = b(() => {
    for (const I of s.value.parentOf.values())
      if (I !== null)
        return !0;
    return !1;
  }), u = b(() => {
    if (t.tree === void 0 || e.serverMode.value)
      return null;
    const I = n.debouncedSearch.value.trim().toLowerCase();
    if (I === "")
      return null;
    const w = _(t.searchKeys);
    return t.searchText === void 0 && w === void 0 ? null : cm({
      source: _(t.data),
      query: I,
      rowKeyField: _(t.rowKey),
      searchText: t.searchText,
      searchKeys: w ?? [],
      parentOf: s.value.parentOf
    });
  }), d = b(() => {
    const I = i.value, w = u.value, C = n.sortKey.value, x = n.sortDirection.value;
    let O = I.get(null) ?? [];
    if (w !== null) {
      const N = _(t.rowKey);
      O = O.filter((T) => w.has(tn(T, N)));
    }
    return !e.serverMode.value && C !== null && x !== null && (O = [...O].sort(El(C, x))), O;
  }), v = b(() => d.value.length), m = b(() => {
    if (e.serverMode.value && o.value)
      return d.value;
    const I = d.value;
    if (!e.paginationEnabled.value || e.pageSize.value <= 0)
      return I;
    const w = e.pageSize.value, C = Math.ceil(I.length / w), O = (Math.max(An, Math.min(e.page.value, C === 0 ? An : C)) - rn) * w, N = O + w;
    return I.slice(O, N);
  }), p = b(() => {
    if (t.tree === void 0)
      return [];
    const I = _(t.rowKey), w = i.value, C = u.value, x = n.sortKey.value, O = n.sortDirection.value, N = C !== null, T = [], L = /* @__PURE__ */ new Set(), k = (W) => {
      let G = w.get(W) ?? [];
      return C !== null && (G = G.filter((A) => C.has(tn(A, I)))), !e.serverMode.value && x !== null && O !== null && (G = [...G].sort(El(x, O))), G;
    }, K = (W, G, A) => {
      for (let E = 0; E < W.length; E++) {
        const D = W[E], X = tn(D, I);
        if (L.has(X))
          continue;
        L.add(X);
        const z = k(X), Q = z.length > 0 || !N && !!t.tree?.hasChildrenKey && D[t.tree.hasChildrenKey] === !0, ne = E === W.length - 1, ae = N ? Q : l.value.includes(X), Ie = A;
        T.push({ row: D, depth: G, hasChildren: Q, expanded: ae, isLast: ne, ancestorLines: Ie }), ae && z.length > 0 && K(z, G + 1, [...A, !ne]);
      }
    };
    return K(m.value, 0, []), T;
  }), g = b(() => {
    const I = /* @__PURE__ */ new Map(), w = _(t.rowKey);
    for (const C of p.value) {
      const x = tn(C.row, w);
      I.set(x, {
        depth: C.depth,
        hasChildren: C.hasChildren,
        expanded: C.expanded,
        isLast: C.isLast,
        ancestorLines: C.ancestorLines
      });
    }
    return I;
  });
  return {
    treeEnabled: o,
    treeColumnKey: a,
    treeShrink: r,
    expandedKeys: l,
    flattenedRows: p,
    treeMetaFor: (I) => {
      const w = g.value.get(I);
      return w && (t.tree?.hasChildrenKey !== void 0 || c.value || w.hasChildren) ? w : null;
    },
    handleToggleExpand: (I) => {
      l.value = l.value.includes(I) ? l.value.filter((w) => w !== I) : [...l.value, I];
    },
    treeRootCount: v
  };
}, fm = (e, t) => String(e[t]), vm = (e) => {
  const t = Y(e.defaultPage ?? rn), n = Y(_(e.pageSize) ?? Qn), l = b(() => _(e.pagination) ?? !1), o = b(() => _(e.mode) === "server"), a = b(() => _(e.data)), r = b(() => _(e.rowKey)), s = (Qe) => fm(Qe, _(e.rowKey)), i = {
    rows: a,
    rowKeyOf: s,
    serverMode: o,
    resetPage: () => {
      t.value = rn;
    },
    page: t,
    pageSize: n,
    paginationEnabled: l
  }, { selectedKeys: c, selectable: u, singleSelect: d, selectedRows: v, bulkActions: m, handleSelectionChange: p } = nm(
    i,
    e
  ), g = [], y = (Qe) => (g.push(Qe), () => {
    const dt = g.indexOf(Qe);
    dt >= 0 && g.splice(dt, 1);
  }), P = (Qe) => {
    let dt = Qe, uo = !1;
    for (const ps of [e.onBeforeCommit, ...g]) {
      const Yt = ps?.(dt);
      if (!(Yt === void 0 || Yt.kind === "proceed")) {
        if (Yt.kind === "replace") {
          dt = { ...dt, value: Yt.value }, uo = !0;
          continue;
        }
        return Yt;
      }
    }
    return uo ? { kind: "replace", value: dt.value } : { kind: "proceed" };
  }, {
    activeCell: I,
    handleActivateCell: w,
    handleDeactivateCell: C,
    cellStateFor: x,
    handleCellCommit: O,
    applyPatch: N,
    setRows: T,
    rowEditKey: L,
    rowEditPresentation: k,
    rowBeingEdited: K,
    handleOpenRowEdit: W,
    handleCloseRowEdit: G,
    handleRowCommit: A,
    rowSchema: E
  } = Lv(i, { ...e, onBeforeCommit: P }), { columnVisibilityEnabled: D, hiddenColumnKeys: X, setHiddenColumnKeys: z } = Uv(i, e), { searchQuery: Q, debouncedSearch: ne, searchedRows: ae, searchable: Ie, searchPlaceholder: ke, handleSearchChange: $e } = tm(
    i,
    e
  ), { sortKey: He, sortDirection: qe, sortedRows: Ye, handleSortKey: j, handleSortDirection: q } = rm(i, e, {
    searchedRows: ae
  }), {
    treeEnabled: J,
    treeColumnKey: ee,
    treeShrink: de,
    expandedKeys: ve,
    flattenedRows: me,
    treeMetaFor: xe,
    handleToggleExpand: Te,
    treeRootCount: We
  } = dm(i, e, { sortKey: He, sortDirection: qe, debouncedSearch: ne }), { pagedRows: Le, total: ht, pageSizeOptions: pt, handlePageChange: Z, handlePageSizeChange: ie } = Yv(i, e, {
    sortedRows: Ye,
    treeEnabled: J,
    treeRootCount: We
  }), { queryState: Se, filterValue: Oe, setFilterValue: M } = om(i, e, {
    sortKey: He,
    sortDirection: qe,
    debouncedSearch: ne
  }), he = b(() => _(e.rowActions) ?? []), ze = b(() => he.value.length > 0), {
    rowStates: ct,
    dirtyKeys: nl,
    removedKeys: F,
    hasDirtyRows: le,
    resetBaseline: te,
    dirtyFieldsFor: Fe,
    foldBaseline: so,
    adoptBaseline: gs
  } = Zv(i, e), io = Y(0), ys = b(() => io.value);
  return {
    activeCell: I,
    handleActivateCell: w,
    handleDeactivateCell: C,
    cellStateFor: x,
    handleCellCommit: O,
    interceptCommits: y,
    applyPatch: (Qe, dt) => {
      N(Qe), dt?.source === "seed" && so(Qe);
    },
    setRows: (Qe, dt) => {
      T(Qe), dt?.source === "seed" && (gs(Qe), Qe.length > 0 && (io.value += 1));
    },
    seedVersion: ys,
    rows: a,
    rowKeyOf: s,
    rowKeyField: r,
    rowEditKey: L,
    rowEditPresentation: k,
    rowBeingEdited: K,
    handleOpenRowEdit: W,
    handleCloseRowEdit: G,
    handleRowCommit: A,
    rowSchema: E,
    // View pipeline
    sortKey: He,
    sortDirection: qe,
    page: t,
    pageSize: n,
    selectedKeys: c,
    searchQuery: Q,
    pagedRows: Le,
    total: ht,
    pageSizeOptions: pt,
    selectable: u,
    singleSelect: d,
    paginationEnabled: l,
    searchable: Ie,
    handleSortKey: j,
    handleSortDirection: q,
    handleSelectionChange: p,
    handlePageChange: Z,
    handlePageSizeChange: ie,
    handleSearchChange: $e,
    // Column visibility
    columnVisibilityEnabled: D,
    hiddenColumnKeys: X,
    setHiddenColumnKeys: z,
    // Tree expansion
    treeEnabled: J,
    treeColumnKey: ee,
    treeShrink: de,
    expandedKeys: ve,
    flattenedRows: me,
    treeMetaFor: xe,
    handleToggleExpand: Te,
    // Row actions
    rowActions: he,
    rowActionsEnabled: ze,
    // Bulk actions
    bulkActions: m,
    selectedRows: v,
    // Row states (dirty tracking)
    rowStates: ct,
    dirtyKeys: nl,
    removedKeys: F,
    hasDirtyRows: le,
    onRowClick: e.onRowClick,
    resetBaseline: te,
    dirtyFieldsFor: Fe,
    // Server mode
    queryState: Se,
    filterValue: Oe,
    setFilterValue: M,
    searchPlaceholder: ke
  };
}, mm = (e) => e, hm = (e, t) => {
  t !== void 0 && t !== e.page.value && (e.page.value = t);
}, bm = (e, t) => {
  t !== void 0 && t !== e.pageSize.value && (e.pageSize.value = t);
}, gm = (e, t) => {
  if (t === void 0)
    return;
  const n = t?.key ?? null, l = t?.direction ?? null;
  (n !== e.sortKey.value || l !== e.sortDirection.value) && (e.sortKey.value = n, e.sortDirection.value = l);
}, ym = (e) => ({
  page: e?.defaultPage ?? rn,
  pageSize: e?.pageSize ?? Qn,
  sort: e?.defaultSort ?? null,
  search: "",
  filterValue: {}
}), tw = (e) => {
  const t = e?.map ?? mm, n = {
    mode: "server",
    ...e?.pageSize !== void 0 ? { pageSize: e.pageSize } : {},
    ...e?.pageSizeOptions !== void 0 ? { pageSizeOptions: e.pageSizeOptions } : {},
    ...e?.defaultSort !== void 0 ? { defaultSort: e.defaultSort } : {},
    ...e?.defaultPage !== void 0 ? { defaultPage: e.defaultPage } : {}
  }, l = Y(t(ym(e)));
  let o, a;
  return {
    params: l,
    tableOptions: n,
    bind: (i, c) => {
      a?.(), o = i, a = oe(
        () => i.queryState.value,
        (u) => {
          const d = t(u);
          l.value = d, c?.onChange?.(d);
        },
        { deep: !0 }
      );
    },
    apply: (i) => {
      o && (hm(o, i.page), bm(o, i.pageSize), gm(o, i.sort));
    }
  };
}, kr = /* @__PURE__ */ ue({
  __name: "SmartTableRowEditForm",
  props: {
    row: {},
    rowKey: {},
    fields: {},
    rowSchema: {},
    labels: {},
    closeOnSave: { type: Boolean, default: !0 },
    onCommit: {},
    onCancel: {}
  },
  setup(e, { expose: t }) {
    const n = e, l = Hl({
      defaultValues: n.row,
      validators: n.rowSchema !== void 0 ? { onChange: n.rowSchema } : void 0
    }), o = l.useStore((s) => s.values);
    return oe(
      () => n.row,
      (s, i) => {
        for (const c of Object.keys(s))
          Object.is(s[c], i[c]) || l.setFieldValue(c, s[c]);
      }
    ), t({ save: async () => {
      await l.handleSubmit();
      const s = o.value;
      return (n.closeOnSave ? n.onCommit(n.rowKey, s) : n.onCommit(n.rowKey, s, { keepOpen: !0 })).ok;
    }, cancel: () => {
      n.onCancel();
    } }), (s, i) => (h(), R(Wl, {
      form: f(l),
      fields: e.fields
    }, null, 8, ["form", "fields"]));
  }
}), pm = /* @__PURE__ */ ue({
  __name: "SmartTableRowEditDialog",
  props: {
    row: {},
    rowKey: {},
    fields: {},
    rowSchema: {},
    labels: {},
    closeOnSave: { type: Boolean },
    onCommit: { type: Function },
    onCancel: { type: Function }
  },
  setup(e) {
    const t = Ce(), n = e, l = Y(), o = async () => {
      await l.value?.save();
    };
    return (a, r) => (h(), R(f(un), {
      open: !0,
      size: "2",
      onClose: e.onCancel
    }, {
      default: S(() => [
        V(f(cn), null, {
          default: S(() => [
            V(f(dn), null, {
              default: S(() => [
                H(U(n.labels?.title ?? f(t)("ui.smartTable.editRow", "Edit row")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        V(f(It), { padded: !0 }, {
          default: S(() => [
            V(kr, {
              ref_key: "formRef",
              ref: l,
              row: e.row,
              "row-key": e.rowKey,
              fields: e.fields,
              "row-schema": e.rowSchema,
              "on-commit": e.onCommit,
              "on-cancel": e.onCancel
            }, null, 8, ["row", "row-key", "fields", "row-schema", "on-commit", "on-cancel"])
          ]),
          _: 1
        }),
        V(f(fn), null, {
          default: S(() => [
            V(f(we), {
              variant: "outline",
              onClick: e.onCancel
            }, {
              default: S(() => [
                H(U(n.labels?.cancel ?? f(t)("ui.common.cancel", "Cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            V(f(we), {
              variant: "filled",
              onClick: o
            }, {
              default: S(() => [
                H(U(n.labels?.save ?? f(t)("ui.common.save", "Save")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClose"]));
  }
}), nw = /* @__PURE__ */ ue({
  __name: "SmartTableRowEditor",
  props: {
    row: {},
    rowKey: {},
    fields: {},
    rowSchema: {},
    labels: {},
    closeOnSave: { type: Boolean, default: !0 },
    onCommit: {},
    onCancel: {}
  },
  setup(e) {
    const t = Ce(), n = e, l = Y(), o = async () => {
      await l.value?.save();
    };
    return (a, r) => (h(), R(f(zl), {
      class: "hp-smart-table-row-editor",
      tone: "surface",
      "top-border": "",
      "right-border": "",
      "bottom-border": "",
      "left-border": ""
    }, {
      default: S(() => [
        V(f(Ol), {
          title: n.labels?.title ?? f(t)("ui.smartTable.editRow", "Edit row"),
          "padding-x": "3",
          "padding-y": "2",
          "bottom-border": ""
        }, null, 8, ["title"]),
        V(f(Oa), {
          "padding-x": "3",
          "padding-y": "3"
        }, {
          default: S(() => [
            V(kr, {
              ref_key: "formRef",
              ref: l,
              row: e.row,
              "row-key": e.rowKey,
              fields: e.fields,
              "row-schema": e.rowSchema,
              "close-on-save": e.closeOnSave,
              "on-commit": e.onCommit,
              "on-cancel": e.onCancel
            }, null, 8, ["row", "row-key", "fields", "row-schema", "close-on-save", "on-commit", "on-cancel"])
          ]),
          _: 1
        }),
        V(f(Al), {
          "padding-x": "3",
          "padding-y": "2",
          "top-border": ""
        }, {
          default: S(() => [
            V(f(Ot), { zone: "right" }, {
              default: S(() => [
                V(f(we), {
                  variant: "outline",
                  onClick: e.onCancel
                }, {
                  default: S(() => [
                    H(U(n.labels?.cancel ?? f(t)("ui.common.cancel", "Cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                V(f(we), {
                  variant: "filled",
                  onClick: o
                }, {
                  default: S(() => [
                    H(U(n.labels?.save ?? f(t)("ui.common.save", "Save")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), wm = /* @__PURE__ */ ue({
  __name: "SmartTableColumnVisibilityDialog",
  props: {
    open: { type: Boolean },
    columns: {},
    hiddenColumnKeys: {},
    columnOrder: {},
    onApply: { type: Function },
    onClose: { type: Function }
  },
  setup(e) {
    const t = Ce(), n = e, l = b(
      () => n.columns.filter((w) => w.alwaysVisible !== !0).map((w) => ({
        key: w.key,
        label: w.label ?? w.key,
        visible: !n.hiddenColumnKeys.includes(w.key),
        reorderable: w.reorderable !== !1
      }))
    ), o = Y(""), a = Y([]), r = Y([]), s = b(() => {
      const w = new Map(l.value.map((O) => [O.key, O])), C = r.value.flatMap((O) => {
        const N = w.get(O);
        return N === void 0 ? [] : [N];
      }), x = new Set(r.value);
      return [...C, ...l.value.filter((O) => !x.has(O.key))];
    }), i = b(() => {
      const w = o.value.trim().toLocaleLowerCase();
      return s.value.filter((C) => C.label.toLocaleLowerCase().includes(w));
    });
    oe(
      () => n.open,
      (w) => {
        w && (o.value = "", a.value = l.value.filter((C) => C.visible).map((C) => C.key), r.value = n.columnOrder ? n.columnOrder.order(l.value).map((C) => C.key) : l.value.map((C) => C.key));
      },
      { immediate: !0 }
    );
    const c = (w) => a.value.includes(w), u = (w) => {
      a.value = c(w) ? a.value.filter((C) => C !== w) : [...a.value, w];
    }, d = () => {
      a.value = [.../* @__PURE__ */ new Set([...a.value, ...i.value.map((w) => w.key)])];
    }, v = () => {
      const w = new Set(i.value.map((C) => C.key));
      a.value = a.value.filter((C) => !w.has(C));
    }, m = (w) => n.columnOrder !== void 0 && w.reorderable && l.value.length > 1, p = (w, C, x) => {
      if (w === C)
        return;
      const O = [...r.value], N = O.indexOf(w);
      if (N < 0)
        return;
      O.splice(N, 1);
      const T = O.indexOf(C);
      T < 0 || (O.splice(T + (x === "after" ? 1 : 0), 0, w), r.value = O);
    }, g = (w, C) => {
      const x = C.target, O = Number(x.value), N = r.value.indexOf(w);
      if (!x.value.trim() || !Number.isInteger(O)) {
        x.value = String(N + 1);
        return;
      }
      const T = Math.max(0, Math.min(r.value.length - 1, O - 1)), L = r.value[T];
      L !== void 0 && p(w, L, T > N ? "after" : "before"), x.value = String(r.value.indexOf(w) + 1);
    }, y = Y(null), P = oi({
      axis: "y",
      rootRef: y,
      itemSelector: "[data-reorder-key]",
      canMove: (w) => {
        const C = l.value.find((x) => x.key === w);
        return C !== void 0 && m(C);
      },
      labelFor: (w) => l.value.find((C) => C.key === w)?.label ?? w,
      onMove: p
    }), I = () => {
      const w = new Set(a.value), C = l.value.filter((x) => !w.has(x.key)).map((x) => x.key);
      n.onApply(C, r.value), n.onClose();
    };
    return (w, C) => (h(), R(f(un), {
      open: e.open,
      variant: "surface",
      size: "2",
      onClose: e.onClose
    }, {
      default: S(() => [
        V(f(cn), null, {
          default: S(() => [
            V(f(dn), null, {
              default: S(() => [
                H(U(f(t)("ui.smartTable.columnSettings", "Column Settings")), 1)
              ]),
              _: 1
            }),
            V(f(Ka))
          ]),
          _: 1
        }),
        V(f(It), { padded: !1 }, {
          default: S(() => [
            be("div", {
              ref_key: "listRef",
              ref: y
            }, [
              V(f(ai), null, {
                default: S(() => [
                  V(f(ri), null, {
                    default: S(() => [
                      V(f(Xt), { interactive: !1 }, {
                        default: S(() => [
                          V(f(Ct), {
                            modelValue: o.value,
                            "onUpdate:modelValue": C[0] || (C[0] = (x) => o.value = x),
                            clearable: "",
                            placeholder: f(t)("ui.smartTable.searchColumns", "Search columns"),
                            "aria-label": f(t)("ui.smartTable.searchColumns", "Search columns")
                          }, null, 8, ["modelValue", "placeholder", "aria-label"])
                        ]),
                        _: 1
                      }),
                      V(f(Xt), { interactive: !1 }, {
                        default: S(() => [
                          V(f(si), { gap: "1" }, {
                            default: S(() => [
                              V(f(we), {
                                variant: "outline",
                                size: "2",
                                onClick: d
                              }, {
                                default: S(() => [
                                  H(U(f(t)("ui.weekScheduler.selectAll", "Select all")), 1)
                                ]),
                                _: 1
                              }),
                              V(f(we), {
                                variant: "outline",
                                size: "2",
                                onClick: v
                              }, {
                                default: S(() => [
                                  H(U(f(t)("ui.weekScheduler.deselectAll", "Deselect all")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  i.value.length ? B("", !0) : (h(), R(f(Xt), {
                    key: 0,
                    interactive: !1
                  }, {
                    default: S(() => [
                      V(f(kl), null, {
                        default: S(() => [
                          H(U(f(t)("ui.smartTable.noColumnsFound", "No columns found")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })),
                  (h(!0), $(se, null, Pe(i.value, (x) => (h(), R(f(Xt), {
                    key: x.key,
                    "data-reorder-key": x.key,
                    class: Ke(f(P).getDropClass(x.key)),
                    interactive: !1,
                    onDragover: (O) => f(P).onDragOver(O, x.key),
                    onDrop: (O) => f(P).onDrop(O, x.key)
                  }, {
                    default: S(() => [
                      m(x) ? (h(), R(f(we), {
                        key: 0,
                        variant: "blank",
                        size: "1",
                        square: "",
                        icon: f(ii),
                        draggable: "true",
                        "data-column-reorder-key": x.key,
                        "aria-label": f(t)("ui.table.moveColumn", "Move {column} column", { column: x.label }),
                        onClick: C[1] || (C[1] = tt(() => {
                        }, ["stop"])),
                        onDragstart: (O) => f(P).onDragStart(O, x.key),
                        onDragend: f(P).onDragEnd,
                        onPointerdown: (O) => f(P).onPointerDown(O, x.key)
                      }, null, 8, ["icon", "data-column-reorder-key", "aria-label", "onDragstart", "onDragend", "onPointerdown"])) : B("", !0),
                      m(x) ? (h(), R(f(Ct), {
                        key: 1,
                        type: "number",
                        size: "1",
                        width: "2.5rem",
                        "min-width": "2.5rem",
                        "max-width": "2.5rem",
                        "model-value": String(r.value.indexOf(x.key) + 1),
                        min: 1,
                        max: r.value.length,
                        step: 1,
                        "aria-label": f(t)("ui.smartTable.columnPosition", "{column} position", { column: x.label }),
                        onChange: (O) => g(x.key, O)
                      }, null, 8, ["model-value", "max", "aria-label", "onChange"])) : B("", !0),
                      V(f(kl), null, {
                        default: S(() => [
                          H(U(x.label), 1)
                        ]),
                        _: 2
                      }, 1024),
                      V(f(Ma), null, {
                        default: S(() => [
                          V(f(qn), {
                            size: "2",
                            "model-value": c(x.key),
                            "aria-label": f(t)("ui.table.columnVisibility", "{column} visibility", { column: x.label }),
                            "onUpdate:modelValue": (O) => u(x.key)
                          }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["data-reorder-key", "class", "onDragover", "onDrop"]))), 128))
                ]),
                _: 1
              })
            ], 512)
          ]),
          _: 1
        }),
        V(f(fn), null, {
          default: S(() => [
            V(f(ui), { align: "right" }, {
              default: S(() => [
                V(f(we), {
                  variant: "outline",
                  size: "3",
                  onClick: e.onClose
                }, {
                  default: S(() => [
                    H(U(f(t)("ui.common.cancel", "Cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                V(f(we), {
                  variant: "filled",
                  size: "3",
                  disabled: a.value.length === 0,
                  onClick: I
                }, {
                  default: S(() => [
                    H(U(f(t)("ui.common.apply", "Apply")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "onClose"]));
  }
}), _o = (e) => e == null ? "" : String(e), $n = (e, t, n) => {
  const l = t.view;
  if (l && On(l) && (l.kind === "text" || l.kind === "number" || l.kind === "textIcon")) {
    const o = l.value ? l.value(e) : n;
    return l.format ? l.format(o, e) : _o(o);
  }
  return t.format ? t.format(n) : _o(n);
}, km = (e) => e == null ? "" : e instanceof Date ? e.toISOString() : typeof e == "object" ? JSON.stringify(e) : String(e), Sm = (e, t, n) => vr(
  {
    href: t.href?.(e),
    text: t.title?.(e),
    emptyActionLabel: t.emptyAction?.label,
    onEmptyAction: t.emptyAction ? () => t.emptyAction.handler(e) : void 0
  },
  n
), Cm = (e, t, n, l) => {
  const o = e[t.key];
  switch (n.kind) {
    case "text":
    case "number":
    case "textIcon":
      return $n(e, t, o);
    case "link":
      return Sm(e, n, l);
    case "badges":
      return n.items(e).map((a) => a.label).join(", ");
    case "thumbnail":
      return (typeof n.alt == "function" ? n.alt(e) : n.alt) ?? "";
    default:
      return "";
  }
}, Im = (e, t, n) => t.copyValue ? t.copyValue(e) : t.view && On(t.view) ? Cm(e, t, t.view, n) : $n(e, t, e[t.key]), Rm = (e) => {
  const t = mt(ci()), n = Ce(), l = b(
    () => _(e.columns).filter(
      (y) => y.rangeSelectable !== !1 && !(y.view && typeof y.view == "object" && "kind" in y.view && y.view.kind === "buttons")
    )
  ), o = b(() => new Map(_(e.rows).map((y) => [e.rowKey(y), y]))), a = b(() => {
    let y = "__hp_summary__";
    for (; o.value.has(y); )
      y = `_${y}`;
    return y;
  }), r = b(() => _(e.summary)), s = b(() => new Map(l.value.map((y) => [y.key, y]))), i = b(() => ({
    rowKeys: [...o.value.keys(), ...r.value ? [a.value] : []],
    columnKeys: l.value.map((y) => y.key),
    visualColumnKeys: _(e.columns).map((y) => y.key),
    getText: (y, P) => {
      if (r.value && y.rowKey === a.value)
        return r.value[y.columnKey] ?? "";
      const I = o.value.get(y.rowKey), w = s.value.get(y.columnKey);
      return !I || !w ? "" : P === "raw" ? km(I[w.key]) : Im(I, w, n("ui.smartTable.add", "Add"));
    },
    getColumnLabel: (y) => s.value.get(y)?.label ?? y
  })), c = di(
    {
      state: t,
      surface: i,
      onChange: (y) => {
        t.value = y;
      }
    },
    e.selection,
    e.clipboard
  ), u = b(
    () => c.enabled.value ? JSON.stringify([
      i.value.rowKeys,
      i.value.columnKeys,
      i.value.visualColumnKeys,
      _(e.revision)
    ]) : ""
  );
  oe([u, c.enabled], () => c.clear(), { flush: "sync" }), oe(c.clipboardEnabled, (y) => {
    y || c.clearCopied();
  });
  const d = () => {
    const y = c.serialize();
    return y.ok ? y.text : void 0;
  };
  let v;
  oe(
    () => t.value.copiedRanges,
    (y) => {
      v = y.length ? d() : void 0;
    },
    { flush: "sync" }
  );
  const m = b(() => t.value.copiedRanges.length ? d() : void 0);
  return oe(
    m,
    (y) => {
      t.value.copiedRanges.length && y !== v && c.clearCopied();
    },
    { flush: "sync" }
  ), { api: c, cellAttrs: (y, P) => vo(c, { rowKey: e.rowKey(y), columnKey: P.key }, { managed: !0 }), summaryCellAttrs: (y) => c.enabled.value ? vo(c, { rowKey: a.value, columnKey: y.key }, { managed: !0 }) : {} };
}, Pm = ["data-editable-cell", "data-row", "data-col", "tabindex", "data-editable-cell-disabled", "aria-disabled", "data-state", "data-self-outlined", "title"], Tm = {
  key: 3,
  class: "hp-smart-table-cell__value"
}, Em = {
  key: 2,
  class: "hp-smart-table-cell__value"
}, dl = '[role="dialog"], dialog[open]', Mm = "input, textarea, select, [contenteditable]", Vm = ".hp-select__trigger-wrapper", Yo = "", xm = /* @__PURE__ */ ue({
  __name: "SmartTableCell",
  props: {
    table: {},
    row: {},
    col: {},
    tableDisabled: { type: Boolean },
    rowLoading: { type: Boolean },
    rangeMode: { type: Boolean },
    failedCommit: {},
    onCommitFailed: { type: Function }
  },
  setup(e) {
    const t = e, n = b(() => t.table.rowKeyOf(t.row)), l = b(() => t.table.cellStateFor(t.row, t.col).value), o = b(() => gr(t.col)), a = b(() => {
      const M = t.col.editor;
      return M !== void 0 && hr(M) ? M : void 0;
    }), r = b(() => a.value?.props?.(t.row) ?? {}), s = b(
      () => o.value === void 0 ? void 0 : { ...o.value, label: void 0 }
    ), i = b(() => {
      const M = o.value;
      return M !== void 0 && M.shape === "value" && M.source === "field" && M.kind === "boolean";
    }), c = b(() => {
      const M = o.value;
      return M !== void 0 && M.shape === "value" && M.source === "field" && M.kind === "date";
    }), u = b(() => {
      const M = o.value;
      return M === void 0 || M.shape !== "value" ? !1 : M.source === "list" ? M.multi === !0 : M.source === "field" && M.kind === "tags";
    }), d = b(
      () => (c.value || u.value) && t.col.minWidth !== void 0 ? { minWidth: `${t.col.minWidth}px` } : void 0
    ), v = Y(null), m = b(() => br(t.col)), p = b(
      () => !m.value && t.col.alwaysEdit === !0 || !m.value && t.table.activeCell.value !== null && t.table.activeCell.value.rowKey === n.value && t.table.activeCell.value.colKey === t.col.key
    ), g = b(() => l.value.disabled === !0 || t.tableDisabled === !0), y = b(() => {
      if (!(m.value || t.rangeMode))
        return g.value ? -1 : 0;
    }), P = b(() => m.value || g.value), I = b(
      () => t.failedCommit !== null && t.failedCommit.rowKey === n.value && t.failedCommit.colKey === t.col.key
    ), w = (M, he) => $n(t.row, he, M), C = b(() => {
      const M = t.col.view;
      return M === void 0 ? null : On(M) ? M.kind === "number" ? "text" : M.kind : ul(M) ? "component" : cl(M) ? "render" : "component";
    }), x = b(() => !p.value && C.value === "badges"), O = (M) => typeof M == "function" ? M(t.row) : M, N = b(() => {
      const M = t.col.view;
      return {
        text: $n(t.row, t.col, l.value.value),
        icon: M.icon ? O(M.icon) : void 0,
        iconPlacement: M.iconPlacement,
        iconColor: M.iconColor ? O(M.iconColor) : void 0,
        iconTooltip: M.iconTooltip,
        iconBadge: M.iconBadge,
        iconBadgeVariant: M.iconBadgeVariant
      };
    }), T = b(() => {
      const M = t.col.view;
      return {
        src: M.src(t.row),
        alt: M.alt ? O(M.alt) : void 0,
        hoverPreview: M.hoverPreview,
        hoverTitle: M.hoverTitle ? O(M.hoverTitle) : void 0,
        hoverDetails: M.hoverDetails ? M.hoverDetails(t.row) : void 0,
        hoverVideoAutoplay: M.hoverVideoAutoplay,
        fallbackImage: M.fallbackImage,
        badge: M.badge ? O(M.badge) : void 0
      };
    }), L = b(() => {
      const M = t.col.view, he = M.emptyAction;
      return {
        href: M.href ? M.href(t.row) : void 0,
        text: M.title ? M.title(t.row) : void 0,
        color: M.color ? O(M.color) : void 0,
        emptyActionLabel: he?.label,
        onEmptyAction: he ? () => he.handler(t.row) : void 0
      };
    }), k = b(() => {
      const M = t.col.view;
      return { items: M.items(t.row), size: M.size, maxVisible: M.maxVisible };
    }), K = b(() => ({ buttons: t.col.view.buttons.filter((ze) => ze.visible?.(t.row) !== !1).map((ze) => ({
      label: ze.label,
      icon: ze.icon,
      onClick: () => ze.handler(t.row),
      variant: ze.variant,
      size: ze.size,
      disabled: typeof ze.disabled == "function" ? ze.disabled(t.row) : ze.disabled
    })) })), W = b(() => {
      const M = t.col.view;
      return M === void 0 ? null : ul(M) ? M.component : !On(M) && !cl(M) ? M : null;
    }), G = b(() => {
      const M = t.col.view, he = { row: t.row, value: l.value.value };
      if (M !== void 0 && ul(M)) {
        const ze = M.props?.(t.row) ?? {};
        return { ...he, ...ze, disabled: g.value || ze.disabled === !0 };
      }
      return he;
    }), A = b(() => {
      const M = t.col.view;
      return M !== void 0 && cl(M) ? M(t.row, t.table.rows.value) : null;
    }), E = or({
      initialValue: l.value.value,
      disabled: b(() => l.value.disabled ?? !1)
    });
    oe(
      [() => l.value.value, () => t.table.seedVersion.value],
      () => {
        t.col.alwaysEdit === !0 && E.setValue(l.value.value);
      }
    );
    const D = (M = !1) => {
      if (t.tableDisabled === !0)
        return { ok: !0 };
      const he = t.col.key, ze = E.state.value.value, ct = t.table.handleCellCommit(n.value, he, ze, {
        keepActive: M
      });
      return ct.ok || t.onCommitFailed({
        rowKey: n.value,
        colKey: t.col.key,
        issues: ct.issues
      }), ct.ok && M !== !0 && (He = !0), ct;
    }, X = b(() => {
      const M = o.value;
      return M === void 0 ? !1 : M.shape === "value" && M.source === "field" ? M.kind === "boolean" || M.kind === "date" : M.shape === "value" && M.source === "list" ? M.multi !== !0 : !1;
    }), z = (M) => {
      E.setValue(M), X.value && D(i.value).ok && !i.value && ee();
    }, Q = b(() => {
      const M = o.value;
      return M === void 0 || M.shape !== "value" ? !1 : M.source === "list" ? !0 : M.source === "field" && (M.kind === "date" || M.kind === "tags");
    }), ne = (M) => {
      const he = M.target?.closest(dl);
      return !!(he && !he.contains(v.value));
    }, ae = () => [...document.querySelectorAll(dl)].some((M) => !t.rangeMode || !M.contains(v.value)), Ie = `${dl}, [data-editable-cell-popup]`, ke = (M) => {
      if (M instanceof HTMLElement) {
        const he = M.closest(Ie);
        return !!(he && !he.contains(v.value));
      }
      return M == null && document.querySelector(Ie) != null;
    };
    let $e = !1, He = !1;
    const qe = (M, he) => M === he ? !0 : JSON.stringify(M) === JSON.stringify(he), Ye = () => {
      if (t.tableDisabled === !0)
        return;
      const M = t.table.cellStateFor(t.row, t.col).value.value, he = E.state.value.value;
      if (qe(he, M))
        return;
      const ze = t.col.key, ct = t.table.handleCellCommit(n.value, ze, he, { keepActive: !0 });
      ct.ok || t.onCommitFailed({ rowKey: n.value, colKey: t.col.key, issues: ct.issues });
    };
    oe(p, (M, he) => {
      if (M)
        E.setValue(l.value.value), ot(() => {
          (v.value?.querySelector(Mm) ?? v.value?.querySelector(Vm))?.focus();
        });
      else if (he) {
        if ($e) {
          $e = !1;
          return;
        }
        if (He) {
          He = !1;
          return;
        }
        Ye();
      }
    });
    const j = () => {
      !p.value || $e || Q.value || D();
    }, q = (M) => {
      if (!p.value)
        return;
      const he = M.relatedTarget;
      he !== null && (v.value?.contains(he) || ke(he) || t.table.handleDeactivateCell());
    }, J = (M) => {
      t.rangeMode && M || P.value || M && ne(M) || p.value || (t.col.editMode === "dialog" || t.col.editMode === "external" ? t.table.handleOpenRowEdit(n.value, t.col.editMode) : (t.table.handleActivateCell(n.value, t.col.key), t.col.rowEditPresentation !== void 0 && t.table.handleOpenRowEdit(n.value, t.col.rowEditPresentation)));
    }, ee = () => {
      ot(() => (t.rangeMode ? v.value?.closest("[data-range-row]") : v.value)?.focus());
    }, de = (M) => {
      if (ne(M))
        return !0;
      const he = M.key === "ArrowUp" || M.key === "ArrowDown";
      return p.value && Q.value && he && ae() ? (M.stopPropagation(), !0) : !1;
    }, ve = (M) => {
      M.defaultPrevented || (M.preventDefault(), $e = !0, t.table.handleDeactivateCell(), ee());
    }, me = (M) => {
      if (!P.value && !de(M)) {
        if (!p.value) {
          M.key === "Enter" && (M.preventDefault(), J());
          return;
        }
        if (M.key === "Escape") {
          ve(M);
          return;
        }
        M.key === "Enter" && (M.preventDefault(), D().ok && ((Le?.moveActive(1, 0) ?? !1) || ee()));
      }
    }, xe = b(() => t.table.treeColumnKey.value === t.col.key), Te = b(
      () => t.table.treeEnabled.value && xe.value ? t.table.treeMetaFor(n.value) : null
    ), We = () => {
      t.table.handleToggleExpand(n.value);
    }, Le = fi(), ht = b(() => p.value ? "editing" : "idle"), pt = b(() => l.value.value), Z = b(() => w(l.value.value, t.col)), ie = b(() => {
      if (p.value || t.col.key !== "name" && t.col.label !== "Name")
        return;
      let M = Z.value;
      return C.value === "textIcon" ? M = N.value.text : C.value === "link" && (M = L.value.text ?? L.value.href ?? ""), M?.trim().length ? M : void 0;
    }), Se = Y(Yo);
    oe(
      () => E.state.value.value,
      (M) => {
        Se.value = M == null ? Yo : String(M);
      }
    );
    let Oe = null;
    return Kl(() => {
      !Le || m.value || (Oe = { rowKey: n.value, colKey: t.col.key }, Le.registerCell(Oe, {
        state: ht,
        value: pt,
        displayValue: Z,
        draft: Se,
        commit: () => p.value ? D().ok : !0,
        activate: () => J()
      }));
    }), Zt(() => {
      !Le || Oe === null || (Le.unregisterCell(Oe), Oe = null);
    }), (M, he) => (h(), $("div", {
      ref_key: "cellRef",
      ref: v,
      "data-editable-cell": m.value ? void 0 : !0,
      "data-row": m.value ? void 0 : n.value,
      "data-col": m.value ? void 0 : e.col.key,
      tabindex: y.value,
      "data-editable-cell-disabled": g.value || void 0,
      "aria-disabled": m.value ? void 0 : g.value || void 0,
      "data-hp-flush-content": "true",
      "data-state": p.value ? "editing" : void 0,
      "data-self-outlined": i.value || void 0,
      title: ie.value,
      class: Ke([{
        "hp-smart-table-cell--content-sized": x.value,
        "hp-smart-table-cell--invalid": I.value,
        "hp-smart-table-cell--editing": p.value,
        "hp-smart-table-cell--range-mode": e.rangeMode
      }, "hp-smart-table-cell"]),
      style: et(d.value),
      onClick: J,
      onKeydown: me,
      onFocusout: q
    }, [
      Te.value !== null ? (h(), R(f(Ea), {
        key: 0,
        class: "hp-smart-table-cell__tree-connector",
        depth: Te.value.depth,
        expandable: Te.value.hasChildren,
        expanded: Te.value.expanded,
        last: Te.value.isLast,
        lines: Te.value.ancestorLines,
        shrink: t.table.treeShrink.value,
        "show-lines": !0,
        onExpand: We
      }, {
        default: S(() => [
          e.rowLoading ? (h(), R(f(vi), {
            key: 0,
            size: "2",
            class: "hp-smart-table-cell__tree-loader"
          })) : B("", !0),
          p.value && s.value ? (h(), R(Lt, {
            key: 1,
            config: s.value,
            state: f(E).state.value,
            cell: !0,
            "onUpdate:value": z,
            onBlur: j
          }, null, 8, ["config", "state"])) : p.value && a.value ? (h(), R(lt(a.value.component), Ve({
            key: 2,
            value: l.value.value
          }, r.value, { "onUpdate:value": z }), null, 16, ["value"])) : (h(), $("span", Tm, [
            C.value === "textIcon" ? (h(), R(Wo, Ge(Ve({ key: 0 }, N.value)), null, 16)) : C.value === "thumbnail" ? (h(), R(Zo, Ge(Ve({ key: 1 }, T.value)), null, 16)) : C.value === "link" ? (h(), R(Ho, Ge(Ve({ key: 2 }, L.value)), null, 16)) : C.value === "badges" ? (h(), R(jo, Ge(Ve({ key: 3 }, k.value)), null, 16)) : C.value === "buttons" ? (h(), R(Uo, Ge(Ve({ key: 4 }, K.value)), null, 16)) : C.value === "component" && W.value ? (h(), R(lt(W.value), Ge(Ve({ key: 5 }, G.value)), null, 16)) : C.value === "render" ? (h(), R(lt(A.value), { key: 6 })) : (h(), $(se, { key: 7 }, [
              H(U(w(l.value.value, e.col)), 1)
            ], 64))
          ]))
        ]),
        _: 1
      }, 8, ["depth", "expandable", "expanded", "last", "lines", "shrink"])) : (h(), $(se, { key: 1 }, [
        p.value && s.value ? (h(), R(Lt, {
          key: 0,
          config: s.value,
          state: f(E).state.value,
          cell: !0,
          "onUpdate:value": z,
          onBlur: j
        }, null, 8, ["config", "state"])) : p.value && a.value ? (h(), R(lt(a.value.component), Ve({
          key: 1,
          value: l.value.value
        }, r.value, { "onUpdate:value": z }), null, 16, ["value"])) : (h(), $("span", Em, [
          C.value === "textIcon" ? (h(), R(Wo, Ge(Ve({ key: 0 }, N.value)), null, 16)) : C.value === "thumbnail" ? (h(), R(Zo, Ge(Ve({ key: 1 }, T.value)), null, 16)) : C.value === "link" ? (h(), R(Ho, Ge(Ve({ key: 2 }, L.value)), null, 16)) : C.value === "badges" ? (h(), R(jo, Ge(Ve({ key: 3 }, k.value)), null, 16)) : C.value === "buttons" ? (h(), R(Uo, Ge(Ve({ key: 4 }, K.value)), null, 16)) : C.value === "component" && W.value ? (h(), R(lt(W.value), Ge(Ve({ key: 5 }, G.value)), null, 16)) : C.value === "render" ? (h(), R(lt(A.value), { key: 6 })) : (h(), $(se, { key: 7 }, [
            H(U(w(l.value.value, e.col)), 1)
          ], 64))
        ]))
      ], 64))
    ], 46, Pm));
  }
}), Km = /* @__PURE__ */ Ae(xm, [["__scopeId", "data-v-048adcd1"]]), zm = { class: "smart-table__header-menu-cell" }, Om = ["aria-disabled"], Am = {
  key: 0,
  class: "smart-table__error-list"
}, $m = 16, Lm = 240, Qo = "__row_actions__", Fm = "40px", Dm = /* @__PURE__ */ ue({
  __name: "SmartTable",
  props: {
    fill: { type: Boolean },
    rangeSelection: { type: [Boolean, Object], default: !1 },
    rangeClipboard: { type: [Boolean, Object], default: !1 },
    summary: {},
    table: {},
    columns: {},
    columnOrder: { default: void 0 },
    columnWidths: { default: void 0 },
    stickyStart: {},
    stickyEnd: {},
    disabled: { type: Boolean, default: !1 },
    showSelectionActions: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 },
    loadingBar: {},
    skeletonRows: { default: 5 },
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    emptyMessage: {},
    emptyPlacement: {},
    fillHeight: { type: Boolean },
    size: { default: "2" },
    headerPaddingY: {},
    headerPaddingX: {},
    toolbarPaddingY: { default: "2" },
    toolbarPaddingX: { default: "4" },
    filtersPaddingX: { default: "4" },
    filtersPaddingY: { default: "3" },
    filtersPaddingTop: {},
    searchWidth: { default: "100%" },
    searchSize: {},
    searchRadius: {},
    searchSuffix: {},
    searchAlign: { default: "center" },
    rowMinHeight: {},
    rowEditLabels: { default: () => ({}) },
    resizable: { type: Boolean, default: !1 },
    stickyHeader: { type: Boolean, default: !0 },
    stickyHeaderMaxHeight: {},
    viewportBound: { type: Boolean },
    hoverable: { type: Boolean, default: void 0 },
    horizontalLines: { type: Boolean, default: void 0 },
    verticalLines: { type: Boolean, default: void 0 },
    clickable: { type: Boolean, default: void 0 },
    stickyEndSpacer: { type: Boolean, default: void 0 },
    card: { type: [Boolean, String], default: void 0 },
    bg: { default: void 0 },
    boxed: { type: Boolean, default: void 0 },
    stableColumns: { type: Boolean, default: !0 },
    headerMenuItems: { default: () => [] },
    headerActionsInMenu: { type: Boolean },
    rowLoading: {},
    rowClass: {}
  },
  setup(e) {
    const t = Ce(), n = Y(), l = Y(0), o = Y(0);
    let a, r = 0;
    const s = () => {
      cancelAnimationFrame(r), r = requestAnimationFrame(() => {
        const F = n.value?.$el;
        F instanceof HTMLElement && (l.value = F.getBoundingClientRect().top, o.value = window.innerHeight);
      });
    };
    Kl(() => {
      if (!u.viewportBound)
        return;
      const F = n.value?.$el;
      a = new ResizeObserver(s), F instanceof HTMLElement && (a.observe(F), F.parentElement && a.observe(F.parentElement)), window.addEventListener("resize", s), window.addEventListener("scroll", s, !0), s();
    }), Zt(() => {
      a?.disconnect(), cancelAnimationFrame(r), window.removeEventListener("resize", s), window.removeEventListener("scroll", s, !0);
    });
    const i = b(() => u.viewportBound ? {
      maxHeight: `${Math.max(Lm, o.value - Math.max(0, l.value) - $m)}px`
    } : void 0), c = b(() => u.fill ? "smart-table--fill" : void 0), u = e, d = xl();
    oe(
      () => u.disabled,
      (F) => {
        F && u.table.handleDeactivateCell();
      }
    );
    const v = Y(!1);
    oe(
      () => u.table.activeCell.value,
      (F) => {
        F !== null && u.stableColumns && (v.value = !0);
      }
    );
    const m = (F) => {
      const le = /* @__PURE__ */ new Set();
      for (const te of F)
        for (const Fe of Object.keys(te))
          le.add(Fe);
      return Array.from(le).map((te) => ({
        key: te,
        label: te,
        // Inferred columns stay editable text (backward compatible): the editor carries the
        // ControlConfig; view falls back to the format text span.
        editor: { shape: "value", source: "field", kind: "text" }
      }));
    }, p = b(
      () => u.columns ?? m(u.table.rows.value)
    ), g = b(
      () => p.value.filter(
        (F) => F.alwaysVisible === !0 || !u.table.hiddenColumnKeys.value.includes(F.key)
      )
    ), y = b(
      () => u.stickyStart ?? g.value.filter((F) => F.sticky === "start").length
    ), P = b(
      () => u.stickyEnd ?? g.value.filter((F) => F.sticky === "end").length
    ), I = b(() => u.headerMenuItems.length > 0), w = (F) => u.table.rowActions.value.filter((le) => le.visible?.(F) !== !1).map((le) => ({
      label: le.label,
      icon: le.icon,
      variant: le.danger ? "danger" : "default",
      disabled: u.disabled || (le.disabled ? le.disabled(F) : !1),
      onClick: () => le.onClick(F)
    })), C = (F) => F.onClick(u.table.selectedRows.value), x = b(
      () => u.table.bulkActions.value.filter((F) => F.visible?.(u.table.selectedRows.value) !== !1)
    ), O = () => {
      u.table.handleSelectionChange([]);
    }, N = (F) => {
      u.disabled || u.table.onRowClick?.(F);
    }, T = b(() => {
      const F = u.rowClass;
      if (F !== void 0)
        return (le) => {
          const te = F(le);
          return te !== void 0 && te !== "" ? { class: te } : {};
        };
    }), L = b(() => t("ui.smartTable.columnSettings", "Column Settings")), k = Y(!1), K = () => {
      k.value = !0;
    }, W = () => {
      k.value = !1;
    }, G = (F, le) => {
      u.table.setHiddenColumnKeys(F), u.columnOrder?.setOrder(le);
    }, A = b(() => p.value.some((F) => F.alwaysVisible !== !0)), E = b(() => u.headerMenuItems.map((F, le) => ({
      ...F,
      divider: F.divider || le === 0 && u.table.columnVisibilityEnabled.value && A.value
    }))), D = b(() => {
      const F = [];
      return u.table.columnVisibilityEnabled.value && A.value && F.push({
        id: "column-settings",
        label: L.value,
        icon: mo,
        presentation: { wide: u.headerActionsInMenu ? "menu" : "icon", compact: "menu", minimal: "menu" },
        variant: "outline",
        disabled: u.disabled,
        onClick: K
      }), I.value && F.push({
        id: "header-menu",
        label: t("ui.smartTable.moreActions", "More actions"),
        icon: al,
        presentation: { wide: u.headerActionsInMenu ? "menu" : "icon", compact: "menu", minimal: "menu" },
        variant: "outline",
        disabled: u.disabled,
        menuItems: E.value
      }), F;
    }), X = b(
      () => !!d.title || !!d["title-actions"] || I.value
    ), z = Y(null), Q = Y(!1), ne = (F) => {
      z.value = F, Q.value = !0;
    }, ae = () => {
      Q.value = !1, z.value = null;
    }, Ie = () => {
      Q.value = !1, z.value = null, u.table.handleDeactivateCell();
    }, ke = () => {
      const F = {};
      for (const le of p.value)
        F[le.key] = le.label ?? le.key;
      return F;
    }, $e = (F, le) => {
      const te = ke();
      if (F.path === le || F.path === "")
        return F.message;
      const Fe = te[F.path] ?? F.path;
      return t("ui.smartTable.crossFieldSuffix", "{message} (field: {field})", {
        message: F.message,
        field: Fe
      });
    }, He = b(() => {
      const F = z.value;
      if (F === null)
        return t("ui.smartTable.validationErrorPlain", "Validation error");
      const le = ke()[F.colKey] ?? F.colKey;
      return t("ui.smartTable.validationErrorForField", "Validation error: {field}", { field: le });
    }), qe = (F) => {
      u.columnWidths?.remember(F);
    }, Ye = b(() => {
      const F = (te) => u.columnWidths?.widths.value[te], le = g.value.map((te) => {
        const Fe = te.resizable === !1 ? void 0 : F(te.key);
        return {
          key: te.key,
          label: te.label ?? te.key,
          // Sorting is one of the surfaces `disabled` locks (see the component-level disabled seam
          // above) — forcing `sortable: false` removes both the click affordance and the sort arrow.
          sortable: u.disabled ? !1 : te.sortable,
          reorderable: te.reorderable,
          tooltip: te.tooltip,
          labelBadge: te.labelBadge,
          labelBadgePlacement: te.labelBadgePlacement,
          width: Fe === void 0 ? te.width : `${Math.round(Fe)}px`,
          mobileWidth: te.mobileWidth,
          minWidth: te.minWidth,
          maxWidth: te.maxWidth,
          mono: te.mono,
          nowrap: te.nowrap,
          truncate: te.truncate,
          align: te.align,
          resizable: te.resizable
        };
      });
      return u.table.rowActionsEnabled.value && le.push({
        key: Qo,
        label: "",
        width: Fm,
        resizable: !1,
        reorderable: !1
      }), le;
    }), j = b(() => g.value.filter((F) => (F.headerMenu?.length ?? 0) > 0)), q = b(() => {
      const F = [];
      for (const le of p.value) {
        const te = gr(le);
        te !== void 0 && F.push({ ...te, key: le.key, label: le.label ?? te.label });
      }
      return F;
    }), J = b(() => {
      const F = u.table.rowBeingEdited.value, le = u.table.rowEditKey.value;
      return F === null || le === null ? null : {
        row: F,
        rowKey: le,
        fields: q.value,
        rowSchema: u.table.rowSchema.value,
        labels: u.rowEditLabels,
        onCommit: u.table.handleRowCommit,
        onCancel: u.table.handleCloseRowEdit
      };
    }), ee = b(
      () => u.table.treeEnabled.value ? u.table.flattenedRows.value.map((F) => F.row) : u.table.pagedRows.value
    ), de = Y(), ve = b(() => u.columnOrder?.order(g.value) ?? g.value), me = Rm({
      rows: () => ee.value,
      columns: ve,
      rowKey: (F) => String(F[u.table.rowKeyField.value]),
      selection: () => u.rangeSelection,
      summary: () => u.summary,
      clipboard: () => u.rangeClipboard,
      revision: () => JSON.stringify(u.table.queryState.value)
    }), xe = (F, le) => u.disabled || u.error ? {} : me.cellAttrs(F, le), Te = (F) => u.disabled || u.error ? {} : me.summaryCellAttrs(F), We = b(() => me.api.enabled.value ? g.value : j.value), Le = (F) => me.api.enabled.value && me.api.options.value.columns !== !1 && me.api.surface.value.columnKeys.includes(F), ht = (F, le) => {
      Le(F.key) && de.value?.selectAxis("column", F.key, le);
    }, pt = async (F) => {
      await ot(), await new Promise((le) => requestAnimationFrame(() => le())), Le(F) && de.value?.selectAxis("column", F);
    }, Z = (F, le) => {
      u.disabled || u.loading || u.error || (u.table.handleSortKey(F), u.table.handleSortDirection(le));
    }, ie = (F) => {
      if (!F.sortable)
        return [];
      const le = u.disabled || u.loading || u.error;
      return [
        {
          label: t("ui.tableRange.sortAscending", "Sort ascending"),
          icon: wi,
          disabled: le,
          onClick: () => Z(F.key, "asc")
        },
        {
          label: t("ui.tableRange.sortDescending", "Sort descending"),
          icon: ki,
          disabled: le,
          onClick: () => Z(F.key, "desc")
        }
      ];
    }, Se = (F) => Le(F.key) ? [
      {
        label: t("ui.tableRange.selectColumn", "Select column"),
        icon: Si,
        divider: !!(F.sortable || F.headerMenu?.length),
        disabled: u.disabled || u.error || !me.api.surface.value.rowKeys.length,
        onClick: () => pt(F.key)
      }
    ] : [], Oe = (F) => [
      ...ie(F),
      ...(F.headerMenu ?? []).map((le) => ({ ...le, disabled: le.disabled || u.loading })),
      ...Se(F)
    ], M = b(() => me.api.enabled.value && me.api.options.value.columns !== !1 ? ht : void 0), he = b(() => {
      const F = u.table.pageSizeOptions.value, le = F?.length ? Math.min(...F) : u.table.pageSize.value;
      return u.table.paginationEnabled.value && u.table.total.value > le;
    }), ze = b(() => {
      const F = u.table.pageSizeOptions.value;
      return F === void 0 ? void 0 : [...F];
    }), ct = (F) => {
      u.disabled || u.table.handlePageChange(F);
    }, nl = (F) => {
      u.disabled || u.table.handlePageSizeChange(F);
    };
    return (F, le) => (h(), $(se, null, [
      V(f(zl), {
        ref_key: "layoutElement",
        ref: n,
        style: et(i.value),
        "layout-id": `smart-table-${F.$.uid}`,
        tone: "surface",
        bg: e.bg,
        "template-columns": "minmax(0, 1fr)",
        class: Ke([f(fr)(e.card), c.value, e.loading && "smart-table--loading", e.viewportBound && "smart-table--viewport"].filter(Boolean).join(" ")),
        "aria-disabled": e.disabled || void 0
      }, {
        default: S(() => [
          X.value ? (h(), R(f(Ol), {
            key: 0,
            "padding-x": e.headerPaddingX,
            "padding-y": e.headerPaddingY,
            gap: "2",
            "bottom-border": ""
          }, {
            default: S(() => [
              d.title ? (h(), R(f(Ot), {
                key: 0,
                zone: "title",
                wrap: ""
              }, {
                default: S(() => [
                  pe(F.$slots, "title", {}, void 0, !0)
                ]),
                _: 3
              })) : B("", !0),
              d["title-actions"] || e.table.columnVisibilityEnabled.value && A.value || I.value ? (h(), R(f(Ot), {
                key: 1,
                zone: "right"
              }, {
                default: S(() => [
                  pe(F.$slots, "title-actions", {}, void 0, !0),
                  D.value.length > 0 ? (h(), R(f(mi), {
                    key: 0,
                    actions: D.value,
                    size: e.size,
                    "menu-icon": f(al),
                    "menu-variant": "outline"
                  }, null, 8, ["actions", "size", "menu-icon"])) : B("", !0)
                ]),
                _: 3
              })) : B("", !0)
            ]),
            _: 3
          }, 8, ["padding-x", "padding-y"])) : B("", !0),
          e.table.searchable.value || e.table.columnVisibilityEnabled.value && !X.value && A.value || d["toolbar-start"] || d["search-after"] || d["toolbar-end"] ? (h(), R(f(ho), {
            key: 1,
            "padding-x": e.toolbarPaddingX,
            "padding-y": e.toolbarPaddingY,
            "bottom-border": ""
          }, {
            default: S(() => [
              d["toolbar-start"] ? (h(), R(f(Ot), {
                key: 0,
                zone: "left",
                wrap: ""
              }, {
                default: S(() => [
                  pe(F.$slots, "toolbar-start", {}, void 0, !0)
                ]),
                _: 3
              })) : B("", !0),
              e.table.searchable.value || d["search-after"] ? (h(), R(f(Ot), {
                key: 1,
                zone: e.searchAlign,
                grow: ""
              }, {
                default: S(() => [
                  e.table.searchable.value ? (h(), R(f(Ct), {
                    key: 0,
                    width: e.searchWidth,
                    size: e.searchSize ?? e.size,
                    radius: e.searchRadius,
                    suffix: e.searchSuffix,
                    "model-value": e.table.searchQuery.value,
                    placeholder: e.table.searchPlaceholder.value,
                    "onUpdate:modelValue": le[0] || (le[0] = (te) => e.table.handleSearchChange(te == null ? "" : String(te)))
                  }, null, 8, ["width", "size", "radius", "suffix", "model-value", "placeholder"])) : B("", !0),
                  pe(F.$slots, "search-after", {}, void 0, !0)
                ]),
                _: 3
              }, 8, ["zone"])) : B("", !0),
              e.table.columnVisibilityEnabled.value && !X.value && A.value || d["toolbar-end"] ? (h(), R(f(Ot), {
                key: 2,
                zone: "right",
                wrap: ""
              }, {
                default: S(() => [
                  e.table.columnVisibilityEnabled.value && !X.value && A.value ? (h(), R(f(Jn), {
                    key: 0,
                    text: L.value,
                    placement: "top-start"
                  }, {
                    default: S(() => [
                      V(f(we), {
                        icon: f(mo),
                        size: e.size,
                        variant: "outline",
                        square: "",
                        disabled: e.disabled,
                        "aria-label": L.value,
                        onClick: K
                      }, null, 8, ["icon", "size", "disabled", "aria-label"])
                    ]),
                    _: 1
                  }, 8, ["text"])) : B("", !0),
                  pe(F.$slots, "toolbar-end", {}, void 0, !0)
                ]),
                _: 3
              })) : B("", !0)
            ]),
            _: 3
          }, 8, ["padding-x", "padding-y"])) : B("", !0),
          d.alerts ? (h(), R(f(za), { key: 2 }, {
            default: S(() => [
              pe(F.$slots, "alerts", {}, void 0, !0)
            ]),
            _: 3
          })) : B("", !0),
          d.filters ? (h(), R(f(ho), {
            key: 3,
            class: "smart-table__filters",
            "padding-x": e.filtersPaddingX,
            "padding-y": e.filtersPaddingY,
            "padding-top": e.filtersPaddingTop
          }, {
            default: S(() => [
              pe(F.$slots, "filters", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["padding-x", "padding-y", "padding-top"])) : B("", !0),
          V(f(hi), {
            ref_key: "rangeGrid",
            ref: de,
            "range-selection": f(me).api,
            "range-blocked": e.disabled || e.error,
            "range-readonly": e.loading
          }, {
            default: S(() => [
              V(f(bi), {
                "rounded-bottom": !!e.card && !d.footer && !he.value,
                data: ee.value,
                columns: Ye.value,
                "initial-column-widths": e.columnWidths?.widths.value,
                onColumnResize: qe,
                "column-order": e.columnOrder,
                "row-key": e.table.rowKeyField.value,
                selectable: e.table.selectable.value,
                "show-selection-actions": e.showSelectionActions,
                "single-select": e.table.singleSelect.value,
                "selected-keys": e.table.selectedKeys.value,
                "sort-key": e.table.sortKey.value,
                "sort-direction": e.table.sortDirection.value,
                "sort-mode": "server",
                resizable: e.resizable,
                "lock-column-widths": v.value,
                boxed: e.boxed,
                bg: e.bg,
                "sticky-start": y.value,
                "sticky-end": P.value + (e.table.rowActionsEnabled.value ? 1 : 0),
                "sticky-header": e.stickyHeader,
                "sticky-header-max-height": e.stickyHeaderMaxHeight,
                hoverable: e.hoverable,
                "horizontal-lines": e.horizontalLines,
                "vertical-lines": e.verticalLines,
                clickable: e.clickable,
                "sticky-end-spacer": e.stickyEndSpacer,
                loading: e.loading,
                "loading-bar": e.loadingBar,
                "empty-placement": e.emptyPlacement,
                "fill-height": e.fillHeight,
                "skeleton-rows": e.skeletonRows,
                size: e.size,
                "row-min-height": e.rowMinHeight,
                "row-states": e.table.rowStates.value,
                "row-attrs": T.value,
                "cell-attrs": xe,
                "header-double-click": M.value,
                "onUpdate:selectedKeys": e.table.handleSelectionChange,
                "onUpdate:sortKey": e.table.handleSortKey,
                "onUpdate:sortDirection": e.table.handleSortDirection,
                onRowClick: N
              }, St({
                default: S(() => [
                  (h(!0), $(se, null, Pe(x.value, (te, Fe) => (h(), R(f(we), {
                    key: Fe,
                    size: "1",
                    variant: te.danger ? "soft" : "outline",
                    disabled: e.disabled || (te.disabled ? te.disabled(e.table.selectedRows.value) : !1),
                    onClick: (so) => C(te)
                  }, {
                    default: S(() => [
                      H(U(te.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant", "disabled", "onClick"]))), 128)),
                  pe(F.$slots, "selection-actions", {
                    selectedRows: e.table.selectedRows.value,
                    clear: O
                  }, void 0, !0)
                ]),
                empty: S(() => [
                  e.error ? pe(F.$slots, "error", { key: 0 }, () => [
                    V(f(Me), {
                      color: "red",
                      size: "3"
                    }, {
                      default: S(() => [
                        H(U(e.errorMessage ?? f(t)("ui.smartTable.failedToLoadData", "Failed to load data")), 1)
                      ]),
                      _: 1
                    })
                  ], !0) : pe(F.$slots, "empty", { key: 1 }, () => [
                    V(f(Me), {
                      variant: "soft",
                      size: "3"
                    }, {
                      default: S(() => [
                        H(U(e.emptyMessage ?? f(t)("ui.smartTable.noData", "No data")), 1)
                      ]),
                      _: 1
                    })
                  ], !0)
                ]),
                _: 2
              }, [
                Pe(g.value, (te) => ({
                  name: `cell-${te.key}`,
                  fn: S(({ row: Fe }) => [
                    V(Km, {
                      table: e.table,
                      row: Fe,
                      col: te,
                      "table-disabled": e.disabled,
                      "row-loading": e.rowLoading?.(Fe),
                      "failed-commit": z.value,
                      "range-mode": f(me).api.enabled.value && f(me).api.surface.value.columnKeys.includes(te.key),
                      "on-commit-failed": ne
                    }, null, 8, ["table", "row", "col", "table-disabled", "row-loading", "failed-commit", "range-mode"])
                  ])
                })),
                Pe(We.value, (te) => ({
                  name: `header-${te.key}`,
                  fn: S(({ column: Fe }) => [
                    be("div", zm, [
                      V(f(gi), {
                        label: Fe.label,
                        tooltip: Fe.tooltip,
                        "label-badge": Fe.labelBadge,
                        "label-badge-placement": Fe.labelBadgePlacement
                      }, null, 8, ["label", "tooltip", "label-badge", "label-badge-placement"]),
                      Oe(te).length ? (h(), $("span", {
                        key: 0,
                        class: "smart-table__header-menu-trigger",
                        onClick: le[1] || (le[1] = tt(() => {
                        }, ["stop"])),
                        onDblclick: le[2] || (le[2] = tt(() => {
                        }, ["stop"]))
                      }, [
                        V(f(yi), {
                          items: Oe(te),
                          "aria-label": `${f(t)("ui.tableRange.columnMenu", "Column menu")}: ${te.label ?? te.key}`,
                          disabled: e.disabled || e.error || e.loading && !Le(te.key)
                        }, null, 8, ["items", "aria-label", "disabled"])
                      ], 32)) : B("", !0)
                    ])
                  ])
                })),
                e.table.rowActionsEnabled.value ? {
                  name: `cell-${Qo}`,
                  fn: S(({ row: te }) => [
                    be("div", {
                      class: "smart-table__row-actions-trigger",
                      "data-hp-flush-content": "true",
                      onClick: le[3] || (le[3] = tt(() => {
                      }, ["stop"]))
                    }, [
                      V(f(Pa), {
                        items: w(te),
                        icon: f(al),
                        variant: "blank",
                        size: "1"
                      }, null, 8, ["items", "icon"])
                    ])
                  ]),
                  key: "0"
                } : void 0,
                d.tfoot || e.summary ? {
                  name: "tfoot",
                  fn: S((te) => [
                    pe(F.$slots, "tfoot", Ve(te, { cellAttrs: Te }), () => [
                      e.summary ? (h(), R(f(pi), Ve({ key: 0 }, te, {
                        values: e.summary,
                        "cell-attrs": Te
                      }), null, 16, ["values"])) : B("", !0)
                    ], !0)
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["rounded-bottom", "data", "columns", "initial-column-widths", "column-order", "row-key", "selectable", "show-selection-actions", "single-select", "selected-keys", "sort-key", "sort-direction", "resizable", "lock-column-widths", "boxed", "bg", "sticky-start", "sticky-end", "sticky-header", "sticky-header-max-height", "hoverable", "horizontal-lines", "vertical-lines", "clickable", "sticky-end-spacer", "loading", "loading-bar", "empty-placement", "fill-height", "skeleton-rows", "size", "row-min-height", "row-states", "row-attrs", "header-double-click", "onUpdate:selectedKeys", "onUpdate:sortKey", "onUpdate:sortDirection"])
            ]),
            _: 3
          }, 8, ["range-selection", "range-blocked", "range-readonly"]),
          d.footer || he.value ? (h(), R(f(Al), {
            key: 4,
            "padding-x": "4",
            "padding-y": "2",
            "top-border": ""
          }, {
            default: S(() => [
              d.footer ? (h(), R(f(Ot), {
                key: 0,
                zone: "left",
                grow: "",
                wrap: ""
              }, {
                default: S(() => [
                  pe(F.$slots, "footer", {}, void 0, !0)
                ]),
                _: 3
              })) : B("", !0),
              he.value ? (h(), $("div", {
                key: 1,
                class: Ke(["smart-table__pagination", { "smart-table__pagination--disabled": e.disabled }]),
                "aria-disabled": e.disabled || void 0
              }, [
                V(f($a), {
                  total: e.table.total.value,
                  page: e.table.page.value,
                  "page-size": e.table.pageSize.value,
                  "page-size-options": ze.value,
                  "always-show": "",
                  "onUpdate:page": ct,
                  "onUpdate:pageSize": nl
                }, null, 8, ["total", "page", "page-size", "page-size-options"])
              ], 10, Om)) : B("", !0)
            ]),
            _: 3
          })) : B("", !0)
        ]),
        _: 3
      }, 8, ["style", "layout-id", "bg", "class", "aria-disabled"]),
      V(f(un), {
        open: Q.value,
        "onUpdate:open": le[4] || (le[4] = (te) => Q.value = te),
        size: "2",
        "close-on-escape": !1,
        "close-on-backdrop": !1,
        "show-close": !1
      }, {
        default: S(() => [
          V(f(cn), null, {
            default: S(() => [
              V(f(dn), null, {
                default: S(() => [
                  H(U(He.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          V(f(It), { padded: !0 }, {
            default: S(() => [
              z.value !== null ? (h(), $("ul", Am, [
                (h(!0), $(se, null, Pe(z.value.issues, (te, Fe) => (h(), $("li", {
                  key: Fe,
                  class: "smart-table__error-item"
                }, U($e(te, z.value.colKey)), 1))), 128))
              ])) : B("", !0)
            ]),
            _: 1
          }),
          V(f(fn), null, {
            default: S(() => [
              V(f(we), {
                variant: "outline",
                onClick: Ie
              }, {
                default: S(() => [
                  H(U(f(t)("ui.smartTable.discardChange", "Discard change")), 1)
                ]),
                _: 1
              }),
              V(f(we), {
                variant: "filled",
                onClick: ae
              }, {
                default: S(() => [
                  H(U(f(t)("ui.smartTable.continueEditing", "Continue editing")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]),
      J.value !== null ? (h(), $(se, { key: 0 }, [
        e.table.rowEditPresentation.value === "external" && d["row-editor"] ? (h(), $("div", {
          key: J.value.rowKey,
          class: "smart-table__row-editor-outlet"
        }, [
          pe(F.$slots, "row-editor", { editorProps: J.value }, void 0, !0)
        ])) : (h(), R(pm, Ve({
          key: J.value.rowKey
        }, J.value), null, 16))
      ], 64)) : B("", !0),
      e.table.columnVisibilityEnabled.value ? (h(), R(wm, {
        key: 1,
        open: k.value,
        columns: p.value,
        "hidden-column-keys": e.table.hiddenColumnKeys.value,
        "column-order": e.columnOrder,
        "on-apply": G,
        "on-close": W
      }, null, 8, ["open", "columns", "hidden-column-keys", "column-order"])) : B("", !0)
    ], 64));
  }
}), Nm = /* @__PURE__ */ Ae(Dm, [["__scopeId", "data-v-6dc162a3"]]), ce = (e) => e, ge = (e) => e, re = (e, t) => `${e}::${t}`, Sr = (e) => {
  const { rows: t, rowKey: n, parentKey: l } = e, o = wr(t, n, l, "strict"), a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  for (const [s, i] of o.parentOf)
    a.set(ce(s), i === null ? null : ce(i)), r.set(
      ce(s),
      (o.childKeysByParent.get(s) ?? []).map((c) => ce(c))
    );
  return {
    roots: o.roots.map((s) => ce(s)),
    parentOf: a,
    childrenOf: r
  };
}, Ft = (e, t) => e.parentOf.get(t) ?? null, it = (e, t) => e.childrenOf.get(t) ?? [], Cr = (e, t, n) => {
  const l = [t];
  for (; l.length > 0; ) {
    const o = l.shift();
    if (n(o) === !1)
      continue;
    const r = it(e, o);
    for (const s of r)
      l.push(s);
  }
}, Et = 0, Bm = (e, t) => e.read(t, e.columnId) ?? Et, jm = (e) => e.min !== void 0 && Number.isFinite(e.min) ? Math.max(Et, e.min) : Et, Um = (e, t) => {
  const n = [];
  let l = Et;
  for (const o of t) {
    const a = Ir(e, o);
    l += a.minValue, a.selfLocked && n.push(re(o, e.columnId)), n.push(...a.lockedDescendantKeys);
  }
  return { childrenMinTotal: l, lockedDescendantKeys: n };
}, Hm = (e, t) => {
  const n = it(e.tree, t), l = Um(e, n), o = e.isLocked(t, e.columnId), a = jm(e), r = Math.max(a, l.childrenMinTotal);
  return o ? {
    rowId: t,
    state: "locked",
    minValue: Bm(e, t),
    selfLocked: o,
    childrenMinTotal: l.childrenMinTotal,
    lockedDescendantKeys: l.lockedDescendantKeys
  } : l.lockedDescendantKeys.length > 0 ? {
    rowId: t,
    state: "constrained",
    minValue: r,
    selfLocked: o,
    childrenMinTotal: l.childrenMinTotal,
    lockedDescendantKeys: l.lockedDescendantKeys
  } : {
    rowId: t,
    state: "auto",
    minValue: r,
    selfLocked: o,
    childrenMinTotal: l.childrenMinTotal,
    lockedDescendantKeys: l.lockedDescendantKeys
  };
}, Ir = (e, t) => {
  const n = e.constraints.get(t);
  if (n !== void 0)
    return n;
  const l = Hm(e, t);
  return e.constraints.set(t, l), l;
}, ql = (e) => {
  const t = { ...e, constraints: /* @__PURE__ */ new Map() };
  for (const n of e.tree.roots)
    Ir(t, n);
  return t.constraints;
}, Rr = (e) => {
  const { tree: t, constraints: n, rowId: l, parentValue: o, requestedValue: a } = e, r = Ft(t, l);
  if (r === null || o === null)
    return {
      parentId: r,
      siblingsMinValue: Et,
      requiredParentValue: null,
      availableValue: null,
      fitsWithinParent: !0
    };
  const i = it(t, r).filter((d) => d !== l).reduce((d, v) => d + (n.get(v)?.minValue ?? Et), Et), c = a + i, u = Math.max(Et, o - i);
  return {
    parentId: r,
    siblingsMinValue: i,
    requiredParentValue: c,
    availableValue: u,
    fitsWithinParent: c <= o
  };
}, Wm = (e) => {
  const { tree: t, columnId: n } = e, l = [];
  for (const o of t.parentOf.keys())
    l.push({ kind: "lock-clear", rowId: o, columnId: n });
  return { patches: l, diagnostics: [], verdict: "preview" };
}, Zm = (e) => {
  const { tree: t, columnId: n, rootRowId: l, isLocked: o } = e, a = [], r = [];
  return o(l, n) ? (r.push({ code: "skipped_lock", cellKey: re(l, n) }), { patches: a, diagnostics: r, verdict: "preview" }) : (Cr(t, l, (s) => s !== l && o(s, n) ? (r.push({ code: "skipped_lock", cellKey: re(s, n) }), !1) : (a.push({ kind: "null", rowId: s, columnId: n }), !0)), { patches: a, diagnostics: r, verdict: "preview" });
}, qm = (e) => {
  const { tree: t, columnId: n } = e, l = [];
  for (const o of t.parentOf.keys())
    l.push({ kind: "lock-clear", rowId: o, columnId: n }), l.push({ kind: "null", rowId: o, columnId: n });
  return { patches: l, diagnostics: [], verdict: "preview" };
}, fl = 1e-4, Jm = 10, Gm = (e, t) => {
  const n = Array.from({ length: t.length }, () => 0);
  let l = e, o = t.map((a, r) => ({
    index: r,
    capacity: a.maxValue === null ? Number.POSITIVE_INFINITY : Math.max(0, a.maxValue - a.minValue)
  }));
  for (; l > fl && o.length > 0; ) {
    const a = l / o.length;
    let r = 0;
    const s = [];
    for (const i of o) {
      const c = Math.min(a, i.capacity);
      n[i.index] = (n[i.index] ?? 0) + c, r += c;
      const u = i.capacity - c;
      u > fl && s.push({ index: i.index, capacity: u });
    }
    if (r <= fl)
      break;
    l -= r, o = s;
  }
  return n;
}, _m = (e, t, n) => {
  const l = Jm ** n, o = Array.from({ length: t.length }, () => 0);
  let a = Math.max(0, Math.round(e * l)), r = t.map((s, i) => {
    const c = s.maxValue === null ? Number.POSITIVE_INFINITY : Math.max(0, Math.floor((s.maxValue - s.minValue) * l));
    return { index: i, capacity: c };
  });
  for (; a > 0 && r.length > 0; ) {
    const s = Math.max(1, Math.floor(a / r.length));
    let i = 0;
    const c = [];
    for (const u of r) {
      if (a <= 0) {
        c.push(u);
        continue;
      }
      const d = Math.min(s, u.capacity, a);
      o[u.index] = (o[u.index] ?? 0) + d, i += d, a -= d;
      const v = u.capacity - d;
      v > 0 && c.push({ index: u.index, capacity: v });
    }
    if (i === 0)
      break;
    r = c;
  }
  return o.map((s) => s / l);
}, Jl = (e) => {
  const t = Math.max(0, e.total);
  return e.rows.length === 0 ? [] : e.precision === void 0 ? Gm(t, e.rows) : _m(t, e.rows, e.precision);
}, Ym = 0.01, Qm = 100, Pr = 2, Tr = 100, Er = (e) => e.mode === "value" ? e.newValue : e.parentValue === null ? Number.NaN : e.newValue * e.parentValue, lw = (e) => Number.isFinite(e) ? Number((e * Tr).toFixed(Pr)) : null, ow = (e) => {
  if (!Number.isFinite(e))
    return null;
  const t = Number(e.toFixed(Pr));
  return t < Ym || t > Qm ? null : t / Tr;
}, Xm = (e, t) => (n, l) => {
  const o = re(n, l);
  return t.has(o) ? t.get(o) ?? null : e(n, l);
}, Mr = (e, t, n) => {
  const l = ql({
    tree: e,
    columnId: n.columnId,
    read: n.read,
    isLocked: n.isLocked,
    ...n.min !== void 0 ? { min: n.min } : {}
  }), o = [], a = [];
  for (const r of t) {
    const s = l.get(r), i = s?.minValue ?? 0, c = {
      rowId: r,
      minValue: i,
      maxValue: oh(n, r, i)
    };
    s?.selfLocked === !0 ? a.push(c) : o.push(c);
  }
  return { adjustable: o, locked: a };
}, eh = (e, t) => e.reduce((n, l) => n + (t.read(l, t.columnId) ?? 0), 0), Ln = (e) => e.reduce((t, n) => t + n.minValue, 0), th = (e, t, n, l, o) => {
  const a = o.filter((i) => i !== n), { adjustable: r, locked: s } = Mr(e, a, t);
  return l + Ln(r) + Ln(s);
}, nh = (e, t, n) => Ft(e, n) !== null && !t.isLocked(n, t.columnId), lh = (e, t) => e == null || !Number.isFinite(e) ? null : Math.max(t, e), oh = (e, t, n) => lh(e.readMax?.(t, e.columnId), n), Fn = (e) => {
  const { tree: t, ctx: n, parentValue: l, rows: o, edited: a } = e, r = a?.value ?? 0, s = a === void 0 ? o : o.filter((P) => P !== a.rowId), { adjustable: i, locked: c } = Mr(t, s, n), u = Ln(c), d = Ln(i), v = c.map((P) => P.rowId), m = r + u + d > l, p = Math.max(0, l - r - u - d), g = Jl({ total: p, rows: i, precision: n.precision });
  return { assignments: i.map((P, I) => ({ rowId: P.rowId, value: P.minValue + (g[I] ?? 0) })), lockedRows: v, diagnosticLockedRows: m ? v : [] };
}, Dn = (e) => {
  const { tree: t, ctx: n, output: l, emit: o, emitLockDiagnostic: a, queue: r } = e, s = new Set(l.diagnosticLockedRows);
  for (const i of l.assignments)
    o(i.rowId, i.value), it(t, i.rowId).length > 0 && r.push({ parentId: i.rowId, newParentValue: i.value });
  for (const i of l.lockedRows)
    if (s.has(i) && a(i), it(t, i).length > 0) {
      const c = n.read(i, n.columnId) ?? 0;
      r.push({ parentId: i, newParentValue: c });
    }
}, ah = (e) => {
  const { tree: t, ctx: n, initialQueue: l, emit: o, emitLockDiagnostic: a } = e, r = [...l];
  for (; r.length > 0; ) {
    const s = r.shift();
    if (s === void 0)
      break;
    const i = it(t, s.parentId), c = Fn({
      tree: t,
      ctx: n,
      parentValue: s.newParentValue,
      rows: i
    });
    Dn({ tree: t, ctx: n, output: c, emit: o, emitLockDiagnostic: a, queue: r });
  }
}, rh = (e, t, n, l) => {
  const o = e.filter((a) => a !== t);
  return o.every((a) => l.read(a, l.columnId) === null) ? n * e.length : n + eh(o, l);
}, Vr = (e) => {
  const { tree: t, ctx: n, emit: l, emitLockDiagnostic: o } = e, a = [];
  let r = e.rowId, s = e.rowValue, i = Ft(t, r);
  for (; i !== null && n.read(i, n.columnId) === null; ) {
    if (n.isLocked(i, n.columnId)) {
      o(i);
      break;
    }
    const c = it(t, i), u = rh(c, r, s, n);
    l(i, u);
    const d = Fn({
      tree: t,
      ctx: n,
      parentValue: u,
      rows: c,
      edited: { rowId: r, value: s }
    });
    Dn({ tree: t, ctx: n, output: d, emit: l, emitLockDiagnostic: o, queue: a }), r = i, s = u, i = Ft(t, r);
  }
  return a;
}, sh = (e) => {
  const { tree: t, ctx: n, emit: l, emitLockDiagnostic: o } = e, a = [];
  let r = e.changedRowId, s = e.changedValue, i = Ft(t, r);
  for (; i !== null; ) {
    const c = n.read(i, n.columnId);
    if (c === null) {
      a.push(...Vr({ tree: t, ctx: n, rowId: r, rowValue: s, emit: l, emitLockDiagnostic: o }));
      break;
    }
    const u = it(t, i), d = th(t, n, r, s, u);
    if (d > c && nh(t, n, i)) {
      l(i, d);
      const m = Fn({
        tree: t,
        ctx: n,
        parentValue: d,
        rows: u,
        edited: { rowId: r, value: s }
      });
      Dn({ tree: t, ctx: n, output: m, emit: l, emitLockDiagnostic: o, queue: a }), r = i, s = d, i = Ft(t, r);
      continue;
    }
    const v = Fn({
      tree: t,
      ctx: n,
      parentValue: c,
      rows: u,
      edited: { rowId: r, value: s }
    });
    Dn({ tree: t, ctx: n, output: v, emit: l, emitLockDiagnostic: o, queue: a });
    break;
  }
  return a;
}, ih = (e) => {
  const { tree: t, ctx: n, edit: l, mode: o, emit: a, emitLockDiagnostic: r, emitModeConflict: s } = e, i = Ft(t, l.rowId), c = i !== null ? n.read(i, n.columnId) : null, u = Er({ mode: o, newValue: l.newValue, parentValue: c });
  if (Number.isNaN(u))
    return s(l.rowId, "percent_mode_null_parent"), [];
  a(l.rowId, u);
  const d = [];
  return it(t, l.rowId).length > 0 && d.push({ parentId: l.rowId, newParentValue: u }), i !== null && c === null ? d.push(...Vr({ tree: t, ctx: n, rowId: l.rowId, rowValue: u, emit: a, emitLockDiagnostic: r })) : i !== null && c !== null && d.push(
    ...sh({ tree: t, ctx: n, changedRowId: l.rowId, changedValue: u, emit: a, emitLockDiagnostic: r })
  ), d;
}, xr = (e) => {
  const { tree: t, columnId: n, mode: l, edit: o, read: a, readMax: r, isLocked: s, min: i, precision: c } = e, u = [], d = [], v = /* @__PURE__ */ new Map(), m = (I, w) => {
    u.push({ kind: "number", rowId: I, columnId: n, value: w }), v.set(re(I, n), w);
  }, p = (I) => {
    d.push({ code: "skipped_lock", cellKey: re(I, n) });
  }, g = (I, w) => {
    d.push({ code: "mode_conflict", cellKey: re(I, n), reason: w });
  }, y = {
    columnId: n,
    read: Xm(a, v),
    readMax: r,
    isLocked: s,
    min: i,
    precision: c
  }, P = ih({
    tree: t,
    ctx: y,
    edit: o,
    mode: l,
    emit: m,
    emitLockDiagnostic: p,
    emitModeConflict: g
  });
  return ah({ tree: t, ctx: y, initialQueue: P, emit: m, emitLockDiagnostic: p }), { patches: u, diagnostics: d, verdict: "preview" };
}, uh = (e, t) => {
  if (e.length === 0)
    return [];
  const n = 10 ** t, l = e.map((u) => u * n), o = l.reduce((u, d) => u + d, 0), a = Math.round(o), r = l.map((u) => Math.floor(u)), s = l.map((u, d) => ({ idx: d, frac: u - (r[d] ?? 0) })), i = r.reduce((u, d) => u + d, 0), c = a - i;
  if (c !== 0) {
    s.sort((d, v) => v.frac - d.frac);
    const u = c > 0 ? 1 : -1;
    for (let d = 0; d < Math.abs(c); d += 1) {
      const v = s[d % s.length];
      v !== void 0 && (r[v.idx] = (r[v.idx] ?? 0) + u);
    }
  }
  return r.map((u) => u / n);
}, aw = (e) => {
  const { total: t, participants: n, precision: l } = e;
  if (n <= 0)
    return [];
  const o = t / n, a = Array.from({ length: n }, () => o);
  return l === void 0 ? a : uh(a, l);
}, ch = (e) => e == null || !Number.isFinite(e) ? null : Math.max(0, e), dh = (e, t, n, l) => e.map((o) => ({
  rowId: o,
  minValue: n,
  maxValue: ch(l?.(o, t))
})), fh = (e, t) => e.reduce((n, l) => n + (t(l) ?? 0), 0), Kr = (e) => {
  const t = e.fixedRows ?? /* @__PURE__ */ new Set(), n = e.min ?? 0, l = [], o = [];
  for (const u of e.tree.roots) {
    if (t.has(u) || e.isLocked(u, e.columnId)) {
      o.push(u);
      continue;
    }
    l.push(u);
  }
  const a = fh(o, e.read), r = n * l.length, s = Math.max(0, e.total - a - r), i = dh(l, e.columnId, n, e.readMax), c = Jl({
    total: s,
    rows: i,
    precision: e.precision
  });
  i.forEach((u, d) => {
    const v = u.minValue + (c[d] ?? 0);
    e.emit(u.rowId, v), e.setEffective(u.rowId, v);
  });
  for (const u of o)
    e.isLocked(u, e.columnId) && e.emitDiagnostic({ code: "skipped_lock", cellKey: re(u, e.columnId) });
}, zr = (e) => {
  const t = /* @__PURE__ */ new Map();
  return {
    readEffective: (n) => {
      const l = re(n, e.columnId);
      return t.has(l) ? t.get(l) ?? null : e.overrides?.has(l) ? e.overrides.get(l) ?? null : e.read(n, e.columnId);
    },
    setEffective: (n, l) => {
      t.set(re(n, e.columnId), l);
    }
  };
}, vh = (e) => {
  const { columnId: t, edit: n, isLocked: l, precision: o, read: a, readMax: r, total: s, tree: i } = e, c = [], u = [], { readEffective: d, setEffective: v } = zr({ columnId: t, read: a }), m = Er({ mode: e.mode, newValue: n.newValue, parentValue: s });
  if (!Number.isFinite(m))
    return {
      patches: c,
      diagnostics: [{ code: "mode_conflict", cellKey: re(n.rowId, t), reason: "flat_total_mode" }],
      verdict: "preview"
    };
  const p = (g, y) => {
    c.push({ kind: "number", rowId: g, columnId: t, value: y }), v(g, y);
  };
  return p(n.rowId, m), Kr({
    tree: i,
    columnId: t,
    total: s,
    min: e.min,
    read: d,
    readMax: r,
    isLocked: l,
    precision: o,
    fixedRows: /* @__PURE__ */ new Set([n.rowId]),
    setEffective: v,
    emit: p,
    emitDiagnostic: (g) => {
      u.push(g);
    }
  }), { patches: c, diagnostics: u, verdict: "preview" };
}, mh = (e) => {
  const { columnId: t, isLocked: n, overrides: l, precision: o, read: a, readMax: r, total: s, tree: i } = e, c = [], u = [], { readEffective: d, setEffective: v } = zr({ columnId: t, read: a, overrides: l }), m = (g, y) => {
    c.push({ kind: "number", rowId: g, columnId: t, value: y }), v(g, y);
  }, p = /* @__PURE__ */ new Set();
  for (const g of i.roots)
    l?.has(re(g, t)) && p.add(g);
  return Kr({
    tree: i,
    columnId: t,
    total: s,
    min: e.min,
    read: d,
    readMax: r,
    isLocked: n,
    precision: o,
    fixedRows: p,
    setEffective: v,
    emit: m,
    emitDiagnostic: (g) => {
      u.push(g);
    }
  }), { patches: c, diagnostics: u, verdict: "preview" };
}, hh = (e, t, n, l, o, a, r) => {
  const s = ql({
    tree: e,
    columnId: a,
    read: (u) => n(u),
    isLocked: o,
    ...r !== void 0 ? { min: r } : {}
  }), i = [], c = [];
  for (const u of t) {
    const d = s.get(u), v = d?.minValue ?? 0, m = {
      rowId: u,
      minValue: v,
      maxValue: bh(l?.(u, a), v)
    };
    d?.selfLocked === !0 ? c.push(m) : i.push(m);
  }
  return { adjustable: i, locked: c };
}, bh = (e, t) => e == null || !Number.isFinite(e) ? null : Math.max(t, e), Nn = (e) => e.reduce((t, n) => t + n.minValue, 0), gh = (e) => Nn(e.locked) + Nn(e.adjustable) > e.parentValue, yh = (e) => {
  const { parentValue: t, adjustable: n, locked: l, precision: o } = e, a = Nn(l), r = Nn(n), s = Math.max(0, t - a - r);
  return Jl({ total: s, rows: n, precision: o });
}, ph = (e) => {
  const { tree: t, columnId: n, read: l, readMax: o, isLocked: a, min: r, precision: s, overrides: i } = e, c = [], u = [], d = /* @__PURE__ */ new Map(), v = (P) => {
    const I = re(P, n);
    return d.has(I) ? d.get(I) ?? null : i?.has(I) ? i.get(I) ?? null : l(P, n);
  }, m = (P, I) => {
    d.set(re(P, n), I);
  }, p = (P, I) => {
    c.push({ kind: "number", rowId: P, columnId: n, value: I }), m(P, I);
  }, g = (P) => {
    c.push({ kind: "null", rowId: P, columnId: n }), m(P, null);
  }, y = (P) => {
    const I = v(P);
    if (I === null) {
      for (const L of it(t, P)) {
        if (a(L, n)) {
          u.push({ code: "skipped_lock", cellKey: re(L, n) }), y(L);
          continue;
        }
        g(L), y(L);
      }
      return;
    }
    const w = it(t, P), { adjustable: C, locked: x } = hh(t, w, v, o, a, n, r), O = {
      parentValue: I,
      adjustable: C,
      locked: x,
      precision: s
    }, N = gh(O), T = yh(O);
    C.forEach((L, k) => {
      p(L.rowId, L.minValue + (T[k] ?? 0)), y(L.rowId);
    });
    for (const L of x)
      N && u.push({ code: "skipped_lock", cellKey: re(L.rowId, n) }), y(L.rowId);
  };
  for (const P of t.roots) {
    const I = v(P);
    m(P, I), y(P);
  }
  return { patches: c, diagnostics: u, verdict: "preview" };
}, wh = (e) => {
  const { tree: t, columnId: n, edit: l, isLocked: o } = e, a = [], r = [];
  return Cr(t, l.rowId, (s) => {
    if (s !== l.rowId && o(s, n)) {
      r.push({ code: "skipped_lock", cellKey: re(s, n) });
      return;
    }
    a.push({ kind: "value", rowId: s, columnId: n, value: l.newValue });
  }), { patches: a, diagnostics: r, verdict: "preview" };
}, kh = (e) => {
  const { tree: t, columnId: n, read: l, isLocked: o, overrides: a } = e, r = [], s = [], i = /* @__PURE__ */ new Map(), c = (m) => {
    const p = re(m, n);
    return i.has(p) ? i.get(p) : a?.has(p) ? a.get(p) : l(m, n);
  }, u = (m, p) => {
    i.set(re(m, n), p);
  }, d = (m, p) => {
    r.push({ kind: "value", rowId: m, columnId: n, value: p }), u(m, p);
  }, v = (m) => {
    const p = c(m);
    for (const g of it(t, m)) {
      if (o(g, n)) {
        s.push({ code: "skipped_lock", cellKey: re(g, n) }), v(g);
        continue;
      }
      d(g, p), v(g);
    }
  };
  for (const m of t.roots) {
    const p = c(m);
    u(m, p), v(m);
  }
  return { patches: r, diagnostics: s, verdict: "preview" };
}, Sh = (e, t) => ({
  patches: [],
  diagnostics: [
    {
      code: "mode_conflict",
      cellKey: re(e, t),
      reason: "non_numeric"
    }
  ],
  verdict: "preview"
}), Ch = (e) => (t, n) => {
  const l = e(t, n);
  return typeof l == "number" ? l : null;
}, Ih = (e) => {
  const { column: t, tree: n, columnId: l, edit: o, read: a, readMax: r, isLocked: s, numeric: i } = e, c = Ch(a);
  return t.flatTotal !== void 0 ? vh({
    tree: n,
    columnId: l,
    mode: t.mode,
    total: t.flatTotal,
    ...t.min !== void 0 ? { min: t.min } : {},
    edit: { rowId: o.rowId, newValue: i },
    read: c,
    ...r !== void 0 ? { readMax: r } : {},
    isLocked: s,
    ...t.precision !== void 0 ? { precision: t.precision } : {}
  }) : xr({
    tree: n,
    columnId: l,
    mode: t.mode,
    ...t.balance !== void 0 ? { balance: t.balance } : {},
    edit: { rowId: o.rowId, newValue: i },
    read: c,
    ...r !== void 0 ? { readMax: r } : {},
    isLocked: s,
    ...t.min !== void 0 ? { min: t.min } : {},
    ...t.precision !== void 0 ? { precision: t.precision } : {}
  });
}, Xo = (e) => {
  const { column: t, tree: n, columnId: l, edit: o, read: a, readMax: r, isLocked: s } = e;
  if (t.kind === "value")
    return wh({ tree: n, columnId: l, edit: o, isLocked: s });
  if (o.newValue === null)
    return Zm({ tree: n, columnId: l, rootRowId: o.rowId, isLocked: s });
  const i = typeof o.newValue == "number" ? o.newValue : Number(o.newValue);
  return Number.isFinite(i) ? Ih({
    column: t,
    tree: n,
    columnId: l,
    edit: o,
    read: a,
    ...r !== void 0 ? { readMax: r } : {},
    isLocked: s,
    numeric: i
  }) : Sh(o.rowId, l);
}, Rh = () => /* @__PURE__ */ new Set(), Ph = (e, t, n) => {
  const l = new Set(e);
  return l.delete(re(t, n)), l;
}, Th = (e, t, n) => {
  const l = new Set(e), o = re(t, n);
  return l.has(o) ? l.delete(o) : l.add(o), l;
}, Eh = (e) => e.map(String).join("."), Mh = Object.freeze({
  fieldErrors: /* @__PURE__ */ new Map(),
  formErrors: Object.freeze([])
}), Vh = (e) => {
  const t = /* @__PURE__ */ new Map(), n = [];
  for (const l of e) {
    if (l.path.length === 0) {
      n.push(l.message);
      continue;
    }
    const o = Eh(l.path);
    t.has(o) || t.set(o, l.message);
  }
  return {
    fieldErrors: t,
    formErrors: n
  };
}, Gl = (e, t) => {
  const n = e.safeParse(t);
  return n.success ? Mh : Vh(n.error.issues);
}, Or = (e) => e.kind !== "lock-clear", xh = (e, t) => {
  const n = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  for (const o of e.patches)
    Or(o) && (n.add(o.rowId), l.add(o.columnId));
  return "rowId" in t && n.add(t.rowId), "columnId" in t && l.add(t.columnId), { rowIds: n, columnIds: l };
}, Kh = (e, t, n, l) => {
  if (n === void 0 || !l.rowIds.has(t))
    return [];
  const o = [], { fieldErrors: a, formErrors: r } = Gl(n, e);
  for (const [s, i] of a) {
    const c = ge(s.split(".")[0] ?? s);
    l.columnIds.has(c) && o.push({
      code: "schema.field",
      message: i,
      rowId: t,
      columnId: c,
      severity: "error"
    });
  }
  for (const s of r)
    o.push({
      code: "schema.form",
      message: s,
      rowId: t,
      severity: "error"
    });
  return o;
}, zh = (e, t, n, l) => {
  if (!l.rowIds.has(n))
    return [];
  const o = [];
  for (const [a, r] of Object.entries(e.columns)) {
    const s = ge(a);
    if (r.kind !== "value" || r.valueSchema === void 0 || !l.columnIds.has(s))
      continue;
    const { fieldErrors: i, formErrors: c } = Gl(
      r.valueSchema,
      t[a]
    );
    for (const [, u] of i)
      o.push({
        code: "column.value_schema.field",
        message: u,
        rowId: n,
        columnId: s,
        severity: "error"
      });
    for (const u of c)
      o.push({
        code: "column.value_schema",
        message: u,
        rowId: n,
        columnId: s,
        severity: "error"
      });
  }
  return o;
}, Oh = (e) => Object.values(e.columns).some((t) => t.kind === "value" && t.valueSchema !== void 0), Ah = (e, t, n) => {
  const l = e.validation?.schema, o = [];
  for (const a of t) {
    const r = ce(String(a[e.rowKey]));
    o.push(...Kh(a, r, l, n)), o.push(...zh(e, a, r, n));
  }
  return o;
}, ea = (e, t, n) => {
  const l = [], o = /* @__PURE__ */ new Map();
  for (const a of e) {
    const r = String(a[t]);
    l.push(r);
    for (const s of n)
      o.set(`${r}::${s}`, a[s]);
  }
  return { keys: l, values: o };
}, $h = (e, t) => {
  if (e.keys.length !== t.keys.length)
    return !0;
  for (let n = 0; n < e.keys.length; n += 1)
    if (e.keys[n] !== t.keys[n])
      return !0;
  if (e.values.size !== t.values.size)
    return !0;
  for (const [n, l] of e.values)
    if (t.values.get(n) !== l)
      return !0;
  return !1;
}, Lh = "__smartCalculatorFlatParentKey__", Fh = (e) => e.kind === "null" ? null : e.value, Dh = (e, t) => ({
  ...e,
  patches: e.patches.filter(
    (n) => !Or(n) || t(n.rowId, n.columnId) !== Fh(n)
  )
}), Nh = (e) => {
  const { rows: t, config: n } = e, l = mt(new Set(n.initialLockState ?? [])), o = mt(null), a = mt(null), r = mt(null), s = mt(null), i = Y(0);
  let c = !1;
  const u = () => {
    const j = /* @__PURE__ */ new Map();
    for (const q of t.value)
      j.set(String(q[n.rowKey]), q);
    return (q, J) => {
      const ee = j.get(q);
      return ee === void 0 ? null : ee[J];
    };
  }, d = (j) => (q, J) => {
    const ee = j(q, J);
    return typeof ee == "number" ? ee : null;
  }, v = (j, q) => {
    if (j.kind !== "number" || j.max === void 0)
      return;
    const J = /* @__PURE__ */ new Map();
    for (const ee of t.value)
      J.set(String(ee[n.rowKey]), ee);
    return (ee, de) => {
      if (de !== q)
        return null;
      const ve = J.get(ee);
      if (ve === void 0)
        return null;
      const me = j.max?.(ve);
      return typeof me == "number" && Number.isFinite(me) ? me : null;
    };
  }, m = () => n.topology === "flat", p = () => Sr({
    rows: t.value,
    rowKey: n.rowKey,
    parentKey: m() || n.parentKey === void 0 ? Lh : n.parentKey
  }), g = (j) => m() ? /* @__PURE__ */ new Set() : new Set(j.roots), y = b(
    () => m() ? /* @__PURE__ */ new Set() : new Set(p().roots)
  ), P = (j, q = y.value) => {
    let J = null;
    for (const ee of q)
      for (const de of Object.keys(n.columns)) {
        const ve = re(ee, ge(de));
        j.has(ve) && (J ??= new Set(j), J.delete(ve));
      }
    return J ?? j;
  }, I = (j, q) => {
    let J = null;
    for (const ee of q) {
      const de = ee, ve = ce(String(de[n.rowKey]));
      for (const [me, xe] of Object.entries(n.columns)) {
        const Te = re(ve, ge(me)), We = de[me];
        xe.kind !== "number" || !j.has(Te) || We != null || (J ??= new Set(j), J.delete(Te));
      }
    }
    return J ?? j;
  }, w = (j, q = y.value) => (J, ee) => !q.has(J) && j.has(re(J, ee)), C = (j) => j === void 0 ? void 0 : new Map(
    Array.from(j.entries()).map(([q, J]) => [q, typeof J == "number" ? J : null])
  ), x = (j, q, J) => kh({
    tree: J.tree,
    columnId: j,
    read: J.read,
    isLocked: w(J.locks, J.sourceRows),
    ...J.overrides !== void 0 ? { overrides: J.overrides } : {}
  }), O = (j, q, J) => {
    const ee = C(J.overrides), de = v(q, j), ve = {
      tree: J.tree,
      columnId: j,
      mode: q.mode,
      read: d(J.read),
      ...de !== void 0 ? { readMax: de } : {},
      isLocked: w(J.locks, J.sourceRows),
      ...q.min !== void 0 ? { min: q.min } : {},
      ...q.precision !== void 0 ? { precision: q.precision } : {},
      ...ee !== void 0 ? { overrides: ee } : {}
    };
    return q.flatTotal !== void 0 ? mh({
      ...ve,
      total: q.flatTotal,
      ...q.min !== void 0 ? { min: q.min } : {}
    }) : ph(ve);
  }, N = (j, q, J) => {
    const ee = n.columns[j];
    if (!ee)
      return { patches: [], diagnostics: [], verdict: "preview" };
    const de = p(), ve = u(), me = g(de), xe = P(J ?? l.value, me);
    return ee.kind === "value" ? x(j, ee, { tree: de, read: ve, locks: xe, sourceRows: me, overrides: q }) : ee.kind === "number" ? O(j, ee, { tree: de, read: ve, locks: xe, sourceRows: me, overrides: q }) : ee;
  }, T = (j, q) => {
    let J = null;
    for (const ee of j)
      ee.kind === "lock-clear" && (J ??= new Set(q), J.delete(re(ee.rowId, ee.columnId)));
    return J ?? q;
  }, L = (j) => {
    const q = /* @__PURE__ */ new Map();
    for (const J of j.patches) {
      if (J.kind === "lock-clear")
        continue;
      const ee = t.value.find((me) => String(me[n.rowKey]) === J.rowId);
      if (ee === void 0)
        continue;
      const de = String(ee[n.rowKey]), ve = q.get(de) ?? { ...ee };
      ve[J.columnId] = J.kind === "null" ? null : J.value, q.set(de, ve);
    }
    return q.size === 0 ? t.value : t.value.map((J) => {
      const ee = String(J[n.rowKey]);
      return q.get(ee) ?? J;
    });
  }, k = (j, q, J) => n.validation?.projectRows?.({ rows: t.value, result: j, trigger: q }) ?? J, K = async (j, q, J, ee) => {
    const de = n.validation;
    if (de === void 0 && !Oh(n))
      return r.value = null, null;
    const ve = k(j, q, ee), me = {
      rows: t.value,
      projectedRows: ve,
      result: j,
      trigger: q,
      nextLockState: J
    }, xe = xh(j, q), Te = [...Ah(n, ve, xe)];
    for (const Le of de?.rules ?? [])
      Te.push(...await Le(me));
    const We = { issues: Te, context: me };
    return r.value = We, Te.length > 0 ? (de?.onInvalid?.(We), We) : null;
  }, W = (j) => {
    const q = { ...j, verdict: "halted" };
    return a.value = q, i.value += 1, n.onHalt?.(q), q;
  }, G = async (j, q, J) => {
    s.value = J;
    const ee = L(j), de = I(P(q), ee), ve = J.kind === "toggle-lock" ? null : await K(j, J, de, ee);
    if (J.kind === "toggle-lock" && (r.value = null), ve !== null)
      return W(j);
    j.patches.length > 0 ? (c = !0, n.onApply(j.patches), Rn(
      ot(() => {
        c = !1;
      })
    )) : J.kind === "toggle-lock" && n.onApply(j.patches), l.value = T(j.patches, de);
    const me = { ...j, verdict: "applied" };
    return o.value = me, r.value = null, me;
  }, A = async (j, q, J) => {
    const ee = n.columns[q];
    if (!ee)
      return { patches: [], diagnostics: [], verdict: "preview" };
    const de = p(), ve = g(de), me = P(l.value, ve), xe = J === null, Te = xe && !ve.has(j) ? Ph(me, j, q) : me;
    if (xe && !ve.has(j) && ee.kind === "number") {
      const Z = N(q, void 0, Te);
      return G(Z, Te, { kind: "cell-edit", rowId: j, columnId: q, value: J });
    }
    const We = ve.has(j) && ee.kind === "number" ? { ...ee, mode: "value", balance: "always" } : ee, Le = v(ee, q), ht = Xo({
      column: We,
      tree: de,
      columnId: q,
      edit: { rowId: j, newValue: J },
      read: u(),
      ...Le !== void 0 ? { readMax: Le } : {},
      isLocked: w(Te, ve)
    }), pt = ve.has(j) || xe ? Te : new Set(Te).add(re(j, q));
    return G(ht, pt, { kind: "cell-edit", rowId: j, columnId: q, value: J });
  }, E = async (j, q) => {
    const J = p(), ee = g(J), de = P(l.value, ee);
    if (ee.has(j)) {
      l.value = de, r.value = null, s.value = { kind: "toggle-lock", rowId: j, columnId: q };
      const xe = { patches: [], diagnostics: [], verdict: "applied" };
      return o.value = xe, xe;
    }
    const ve = Th(de, j, q), me = N(q, void 0, ve);
    return G(me, ve, { kind: "toggle-lock", rowId: j, columnId: q });
  }, D = async (j) => {
    const q = qm({ tree: p(), columnId: j });
    return G(q, l.value, { kind: "nullify-tree", columnId: j });
  }, X = async (j) => {
    const q = Wm({ tree: p(), columnId: j });
    return G(q, l.value, { kind: "autofy-tree", columnId: j });
  }, z = async (j) => {
    const q = N(j);
    return G(q, l.value, { kind: "recompute", columnId: j });
  }, Q = async (j, q = l.value, J = "validator") => G(j, q, { kind: "validation-resolution", resolution: J }), ne = (j, q, J) => {
    const ee = n.columns[q];
    if (!ee)
      return { patches: [], diagnostics: [], verdict: "preview" };
    const de = p(), ve = g(de), me = P(l.value, ve), xe = ve.has(j) && ee.kind === "number" ? { ...ee, mode: "value", balance: "always" } : ee, Te = v(ee, q);
    return Xo({
      column: xe,
      tree: de,
      columnId: q,
      edit: { rowId: j, newValue: J },
      read: u(),
      ...Te !== void 0 ? { readMax: Te } : {},
      isLocked: w(me, ve)
    });
  }, ae = (j) => N(j.columnId, j.overrides, j.lockOverrides), Ie = (j, q) => w(l.value)(j, q), ke = () => {
    l.value = Rh(), o.value = null, a.value = null, r.value = null, s.value = null, i.value = 0;
  }, $e = mt(null), He = () => {
    for (const j of Object.keys(n.columns))
      Rn(z(ge(j)));
  }, qe = () => {
    const j = [], q = [];
    for (const ee of Object.keys(n.columns)) {
      const de = Dh(N(ge(ee)), u());
      j.push(...de.patches), q.push(...de.diagnostics);
    }
    j.length > 0 && (c = !0, (n.onInitialApply ?? n.onApply)(j), Rn(
      ot(() => {
        c = !1;
      })
    ));
    const J = { patches: j, diagnostics: q, verdict: "applied" };
    l.value = I(
      T(j, P(l.value)),
      L(J)
    ), (j.length > 0 || q.length > 0) && (o.value = J), r.value = null;
  }, Ye = (j) => {
    j?.lockState !== void 0 && (l.value = new Set(j.lockState)), o.value = null, a.value = null, r.value = null, s.value = null, i.value = 0, c = !0, $e.value = ea(t.value, n.rowKey, Object.keys(n.columns)), qe();
  };
  return oe(
    () => t.value,
    () => {
      const j = c;
      c = !1;
      const q = ea(t.value, n.rowKey, Object.keys(n.columns)), J = $e.value;
      if ($e.value = q, J === null) {
        qe();
        return;
      }
      $h(J, q) && (j || He());
    },
    { immediate: !0, deep: !1, flush: "post" }
  ), {
    lockState: l,
    lastResult: o,
    lastHalt: a,
    lastValidation: r,
    lastTrigger: s,
    haltCount: i,
    onCellEdit: A,
    onToggleLock: E,
    nullifyTree: D,
    autofyTree: X,
    recompute: z,
    applyResolution: Q,
    previewCellEdit: ne,
    preview: ae,
    isLocked: Ie,
    managedColumnKeys: new Set(Object.keys(n.columns)),
    reset: ke,
    reseed: Ye
  };
}, ta = (e) => e.filter((t) => t.kind !== "lock-clear").map((t) => ({
  rowKey: String(t.rowId),
  field: String(t.columnId),
  value: t.kind === "null" ? null : t.value
})), rw = (e) => {
  const { table: t, rows: n, config: l, onApplied: o } = e, a = Nh({
    rows: n,
    config: {
      ...l,
      onApply: (s) => {
        const i = n.value;
        t.applyPatch(ta(s), { source: "derived" }), o?.(s, { rowsBefore: i });
      },
      // Initial/reseed normalization: reconcile seed display to the cascade invariant WITHOUT
      // notifying onApplied, and tagged 'seed' so the patches FOLD into the table's dirty
      // baseline — a freshly loaded (or just-reseeded) table must not report dirty cells for
      // its own normalization. User edits keep flowing through onApply → onApplied.
      onInitialApply: (s) => {
        t.applyPatch(ta(s), { source: "seed" });
      }
    }
  });
  return { ...a, intercept: (s) => a.managedColumnKeys.has(s.field) ? (Rn(a.onCellEdit(ce(s.rowKey), ge(s.field), s.value)), { kind: "handled" }) : { kind: "proceed" } };
}, Bh = "violation", vl = 1e-4, na = (e, t) => {
  const n = e[t];
  return typeof n == "number" ? n : null;
}, la = (e, t) => t === "left" ? e.leftLabel ?? e.left : e.rightLabel ?? e.right, Ar = (e, t) => t === e.left || t === e.right, jh = (e, t, n) => t?.kind !== "cell-edit" || String(t.rowId) !== n || !Ar(e, String(t.columnId)) ? null : {
  rowId: String(t.rowId),
  columnId: String(t.columnId)
}, Uh = (e, t, n) => t?.kind !== "cell-edit" || !Ar(e, String(t.columnId)) ? null : {
  rowId: n,
  columnId: String(t.columnId)
}, Hh = (e, t, n) => ({
  rowId: ye(e, t),
  columnId: n.left
}), Wh = (e, t, n, l, o) => {
  const a = ye(e, t), r = jh(n, l, a);
  if (o === "trigger" && r !== null)
    return r;
  const s = Uh(n, l, a);
  return o === "trigger-column" && s !== null ? s : Hh(e, t, n);
}, Zh = (e, t, n) => {
  const l = ye(e, t);
  return [
    { rowId: l, columnId: n.left },
    { rowId: l, columnId: n.right }
  ];
}, _l = (e, t, n) => {
  if (t === null || n === null)
    return !1;
  switch (e.operator) {
    case "<=":
      return t - n > vl;
    case ">=":
      return n - t > vl;
    case "=":
      return Math.abs(t - n) > vl;
    default:
      return !1;
  }
}, qh = (e, t) => {
  const n = la(e, "left"), l = la(e, "right"), o = n.toLowerCase(), a = l.toLowerCase();
  return e.operator === "=" ? t === e.right ? `${l} must match ${o}` : `${n} must match ${a}` : e.operator === "<=" ? t === e.right ? `${l} must be at least ${o}` : `${n} must not exceed ${a}` : t === e.right ? `${l} must not exceed ${o}` : `${n} must be at least ${a}`;
}, $r = ({
  config: e,
  rows: t,
  rules: n,
  targetMode: l = Bh,
  trigger: o
}) => {
  const a = n ?? [], r = [];
  for (const s of t)
    for (const i of a) {
      const c = na(s, i.left), u = na(s, i.right);
      if (!_l(i, c, u))
        continue;
      const d = l === "participants" ? Zh(e, s, i) : [Wh(e, s, i, o, l)];
      for (const v of d)
        r.push({
          code: i.id,
          message: `${qh(i, v.columnId)} (${Vt(e, s)})`,
          rowId: ce(v.rowId),
          columnId: ge(v.columnId),
          severity: "error"
        });
    }
  return r;
};
function sw(e) {
  return e !== void 0 ? e : (t) => t;
}
const Gt = () => (e) => e, Be = (e) => {
  const { target: t } = e;
  return t === void 0 ? null : {
    ...t,
    rowKey: String(t.rowId),
    colKey: String(t.columnId),
    row: t.row,
    value: t.attemptedValue
  };
};
function Jh(e) {
  return e !== void 0 ? e : (t) => t;
}
function Gh(e) {
  return e !== void 0 ? e : (t) => t;
}
function iw(e) {
  return e !== void 0 ? e : (t) => t;
}
const _h = (e, t, n) => ({
  ...e,
  [t]: n
}), oa = (e, t) => e[t], aa = (e) => e == null || typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e instanceof Date || e instanceof Blob || Array.isArray(e) || typeof e == "object" ? e : String(e), vn = (e) => {
  if (e.patches.length === 0)
    return e.rows;
  const t = e.applyValue ?? _h, n = /* @__PURE__ */ new Map();
  for (const l of e.patches) {
    if (l.kind === "lock-clear")
      continue;
    const o = n.get(l.rowId) ?? [];
    o.push(l), n.set(l.rowId, o);
  }
  return e.rows.map((l) => {
    const o = n.get(e.getRowKey(l));
    if (o === void 0)
      return l;
    let a = l;
    for (const r of o) {
      const s = r.kind === "null" ? null : r.value;
      a = t(a, String(r.columnId), s);
    }
    return a;
  });
}, Yh = (e) => {
  const t = new Set(e.lockedKeys);
  for (const n of e.rows)
    if (e.isSourceRow?.(n) ?? e.getParentKey(n) === null)
      for (const o of e.columnIds)
        t.delete(re(ce(e.getRowKey(n)), ge(o)));
  return t;
}, Qh = (e) => {
  const t = new Map(e.projectedRows.map((n) => [e.getRowKey(n), n]));
  return e.rows.map((n) => {
    const l = e.getRowKey(n), o = t.get(l) ?? n, a = oa(n, e.columnId), r = oa(o, e.columnId), s = e.isSourceRow?.(n) !== !0, i = ce(l), c = ge(e.columnId);
    return {
      id: l,
      parentId: e.getParentKey(n),
      name: e.getRowLabel(n),
      beforeValue: aa(a),
      before: e.formatValue({ row: n, columnId: e.columnId, value: a }),
      beforeLocked: s && e.isBeforeLocked(i, c),
      afterValue: aa(r),
      after: e.formatValue({ row: o, columnId: e.columnId, value: r }),
      afterLocked: s && e.isAfterLocked(i, c),
      lockVisible: s
    };
  });
}, Xh = (e) => e.filter(
  (t) => t.before !== t.after || t.beforeLocked !== t.afterLocked || t.compareBefore !== t.compareAfter || t.compareBeforeLocked !== t.compareAfterLocked
).map((t) => t.id), eb = (e, t) => {
  const n = new Map(e.map((o) => [o.id, o])), l = /* @__PURE__ */ new Set();
  for (const o of t) {
    let a = n.get(o)?.parentId ?? null;
    for (; a !== null; )
      l.add(a), a = n.get(a)?.parentId ?? null;
  }
  return Array.from(l);
}, kt = Ce(), Lr = "column-relation", Bt = (e, t) => t === "left" ? e.leftLabel ?? e.left : e.rightLabel ?? e.right, ra = (e, t) => {
  if (e === void 0)
    return null;
  const n = De({ row: e, columnId: t });
  return typeof n == "number" ? n : null;
}, Fr = (e, t, n) => {
  const l = e.filter((o) => o.left === t || o.right === t);
  return l.length === 0 ? null : l.find(
    (o) => _l(
      o,
      ra(n, o.left),
      ra(n, o.right)
    )
  ) ?? null;
}, tb = (e, t, n, l, o) => {
  const a = o.find((r) => ye(e, r) === n);
  a !== void 0 && !rt(e, a) && t.add(re(ce(n), l));
}, nb = (e, t, n) => typeof n == "number" ? { kind: "number", rowId: ce(e), columnId: ge(t), value: n } : { kind: "null", rowId: ce(e), columnId: ge(t) }, lb = ({
  config: e,
  context: t,
  mode: n,
  rows: l,
  rules: o,
  sideToChange: a
}) => {
  const r = Be(t);
  if (r === null)
    return { rows: l, lockedKeys: t.lockedKeys, patches: [] };
  const s = t.projectedRows.find((g) => ye(e, g) === r.rowKey) ?? r.row, i = Fr(o, r.colKey, s);
  if (i === null)
    return { rows: l, lockedKeys: t.lockedKeys, patches: [] };
  const c = a === "left" ? i.left : i.right, u = a === "left" ? i.right : i.left, d = ge(c), v = ge(u), m = new Set(t.lockedKeys), p = l.map((g) => {
    const y = ye(e, g), P = n === "clear" ? null : De({ row: g, columnId: u });
    return m.delete(re(ce(y), d)), n === "copy" && typeof P == "number" && t.lockedKeys.has(re(ce(y), v)) && tb(e, m, y, d, l), nb(y, c, P);
  });
  return {
    rows: vn({
      rows: l,
      patches: p,
      getRowKey: (g) => ye(e, g)
    }),
    lockedKeys: m,
    patches: p
  };
}, ob = (e, t) => {
  if (t.calculator === void 0)
    return [];
  const n = t.config, { rules: l } = e, o = (c) => {
    const u = Be(c);
    if (u === null)
      return null;
    const d = c.projectedRows.find((m) => ye(n, m) === u.rowKey) ?? u.row, v = Fr(l, u.colKey, d);
    return v === null ? null : { rule: v, target: u };
  }, a = (c, u) => u.strategies === void 0 || u.strategies.includes(c), r = (c) => (u) => {
    const d = o(u);
    return d !== null && a(c, d.rule);
  }, s = (c, u) => (d) => lb({ context: d, config: n, rules: l, rows: t.getRows(), sideToChange: c, mode: u }), i = (c, u, d) => (v) => {
    const m = o(v);
    return m === null ? d() : u(m.rule);
  };
  return [
    {
      id: "match-left-to-right",
      label: i(
        "left",
        (c) => kt("ui.smart.copyColumnTo", "Copy {from} to {to}", {
          from: Bt(c, "right"),
          to: Bt(c, "left")
        }),
        () => kt("ui.smart.copyRightToLeft", "Copy right column to left")
      ),
      isAvailable: r("match-left-to-right"),
      exclusive: !0,
      isPreferred: (c) => o(c)?.target.colKey === o(c)?.rule.left,
      buildProjection: s("left", "copy")
    },
    {
      id: "match-right-to-left",
      label: i(
        "right",
        (c) => kt("ui.smart.copyColumnTo", "Copy {from} to {to}", {
          from: Bt(c, "left"),
          to: Bt(c, "right")
        }),
        () => kt("ui.smart.copyLeftToRight", "Copy left column to right")
      ),
      isAvailable: r("match-right-to-left"),
      exclusive: !0,
      isPreferred: (c) => o(c)?.target.colKey === o(c)?.rule.right,
      buildProjection: s("right", "copy")
    },
    {
      id: "clear-left",
      label: i(
        "left",
        (c) => kt("ui.smart.clearColumn", "Clear {column}", { column: Bt(c, "left") }),
        () => kt("ui.smart.clearLeftColumn", "Clear left column")
      ),
      isAvailable: r("clear-left"),
      exclusive: !0,
      buildProjection: s("left", "clear")
    },
    {
      id: "clear-right",
      label: i(
        "right",
        (c) => kt("ui.smart.clearColumn", "Clear {column}", { column: Bt(c, "right") }),
        () => kt("ui.smart.clearRightColumn", "Clear right column")
      ),
      isAvailable: r("clear-right"),
      exclusive: !0,
      buildProjection: s("right", "clear")
    },
    {
      id: "keep-as-is",
      label: () => kt("ui.smart.leaveAsIsIWillFixItMyself", "Leave as is — I will fix it myself"),
      isAvailable: r("keep-as-is"),
      exclusive: !0,
      keepsCurrentValue: !0,
      buildProjection: (c) => ({
        rows: c.rows,
        lockedKeys: c.lockedKeys,
        patches: []
      })
    }
  ];
}, ab = (e, t) => {
  const n = t.config, { rules: l } = e;
  return l.map((o) => ({
    id: o.id,
    label: o.label ?? o.id,
    kind: "condition",
    scope: "row",
    validate: (a) => $r({
      config: n,
      rows: a.projectedRows,
      rules: [o],
      trigger: a.trigger,
      targetMode: "violation"
    })
  }));
}, uw = (e) => Gt()({
  id: Lr,
  // Registry metadata, not display copy: nothing in the repo renders a module label, so it stays
  // a stable technical literal rather than a translated string that changes with the UI language.
  label: "Column relation resolution",
  scope: "row",
  columns: [...new Set(e.rules.flatMap((t) => [t.left, t.right]))],
  buildRules: (t) => ab(e, t),
  buildStrategies: (t) => ob(e, t),
  metadata: {
    rules: e.rules
  }
}), rb = "-", sb = "__root__", Dr = (e, t) => {
  if (e === void 0)
    throw new Error(`SmartResolutionConfig.${t} is required when topology does not provide it`);
  return e;
}, Nr = (e) => Dr(e.topology?.rowKey ?? e.rowKey, "rowKey"), Br = (e) => e.topology?.kind === "tree" ? e.topology.parentKey : e.parentKey, Vt = (e, t) => {
  const n = e.topology?.getLabel ?? e.getRowLabel;
  return Dr(n, "getRowLabel")(t);
}, Re = (e, t) => e.columns[t], mn = (e) => Object.keys(e.columns), ib = (e) => {
  if (typeof e != "object" || e === null)
    return !1;
  const t = e;
  return typeof t.id == "string" && typeof t.left == "string" && typeof t.right == "string" && (t.operator === "<=" || t.operator === ">=" || t.operator === "=");
}, jr = (e) => (e.modules ?? []).filter((t) => t.id === Lr).flatMap((t) => {
  const n = t.metadata?.rules;
  return Array.isArray(n) ? n.filter(ib) : [];
}), ub = (e, t) => jr(e).filter((n) => n.left === t || n.right === t), ye = (e, t) => String(t[Nr(e)]), _e = (e, t) => {
  if (e.topology?.kind === "flat")
    return null;
  if (e.topology?.kind === "custom") {
    const o = e.topology.getParentKey?.(t);
    return o == null ? null : String(o);
  }
  const n = Br(e);
  if (n === void 0)
    return null;
  const l = t[n];
  return l == null ? null : String(l);
}, rt = (e, t) => e.topology?.kind !== "flat" && _e(e, t) === null, De = ({ row: e, columnId: t }) => e[t], Ur = (e) => typeof e == "number" ? Number.isFinite(e) && e !== 0 : e != null, cb = (e, t, n, l) => {
  if (l === void 0)
    return !0;
  if (Re(e, l)?.kind !== "number")
    return !1;
  const o = t.find((a) => ye(e, a) === n);
  return o === void 0 ? !1 : Ur(De({ row: o, columnId: l }));
}, db = (e, t, n) => t.length <= 1 ? !1 : n === void 0 ? !0 : Re(e, n)?.kind !== "number" ? !1 : t.some((l) => Ur(De({ row: l, columnId: n }))), fb = (e, t, n) => {
  const l = /* @__PURE__ */ new Map();
  for (const o of t) {
    if (rt(e, o))
      continue;
    const a = _e(e, o) ?? sb;
    if (!cb(e, t, a, n))
      continue;
    const r = (l.get(a) ?? 0) + 1;
    if (r > 1)
      return !0;
    l.set(a, r);
  }
  return !1;
}, cw = (e, t, n) => e.topology?.kind === "flat" ? db(e, t, n) : fb(e, t, n), Hr = (e, t, n) => Object.assign({}, e, { [t]: n }), sn = (e, t) => Re(e, t)?.kind === "number", vb = (e, t) => {
  const n = Re(e, t);
  return n?.kind === "number" ? n.precision : void 0;
}, mb = (e, t, n) => {
  const l = Re(e, n);
  return l?.kind === "number" ? l.max?.(t) ?? null : null;
}, hb = (e, t) => {
  const n = Re(e, t);
  return n?.kind === "number" ? n.buildExtraPatches : void 0;
}, bb = (e) => ({
  getRowKey: (t) => ye(e, t),
  getParentKey: (t) => _e(e, t),
  readNumber: (t, n) => {
    if (!sn(e, n))
      return null;
    const l = De({ row: t, columnId: n });
    return typeof l == "number" ? l : null;
  },
  withNumberValue: (t, n, l) => sn(e, n) ? Hr(t, n, l) : t,
  getMax: (t, n) => mb(e, t, n),
  getPrecision: (t) => vb(e, t)
}), Bn = (e, t) => {
  const n = Re(e, t.columnId);
  return n !== void 0 ? n.formatValue(t) : t.value === null || t.value === void 0 ? rb : String(t.value);
}, gb = (e) => ({
  rows: e.rows,
  projectedRows: e.rows,
  patches: e.patches,
  lockedKeys: e.lockedKeys
}), yb = ({
  config: e,
  projection: t
}) => e.validateProjection?.(gb(t)) ?? [], ml = (e, t) => JSON.stringify({ rows: e, lockedKeys: [...t].map(String).sort((n, l) => n.localeCompare(l)) }), hl = (e) => ({
  resolution: e,
  preview: "",
  valueOverride: void 0
}), pb = ({
  apply: e,
  clearTransientState: t,
  defaultStrategy: n,
  getContext: l,
  getInitialContext: o,
  onCancel: a,
  registry: r,
  validation: s,
  mapContext: i
}) => {
  const c = Hl({
    defaultValues: hl(n)
  }), u = () => {
    c.reset(hl(n));
  }, d = (N) => {
    c.setFieldValue("resolution", N);
  }, v = (N) => {
    const T = l(N);
    return i?.(T, c.state.values) ?? T;
  }, m = (N, T, L) => {
    if (N.keepsCurrentValue === !0)
      return !0;
    const k = L ?? N.buildProjection(T);
    return ml(k.rows, k.lockedKeys) !== ml(T.rows, T.lockedKeys);
  }, p = (N, T) => {
    const L = /* @__PURE__ */ new Set();
    return N.flatMap((k) => {
      const K = k.buildProjection(T);
      if (!m(k, T, K))
        return [];
      if (k.keepsCurrentValue === !0)
        return [{ handler: k, projection: K }];
      const W = ml(K.rows, K.lockedKeys);
      return L.has(W) ? [] : (L.add(W), [{ handler: k, projection: K }]);
    });
  }, g = (N) => {
    const T = r.getAvailable(N), L = p(
      T.filter((k) => k.isFallback !== !0),
      N
    );
    return L.length > 0 ? { available: T, offered: L } : {
      available: T,
      offered: p(
        T.filter((k) => k.isFallback === !0),
        N
      )
    };
  }, y = (N, T) => {
    const { available: L, offered: k } = g(N);
    if (k.some(({ handler: G }) => G.id === T))
      return { strategy: T, requestedWasSubstituted: !1 };
    const K = r.getPreferred(N)?.id;
    return {
      strategy: (k.find(({ handler: G }) => G.id === K) ?? k[0])?.handler.id ?? null,
      // Only a request the registry DID let through counts as substituted. One that never got that
      // far — the popover's untouched default, or a strategy hidden by an exclusive sibling — has
      // no user intent behind it for `handleSubmit` to protect.
      requestedWasSubstituted: L.some((G) => G.id === T)
    };
  }, P = (N, T) => y(N, T).strategy, I = (N) => {
    const T = c.state.values.resolution, L = P(v(N), T);
    L === null || L === T || queueMicrotask(() => {
      c.state.values.resolution === T && d(L);
    });
  }, w = (N) => {
    I(N);
    const T = v(N), L = P(T, c.state.values.resolution);
    return L === null ? {
      rows: T.rows,
      lockedKeys: T.lockedKeys,
      patches: []
    } : r.require(L).buildProjection(T);
  }, C = (N) => {
    I(N);
    const T = v(N);
    return g(T).offered.map(({ handler: L }) => ({
      value: L.id,
      label: r.getLabel(L, T),
      ...L.keepsCurrentValue === !0 ? { keepsCurrentValue: !0 } : {}
    }));
  }, x = async (N, T) => {
    const L = v(N), { requestedWasSubstituted: k, strategy: K } = y(L, c.state.values.resolution);
    K === null || (d(K), k) || (await e({ projection: r.require(K).buildProjection(L), strategy: K })).verdict === "halted" || (T(), u());
  }, O = (N) => {
    N(), t(), a?.(), u();
  };
  return s !== void 0 && oe(s, () => {
    const N = o?.() ?? null;
    if (N !== null) {
      const T = r.getPreferred(N);
      c.reset(hl(T !== void 0 ? T.id : n));
    }
  }), {
    form: c,
    getAvailableStrategy: P,
    syncAvailableStrategy: I,
    buildProjection: w,
    buildOptions: C,
    handleSubmit: x,
    handleCancel: O
  };
}, Wr = "keep-current", sa = "Keep the current value", wb = (e, t) => {
  const n = t.target;
  if (n?.row === void 0)
    return sa;
  const l = String(n.columnId), o = De({ row: n.row, columnId: l });
  return `${sa} (${Bn(e, { row: n.row, columnId: l, value: o })})`;
}, kb = (e) => [
  {
    id: "keep-current-value",
    label: (t) => wb(e.config, t),
    isAvailable: () => !0,
    // Commits nothing: `rows` are the live rows the refused edit never reached, and there are no
    // patches to apply. Apply therefore just dismisses the halt — same end state as Cancel, but
    // stated as a choice the user made rather than one they had to infer.
    keepsCurrentValue: !0,
    isFallback: !0,
    buildProjection: (t) => ({
      rows: t.rows,
      lockedKeys: t.lockedKeys,
      patches: []
    })
  }
], Sb = () => Gt()({
  id: Wr,
  label: "Keep current value",
  buildStrategies: (e) => kb(e)
}), Cb = Ce(), Zr = "manual", Ib = (e) => [
  {
    id: "manual",
    label: () => Cb("ui.smart.manualKeepCurrentValue", "Manual: keep current value"),
    isAvailable: () => e,
    // Changing nothing is the whole point, so it must be exempt from the popover's no-op filter
    // (`useSmartResolutionDialog`) — without this it would be dropped from its own option list.
    keepsCurrentValue: !0,
    buildProjection: (t) => ({
      rows: t.rows,
      lockedKeys: t.lockedKeys,
      patches: t.patches
    })
  }
], Rb = (e) => Gt()({
  id: Zr,
  // Registry metadata, not display copy: nothing in the repo renders a module label, so it stays
  // a stable technical literal rather than a translated string that changes with the UI language.
  label: "Manual resolution",
  buildStrategies: () => Ib(e)
}), ia = "__smartResolutionRowId", ua = "__smartResolutionParentId", Yl = 0, qr = 10, Pn = Number.POSITIVE_INFINITY, Dt = (e, t, n) => e.find((l) => n.getRowKey(l) === t), Jr = (e, t, n) => {
  const l = n.getMax?.(e, t);
  return typeof l == "number" && Number.isFinite(l) ? l : Pn;
}, Ql = (e, t, n) => n.getPrecision?.(t) === Yl ? Math.round(e) : e, Pb = (e, t, n) => ({
  kind: "number",
  rowId: ce(e),
  columnId: ge(t),
  value: n
}), Tb = (e, t, n) => {
  const l = n.getRowKey(t);
  return e.map((o) => n.getRowKey(o) === l ? t : o);
}, Eb = (e, t, n, l) => {
  const o = Dt(e, t, l);
  return o === void 0 ? 0 : l.readNumber(o, n) ?? 0;
}, Mb = (e, t, n, l) => e.filter((o) => l.getParentKey(o) === t).reduce((o, a) => o + (l.readNumber(a, n) ?? 0), 0), Vb = (e, t, n, l, o, a) => {
  const r = Eb(t, a, e.columnId, e.adapter);
  if (e.raiseChain)
    return Mb(t, o, e.columnId, e.adapter);
  const s = Xl({
    ...e,
    rows: t,
    lockedKeys: n
  });
  return Rr({
    tree: s.tree,
    constraints: s.constraints,
    rowId: ce(a),
    parentValue: e.adapter.readNumber(l, e.columnId) ?? 0,
    requestedValue: r
  }).requiredParentValue ?? r;
}, xb = (e, t, n) => t.filter((l) => n.has(e.adapter.getRowKey(l))).map(
  (l) => Pb(e.adapter.getRowKey(l), e.columnId, e.adapter.readNumber(l, e.columnId) ?? 0)
), Gr = (e, t) => Sr({
  rows: e.map((n) => ({
    [ia]: t.getRowKey(n),
    [ua]: t.getParentKey(n)
  })),
  rowKey: ia,
  parentKey: ua
}), Xl = (e) => {
  const t = Gr(e.rows, e.adapter), n = ge(e.columnId);
  return {
    tree: t,
    constraints: ql({
      tree: t,
      columnId: n,
      read: (l, o) => {
        const a = Dt(e.rows, String(l), e.adapter);
        return a === void 0 ? null : e.adapter.readNumber(a, String(o));
      },
      isLocked: (l, o) => e.lockedKeys.has(re(l, o))
    })
  };
}, _r = (e) => Xl(e).constraints.get(ce(e.rowId))?.childrenMinTotal ?? 0, Yr = (e) => {
  const t = e.adapter.getParentKey(e.row);
  if (t === null)
    return Pn;
  const n = Dt(e.rows, t, e.adapter);
  if (n === void 0)
    return Pn;
  const l = Xl(e);
  return Rr({
    tree: l.tree,
    constraints: l.constraints,
    rowId: ce(e.adapter.getRowKey(e.row)),
    parentValue: e.adapter.readNumber(n, e.columnId) ?? 0,
    requestedValue: 0
  }).availableValue ?? Pn;
}, Kb = (e) => {
  const t = typeof e.attemptedValue == "number" ? e.attemptedValue : 0, n = Ql(t, e.columnId, e.adapter), l = e.adapter.getRowKey(e.row), o = Math.max(
    0,
    _r({
      ...e,
      rowId: l
    })
  ), a = Jr(e.row, e.columnId, e.adapter), r = e.respectParentCapacity ? Math.min(a, Yr(e)) : a;
  return r < o ? o : Math.min(Math.max(n, o), r);
}, zb = (e, t) => qr ** -(t.getPrecision?.(e) ?? Yl), Ob = (e, t, n) => {
  const l = qr ** (n.getPrecision?.(t) ?? Yl);
  return Math.round(e * l) / l;
}, Qr = (e) => {
  const t = zb(e.columnId, e.adapter), n = (l) => {
    const o = e.rows.filter((i) => e.adapter.getParentKey(i) === l);
    if (o.length === 0)
      return t;
    let a = 0, r = 0, s = 0;
    for (const i of o) {
      const c = e.adapter.getRowKey(i);
      if (e.lockedKeys.has(re(ce(c), ge(e.columnId)))) {
        a += e.adapter.readNumber(i, e.columnId) ?? 0;
        continue;
      }
      r += 1, s = Math.max(s, n(c));
    }
    return Ob(a + r * s, e.columnId, e.adapter);
  };
  return n(e.rowId);
}, Ab = (e) => {
  const t = Yr(e), n = Jr(e.row, e.columnId, e.adapter), l = Number.isFinite(t) ? Math.min(t, n) : n, o = _r({
    ...e,
    rowId: e.adapter.getRowKey(e.row)
  });
  return Ql(Math.max(o, l), e.columnId, e.adapter);
}, $b = (e, t, n) => typeof e != "number" ? null : Math.max(0, Ql(e, t, n)), ca = (e, t, n, l, o) => {
  const a = Dt(t, n, o);
  a === void 0 || o.getParentKey(a) === null || e.add(re(ce(n), l));
}, Lb = (e) => {
  const t = ge(e.columnId);
  let n = [...e.rows];
  const l = /* @__PURE__ */ new Set(), o = (g) => Dt(n, g, e.adapter), a = (g, y) => {
    const P = e.adapter.withNumberValue(g, e.columnId, y);
    return n = Tb(n, P, e.adapter), l.add(e.adapter.getRowKey(P)), P;
  }, r = o(e.targetRowId);
  if (r === void 0)
    return null;
  a(r, e.targetValue);
  const s = new Set(e.lockedKeys), i = re(ce(e.targetRowId), t);
  ca(s, n, e.targetRowId, t, e.adapter);
  let c = e.adapter.getParentKey(r);
  const u = c;
  let d = null, v = e.targetRowId;
  for (; c !== null; ) {
    const g = o(c);
    if (g === void 0)
      break;
    const y = Vb(e, n, s, g, c, v);
    if ((e.adapter.readNumber(g, e.columnId) ?? 0) < y && a(g, y), ca(s, n, c, t, e.adapter), u === c) {
      const I = o(c);
      d = I === void 0 ? null : e.adapter.readNumber(I, e.columnId);
    }
    if (!e.raiseChain)
      break;
    v = c, c = e.adapter.getParentKey(g);
  }
  const m = xb(e, n, l), p = e.buildExtraPatches?.({
    rows: n,
    changedRowIds: l,
    columnId: e.columnId,
    adapter: e.adapter
  }) ?? [];
  return {
    rows: n,
    lockedKeys: s,
    overridePatches: [...m, ...p],
    targetCellKey: i,
    directParentId: u,
    directParentValue: d
  };
}, Fb = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  for (const l of e)
    l.kind !== "number" || String(l.columnId) !== String(t) || n.set(re(l.rowId, l.columnId), l.value);
  return n;
}, Xn = (e, t) => {
  const n = new Set(t.map((o) => re(o.rowId, o.columnId))), l = e.filter(
    (o) => o.kind === "lock-clear" || !n.has(re(o.rowId, o.columnId))
  );
  return [...t, ...l];
}, Db = (e) => xr({
  tree: Gr(e.rows, e.adapter),
  columnId: ge(e.columnId),
  mode: "value",
  edit: { rowId: e.rowId, newValue: e.newValue },
  read: (t, n) => {
    const l = re(t, n);
    if (e.overrides.has(l))
      return e.overrides.get(l) ?? null;
    const o = Dt(e.rows, String(t), e.adapter);
    return o === void 0 ? null : e.adapter.readNumber(o, String(n));
  },
  readMax: (t, n) => {
    const l = Dt(e.rows, String(t), e.adapter);
    return l === void 0 ? null : e.adapter.getMax?.(l, String(n)) ?? null;
  },
  isLocked: (t, n) => e.lockedKeys.has(re(t, n)),
  precision: e.adapter.getPrecision?.(String(e.columnId))
}), Nb = (e) => {
  const { directParentId: t, directParentValue: n, lockedKeys: l, overridePatches: o, targetCellKey: a } = e.draft;
  if (t === null || n === null)
    return null;
  const r = new Map(Fb(o, e.columnId));
  r.set(a, e.targetValue);
  const s = Db({
    rows: e.rows,
    columnId: String(e.columnId),
    rowId: ce(t),
    newValue: n,
    lockedKeys: l,
    overrides: r,
    adapter: e.adapter,
    balance: e.balance
  }), i = Xn(s.patches, o);
  return { rows: e.applyPatches(i), lockedKeys: l, patches: i };
}, Bb = (e) => {
  const t = [e.rootRowId];
  for (; t.length > 0; ) {
    const n = t.shift();
    if (n === void 0)
      break;
    e.lockedKeys.delete(re(ce(n), e.columnId));
    for (const l of e.rows.filter((o) => e.adapter.getParentKey(o) === n))
      t.push(e.adapter.getRowKey(l));
  }
}, jb = 10, Ub = (e, t) => vn({
  rows: e.rows,
  patches: t,
  getRowKey: (n) => ye(e.config, n)
}), bl = (e, t, n) => ({
  kind: "number",
  rowId: ce(e),
  columnId: ge(t),
  value: typeof n == "number" ? n : 0
}), Hb = (e, t, n, l) => {
  const o = e.rows.find((a) => ye(e.config, a) === n);
  o === void 0 || rt(e.config, o) || t.add(re(ce(n), l));
}, gl = (e, t, n) => {
  const l = Re(n, e);
  if (l?.kind !== "number" || l.precision === void 0)
    return t;
  const o = jb ** l.precision;
  return Math.round(t * o) / o;
}, Wb = (e, t, n) => {
  const l = Re(e.config, n);
  return l?.kind !== "number" ? 0 : Math.max(0, l.min?.(t) ?? 0);
}, Xr = (e, t, n) => e.numberAdapter.readNumber(t, n) ?? 0, Zb = (e, t, n, l) => {
  const o = t.map((m) => Wb(e, m, n)), a = o.reduce((m, p) => m + p, 0), r = l - a;
  if (r < 0)
    return [];
  const s = t.map((m) => Math.max(0, Xr(e, m, n))), i = s.reduce((m, p) => m + p, 0), u = t.map((m, p) => {
    const g = o[p] ?? 0, y = i > 0 ? (s[p] ?? 0) / i : 1 / t.length;
    return g + r * y;
  }).map((m) => gl(n, m, e.config)), d = u.reduce((m, p) => m + p, 0), v = gl(n, l - d, e.config);
  return u.length > 0 && v !== 0 && (u[0] = gl(n, (u[0] ?? 0) + v, e.config)), u;
}, qb = (e, t) => {
  if (Re(e.config, t.colKey)?.kind !== "number")
    return null;
  const l = t.row === void 0 ? null : _e(e.config, t.row);
  if (l === null)
    return e.total;
  const o = e.rows.find((r) => ye(e.config, r) === l);
  if (o === void 0)
    return null;
  const a = De({ row: o, columnId: t.colKey });
  return typeof a == "number" && Number.isFinite(a) ? a : null;
}, Jb = (e, t, n, l) => {
  if (t.row === void 0 || Re(e.config, t.colKey)?.kind !== "number" || typeof t.value != "number")
    return l(n);
  const o = qb(e, t);
  if (o === null)
    return l(n);
  const a = ge(t.colKey), r = re(ce(t.rowKey), a), s = _e(e.config, t.row), i = new Set(n);
  Hb(e, i, t.rowKey, a);
  const c = e.rows.filter((w) => ye(e.config, w) !== t.rowKey && _e(e.config, w) === s), u = c.filter(
    (w) => i.has(re(ce(ye(e.config, w)), a))
  ), d = c.filter(
    (w) => !i.has(re(ce(ye(e.config, w)), a))
  ), v = u.reduce((w, C) => w + Xr(e, C, t.colKey), 0), m = o - t.value - v, p = Zb(e, d, t.colKey, m), g = [bl(t.rowKey, t.colKey, t.value)];
  p.forEach((w, C) => {
    const x = d[C];
    x !== void 0 && g.push(bl(ye(e.config, x), t.colKey, w));
  });
  const y = Xn(g, [
    bl(t.rowKey, t.colKey, t.value)
  ]), P = /* @__PURE__ */ new Map();
  for (const w of y)
    (w.kind === "number" || w.kind === "value" || w.kind === "null") && P.set(re(w.rowId, w.columnId), w);
  const I = [...P.values()];
  return {
    rows: Ub(e, I),
    lockedKeys: /* @__PURE__ */ new Set([...i, r]),
    patches: I
  };
}, Gb = (e, t) => ({
  config: e.config,
  numberAdapter: e.numberAdapter,
  rows: e.getRows(),
  total: t
}), _b = (e, t, n) => (l) => {
  const o = Be(l);
  if (o === null)
    return { rows: e.getRows(), lockedKeys: l.lockedKeys, patches: [] };
  const a = Gb(e, t);
  return Jb(
    a,
    o,
    l.lockedKeys,
    (r) => n({ ...l, lockedKeys: r })
  );
}, Yb = (e, t) => (n) => {
  const l = Be(n);
  if (l === null || e.calculator === void 0)
    return { rows: e.getRows(), lockedKeys: n.lockedKeys, patches: [] };
  const o = e.config, a = ge(l.colKey), r = new Set(n.lockedKeys), s = l.row;
  s !== void 0 && !rt(o, s) && r.add(re(ce(l.rowKey), a));
  const i = Re(o, l.colKey), c = i?.suggestValue !== void 0 ? i.suggestValue({
    row: l.row,
    columnId: l.colKey,
    attemptedValue: l.value,
    rows: e.getRows(),
    lockedKeys: r
  }) : l.value, u = t.previewCellEdit(ce(l.rowKey), a, c);
  return {
    rows: vn({
      rows: e.getRows(),
      patches: u.patches,
      getRowKey: (d) => ye(o, d)
    }),
    lockedKeys: r,
    patches: u.patches
  };
}, da = Ce(), Qb = "number-flat-total", Xb = (e) => e?.kind === "cell-edit" && typeof e.value == "number" && e.value > 0, fa = (e, t) => t === void 0 || t.includes(e), eg = (e, t) => {
  const n = t.config, { strategies: l } = e, o = (d) => sn(n, d) && e.columns.includes(d), a = (d) => {
    const v = Be(d);
    return v !== null && o(v.colKey);
  }, r = (d) => {
    const v = Be(d);
    return v === null || !o(v.colKey) ? !1 : v.row === void 0 ? !0 : Re(n, v.colKey)?.kind === "number";
  };
  if (t.calculator === void 0)
    return [];
  const s = t.calculator, i = Yb(t, s), c = _b(t, e.total, i), u = [];
  return fa("fit-current", l) && u.push({
    id: "fit-current",
    label: () => da("ui.smart.useNearestValidValue", "Use nearest valid value"),
    isAvailable: (d) => a(d),
    buildProjection: i
  }), fa("resize-siblings-proportionally", l) && u.push({
    id: "resize-siblings-proportionally",
    label: () => da("ui.smart.resizeSiblingsProportionally", "Resize siblings proportionally"),
    isAvailable: (d) => a(d) && r(d),
    isPreferred: (d) => r(d) && Xb(d.trigger),
    buildProjection: c
  }), u;
}, dw = (e) => Gt()({
  id: Qb,
  // Registry metadata, not display copy: nothing in the repo renders a module label, so it stays
  // a stable technical literal rather than a translated string that changes with the UI language.
  label: "Number flat total resolution",
  scope: "table",
  columns: e.columns,
  buildStrategies: (t) => eg(e, t),
  metadata: {
    total: e.total,
    strategies: e.strategies
  }
}), tg = ({
  adapter: e,
  buildPatch: t,
  changedRowIds: n,
  columnId: l,
  config: o,
  rows: a
}) => {
  const r = hb(o, l);
  return r === void 0 ? [] : r({
    rows: a,
    changedRowIds: n,
    columnId: l,
    readNumber: (s, i) => e.readNumber(s, i) ?? 0,
    buildPatch: t
  });
}, el = (e, t) => Re(e, t)?.kind === "number", hn = (e, t) => vn({
  rows: e.rows,
  patches: t,
  getRowKey: (n) => ye(e.config, n)
}), eo = (e, t, n) => ({
  kind: "number",
  rowId: ce(e),
  columnId: ge(t),
  value: typeof n == "number" ? n : 0
}), to = (e, t, n, l) => {
  const o = e.rows.find((a) => ye(e.config, a) === n);
  o === void 0 || rt(e.config, o) || t.add(re(ce(n), l));
}, es = (e, t, n, l, o) => {
  const a = Re(e.config, t);
  return a?.suggestValue !== void 0 ? a.suggestValue({ row: n, columnId: t, attemptedValue: l, rows: e.rows, lockedKeys: o }) : a?.kind === "number" ? n === void 0 ? 0 : Kb({
    rows: e.rows,
    row: n,
    columnId: t,
    attemptedValue: l,
    lockedKeys: o,
    respectParentCapacity: !0,
    adapter: e.numberAdapter
  }) : l;
}, at = (e, t) => ({
  rows: e,
  lockedKeys: t,
  patches: []
}), ts = (e, t, n, l) => {
  const o = ge(n.colKey), a = new Set(l);
  to(e, a, n.rowKey, o);
  const r = es(e, n.colKey, n.row, n.value, a), s = t.previewCellEdit(ce(n.rowKey), o, r);
  return {
    rows: hn(e, s.patches),
    lockedKeys: a,
    patches: s.patches
  };
}, ng = (e, t, n, l) => {
  if (!el(e.config, n.colKey) || n.row === void 0)
    return ts(e, t, n, l);
  const o = ge(n.colKey), a = new Set(l);
  to(e, a, n.rowKey, o);
  const r = Ab({
    rows: e.rows,
    row: n.row,
    columnId: n.colKey,
    lockedKeys: a,
    adapter: e.numberAdapter
  }), s = t.previewCellEdit(ce(n.rowKey), o, r);
  return {
    rows: hn(e, s.patches),
    lockedKeys: a,
    patches: s.patches
  };
}, ns = (e, t, n, l) => {
  if (!el(e.config, t.colKey))
    return at(e.rows, n);
  const o = $b(t.value, t.colKey, e.numberAdapter);
  if (typeof o != "number")
    return at(e.rows, n);
  const a = ge(t.colKey), r = Lb({
    rows: e.rows,
    columnId: t.colKey,
    targetRowId: t.rowKey,
    targetValue: o,
    lockedKeys: n,
    raiseChain: l,
    adapter: e.numberAdapter,
    buildExtraPatches: ({ rows: s, changedRowIds: i, columnId: c }) => tg({
      config: e.config,
      rows: s,
      changedRowIds: i,
      columnId: c,
      adapter: e.numberAdapter,
      buildPatch: eo
    })
  });
  return r === null ? at(e.rows, n) : Nb({
    rows: e.rows,
    columnId: a,
    targetValue: o,
    draft: r,
    adapter: e.numberAdapter,
    applyPatches: (s) => hn(e, s),
    balance: e.balance
  }) ?? at(e.rows, n);
}, lg = (e, t, n, l) => {
  if (!el(e.config, n.colKey) || typeof n.value != "number")
    return at(e.rows, l);
  const o = ce(n.rowKey), a = ge(n.colKey), r = re(o, a), s = n.row === void 0 ? null : _e(e.config, n.row), i = e.rows.filter((p) => _e(e.config, p) === s), c = new Set(l);
  for (const p of i)
    Bb({
      rows: e.rows,
      rootRowId: ye(e.config, p),
      columnId: a,
      lockedKeys: c,
      adapter: e.numberAdapter
    });
  to(e, c, n.rowKey, a);
  const u = es(e, n.colKey, n.row, n.value, c), d = /* @__PURE__ */ new Map([[r, u]]), v = t.preview({ columnId: a, overrides: d, lockOverrides: c }), m = Xn(v.patches, [
    eo(n.rowKey, n.colKey, u)
  ]);
  return {
    rows: hn(e, m),
    lockedKeys: c,
    patches: m
  };
}, og = (e, t, n, l) => {
  if (!el(e.config, n.columnId))
    return at(e.rows, l);
  const o = Qr({
    rows: e.rows,
    columnId: n.columnId,
    lockedKeys: l,
    adapter: e.numberAdapter,
    rowId: n.rowId
  }), a = t.previewCellEdit(ce(n.rowId), ge(n.columnId), o), r = Xn(a.patches, [
    eo(n.rowId, n.columnId, o)
  ]);
  return {
    rows: hn(e, r),
    lockedKeys: l,
    patches: r
  };
}, _t = (e, t) => ({
  config: e.config,
  numberAdapter: e.numberAdapter,
  balance: t,
  rows: e.getRows()
}), ag = (e, t) => (n) => {
  const l = Be(n);
  return l === null || e.calculator === void 0 ? at(e.getRows(), n.lockedKeys) : ts(
    _t(e, t),
    e.calculator,
    l,
    n.lockedKeys
  );
}, rg = (e, t) => (n) => {
  const l = Be(n);
  return l === null || e.calculator === void 0 ? at(e.getRows(), n.lockedKeys) : og(
    _t(e, t),
    e.calculator,
    { rowId: l.rowKey, columnId: l.colKey },
    n.lockedKeys
  );
}, sg = (e, t) => (n) => {
  const l = Be(n);
  if (l === null || e.calculator === void 0)
    return at(e.getRows(), n.lockedKeys);
  const o = _t(e, t);
  return ng(o, e.calculator, l, n.lockedKeys);
}, ig = (e, t) => (n) => {
  const l = Be(n);
  return l === null ? at(e.getRows(), n.lockedKeys) : ns(_t(e, t), l, n.lockedKeys, !1);
}, ug = (e, t) => (n) => {
  const l = Be(n);
  return l === null ? at(e.getRows(), n.lockedKeys) : ns(_t(e, t), l, n.lockedKeys, !0);
}, cg = (e, t) => (n) => {
  const l = Be(n);
  return l === null || e.calculator === void 0 ? at(e.getRows(), n.lockedKeys) : lg(
    _t(e, t),
    e.calculator,
    l,
    n.lockedKeys
  );
}, Rt = Ce(), ls = "number-tree", dg = (e) => e?.kind === "cell-edit" && typeof e.value == "number" && e.value > 0, fg = (e, t) => t === void 0 || t.includes(e), vg = (e, t) => {
  const n = t.config, { strategies: l } = e, o = e.balance ?? "overflow-only", a = (w) => sn(n, w) && e.columns.includes(w), r = (w) => {
    const C = Be(w);
    return C?.row !== void 0 && rt(n, C.row);
  }, s = (w) => {
    const C = Be(w);
    return C !== null && a(C.colKey);
  }, i = (w) => {
    const C = Be(w);
    return C === null || C.row === void 0 || !rt(n, C.row) || !sn(n, C.colKey) || typeof C.value != "number" ? !1 : t.getRows().filter((O) => _e(n, O) === C.rowKey).reduce((O, N) => O + (t.readNumber(N, C.colKey) ?? 0), 0) > C.value;
  }, c = (w) => {
    const C = Be(w);
    if (C === null)
      return !1;
    const x = t.getRows(), O = x.find((L) => t.numberAdapter.getRowKey(L) === C.rowKey);
    if (O === void 0 || !rt(n, O))
      return !1;
    const N = typeof C.value == "number" ? C.value : t.readNumber(O, C.colKey);
    return N === null || N <= 0 ? !1 : Qr({
      rows: x,
      columnId: C.colKey,
      lockedKeys: w.lockedKeys,
      adapter: t.numberAdapter,
      rowId: C.rowKey
    }) > N;
  }, u = ag(t, o), d = rg(t, o), v = sg(t, o), m = ig(t, o), p = ug(t, o), g = cg(t, o), y = (w, C) => w === "any-column" || s(C), P = (w) => {
    const { isAvailableInScope: C, isPreferredInScope: x, targetScope: O, ...N } = w, T = (L) => y(O, L) && (C?.(L) ?? !0);
    return {
      ...N,
      isAvailable: T,
      // `registry.getPreferred` only consults handlers it already found available, but `isPreferred`
      // is called directly elsewhere too — so it carries the same gate rather than trusting callers.
      ...x === void 0 ? {} : { isPreferred: (L) => T(L) && x(L) }
    };
  };
  return [
    {
      id: "raise-direct-parent",
      label: () => Rt("ui.smart.raiseDirectParent", "Raise direct parent"),
      targetScope: "numeric-only",
      isAvailableInScope: (w) => !r(w),
      isPreferredInScope: (w) => dg(w.trigger),
      buildProjection: m
    },
    {
      id: "raise-parent-chain",
      label: () => Rt("ui.smart.raiseTopParent", "Raise top parent"),
      targetScope: "numeric-only",
      isAvailableInScope: (w) => !r(w),
      buildProjection: p
    },
    {
      id: "fit-current",
      label: (w) => i(w) ? Rt("ui.smart.resizeChildrenEvenly", "Resize children evenly") : Rt("ui.smart.useNearestValidValue", "Use nearest valid value"),
      targetScope: "any-column",
      buildProjection: u
    },
    {
      id: "fit-minimums",
      label: () => Rt("ui.smart.useMinimumValues", "Use minimum values"),
      targetScope: "numeric-only",
      isAvailableInScope: c,
      buildProjection: d
    },
    {
      id: "cap-max-possible",
      label: () => Rt("ui.smart.useMaxPossibleValue", "Use max possible value"),
      targetScope: "numeric-only",
      buildProjection: v
    },
    {
      id: "autofy-children",
      label: (w) => i(w) ? Rt("ui.smart.setChildrenToAuto", "Set children to auto") : Rt("ui.smart.setSiblingsToAuto", "Set siblings to auto"),
      targetScope: "numeric-only",
      buildProjection: g
    }
  ].filter((w) => fg(w.id, l)).map(P);
}, fw = (e) => Gt()({
  id: ls,
  // Registry metadata, not display copy: nothing in the repo renders a module label, so it stays
  // a stable technical literal rather than a translated string that changes with the UI language.
  label: "Number tree resolution",
  scope: "tree-family",
  columns: e.columns,
  buildStrategies: (t) => vg(e, t),
  metadata: {
    balance: e.balance,
    strategies: e.strategies
  }
}), os = Ce(), mg = "value-schema", hg = "fill-missing-values", no = (e) => e == null, bg = (e) => e?.kind === "value" && e.requireValueWhenAnyRowHasValue === !0, lo = (e, t) => e.valueSchema?.safeParse(t).success ?? !0, gg = (e, t, n) => {
  for (const l of n) {
    const o = De({ row: l, columnId: e });
    if (!no(o) && lo(t, o))
      return o;
  }
}, yg = ({ column: e, columnId: t, context: n }) => {
  if (e.suggestValue === void 0)
    return;
  const l = e.suggestValue({
    row: n.target?.row,
    columnId: t,
    attemptedValue: n.target?.attemptedValue,
    rows: n.projectedRows,
    lockedKeys: n.lockedKeys
  });
  return !no(l) && lo(e, l) ? l : void 0;
}, pg = (e) => {
  const t = gg(e.columnId, e.column, e.context.projectedRows);
  return t !== void 0 ? t : yg(e);
}, va = (e) => {
  const t = pg(e);
  if (t === void 0)
    return null;
  const n = ge(e.columnId), l = e.context.projectedRows.flatMap((o) => {
    const a = De({ row: o, columnId: e.columnId });
    return !no(a) && lo(e.column, a) ? [] : [
      {
        kind: "value",
        rowId: ce(ye(e.ctx.config, o)),
        columnId: n,
        value: t
      }
    ];
  });
  return l.length === 0 ? null : { patches: l };
}, wg = (e, t) => e.kind !== "lock-clear" && t.some(
  (n) => n.kind !== "lock-clear" && n.rowId === e.rowId && n.columnId === e.columnId
), kg = (e, t) => [
  ...e.filter((n) => !wg(n, t)),
  ...t
], Sg = (e, t) => {
  const n = t.config, l = [];
  for (const o of e.columns) {
    const a = Re(n, o);
    if (a?.kind !== "value" || a.valueSchema === void 0)
      continue;
    const r = a.valueSchema;
    l.push({
      id: `value-schema.${o}`,
      label: `Value schema for ${a.label ?? o}`,
      kind: "condition",
      scope: "column",
      validate: (s) => {
        const i = [];
        for (const c of s.projectedRows) {
          const u = De({ row: c, columnId: o }), d = r.safeParse(u);
          d.success || i.push({
            code: `value-schema.${o}`,
            // Reaches the rendered issue list in the popover, so it is display copy — the schema's
            // own message wins when it has one.
            message: d.error.issues[0]?.message ?? os("ui.smart.invalidValueFor", "Invalid value for {column}", {
              column: a.label ?? o
            }),
            rowId: ce(ye(n, c)),
            columnId: ge(o),
            severity: "error"
          });
        }
        return i;
      }
    });
  }
  return l;
}, Cg = (e, t) => {
  const n = e.columns.flatMap((l) => {
    const o = Re(t.config, l);
    return bg(o) ? [{ columnId: l, column: o }] : [];
  });
  return n.length === 0 ? [] : [
    {
      id: hg,
      label: (l) => {
        const o = String(l.target?.columnId ?? n[0]?.columnId ?? ""), a = Re(t.config, o);
        return os("ui.smart.fillMissingValues", "Fill missing {column} values", {
          column: a?.label ?? o
        });
      },
      isAvailable: (l) => {
        const o = String(l.target?.columnId ?? ""), a = n.find((r) => r.columnId === o)?.column;
        return a === void 0 ? !1 : va({ context: l, ctx: t, columnId: o, column: a }) !== null;
      },
      isPreferred: (l) => {
        const o = String(l.target?.columnId ?? "");
        return n.some((a) => a.columnId === o);
      },
      buildProjection: (l) => {
        const o = String(l.target?.columnId ?? ""), a = n.find((c) => c.columnId === o)?.column, r = a === void 0 ? null : va({ context: l, ctx: t, columnId: o, column: a });
        if (r === null)
          return {
            rows: l.projectedRows,
            lockedKeys: l.lockedKeys,
            patches: l.patches
          };
        const s = kg(l.patches, r.patches);
        return { rows: vn({
          rows: l.projectedRows,
          patches: s,
          getRowKey: (c) => ye(t.config, c),
          applyValue: Hr
        }), lockedKeys: l.lockedKeys, patches: s };
      }
    }
  ];
}, vw = (e) => Gt()({
  id: mg,
  // Registry metadata, not display copy: nothing in the repo renders a module label, so it stays
  // a stable technical literal rather than a translated string that changes with the UI language.
  label: "Value schema resolution",
  scope: "column",
  columns: e.columns,
  buildRules: (t) => Sg(e, t),
  buildStrategies: (t) => Cg(e, t)
}), ma = () => Ce()("ui.smart.forceApply", "Force apply"), Ig = (e) => e === !1 ? !1 : e === void 0 || typeof e == "string" ? { label: ma() } : { ...e, label: ma() }, Rg = (e) => e === !1 ? !1 : e === void 0 ? { disabled: !0 } : typeof e == "string" ? { label: e, disabled: !0 } : { ...e, disabled: !0 }, as = (e) => e.some((t) => t.afterForceIssue !== void 0 || t.compareAfterForceIssue !== void 0), Pg = (e, { canSubmit: t, hasForceIssues: n, hasOptions: l }) => {
  if (!l)
    return !1;
  const o = n ? Ig(e.submit) : e.submit;
  return t ? o : Rg(o);
}, rs = (e, { canSubmit: t, hasForceIssues: n, hasOptions: l }) => ({
  ...e,
  submit: Pg(e, { canSubmit: t, hasForceIssues: n, hasOptions: l })
}), jn = (e) => e === !1, Un = (e, t) => e === !1 ? "" : typeof e == "string" ? e : e?.label ?? t, ss = (e) => e !== !1 && typeof e != "string" && e?.disabled === !0, Tg = /* @__PURE__ */ ue({
  __name: "SmartResolutionOptions",
  props: /* @__PURE__ */ nn({
    options: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ce(), n = Wn(e, "modelValue");
    return (l, o) => e.options.length === 0 ? (h(), R(f(Me), {
      key: 0,
      as: "p",
      size: "2",
      variant: "soft",
      class: "hp-smart-resolution-options__empty"
    }, {
      default: S(() => [
        H(U(f(t)("ui.smart.noValidResolutionOptions", "No valid resolution options")), 1)
      ]),
      _: 1
    })) : (h(), R(f(Ci), {
      key: 1,
      modelValue: n.value,
      "onUpdate:modelValue": o[0] || (o[0] = (a) => n.value = a),
      options: e.options,
      variant: "outline",
      size: "2"
    }, null, 8, ["modelValue", "options"]));
  }
}), is = /* @__PURE__ */ Ae(Tg, [["__scopeId", "data-v-8094f9ae"]]), ha = 3, Eg = /* @__PURE__ */ ue({
  __name: "SmartResolutionPopoverHeader",
  props: {
    title: {},
    haltIssues: {}
  },
  setup(e) {
    const t = Ce(), n = () => t("ui.smart.haltGeneric", "Resolution is required for this edit"), l = e, o = b(() => l.haltIssues.slice(0, ha)), a = b(() => Math.max(0, l.haltIssues.length - ha));
    return (r, s) => (h(), R(f(cn), null, {
      default: S(() => [
        V(f(dn), null, {
          default: S(() => [
            H(U(e.title), 1)
          ]),
          _: 1
        }),
        o.value.length > 0 ? (h(), $(se, { key: 0 }, [
          (h(!0), $(se, null, Pe(o.value, (i, c) => (h(), R(f(Me), {
            key: c,
            as: "p",
            size: "2",
            color: "red"
          }, {
            default: S(() => [
              H(U(i), 1)
            ]),
            _: 2
          }, 1024))), 128)),
          a.value > 0 ? (h(), R(f(Me), {
            key: 0,
            as: "p",
            size: "2",
            variant: "soft"
          }, {
            default: S(() => [
              H(U(f(t)("ui.smart.hiddenIssues", "+{count} more", { count: a.value })), 1)
            ]),
            _: 1
          })) : B("", !0)
        ], 64)) : (h(), R(f(Me), {
          key: 1,
          size: "2",
          color: "red"
        }, {
          default: S(() => [
            H(U(n()), 1)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }));
  }
}), us = /* @__PURE__ */ Ae(Eg, [["__scopeId", "data-v-67002cf9"]]), cs = /* @__PURE__ */ ue({
  __name: "SmartResolutionPreviewTable",
  props: {
    cell: {},
    previewColumns: {},
    buildPreviewColumns: { type: Function },
    previewMaxHeight: {},
    buildPreviewRows: { type: Function },
    buildPreviewDirtyKeys: { type: Function },
    buildPreviewExpandedRowKeys: { type: Function }
  },
  setup(e) {
    const t = e, n = b(
      () => t.buildPreviewColumns?.(t.cell) ?? t.previewColumns
    ), l = b(() => t.buildPreviewRows(t.cell)), o = b(() => {
      const r = {};
      for (const s of t.buildPreviewDirtyKeys(t.cell))
        r[s] = { dirty: !0 };
      return r;
    }), a = vm({
      data: l,
      rowKey: "id",
      tree: { parentKey: "parentId", column: "name" },
      disabled: !0,
      rowStates: o
    });
    return oe(
      () => t.buildPreviewExpandedRowKeys(t.cell),
      (r) => {
        a.expandedKeys.value = [...r];
      },
      { immediate: !0 }
    ), (r, s) => (h(), R(Nm, {
      key: `${e.cell.rowKey}-${e.cell.colKey}`,
      table: f(a),
      columns: n.value,
      size: "1",
      "sticky-header-max-height": e.previewMaxHeight
    }, null, 8, ["table", "columns", "sticky-header-max-height"]));
  }
}), Mg = 'button[type="submit"]:not(:disabled)', Vg = /* @__PURE__ */ ue({
  __name: "SmartResolutionColumnRelationPopoverContent",
  props: {
    cell: {},
    form: {},
    fields: {},
    actions: {},
    previewColumns: {},
    buildPreviewColumns: {},
    previewMaxHeight: {},
    buildPreviewRows: {},
    buildPreviewDirtyKeys: {},
    buildPreviewExpandedRowKeys: {},
    getTitle: {},
    getHaltIssues: { type: Function, default: () => [] },
    buildOptions: {}
  },
  emits: ["submit", "cancel"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = {
      mounted: (v) => {
        ot(() => {
          v.querySelector(Mg)?.focus();
        });
      }
    }, r = b(() => n.buildOptions(n.cell)), s = b(() => r.value.length > 0), i = b(() => n.buildPreviewRows(n.cell)), c = b(() => as(i.value)), u = b(
      () => rs(n.actions, {
        hasOptions: s.value,
        hasForceIssues: c.value,
        canSubmit: !0
      })
    ), d = n.form.useStore((v) => v.values.resolution);
    return oe(
      r,
      (v) => {
        const m = d.value;
        v.length === 0 || v.some((p) => p.value === m) || n.form.setFieldValue("resolution", v[0]?.value ?? m);
      },
      { immediate: !0 }
    ), (v, m) => (h(), $(se, null, [
      V(us, {
        title: e.getTitle(e.cell),
        "halt-issues": e.getHaltIssues(e.cell)
      }, null, 8, ["title", "halt-issues"]),
      s.value ? (h(), R(f(It), { key: 0 }, {
        default: S(() => [
          (h(), R(cs, {
            key: f(d),
            cell: e.cell,
            "preview-columns": e.previewColumns,
            "build-preview-columns": e.buildPreviewColumns,
            "preview-max-height": e.previewMaxHeight,
            "build-preview-rows": e.buildPreviewRows,
            "build-preview-dirty-keys": e.buildPreviewDirtyKeys,
            "build-preview-expanded-row-keys": e.buildPreviewExpandedRowKeys
          }, null, 8, ["cell", "preview-columns", "build-preview-columns", "preview-max-height", "build-preview-rows", "build-preview-dirty-keys", "build-preview-expanded-row-keys"]))
        ]),
        _: 1
      })) : B("", !0),
      V(f(It), {
        padded: !0,
        class: "hp-smart-resolution-below"
      }, {
        default: S(() => [
          V(is, {
            "model-value": f(d),
            options: r.value,
            "onUpdate:modelValue": m[0] || (m[0] = (p) => e.form.setFieldValue("resolution", p))
          }, null, 8, ["model-value", "options"])
        ]),
        _: 1
      }),
      Tn((h(), R(f(fn), null, {
        default: S(() => [
          f(jn)(u.value.cancel) ? B("", !0) : (h(), R(f(we), {
            key: 0,
            variant: "soft",
            onClick: m[1] || (m[1] = (p) => l("cancel"))
          }, {
            default: S(() => [
              H(U(f(Un)(u.value.cancel, "Cancel")), 1)
            ]),
            _: 1
          })),
          f(jn)(u.value.submit) ? B("", !0) : (h(), R(f(we), {
            key: 1,
            type: "submit",
            variant: "filled",
            disabled: f(ss)(u.value.submit),
            onClick: m[2] || (m[2] = (p) => l("submit", e.cell))
          }, {
            default: S(() => [
              H(U(f(Un)(u.value.submit, "Apply")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        ]),
        _: 1
      })), [
        [a]
      ])
    ], 64));
  }
}), xg = /* @__PURE__ */ Ae(Vg, [["__scopeId", "data-v-47998b2b"]]), Kg = {
  key: 0,
  class: "hp-smart-resolution-popover__value"
}, zg = 250, Og = /* @__PURE__ */ ue({
  __name: "SmartResolutionValueFooter",
  props: {
    valuePreview: {},
    valueOverride: {}
  },
  emits: ["update:valueOverride", "validity-change"],
  setup(e, { emit: t }) {
    const n = Ce(), l = e, o = t, a = Y(""), r = Y(!1), s = Y(!0);
    let i, c = !1;
    const u = () => l.valueOverride !== void 0 ? l.valueOverride : typeof l.valuePreview?.resolvedValue == "number" ? l.valuePreview.resolvedValue : "", d = (I) => {
      const w = String(I).trim();
      if (w === "")
        return;
      const C = Number(w);
      return Number.isFinite(C) ? C : void 0;
    }, v = (I) => {
      const w = d(I), C = l.valuePreview?.inputMin;
      return w !== void 0 && (C === void 0 || w >= C);
    }, m = () => {
      i !== void 0 && (clearTimeout(i), i = void 0);
    }, p = () => {
      const I = v(a.value);
      return s.value = I, o("validity-change", I), I;
    }, g = () => {
      m(), p() && o("update:valueOverride", d(a.value));
    }, y = () => {
      r.value = !0;
    }, P = () => {
      g(), r.value = !1;
    };
    return oe(
      () => [l.valueOverride, l.valuePreview?.resolvedValue],
      () => {
        if (r.value)
          return;
        const I = u();
        a.value !== I && (c = !0, a.value = I);
      },
      { immediate: !0 }
    ), oe(a, () => {
      if (c) {
        c = !1;
        return;
      }
      m(), p() && (i = setTimeout(g, zg));
    }), Zt(m), (I, w) => e.valuePreview ? (h(), $("div", Kg, [
      V(f(xa), null, {
        default: S(() => [
          H(U(f(n)("ui.smart.value", "Value")), 1)
        ]),
        _: 1
      }),
      V(f(Xe), {
        size: "2",
        color: "blue",
        variant: "soft"
      }, {
        default: S(() => [
          H(U(e.valuePreview.attempted), 1)
        ]),
        _: 1
      }),
      w[1] || (w[1] = be("span", {
        class: "hp-smart-resolution-popover__value-arrow",
        "aria-hidden": "true"
      }, "→", -1)),
      e.valuePreview.editable ? (h(), R(f(Ct), {
        key: 0,
        modelValue: a.value,
        "onUpdate:modelValue": w[0] || (w[0] = (C) => a.value = C),
        class: "hp-smart-resolution-popover__value-input",
        type: "number",
        size: "2",
        variant: "filled",
        align: "center",
        invalid: !s.value,
        step: e.valuePreview.inputStep,
        "aria-label": f(n)("ui.smart.resolutionValue", "Resolution value"),
        onBlur: P,
        onChange: g,
        onFocus: y
      }, null, 8, ["modelValue", "invalid", "step", "aria-label"])) : (h(), R(f(Xe), {
        key: 1,
        size: "2",
        color: "green",
        variant: "soft"
      }, {
        default: S(() => [
          H(U(e.valuePreview.resolved), 1)
        ]),
        _: 1
      }))
    ])) : B("", !0);
  }
}), Ag = /* @__PURE__ */ Ae(Og, [["__scopeId", "data-v-fcca4e72"]]), $g = 'button[type="submit"]:not(:disabled)', Lg = /* @__PURE__ */ ue({
  __name: "SmartResolutionPopoverContent",
  props: {
    cell: {},
    form: {},
    fields: {},
    actions: {},
    previewColumns: {},
    buildPreviewColumns: {},
    previewMaxHeight: {},
    buildPreviewRows: {},
    buildPreviewDirtyKeys: {},
    buildPreviewExpandedRowKeys: {},
    getTitle: {},
    getHaltIssues: { type: Function, default: () => [] },
    getValuePreview: {},
    buildOptions: {}
  },
  emits: ["submit", "cancel"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = {
      mounted: (I) => {
        ot(() => {
          I.querySelector($g)?.focus();
        });
      }
    }, r = n.form.useStore((I) => I.values.resolution), s = n.form.useStore((I) => I.values.valueOverride), i = (I, w) => w(), c = b(
      () => i(s.value, () => n.getValuePreview(n.cell))
    ), u = Y(!0), d = b(
      () => i(s.value, () => n.buildOptions(n.cell))
    ), v = b(() => d.value.length > 0), m = b(
      () => v.value && !d.value.every((I) => I.keepsCurrentValue === !0)
    ), p = b(
      () => i(s.value, () => n.buildPreviewRows(n.cell))
    ), g = b(() => as(p.value)), y = b(
      () => rs(n.actions, {
        hasOptions: v.value,
        hasForceIssues: g.value,
        canSubmit: u.value
      })
    ), P = b(() => `${r.value}:${s.value ?? ""}`);
    return oe(c, (I) => {
      I?.editable !== !0 && (u.value = !0);
    }), oe(
      d,
      (I) => {
        const w = r.value;
        I.length === 0 || I.some((C) => C.value === w) || n.form.setFieldValue("resolution", I[0]?.value ?? w);
      },
      { immediate: !0 }
    ), (I, w) => (h(), $(se, null, [
      V(us, {
        title: e.getTitle(e.cell),
        "halt-issues": e.getHaltIssues(e.cell)
      }, null, 8, ["title", "halt-issues"]),
      m.value ? (h(), R(f(It), { key: 0 }, {
        default: S(() => [
          (h(), R(cs, {
            key: P.value,
            cell: e.cell,
            "preview-columns": e.previewColumns,
            "build-preview-columns": e.buildPreviewColumns,
            "preview-max-height": e.previewMaxHeight,
            "build-preview-rows": e.buildPreviewRows,
            "build-preview-dirty-keys": e.buildPreviewDirtyKeys,
            "build-preview-expanded-row-keys": e.buildPreviewExpandedRowKeys
          }, null, 8, ["cell", "preview-columns", "build-preview-columns", "preview-max-height", "build-preview-rows", "build-preview-dirty-keys", "build-preview-expanded-row-keys"]))
        ]),
        _: 1
      })) : B("", !0),
      V(f(It), {
        padded: !0,
        class: "hp-smart-resolution-below"
      }, {
        default: S(() => [
          V(is, {
            "model-value": f(r),
            options: d.value,
            "onUpdate:modelValue": w[0] || (w[0] = (C) => e.form.setFieldValue("resolution", C))
          }, null, 8, ["model-value", "options"]),
          V(Ag, {
            "value-preview": c.value,
            "value-override": f(s),
            "onUpdate:valueOverride": w[1] || (w[1] = (C) => e.form.setFieldValue("valueOverride", C)),
            onValidityChange: w[2] || (w[2] = (C) => u.value = C)
          }, null, 8, ["value-preview", "value-override"])
        ]),
        _: 1
      }),
      Tn((h(), R(f(fn), null, {
        default: S(() => [
          f(jn)(y.value.cancel) ? B("", !0) : (h(), R(f(we), {
            key: 0,
            variant: "soft",
            onClick: w[3] || (w[3] = (C) => l("cancel"))
          }, {
            default: S(() => [
              H(U(f(Un)(y.value.cancel, "Cancel")), 1)
            ]),
            _: 1
          })),
          f(jn)(y.value.submit) ? B("", !0) : (h(), R(f(we), {
            key: 1,
            type: "submit",
            variant: "filled",
            disabled: f(ss)(y.value.submit),
            onClick: w[4] || (w[4] = (C) => l("submit", e.cell))
          }, {
            default: S(() => [
              H(U(f(Un)(y.value.submit, "Apply")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        ]),
        _: 1
      })), [
        [a]
      ])
    ], 64));
  }
}), Fg = /* @__PURE__ */ Ae(Lg, [["__scopeId", "data-v-0e97217c"]]), Dg = /* @__PURE__ */ ue({
  __name: "SmartResolutionCellPopover",
  props: {
    cell: {},
    popover: {},
    close: { type: Function }
  },
  setup(e) {
    return (t, n) => e.popover.isColumnRelationPopover(e.cell) ? (h(), R(xg, {
      key: 0,
      form: e.popover.popoverForm,
      cell: e.cell,
      fields: e.popover.popoverFields.value,
      actions: e.popover.popoverActions,
      "preview-columns": e.popover.previewColumns,
      "build-preview-columns": e.popover.buildPreviewColumns,
      "preview-max-height": e.popover.previewMaxHeight,
      "build-preview-rows": e.popover.buildPreviewRows,
      "build-preview-dirty-keys": e.popover.buildPreviewDirtyKeys,
      "build-preview-expanded-row-keys": e.popover.buildPreviewExpandedRowKeys,
      "get-title": e.popover.getPopoverTitle,
      "get-halt-issues": e.popover.getHaltIssueMessages,
      "build-options": e.popover.buildResolutionOptions,
      onSubmit: n[0] || (n[0] = (l) => e.popover.handlePopoverSubmit(l, e.close)),
      onCancel: n[1] || (n[1] = (l) => e.popover.handlePopoverCancel(e.close))
    }, null, 8, ["form", "cell", "fields", "actions", "preview-columns", "build-preview-columns", "preview-max-height", "build-preview-rows", "build-preview-dirty-keys", "build-preview-expanded-row-keys", "get-title", "get-halt-issues", "build-options"])) : (h(), R(Fg, {
      key: 1,
      form: e.popover.popoverForm,
      cell: e.cell,
      fields: e.popover.popoverFields.value,
      actions: e.popover.popoverActions,
      "preview-columns": e.popover.previewColumns,
      "build-preview-columns": e.popover.buildPreviewColumns,
      "preview-max-height": e.popover.previewMaxHeight,
      "build-preview-rows": e.popover.buildPreviewRows,
      "build-preview-dirty-keys": e.popover.buildPreviewDirtyKeys,
      "build-preview-expanded-row-keys": e.popover.buildPreviewExpandedRowKeys,
      "get-title": e.popover.getPopoverTitle,
      "get-halt-issues": e.popover.getHaltIssueMessages,
      "get-value-preview": e.popover.getPopoverValuePreview,
      "build-options": e.popover.buildResolutionOptions,
      onSubmit: n[2] || (n[2] = (l) => e.popover.handlePopoverSubmit(l, e.close)),
      onCancel: n[3] || (n[3] = (l) => e.popover.handlePopoverCancel(e.close))
    }, null, 8, ["form", "cell", "fields", "actions", "preview-columns", "build-preview-columns", "preview-max-height", "build-preview-rows", "build-preview-dirty-keys", "build-preview-expanded-row-keys", "get-title", "get-halt-issues", "get-value-preview", "build-options"]));
  }
}), Ng = "5", mw = /* @__PURE__ */ ue({
  __name: "SmartResolutionPopover",
  props: {
    open: { type: Boolean },
    cell: {},
    popover: {},
    close: { type: Function },
    anchorEl: {}
  },
  setup(e) {
    const t = e, n = (l) => {
      l || t.popover.handlePopoverCancel(t.close);
    };
    return (l, o) => (h(), R(f(un), {
      open: e.open,
      size: Ng,
      "close-on-backdrop": !0,
      "show-close": !1,
      "onUpdate:open": n
    }, {
      default: S(() => [
        e.open ? (h(), R(Dg, {
          key: 0,
          cell: e.cell,
          popover: e.popover,
          close: e.close
        }, null, 8, ["cell", "popover", "close"])) : B("", !0)
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), bt = Ce(), hw = "fit-current", Bg = "raise-direct-parent", bw = [
  {
    value: "match-left-to-right",
    get label() {
      return bt("ui.smart.matchLeftToRight", "Match left to right");
    }
  },
  {
    value: "match-right-to-left",
    get label() {
      return bt("ui.smart.matchRightToLeft", "Match right to left");
    }
  },
  {
    value: "raise-direct-parent",
    get label() {
      return bt("ui.smart.raiseDirectParent", "Raise direct parent");
    }
  },
  {
    value: "raise-parent-chain",
    get label() {
      return bt("ui.smart.raiseTopParent", "Raise top parent");
    }
  },
  {
    value: "fit-current",
    get label() {
      return bt("ui.smart.useNearestValidValue", "Use nearest valid value");
    }
  },
  {
    value: "fit-minimums",
    get label() {
      return bt("ui.smart.useMinimumValues", "Use minimum values");
    }
  },
  {
    value: "cap-max-possible",
    get label() {
      return bt("ui.smart.useMaxPossibleValue", "Use max possible value");
    }
  },
  {
    value: "resize-siblings-proportionally",
    get label() {
      return bt("ui.smart.resizeSiblingsProportionally", "Resize siblings proportionally");
    }
  },
  {
    value: "autofy-children",
    get label() {
      return bt("ui.smart.setSiblingsToAuto", "Set siblings to auto");
    }
  }
], gw = {
  value: "manual",
  get label() {
    return bt("ui.smart.manualKeepCurrentValue", "Manual: keep current value");
  }
}, jg = {}, Ug = { class: "hp-smart-resolution-preview__arrow-cell" };
function Hg(e, t) {
  return h(), $("div", Ug, [...t[0] || (t[0] = [
    be("span", {
      class: "hp-smart-resolution-preview__arrow",
      "aria-hidden": "true"
    }, "→", -1)
  ])]);
}
const Wg = /* @__PURE__ */ Ae(jg, [["render", Hg], ["__scopeId", "data-v-5f208e24"]]), Zg = /* @__PURE__ */ ue({
  __name: "SmartResolutionPreviewValueCell",
  props: {
    rowId: {},
    colId: {},
    value: {},
    lockVisible: { type: Boolean },
    locked: { type: Boolean },
    forceIssue: {}
  },
  setup(e) {
    return (t, n) => e.value !== void 0 ? (h(), R(f(Ii), {
      key: 0,
      "row-id": e.rowId,
      "col-id": e.colId,
      "model-value": e.value,
      "display-value": e.value,
      editable: !1,
      "show-toggle": e.lockVisible,
      toggle: e.locked,
      align: "left",
      "grid-nav": !1
    }, St({ _: 2 }, [
      e.forceIssue !== void 0 ? {
        name: "right",
        fn: S(() => [
          V(f(Mt), {
            class: "hp-smart-resolution-preview__force-issue",
            size: "2",
            "icon-size": "2",
            variant: "soft",
            color: "yellow",
            square: "",
            radius: "full",
            title: e.forceIssue,
            "aria-label": e.forceIssue
          }, {
            default: S(() => [...n[0] || (n[0] = [
              H(" ! ", -1)
            ])]),
            _: 1
          }, 8, ["title", "aria-label"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["row-id", "col-id", "model-value", "display-value", "show-toggle", "toggle"])) : B("", !0);
  }
}), tl = /* @__PURE__ */ Ae(Zg, [["__scopeId", "data-v-97476e61"]]), ba = 280, wn = 130, yl = 44, ga = 170, kn = 112, Sn = 125, jt = 32, qg = 600, Jg = 10, Ml = { component: Wg }, ds = {
  component: tl,
  props: (e) => {
    const t = e;
    return {
      rowId: t.id,
      colId: "before",
      value: t.before,
      lockVisible: t.lockVisible,
      locked: t.beforeLocked
    };
  }
}, fs = {
  component: tl,
  props: (e) => {
    const t = e;
    return {
      rowId: t.id,
      colId: "after",
      value: t.after,
      lockVisible: t.lockVisible,
      locked: t.afterLocked,
      forceIssue: t.afterForceIssue
    };
  }
}, Gg = {
  component: tl,
  props: (e) => {
    const t = e;
    return {
      rowId: t.id,
      colId: "compareBefore",
      value: t.compareBefore,
      lockVisible: t.compareLockVisible,
      locked: t.compareBeforeLocked
    };
  }
}, _g = {
  component: tl,
  props: (e) => {
    const t = e;
    return {
      rowId: t.id,
      colId: "compareAfter",
      value: t.compareAfter,
      lockVisible: t.compareLockVisible,
      locked: t.compareAfterLocked,
      forceIssue: t.compareAfterForceIssue
    };
  }
}, Tt = Ce(), ya = [
  {
    key: "name",
    get label() {
      return Tt("ui.smart.previewName", "Name");
    },
    width: `${ba}px`,
    minWidth: ba
  },
  {
    key: "before",
    get label() {
      return Tt("ui.smart.previewBefore", "Before");
    },
    width: `${wn}px`,
    minWidth: wn,
    view: ds
  },
  {
    key: "change",
    label: "",
    width: `${yl}px`,
    minWidth: yl,
    maxWidth: yl,
    view: Ml
  },
  {
    key: "after",
    get label() {
      return Tt("ui.smart.previewAfter", "After");
    },
    width: `${wn}px`,
    minWidth: wn,
    view: fs
  }
], Yg = (e, t) => [
  {
    key: "name",
    get label() {
      return Tt("ui.smart.previewName", "Name");
    },
    width: `${ga}px`,
    minWidth: ga
  },
  {
    key: "before",
    label: Tt("ui.smart.previewColumnBefore", "{column} before", { column: e }),
    width: `${kn}px`,
    minWidth: kn,
    view: ds
  },
  {
    key: "change",
    label: "",
    width: `${jt}px`,
    minWidth: jt,
    maxWidth: jt,
    view: Ml
  },
  {
    key: "after",
    label: Tt("ui.smart.previewColumnAfter", "{column} after", { column: e }),
    width: `${kn}px`,
    minWidth: kn,
    view: fs
  },
  {
    key: "compareBefore",
    label: Tt("ui.smart.previewColumnBefore", "{column} before", { column: t }),
    width: `${Sn}px`,
    minWidth: Sn,
    view: Gg
  },
  {
    key: "compareChange",
    label: "",
    width: `${jt}px`,
    minWidth: jt,
    maxWidth: jt,
    view: Ml
  },
  {
    key: "compareAfter",
    label: Tt("ui.smart.previewColumnAfter", "{column} after", { column: t }),
    width: `${Sn}px`,
    minWidth: Sn,
    view: _g
  }
], Qg = ({
  args: e,
  buildProjection: t,
  runtime: n
}) => {
  const l = `${e.config.popover?.maxPreviewHeight ?? qg}px`, o = (k) => k === void 0 ? void 0 : `${k}px`, a = o(e.config.popover?.width), r = o(e.config.popover?.minWidth), s = o(e.config.popover?.maxWidth), i = (k, K) => De({ row: k, columnId: K }), c = (k, K) => K === "left" ? k.leftLabel ?? k.left : k.rightLabel ?? k.right, u = (k, K, W) => Bn(e.config, { row: k, columnId: K, value: W }), d = (k) => {
    const K = /* @__PURE__ */ new Map();
    for (const W of k.rows) {
      const G = ye(e.config, W);
      for (const [A, E] of Object.entries(e.config.columns)) {
        const D = E.getForceIssue?.({
          row: W,
          rows: k.rows,
          columnId: A,
          value: i(W, A)
        }) ?? null;
        D === null || D === "" || K.set(re(ce(G), ge(A)), D);
      }
    }
    return K;
  }, v = (k, K, W) => k.get(re(ce(K), ge(W))), m = (k) => n.getColumnRelationContext(n.buildResolutionContextForCell(k)), p = (k) => m(k) !== null, g = (k) => k.target.colKey, y = (k) => g(k) === k.rule.left ? k.rule.right : k.rule.left, P = (k) => {
    const K = m(k);
    if (K === null)
      return ya;
    const W = g(K), G = y(K), A = W === K.rule.left ? c(K.rule, "left") : c(K.rule, "right"), E = G === K.rule.left ? c(K.rule, "left") : c(K.rule, "right");
    return Yg(A, E);
  }, I = (k) => k.row === void 0 ? null : Re(e.config, k.colKey)?.getForceIssue?.({
    row: k.row,
    rows: e.rows.value,
    columnId: k.colKey,
    value: k.value
  }) ?? null, w = (k) => {
    const K = Re(e.config, k.colKey), W = I(k);
    return K?.kind === "number" && K.resolveForceIssueValue !== void 0 && W !== null && W !== "";
  }, C = (k) => {
    const K = Re(e.config, k);
    if (!(K?.kind !== "number" || K.precision === void 0))
      return Jg ** -K.precision;
  }, x = (k) => {
    const K = n.getResolutionTarget(k);
    if (K.value === void 0 || p(k))
      return null;
    const G = t(k).rows.find((X) => ye(e.config, X) === K.rowKey), A = G === void 0 ? K.value : i(G, K.colKey), E = n.formatPopoverCellValue(K.row ?? k.row, K.colKey, K.value), D = n.formatPopoverCellValue(G ?? K.row ?? k.row, K.colKey, A);
    return {
      attempted: E,
      attemptedValue: K.value,
      resolved: D,
      resolvedValue: A,
      changed: E !== D,
      editable: w(K),
      inputMin: 0,
      inputStep: C(K.colKey)
    };
  }, O = (k, K) => {
    const W = new Map(K.rows.map((D) => [ye(e.config, D), D])), G = d(K), A = g(k), E = y(k);
    return e.rows.value.map((D) => {
      const X = ye(e.config, D), z = W.get(X) ?? D, Q = i(D, A), ne = i(z, A), ae = i(D, E), Ie = i(z, E), ke = !rt(e.config, D), $e = ce(X), He = ge(A), qe = ge(E), Ye = e.calculator;
      return {
        id: X,
        parentId: _e(e.config, D),
        name: Vt(e.config, D),
        compareValue: u(z, E, Ie),
        compare: u(z, E, Ie),
        compareBeforeValue: u(D, E, ae),
        compareBefore: u(D, E, ae),
        compareBeforeLocked: ke && !!Ye?.isLocked($e, qe),
        compareAfterValue: u(z, E, Ie),
        compareAfter: u(z, E, Ie),
        compareAfterLocked: ke && n.isPreviewLocked(K.lockedKeys, X, E),
        compareLockVisible: ke,
        beforeValue: u(D, A, Q),
        before: u(D, A, Q),
        beforeLocked: ke && !!Ye?.isLocked($e, He),
        afterValue: u(z, A, ne),
        after: u(z, A, ne),
        afterLocked: ke && n.isPreviewLocked(K.lockedKeys, X, A),
        afterForceIssue: v(G, X, A),
        compareAfterForceIssue: v(G, X, E),
        lockVisible: ke
      };
    });
  }, N = (k) => {
    const K = t(k), W = m(k);
    if (W !== null)
      return O(W, K);
    const G = d(K);
    return Qh({
      rows: e.rows.value,
      projectedRows: K.rows,
      columnId: k.colKey,
      getRowKey: (A) => ye(e.config, A),
      getParentKey: (A) => _e(e.config, A),
      getRowLabel: (A) => Vt(e.config, A),
      formatValue: ({ row: A, columnId: E, value: D }) => Bn(e.config, { row: A, columnId: E, value: D }),
      isSourceRow: (A) => rt(e.config, A),
      isBeforeLocked: (A, E) => !!e.calculator?.isLocked(A, E),
      isAfterLocked: (A, E) => n.isPreviewLocked(K.lockedKeys, String(A), String(E))
    }).map((A) => ({
      ...A,
      afterForceIssue: v(G, A.id, k.colKey)
    }));
  }, T = (k) => Xh(N(k));
  return {
    previewColumns: ya,
    previewMaxHeight: l,
    contentWidth: a,
    contentMinWidth: r,
    contentMaxWidth: s,
    isColumnRelationPopover: p,
    buildPreviewColumns: P,
    buildPreviewRows: N,
    buildPreviewDirtyKeys: T,
    buildPreviewExpandedRowKeys: (k) => {
      const K = N(k), W = T(k);
      return eb(K, W);
    },
    getPopoverValuePreview: x
  };
}, Xg = (e) => e.kind !== "lock-clear", ey = (e, t) => {
  const n = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), a = (s, i) => {
    n.add(s), l.add(i), o.add(re(s, i));
  };
  for (const s of t.patches)
    Xg(s) && a(s.rowId, s.columnId);
  const r = e.target;
  return r !== void 0 && a(r.rowId, r.columnId), { rowIds: n, columnIds: l, cellKeys: o };
}, vs = (e, t) => e.rowId === void 0 && e.columnId === void 0 ? !0 : e.rowId !== void 0 && e.columnId !== void 0 ? t.cellKeys.has(re(e.rowId, e.columnId)) || t.columnIds.has(e.columnId) : e.columnId !== void 0 ? t.columnIds.has(e.columnId) : e.rowId !== void 0 && t.rowIds.has(e.rowId), ty = (e, t, n) => {
  for (const l of t.rows) {
    const o = ce(ye(e, l));
    if (n.rowIds.has(o)) {
      if (!ny(e, l, o, n))
        return !1;
      for (const a of n.columnIds) {
        const r = String(a), s = Re(e, r);
        if (s?.kind !== "value" || s.valueSchema === void 0)
          continue;
        const i = De({ row: l, columnId: r });
        if (!s.valueSchema.safeParse(i).success)
          return !1;
      }
    }
  }
  return !yb({ config: e, projection: t }).some((l) => vs(l, n));
}, ny = (e, t, n, l) => {
  if (e.rowSchema === void 0)
    return !0;
  const { fieldErrors: o, formErrors: a } = Gl(e.rowSchema, t);
  return a.length > 0 ? !1 : !Array.from(o).some(([r]) => {
    const s = ge(r.split(".")[0] ?? r);
    return l.cellKeys.has(re(n, s));
  });
}, ly = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) {
    if (t.has(n.id))
      throw new Error(`Duplicate resolution strategy id: ${n.id}`);
    t.add(n.id);
  }
}, oy = (e, t) => typeof e.label == "function" ? e.label(t) : e.label;
function ms(e) {
  if (e === void 0)
    return (l) => ms(l);
  ly(e);
  const t = new Map(e.map((l) => [l.id, l])), n = (l) => {
    const o = e.filter((r) => r.isAvailable(l)), a = o.filter((r) => r.exclusive === !0);
    return a.length > 0 ? a : o;
  };
  return {
    strategies: e,
    byId: t,
    get: (l) => t.get(l),
    require: (l) => {
      const o = t.get(l);
      if (o === void 0)
        throw new Error(`Unknown resolution strategy id: ${l}`);
      return o;
    },
    getAvailable: n,
    getPreferred: (l) => {
      const o = n(l);
      return o.find((a) => a.isPreferred?.(l) === !0) ?? o[0];
    },
    getLabel: oy
  };
}
const ay = (e, t) => ({
  ...e,
  rows: t.rows,
  projectedRows: t.rows,
  patches: t.patches,
  lockedKeys: t.lockedKeys
}), ry = (e, t, n) => {
  for (const l of e) {
    const o = l.validate(t);
    if (!(o instanceof Promise) && o.some((a) => vs(a, n)))
      return !1;
  }
  return !0;
}, sy = (e, t, n) => ({
  ...e,
  isAvailable: (l) => {
    if (!e.isAvailable(l))
      return !1;
    if (e.keepsCurrentValue === !0)
      return !0;
    const o = e.buildProjection(l), a = ey(l, o);
    return ty(t, o, a) ? n.length === 0 ? !0 : ry(
      n,
      ay(l, o),
      a
    ) : !1;
  }
}), iy = (e, t) => {
  const n = e.flatMap((l) => l.buildRules?.(t) ?? []);
  return ms(
    e.flatMap((l) => l.buildStrategies?.(t) ?? []).map((l) => sy(l, t.config, n))
  );
}, uy = 0, cy = 1, dy = 2, fy = (e) => {
  const t = Nr(e), n = Br(e), l = (o) => Vt(e, o);
  return n === void 0 ? Gh()({ kind: "flat", rowKey: t, getLabel: l }) : Jh()({ kind: "tree", rowKey: t, parentKey: n, getLabel: l });
}, vy = (e) => {
  const t = bb(e.config), n = e.config.topology ?? fy(e.config), l = (E, D, X) => {
    const z = e.calculator?.lastValidation.value?.context.projectedRows.find(
      (Q) => ye(e.config, Q) === E
    );
    return z === void 0 ? X : De({ row: z, columnId: D });
  }, o = (E) => l(E.rowKey, E.colKey, E.value), a = (E, D, X) => ({
    rowId: ce(E),
    columnId: ge(D),
    rowKey: E,
    colKey: D,
    row: e.rows.value.find((z) => ye(e.config, z) === E),
    attemptedValue: X,
    value: X
  }), r = (E) => E.result?.verdict === "halted", s = (E) => {
    const D = e.calculator?.lastValidation.value?.context.trigger;
    if (r(E) && D?.kind === "cell-edit") {
      const X = String(D.rowId), z = String(D.columnId), Q = l(X, z, D.value);
      return a(X, z, Q);
    }
    return a(E.rowKey, E.colKey, o(E));
  }, i = (E) => e.calculator?.lastValidation.value?.context.projectedRows.find(
    (D) => ye(e.config, D) === E
  ), c = (E) => i(E.rowKey) ?? E.row, u = (E, D) => {
    if (E === void 0)
      return null;
    const X = De({ row: E, columnId: D });
    return typeof X == "number" ? X : null;
  }, d = (E) => {
    const D = ub(e.config, E.colKey);
    if (D.length === 0)
      return null;
    const X = c(E);
    return D.find(
      (z) => _l(
        z,
        u(X, z.left),
        u(X, z.right)
      )
    ) ?? null;
  }, v = (E) => {
    const D = Be(E);
    if (D === null)
      return null;
    const X = d(D);
    return X === null ? null : { rule: X, target: D, row: c(D) };
  }, m = (E) => {
    const D = s(E);
    return `${D.row === void 0 ? D.rowKey : Vt(e.config, D.row)} · ${D.colKey}`;
  }, p = (E) => {
    const D = e.calculator?.lastValidation.value?.issues ?? [], X = s(E), z = (ke) => ke.rowId !== void 0 && String(ke.rowId) === X.rowKey, Q = (ke) => z(ke) && ke.columnId !== void 0 && String(ke.columnId) === X.colKey, ne = (ke) => Q(ke) ? uy : z(ke) ? cy : dy, Ie = [...r(E) ? D : D.filter(Q)].sort((ke, $e) => ne(ke) - ne($e));
    return [...new Set(Ie.map((ke) => ke.message).filter((ke) => ke !== ""))];
  }, g = (E) => {
    const D = e.rows.value.find((X) => ye(e.config, X) === E);
    return D !== void 0 && rt(e.config, D);
  }, y = (E) => Yh({
    rows: e.rows.value,
    lockedKeys: E,
    columnIds: mn(e.config),
    getRowKey: (D) => ye(e.config, D),
    getParentKey: (D) => _e(e.config, D),
    isSourceRow: (D) => rt(e.config, D)
  }), P = () => y(e.calculator?.lockState.value ?? /* @__PURE__ */ new Set()), I = (E, D, X) => {
    const z = X ? e.calculator?.lastValidation.value?.context : void 0;
    return {
      topology: n,
      rows: e.rows.value,
      projectedRows: z?.projectedRows ?? e.rows.value,
      patches: z?.result.patches ?? [],
      lockedKeys: D,
      trigger: z?.trigger,
      target: E
    };
  }, w = (E) => I(s(E), P(), r(E)), C = {
    config: e.config,
    topology: n,
    numberAdapter: t,
    getRows: () => e.rows.value,
    readNumber: (E, D) => t.readNumber(E, D),
    calculator: {
      previewCellEdit: (E, D, X) => {
        const z = e.calculator;
        return z === void 0 ? { patches: [] } : z.previewCellEdit(E, D, X);
      },
      preview: ({ columnId: E, overrides: D, lockOverrides: X }) => {
        const z = e.calculator;
        return z === void 0 ? { patches: [] } : z.preview({ columnId: E, overrides: D, lockOverrides: X });
      }
    }
  }, x = e.config.modules ?? [], O = x.some((E) => E.id === Zr), N = e.config.popover?.allowManualResolution === !0, T = x.some((E) => E.id === Wr), L = [
    ...x,
    ...O ? [] : [Rb(N)],
    ...T ? [] : [Sb()]
  ], k = iy(L, C);
  return {
    getResolutionTarget: s,
    getBaseLockedKeys: P,
    getContextTarget: Be,
    getInitialResolutionContext: () => {
      const E = e.calculator?.lastValidation.value?.context.trigger;
      if (E?.kind !== "cell-edit")
        return null;
      const D = String(E.rowId), X = String(E.columnId), z = l(D, X, E.value);
      return I(a(D, X, z), P(), !0);
    },
    buildResolutionContextForCell: w,
    getPopoverTitle: m,
    getHaltIssueMessages: p,
    clearTransientResolutionState: () => {
      const E = e.calculator;
      E !== void 0 && (E.lastResult.value = null, E.lastHalt.value = null, E.lastValidation.value = null, E.haltCount.value = 0);
    },
    strategyRegistry: k,
    formatPopoverCellValue: (E, D, X) => E !== void 0 ? Bn(e.config, { row: E, columnId: D, value: X }) : X == null ? "-" : String(X),
    getColumnRelationContext: v,
    isPreviewLocked: (E, D, X) => !g(D) && E.has(re(ce(D), ge(X)))
  };
}, hs = (e) => typeof e == "number" && Number.isFinite(e), my = (e) => e.target !== void 0, hy = (e, t, n) => {
  const { row: l } = t.target;
  if (l === void 0)
    return;
  const o = Re(e, n), a = {
    row: l,
    rows: t.rows,
    columnId: n,
    value: t.target.attemptedValue
  }, r = o?.getForceIssue?.(a) ?? null;
  if (r === null || r === "")
    return;
  const s = o?.resolveForceIssueValue?.(a);
  return hs(s) ? s : void 0;
}, by = (e, t, n, l) => hs(n.valueOverride) ? n.valueOverride : hy(e, t, l), gy = (e, t, n) => {
  if (!my(t))
    return t;
  const l = String(t.target.columnId), o = by(e, t, n, l);
  return o === void 0 ? t : {
    ...t,
    target: {
      ...t.target,
      attemptedValue: o
    },
    trigger: t.trigger?.kind === "cell-edit" ? {
      ...t.trigger,
      value: o
    } : t.trigger
  };
}, yy = (e) => {
  const t = vy(e), n = pb({
    defaultStrategy: Bg,
    registry: t.strategyRegistry,
    validation: () => e.calculator?.lastValidation.value,
    getInitialContext: t.getInitialResolutionContext,
    getContext: t.buildResolutionContextForCell,
    mapContext: (s, i) => gy(e.config, s, i),
    apply: async ({ projection: s, strategy: i }) => {
      const c = e.calculator;
      return c === void 0 ? {} : c.applyResolution(
        { patches: s.patches, diagnostics: [], verdict: "preview" },
        new Set(s.lockedKeys),
        i
      );
    },
    clearTransientState: t.clearTransientResolutionState,
    onCancel: e.onCancel
  }), l = Qg({
    args: e,
    runtime: t,
    buildProjection: n.buildProjection
  }), o = Ce(), a = b(() => [
    { key: "preview", label: o("ui.smart.preview", "Preview"), ...Ne.text() },
    { key: "resolution", label: o("ui.smart.resolution", "Resolution"), ...Ne.text() }
  ]), r = {
    submit: {
      get label() {
        return o("ui.common.apply", "Apply");
      },
      variant: "filled",
      size: "3"
    },
    cancel: {
      get label() {
        return o("ui.common.cancel", "Cancel");
      },
      size: "3"
    },
    layout: "right"
  };
  return {
    popoverForm: n.form,
    popoverFields: a,
    popoverActions: r,
    previewColumns: l.previewColumns,
    previewMaxHeight: l.previewMaxHeight,
    contentWidth: l.contentWidth,
    contentMinWidth: l.contentMinWidth,
    contentMaxWidth: l.contentMaxWidth,
    isColumnRelationPopover: l.isColumnRelationPopover,
    buildPreviewColumns: l.buildPreviewColumns,
    buildPreviewRows: l.buildPreviewRows,
    buildPreviewDirtyKeys: l.buildPreviewDirtyKeys,
    buildPreviewExpandedRowKeys: l.buildPreviewExpandedRowKeys,
    getPopoverTitle: t.getPopoverTitle,
    getHaltIssueMessages: t.getHaltIssueMessages,
    getPopoverValuePreview: l.getPopoverValuePreview,
    buildResolutionOptions: n.buildOptions,
    handlePopoverSubmit: n.handleSubmit,
    handlePopoverCancel: n.handleCancel
  };
}, py = {
  cascade: "Cascade rules",
  math: "Math rules",
  condition: "Condition rules"
}, wy = {
  cell: "Cell rules",
  "column-family": "Column family rules",
  column: "Column rules",
  row: "Row rules",
  table: "Table rules",
  "tree-family": "Tree family rules"
}, ky = Object.entries(wy), Sy = Object.entries(py), yw = (e) => e, Cy = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) {
    if (t.has(n.id))
      throw new Error(`Duplicate resolution rule id: ${n.id}`);
    t.add(n.id);
  }
}, Iy = (e) => ky.map(([t, n]) => ({
  scope: t,
  label: n,
  rules: e.filter((l) => l.scope === t)
})).filter((t) => t.rules.length > 0), Ry = (e) => Sy.map(([t, n]) => ({
  kind: t,
  label: n,
  rules: e.filter((l) => l.kind === t)
})).filter((t) => t.rules.length > 0), pw = (e) => {
  Cy(e);
  const t = new Map(e.map((o) => [o.id, o])), n = Iy(e), l = Ry(e);
  return {
    rules: e,
    groups: n,
    kindGroups: l,
    byId: t,
    getByKind: (o) => e.filter((a) => a.kind === o),
    getByScope: (o) => e.filter((a) => a.scope === o)
  };
}, Py = 1e-4, oo = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  for (const l of e) {
    const o = t.getParentKey(l);
    if (o === null)
      continue;
    const a = n.get(o) ?? [];
    a.push(l), n.set(o, a);
  }
  return n;
}, ao = (e, t, n) => e.reduce((l, o) => l + (n.readNumber(o, t) ?? 0), 0), ro = (e) => e ?? Py, Hn = (e) => Number.isInteger(e) ? String(e) : parseFloat(e.toFixed(2)).toString(), Ty = (e, t) => t.label ?? Re(e, t.id)?.label ?? t.id, Ey = ({
  columns: e,
  config: t
}) => e !== void 0 ? e : mn(t).filter((n) => Re(t, n)?.kind === "number").map((n) => ({
  id: n,
  label: Re(t, n)?.label
})), My = (e) => ({
  getRowKey: (t) => ye(e, t),
  getParentKey: (t) => _e(e, t),
  readNumber: (t, n) => {
    if (Re(e, n)?.kind !== "number")
      return null;
    const o = De({ row: t, columnId: n });
    return typeof o == "number" ? o : null;
  }
}), Vy = (e) => {
  const { childTotal: t, column: n, config: l, parent: o, parentValue: a, tolerance: r } = e, s = ce(ye(l, o)), i = ge(n.id), c = Ty(l, n), u = Vt(l, o);
  return t - a > r ? {
    code: "math.parent_child_total",
    // Reaches the popover's rendered issue list, so it is display copy.
    message: Ce()("ui.smart.childrenTotalExceeds", "{column} children total exceeds {parent}", {
      column: c,
      parent: u
    }),
    rowId: s,
    columnId: i,
    severity: "error"
  } : null;
}, xy = (e) => {
  const { config: t, rows: n } = e, l = [], o = My(t), a = oo(n, o), r = ro(e.tolerance);
  for (const s of Ey(e))
    for (const i of n) {
      const c = a.get(ye(t, i)), u = o.readNumber(i, s.id);
      if (c === void 0 || u === null)
        continue;
      const d = ao(c, s.id, o), v = Vy({
        config: t,
        column: s,
        parent: i,
        parentValue: u,
        childTotal: d,
        tolerance: r
      });
      v !== null && l.push(v);
    }
  return l;
}, ww = (e) => (t) => xy({
  ...e,
  rows: t.projectedRows,
  lockedKeys: t.lockedKeys
}), bs = (e) => e.label ?? e.id, Ky = (e) => {
  const { childTotal: t, column: n, config: l, mode: o, parent: a, parentValue: r, tolerance: s } = e, i = ce(l.getRowKey(a)), c = ge(n.id), u = bs(n), d = l.getRowLabel(a);
  return t - r > s ? {
    code: o === "percent" ? "math.percent_family_total" : "math.parent_child_total",
    // Reaches the popover's rendered issue list, so it is display copy.
    message: Ce()(
      "ui.smart.childrenTotalExceedsValues",
      "{column} children total {total} exceeds {parent} {parentValue}",
      {
        column: u,
        total: Hn(t),
        parent: d,
        parentValue: Hn(r)
      }
    ),
    rowId: i,
    columnId: c,
    severity: "error"
  } : null;
}, zy = (e, t) => {
  const n = e.trigger;
  if (n.kind !== "cell-edit" || typeof n.value != "number" || n.value < 0)
    return null;
  const l = t.columns.find((i) => i.id === String(n.columnId));
  if (l === void 0)
    return null;
  const o = String(n.rowId), a = e.projectedRows.find((i) => t.getRowKey(i) === o);
  if (a === void 0 || t.getParentKey(a) !== null)
    return null;
  const r = oo(e.projectedRows, t).get(o), s = t.readNumber(a, l.id);
  return r === void 0 || s === null ? null : {
    columnId: l.id,
    columnLabel: bs(l),
    sourceRow: a,
    sourceValue: s,
    currentChildrenTotal: ao(r, l.id, t)
  };
}, Oy = (e) => (t) => {
  const n = zy(t, e);
  return n === null || n.currentChildrenTotal - n.sourceValue <= ro(e.tolerance) ? [] : [
    {
      code: e.getMode?.(n.columnId) === "percent" ? "math.percent_source_children_rebalance" : "math.source_children_rebalance",
      message: Ce()(
        "ui.smart.sourceBelowChildrenTotal",
        "{column} source {source} is below current children total {total}",
        {
          column: n.columnLabel,
          source: Hn(n.sourceValue),
          total: Hn(n.currentChildrenTotal)
        }
      ),
      rowId: ce(e.getRowKey(n.sourceRow)),
      columnId: ge(n.columnId),
      severity: "error"
    }
  ];
}, Ay = (e) => (t) => {
  const n = [], l = oo(t.projectedRows, e), o = ro(e.tolerance);
  for (const a of e.columns) {
    const r = e.getMode?.(a.id);
    for (const s of t.projectedRows) {
      const i = l.get(e.getRowKey(s)), c = e.readNumber(s, a.id);
      if (i === void 0 || c === null)
        continue;
      const u = ao(i, a.id, e), d = Ky({
        config: e,
        column: a,
        mode: r,
        parent: s,
        parentValue: c,
        childTotal: u,
        tolerance: o
      });
      d !== null && n.push(d);
    }
  }
  return n;
}, $y = (e) => [
  Oy(e),
  Ay(e)
], pa = "::", Ly = (e) => {
  const t = String(e), n = t.lastIndexOf(pa);
  if (n < 0)
    return null;
  const l = t.slice(0, n), o = t.slice(n + pa.length);
  return l === "" || o === "" ? null : { rowId: l, columnId: o };
}, Fy = (e, t, n) => {
  if (t.getRowLabel === void 0)
    return null;
  const l = e.find((o) => t.getRowKey(o) === n);
  return l === void 0 ? null : t.getRowLabel(l);
}, Dy = (e, t) => {
  const n = Ly(e.cellKey);
  return n === null ? null : t.kind === "cell-edit" && String(t.columnId) === n.columnId ? {
    rowId: String(t.rowId),
    columnId: String(t.columnId),
    diagnosticRowId: n.rowId
  } : { ...n, diagnosticRowId: n.rowId };
}, Ny = (e, t, n) => {
  const l = Fy(e, t, n);
  return l === null ? "" : ` (${l})`;
}, By = (e, t) => e.getColumnLabel?.(t) ?? t, jy = (e, t, n, l) => {
  const o = By(t, l.columnId), a = Ny(n, t, l.diagnosticRowId);
  switch (e.code) {
    case "skipped_lock":
      return t.isValueColumn?.(l.columnId) ?? !1 ? null : Ce()(
        "ui.smart.lockedCellsPreventRecalc",
        "{column} has locked cells that prevent recalculation{row}",
        { column: o, row: a }
      );
    case "mode_conflict":
      return Ce()(
        "ui.smart.modeConflict",
        "{column} cannot apply this value in the current calculator mode{row}",
        { column: o, row: a }
      );
    default:
      return null;
  }
}, Uy = (e) => e.kind === "recompute", Hy = (e) => (t) => {
  if (Uy(t.trigger))
    return [];
  const n = [];
  for (const l of t.result.diagnostics) {
    const o = Dy(l, t.trigger);
    if (o === null)
      continue;
    const a = jy(l, e, t.projectedRows, o);
    a !== null && n.push({
      code: `diagnostic.${l.code}`,
      message: a,
      rowId: ce(o.rowId),
      columnId: ge(o.columnId),
      severity: "error"
    });
  }
  return n;
}, Wy = (e) => e?.diagnostics ?? !0, Zy = (e) => {
  const t = /* @__PURE__ */ new Set(), n = [];
  for (const l of e.modules ?? [])
    if (l.id === ls)
      for (const o of l.columns ?? [])
        t.has(o) || (t.add(o), n.push(o));
  return n;
}, qy = (e) => Zy(e).filter((t) => Re(e, t)?.kind === "number").map((t) => ({
  id: t,
  label: Re(e, t)?.label
})), Jy = (e, t, n) => {
  if (Re(e, n)?.kind !== "number")
    return null;
  const o = De({ row: t, columnId: n });
  return typeof o == "number" ? o : null;
}, Gy = ({
  config: e,
  options: t
}) => {
  const n = qy(e);
  return n.length === 0 ? [] : $y({
    columns: n,
    getRowKey: (l) => ye(e, l),
    getParentKey: (l) => _e(e, l),
    getRowLabel: (l) => Vt(e, l),
    readNumber: (l, o) => Jy(e, l, o),
    ...t?.getMode === void 0 ? {} : { getMode: t.getMode }
  });
}, wa = (e) => e == null, _y = (e) => {
  const t = [];
  for (const n of mn(e.config)) {
    const l = Re(e.config, n);
    l?.haltOnForceIssue !== !0 || l.getForceIssue === void 0 || t.push((o) => {
      const a = [];
      for (const r of o.projectedRows) {
        const s = De({ row: r, columnId: n }), i = l.getForceIssue?.({ row: r, rows: o.projectedRows, columnId: n, value: s }) ?? null;
        i === null || i === "" || a.push({
          code: `force-issue.${n}`,
          message: i,
          rowId: ce(ye(e.config, r)),
          columnId: ge(n),
          severity: "error"
        });
      }
      return a;
    });
  }
  return t;
}, Yy = (e) => {
  const t = [];
  for (const n of mn(e.config)) {
    const l = Re(e.config, n);
    l?.kind !== "value" || l.requireValueWhenAnyRowHasValue !== !0 || t.push((o) => {
      if (!new Set(
        o.trigger.kind === "validation-resolution" ? o.result.patches.flatMap((i) => i.kind === "lock-clear" ? [] : [String(i.columnId)]) : "columnId" in o.trigger ? [String(o.trigger.columnId)] : []
      ).has(n))
        return [];
      if (!o.projectedRows.some(
        (i) => !wa(De({ row: i, columnId: n }))
      ))
        return [];
      const s = l.label ?? n;
      return o.projectedRows.flatMap((i) => {
        const c = De({ row: i, columnId: n });
        return wa(c) ? [
          {
            code: `value-completeness.${n}`,
            // Reaches the popover's rendered issue list, so it is display copy.
            message: Ce()(
              "ui.smart.valueRequiredBySibling",
              "{column} is required because another row has a value",
              { column: s }
            ),
            rowId: ce(ye(e.config, i)),
            columnId: ge(n),
            severity: "error"
          }
        ] : [];
      });
    });
  }
  return t;
}, Qy = (e) => Wy(e.options) ? [
  Hy({
    getRowKey: (t) => ye(e.config, t),
    getRowLabel: (t) => Vt(e.config, t),
    getColumnLabel: (t) => Re(e.config, t)?.label ?? t,
    isValueColumn: (t) => Re(e.config, t)?.kind === "value"
  })
] : [], Xy = (e) => {
  const t = {};
  for (const n of mn(e)) {
    const l = Re(e, n);
    l?.kind === "value" && l.valueSchema !== void 0 && (t[n] = l.valueSchema);
  }
  return t;
}, ep = ({
  config: e,
  options: t
}) => ({
  ...e.rowSchema === void 0 ? {} : { schema: e.rowSchema },
  rules: [
    ...Gy({ config: e, options: t }),
    ..._y({ config: e }),
    ...Yy({ config: e }),
    ...Qy({ config: e, options: t })
  ]
}), tp = (e) => ({
  calculatorValidation: ep(e),
  valueSchemas: Xy(e.config)
}), kw = ({
  calculator: e,
  calculatorRuntime: t,
  config: n,
  relations: l,
  rows: o,
  onCancel: a
}) => {
  const r = {
    rows: o,
    config: n,
    ...t === void 0 ? {} : { calculator: t },
    ...a === void 0 ? {} : { onCancel: a }
  }, s = tp({ config: n, options: e }), i = b(() => {
    const d = t?.lastTrigger.value ?? null;
    return $r({
      config: n,
      rows: o.value,
      rules: jr(n),
      targetMode: l?.targetMode ?? "trigger-column",
      ...d === null ? {} : { trigger: d }
    });
  }), c = b(() => {
    const d = /* @__PURE__ */ new Map();
    for (const v of i.value)
      v.rowId === void 0 || v.columnId === void 0 || d.set(re(v.rowId, v.columnId), v.message);
    return d;
  }), u = b(() => {
    const d = /* @__PURE__ */ new Map();
    for (const v of o.value) {
      const m = ye(n, v);
      for (const [p, g] of Object.entries(n.columns)) {
        const y = g.getForceIssue?.({
          row: v,
          rows: o.value,
          columnId: p,
          value: De({ row: v, columnId: p })
        }) ?? null;
        y === null || y === "" || d.set(re(ce(m), ge(p)), y);
      }
    }
    return d;
  });
  return {
    calculator: s,
    forceIssues: u,
    getForceIssue: (d, v) => u.value.get(re(d, v)),
    getRelationIssue: (d, v) => c.value.get(re(d, v)),
    relationIssues: i,
    popover: yy(r)
  };
}, np = { class: "d-flex flex-column gap-3" }, lp = { class: "filter-builder__column filter-builder__nav" }, op = { class: "filter-builder__main" }, ap = { class: "filter-builder__bar filter-builder__back" }, rp = {
  key: 0,
  class: "filter-builder__bar filter-builder__toolbar filter-builder__header"
}, sp = { class: "d-flex items-center gap-2" }, ip = { class: "filter-builder__body" }, up = ["aria-label"], cp = {
  key: 0,
  class: "filter-builder__bar d-flex flex-column gap-2"
}, dp = { class: "d-flex flex-wrap gap-2" }, fp = {
  key: 1,
  class: "filter-builder__bar filter-builder__pagination"
}, vp = {
  key: 2,
  class: "filter-builder__bar"
}, mp = ["aria-label"], hp = { class: "filter-builder__selected-scroll" }, bp = {
  key: 0,
  class: "filter-builder__selected-group d-flex flex-column gap-2"
}, gp = { class: "d-flex flex-wrap gap-1" }, yp = {
  key: 1,
  class: "filter-builder__selected-empty"
}, pp = { class: "filter-builder__group-header" }, wp = { class: "filter-builder__bar filter-builder__actions" }, kp = 20, Sp = /* @__PURE__ */ ue({
  __name: "SmartFilterPanel",
  props: {
    enabledModes: {},
    config: {},
    disabled: { type: Boolean },
    queryContext: {},
    modelValue: {},
    includeModes: {}
  },
  emits: ["update:modelValue", "update:includeModes", "apply", "draftChange", "cancel", "queryChange"],
  setup(e, { emit: t }) {
    const n = Ce(), l = e, o = t, a = b(() => l.config.facets.map((z) => ({
      ...z,
      label: z.triggerLabel ?? z.key,
      options: z.config.shape === "value" && z.config.source === "tree" && !z.config.options.some((Q) => Q.children?.length) ? z.config.options : void 0
    }))), r = (z) => {
      l.disabled || w.handleFacetApply(z);
    }, s = () => {
      l.disabled || w.handleClearAll();
    }, i = Y({ ...l.enabledModes });
    oe(() => l.enabledModes, (z) => {
      i.value = { ...z };
    }, { deep: !0 });
    const c = (z) => {
      i.value = { ...i.value, [z]: i.value[z] === !1 };
    }, u = Y(a.value[0]?.key ?? ""), d = Y(!1), v = (z) => {
      u.value = z, d.value = !0;
    }, m = Y(l.config.pageSize ?? kp), p = Y(""), g = Y(1), y = b(() => a.value.find((z) => z.key === u.value) ?? a.value[0]), P = b(() => (y.value?.options ?? []).filter((z) => z.label.toLowerCase().includes(p.value.trim().toLowerCase()))), I = b(() => a.value.map((z) => ({
      ...z,
      config: z.options && z.config.shape === "value" && z.config.source === "tree" ? { ...z.config, options: z.remote ? z.options : z.key === u.value ? P.value.slice((g.value - 1) * m.value, g.value * m.value) : z.options, search: !1, preserveUnknownKeys: !0, selectedPanel: !1 } : z.config
    }))), w = jf({ facets: I, modelValue: () => l.modelValue ?? {}, includeModes: () => l.includeModes ?? {} });
    oe([w.normalizedValue, w.includeModes, i], () => {
      o("draftChange", {
        value: { ...w.normalizedValue.value },
        includeModes: { ...w.includeModes.value },
        ...l.enabledModes === void 0 ? {} : { enabledModes: { ...i.value } }
      });
    }, { deep: !0, immediate: !0 });
    const C = b(() => I.value.find((z) => z.key === u.value)), x = b(() => {
      for (const z of a.value.filter((Q) => !Q.options)) {
        const Q = w.value.value[z.key];
        if (Q && typeof Q == "object" && "min" in Q && "max" in Q && typeof Q.min == "number" && typeof Q.max == "number" && Q.min > Q.max)
          return n("ui.smartFilterPanel.invalidRange", "{field}: minimum must not exceed maximum.", { field: z.label });
      }
      return "";
    }), O = b(() => JSON.stringify(i.value) !== JSON.stringify(l.enabledModes ?? {}) || JSON.stringify({ value: w.normalizedValue.value, includeModes: w.includeModes.value }) !== JSON.stringify({ value: l.modelValue ?? {}, includeModes: l.includeModes ?? {} })), N = (z, Q) => {
      const ne = Reflect.get(z, Q);
      return typeof ne == "number" ? ne : void 0;
    }, T = (z) => {
      const Q = w.normalizedValue.value[z], ne = a.value.find((ke) => ke.key === z)?.badge;
      if (ne)
        return ne(Q);
      if (Array.isArray(Q))
        return Q.length;
      if (!Q || typeof Q != "object")
        return;
      const ae = N(Q, "min"), Ie = N(Q, "max");
      if (ae !== void 0 && Ie !== void 0)
        return ae === Ie ? `x = ${ae}` : `${ae} ≤ x ≤ ${Ie}`;
      if (ae !== void 0)
        return `x ≥ ${ae}`;
      if (Ie !== void 0)
        return `x ≤ ${Ie}`;
    }, L = b(() => a.value.flatMap((z) => {
      const Q = w.normalizedValue.value[z.key];
      return Q === void 0 ? [] : (Array.isArray(Q) ? Q : [Q]).map((ae) => ({
        key: z.key,
        value: ae,
        field: z.label,
        label: z.formatValue?.(ae) ?? z.options?.find((Ie) => Ie.value === ae)?.label ?? (typeof ae == "object" ? Object.entries(ae).map(([Ie, ke]) => `${Ie}: ${ke}`).join(" · ") : String(ae))
      }));
    })), k = b(() => a.value.map((z) => ({ key: z.key, label: z.label, items: L.value.filter((Q) => Q.key === z.key) })).filter((z) => z.items.length)), K = (z) => r({ key: z, value: void 0, include: w.includeFor(z) }), W = (z, Q) => {
      const ne = w.valueFor(z);
      r({ key: z, value: Array.isArray(ne) ? ne.filter((ae) => ae !== Q) : void 0, include: w.includeFor(z) });
    }, G = (z) => r({ key: u.value, value: z.value, include: z.include ?? w.includeFor(u.value) }), A = () => {
      if (!l.disabled && !x.value) {
        const z = { value: { ...w.normalizedValue.value }, includeModes: { ...w.includeModes.value } };
        o("update:modelValue", z.value), o("update:includeModes", z.includeModes), o("apply", l.enabledModes === void 0 ? z : { ...z, enabledModes: { ...i.value } });
      }
    }, E = () => {
      i.value = { ...l.enabledModes }, w.handleApplyAll({ value: { ...l.modelValue }, includeModes: { ...l.includeModes } }), o("cancel");
    };
    oe(a, (z) => {
      z.some((Q) => Q.key === u.value) || (u.value = z[0]?.key ?? "");
    }), oe(() => l.queryContext, () => {
      g.value = 1;
    }), oe([u, p, m], () => {
      g.value = 1;
    }), oe(u, () => {
      p.value = "";
    }), oe([u, p, g, m], () => {
      y.value?.remote && o("queryChange", { key: u.value, search: p.value, page: g.value, pageSize: m.value });
    }, { immediate: !0, flush: "post" });
    const D = (z) => {
      g.value = z;
    }, X = (z) => {
      m.value = z;
    };
    return (z, Q) => (h(), $("div", np, [
      V(f(Ri), {
        class: "filter-builder",
        style: et({ "--filter-panel-max-height": e.config.maxHeight ?? "40rem" })
      }, {
        default: S(() => [
          V(f(Pi), { "no-padding": "" }, {
            default: S(() => [
              be("div", {
                class: Ke(["filter-builder__columns", { "filter-builder__columns--values": d.value }])
              }, [
                Tn((h(), $("aside", lp, [
                  (h(), $(se, null, Pe(["1", "4"], (ne) => be("div", {
                    key: ne,
                    class: Ke(ne === "1" ? "filter-builder__menu-desktop" : "filter-builder__menu-mobile")
                  }, [
                    V(f(Ti), {
                      size: ne === "1" ? "3" : ne,
                      variant: "soft",
                      "aria-label": f(n)("ui.smartFilterPanel.fields", "Filter fields")
                    }, {
                      default: S(() => [
                        (h(!0), $(se, null, Pe(a.value, (ae) => (h(), R(f(La), {
                          key: ae.key,
                          "data-theme": i.value[ae.key] === !1 ? "default" : "blue",
                          active: u.value === ae.key,
                          role: "button",
                          tabindex: "0",
                          "aria-pressed": u.value === ae.key,
                          onClick: (Ie) => v(ae.key),
                          onKeydown: [
                            En(tt((Ie) => v(ae.key), ["prevent"]), ["enter"]),
                            En(tt((Ie) => v(ae.key), ["prevent"]), ["space"])
                          ]
                        }, {
                          default: S(() => [
                            V(f(Fa), null, {
                              default: S(() => [
                                be("span", {
                                  class: Ke({ "filter-builder__paused-label": i.value[ae.key] === !1 })
                                }, U(ae.label), 3)
                              ]),
                              _: 2
                            }, 1024),
                            T(ae.key) !== void 0 ? (h(), R(f(Xe), {
                              key: 0,
                              size: "2",
                              radius: "full",
                              square: /^\d$/.test(String(T(ae.key))),
                              color: ae.badgeColor ?? (f(w).includeFor(ae.key) ? "green" : "red")
                            }, {
                              default: S(() => [
                                H(U(T(ae.key)), 1)
                              ]),
                              _: 2
                            }, 1032, ["square", "color"])) : B("", !0),
                            i.value[ae.key] === !1 ? (h(), R(f(Mt), {
                              key: 1,
                              class: "filter-builder__lock-chip",
                              size: "2",
                              "icon-size": "1",
                              square: "",
                              variant: "filled",
                              color: "default",
                              icon: f(wl),
                              title: f(n)("ui.smartFilterPanel.pause", "Pause filter")
                            }, null, 8, ["icon", "title"])) : B("", !0)
                          ]),
                          _: 2
                        }, 1032, ["data-theme", "active", "aria-pressed", "onClick", "onKeydown"]))), 128))
                      ]),
                      _: 1
                    }, 8, ["size", "aria-label"])
                  ], 2)), 64))
                ])), [
                  [f(bo), { edge: "right", min: 180 }]
                ]),
                be("div", op, [
                  be("div", ap, [
                    V(f(we), {
                      size: "2",
                      variant: "outline",
                      onClick: Q[0] || (Q[0] = (ne) => d.value = !1)
                    }, {
                      default: S(() => [
                        H(U(f(n)("ui.smartFilterPanel.back", "Back to filters")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  y.value ? (h(), $("div", rp, [
                    V(f(Ei), { size: "4" }, {
                      default: S(() => [
                        H(U(y.value.label), 1)
                      ]),
                      _: 1
                    }),
                    be("div", sp, [
                      y.value.includeModeToggle !== !1 ? (h(), R(f(Va), {
                        key: 0,
                        layout: "left",
                        disabled: e.disabled || i.value[y.value.key] === !1,
                        exclude: !f(w).includeFor(y.value.key),
                        onToggle: Q[1] || (Q[1] = (ne) => f(w).setIncludeMode(y.value.key, !f(w).includeFor(y.value.key)))
                      }, null, 8, ["disabled", "exclude"])) : B("", !0),
                      e.enabledModes !== void 0 ? (h(), R(f(qn), {
                        key: 1,
                        "model-value": i.value[y.value.key] !== !1,
                        disabled: e.disabled,
                        size: "3",
                        "label-position": "left",
                        label: f(n)("ui.smartFilterPanel.show", "Show results"),
                        "aria-label": f(n)("ui.smartFilterPanel.show", "Show results"),
                        onChange: Q[2] || (Q[2] = (ne) => c(y.value.key))
                      }, null, 8, ["model-value", "disabled", "label", "aria-label"])) : B("", !0)
                    ])
                  ])) : B("", !0),
                  be("div", ip, [
                    y.value ? (h(), $("section", {
                      key: 0,
                      class: "filter-builder__column filter-builder__editor",
                      "aria-label": y.value.label
                    }, [
                      pe(z.$slots, "status", { field: y.value }, void 0, !0),
                      be("div", {
                        class: Ke(["filter-builder__values-scroll", { "filter-builder__bar": !y.value.options }])
                      }, [
                        (h(), R(Pl, {
                          key: y.value.key,
                          inline: "",
                          config: C.value.config,
                          disabled: e.disabled,
                          "model-value": f(w).valueFor(y.value.key),
                          "include-mode": f(w).includeFor(y.value.key),
                          onApply: Q[4] || (Q[4] = (ne) => r({ key: y.value.key, ...ne }))
                        }, St({ _: 2 }, [
                          y.value.options ? {
                            name: "toolbar-prefix",
                            fn: S(() => [
                              V(f(Ct), {
                                modelValue: p.value,
                                "onUpdate:modelValue": Q[3] || (Q[3] = (ne) => p.value = ne),
                                disabled: e.disabled,
                                size: "2",
                                placeholder: f(n)("ui.smartFilterPanel.search", "Search {field}", { field: y.value.label }),
                                "aria-label": f(n)("ui.smartFilterPanel.search", "Search {field}", { field: y.value.label })
                              }, null, 8, ["modelValue", "disabled", "placeholder", "aria-label"])
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1032, ["config", "disabled", "model-value", "include-mode"]))
                      ], 2),
                      !y.value.options && y.value.presets?.length ? (h(), $("div", cp, [
                        V(f(Me), {
                          size: "2",
                          weight: "medium",
                          variant: "soft"
                        }, {
                          default: S(() => [
                            H(U(f(n)("ui.smartFilterPanel.presets", "Presets")), 1)
                          ]),
                          _: 1
                        }),
                        be("div", dp, [
                          (h(!0), $(se, null, Pe(y.value.presets, (ne) => (h(), R(f(we), {
                            key: ne.label,
                            size: "2",
                            variant: "outline",
                            disabled: e.disabled,
                            onClick: (ae) => G(ne)
                          }, {
                            default: S(() => [
                              H(U(ne.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))), 128))
                        ])
                      ])) : B("", !0),
                      y.value.options ? (h(), $("div", fp, [
                        y.value.remote ? pe(z.$slots, "pagination", {
                          key: 0,
                          page: g.value,
                          pageSize: m.value,
                          setPage: D,
                          setPageSize: X
                        }, void 0, !0) : (h(), R(f($a), {
                          key: 1,
                          class: "filter-builder__pagination-control",
                          page: g.value,
                          "onUpdate:page": Q[5] || (Q[5] = (ne) => g.value = ne),
                          "page-size": m.value,
                          "onUpdate:pageSize": Q[6] || (Q[6] = (ne) => m.value = ne),
                          total: P.value.length,
                          "page-size-options": e.config.pageSizeOptions ? [...e.config.pageSizeOptions] : [10, 20, 50],
                          "max-pages": 7,
                          "always-show": "",
                          size: "1"
                        }, null, 8, ["page", "page-size", "total", "page-size-options"]))
                      ])) : B("", !0),
                      x.value ? (h(), $("div", vp, [
                        V(f(Aa), {
                          color: "red",
                          variant: "soft",
                          title: x.value
                        }, null, 8, ["title"])
                      ])) : B("", !0)
                    ], 8, up)) : B("", !0),
                    Tn((h(), $("aside", {
                      class: "filter-builder__column filter-builder__selected",
                      "aria-label": f(n)("ui.smartFilterPanel.selected", "Selected elements")
                    }, [
                      be("div", hp, [
                        y.value?.options && y.value.presets?.length ? (h(), $("div", bp, [
                          V(f(Me), {
                            size: "2",
                            weight: "medium",
                            variant: "soft"
                          }, {
                            default: S(() => [
                              H(U(f(n)("ui.smartFilterPanel.presets", "Presets")), 1)
                            ]),
                            _: 1
                          }),
                          be("div", gp, [
                            (h(!0), $(se, null, Pe(y.value.presets, (ne) => (h(), R(f(we), {
                              key: ne.label,
                              size: "1",
                              variant: "outline",
                              disabled: e.disabled,
                              onClick: (ae) => G(ne)
                            }, {
                              default: S(() => [
                                H(U(ne.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))), 128))
                          ])
                        ])) : B("", !0),
                        L.value.length ? B("", !0) : (h(), $("div", yp, [
                          V(f(Me), { variant: "soft" }, {
                            default: S(() => [
                              H(U(f(n)("ui.smartFilterPanel.empty", "No selected elements.")), 1)
                            ]),
                            _: 1
                          })
                        ])),
                        (h(!0), $(se, null, Pe(k.value, (ne) => (h(), $("div", {
                          key: ne.key,
                          class: "filter-builder__selected-group d-flex flex-column gap-2"
                        }, [
                          be("div", pp, [
                            V(f(Me), {
                              size: "2",
                              weight: "medium",
                              variant: "soft"
                            }, {
                              default: S(() => [
                                i.value[ne.key] === !1 ? (h(), R(f(wl), {
                                  key: 0,
                                  class: "filter-builder__lock-icon"
                                })) : B("", !0),
                                H(U(ne.label) + " · " + U(f(w).includeFor(ne.key) ? f(n)("ui.smartFilter.include", "Include") : f(n)("ui.smartFilter.exclude", "Exclude")), 1)
                              ]),
                              _: 2
                            }, 1024),
                            V(f(we), {
                              class: "filter-builder__group-clear",
                              disabled: e.disabled,
                              size: "1",
                              variant: "blank",
                              "aria-label": f(n)("ui.smartFilterPanel.clearGroup", "Clear {field}", { field: ne.label }),
                              onClick: (ae) => K(ne.key)
                            }, {
                              default: S(() => [
                                H(U(f(n)("ui.common.clear", "Clear")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "aria-label", "onClick"])
                          ]),
                          V(f(Mi), {
                            items: ne.items,
                            "max-visible": e.config.selectedLimit ?? 15,
                            "max-rows": e.config.selectedLimit ?? 15,
                            size: "2",
                            gap: "var(--space-1)"
                          }, {
                            default: S(({ item: ae }) => [
                              V(f(Mt), {
                                size: "2",
                                variant: "soft",
                                color: f(w).includeFor(ae.key) ? "green" : "red",
                                dismissible: !e.disabled,
                                clickable: "",
                                truncate: "",
                                "max-width": "100%",
                                title: ae.label,
                                onClick: (Ie) => v(ae.key),
                                onDismiss: (Ie) => W(ae.key, ae.value)
                              }, {
                                default: S(() => [
                                  H(U(ae.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["color", "dismissible", "title", "onClick", "onDismiss"])
                            ]),
                            more: S(({ hiddenCount: ae, expanded: Ie, toggle: ke }) => [
                              V(f(Mt), {
                                size: "2",
                                variant: "soft",
                                clickable: "",
                                onClick: ke
                              }, {
                                default: S(() => [
                                  H(U(Ie ? f(n)("ui.smartFilterPanel.less", "Less") : f(n)("ui.smartFilterPanel.more", "More ({count})", { count: ae })), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["items", "max-visible", "max-rows"])
                        ]))), 128)),
                        pe(z.$slots, "presets", {}, void 0, !0)
                      ])
                    ], 8, mp)), [
                      [f(bo), { edge: "left", min: 180 }]
                    ])
                  ])
                ])
              ], 2),
              be("div", wp, [
                V(f(we), {
                  class: "filter-builder__clear",
                  size: "2",
                  variant: "outline",
                  disabled: e.disabled || !L.value.length,
                  onClick: s
                }, {
                  default: S(() => [
                    H(U(f(n)("ui.smartFilter.clearAll", "Clear all")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                V(f(we), {
                  size: "2",
                  variant: "outline",
                  onClick: E
                }, {
                  default: S(() => [
                    H(U(f(n)("ui.common.cancel", "Cancel")), 1)
                  ]),
                  _: 1
                }),
                V(f(we), {
                  size: "2",
                  variant: "filled",
                  disabled: e.disabled || !O.value || !!x.value,
                  onClick: A
                }, {
                  default: S(() => [
                    H(U(e.config.applyLabel ?? f(n)("ui.smartFilterPanel.apply", "Apply filters")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["style"])
    ]));
  }
}), Sw = /* @__PURE__ */ Ae(Sp, [["__scopeId", "data-v-45e7e4c6"]]), Cw = () => ({
  item: (e, t) => st({ key: e }, t),
  section: (e, t) => st({ key: e }, t)
}), Cp = /* @__PURE__ */ ue({
  __name: "SmartNavigationExtension",
  props: {
    extension: {},
    context: {}
  },
  setup(e) {
    const t = e, n = b(() => {
      const o = t.extension;
      if ("component" in o)
        return t.context.compact ? o.compact : o;
    }), l = b(() => {
      const o = t.extension;
      return !("kind" in o) || o.kind !== "badge" ? "" : t.context.compact ? o.compact === "count" || o.compact !== "dot" && /^\d{1,2}$/.test(o.label) ? o.label : "•" : o.label;
    });
    return (o, a) => e.extension.visible?.(e.context) !== !1 ? (h(), $(se, { key: 0 }, [
      "kind" in e.extension && e.extension.kind === "badge" && (!e.context.compact || e.extension.compact !== "hidden") ? (h(), R(f(Xe), {
        key: 0,
        size: e.context.compact ? "1" : "3",
        variant: "soft",
        color: e.extension.color,
        title: e.extension.label,
        "aria-label": e.extension.label
      }, {
        default: S(() => [
          H(U(l.value), 1)
        ]),
        _: 1
      }, 8, ["size", "color", "title", "aria-label"])) : "kind" in e.extension && e.extension.kind === "button" && (!e.context.compact || e.extension.compact === "icon" && e.extension.icon) ? (h(), R(f(we), {
        key: 1,
        size: "1",
        variant: "blank",
        icon: e.extension.icon,
        square: e.context.compact,
        "aria-label": e.extension.label,
        title: e.extension.label,
        disabled: e.extension.disabled?.(e.context),
        onClick: a[0] || (a[0] = tt((r) => e.extension.handler(e.context), ["stop"]))
      }, {
        default: S(() => [
          H(U(e.context.compact ? void 0 : e.extension.label), 1)
        ]),
        _: 1
      }, 8, ["icon", "square", "aria-label", "title", "disabled"])) : n.value ? (h(), R(lt(n.value.component), Ge(Ve({ key: 2 }, n.value.props?.(e.context))), null, 16)) : B("", !0)
    ], 64)) : B("", !0);
  }
}), Ip = ["data-theme"], Rp = /* @__PURE__ */ ue({
  __name: "SmartNavigationItem",
  props: {
    item: {},
    navigation: {},
    compact: { type: Boolean },
    matchNestedRoutes: { type: Boolean },
    activeColor: {},
    depth: { default: 0 }
  },
  setup(e) {
    const t = e, n = b(() => t.item.children?.filter((p) => p.visible?.() !== !1) ?? []), l = b(() => n.value.length > 0), o = b(
      () => (t.item.extensions ?? []).filter((p) => p.visible?.({ item: t.item, compact: t.compact }) === !1 ? !1 : t.compact ? "component" in p ? !!p.compact : p.kind === "badge" ? p.compact !== "hidden" : p.compact === "icon" && !!p.icon : !0)
    ), a = b(() => t.item.collapsedMode ?? "parent"), r = b(() => t.compact && a.value === "children" && l.value), s = b(() => t.depth > 0 && !l.value && t.item.labelPresentation === "chip"), i = b(() => s.value ? Vi : t.depth > 0 && !l.value ? xi : La), c = b(() => s.value ? { icon: t.item.icon, color: t.activeColor } : {}), u = b(() => {
      if (!t.compact)
        return t.item.label;
      const p = Array.from(t.item.label.trim());
      return t.item.compactPresentation === "initial" ? p.slice(0, 1).join("") : t.item.compactPresentation === "text" ? p.slice(0, 2).join("") : t.item.label;
    }), d = (p) => {
      let g = p.length;
      for (; g > 0 && p[g - 1] === "/"; )
        g -= 1;
      return p.slice(0, g);
    }, v = b(() => {
      const p = t.navigation.activeKey.value;
      if (p === t.item.key)
        return !0;
      const g = t.item.href === void 0 ? void 0 : d(t.item.href);
      return !!(t.matchNestedRoutes && g && p?.startsWith(`${g}/`));
    }), m = async () => {
      t.item.disabled || (t.navigation.select(t.item.key), await t.item.handler?.());
    };
    return (p, g) => {
      const y = Ps("SmartNavigationItem", !0);
      return e.item.visible?.() !== !1 ? (h(), $(se, { key: 0 }, [
        r.value ? (h(!0), $(se, { key: 0 }, Pe(n.value, (P) => (h(), R(y, {
          key: P.key,
          item: P,
          navigation: e.navigation,
          compact: e.compact,
          depth: e.item.childrenPresentation === "flat" ? 0 : e.depth + 1,
          "match-nested-routes": e.matchNestedRoutes,
          "active-color": e.activeColor
        }, null, 8, ["item", "navigation", "compact", "depth", "match-nested-routes", "active-color"]))), 128)) : (h(), $("div", {
          key: 1,
          class: "smart-navigation-item",
          "data-theme": v.value ? e.activeColor : void 0
        }, [
          V(f(Jn), {
            text: e.item.label,
            placement: "right",
            disabled: !e.compact
          }, {
            default: S(() => [
              (h(), R(lt(i.value), Ve(c.value, {
                link: e.item.href,
                "aria-label": e.compact ? e.item.label : void 0,
                active: v.value,
                disabled: e.item.disabled,
                variant: e.item.variant,
                "compact-icon": e.item.icon,
                "compact-presentation": e.item.compactPresentation,
                dense: e.item.dense,
                "is-open": e.navigation.expandedKeys.value.has(e.item.key),
                role: !e.item.href && !l.value ? "button" : void 0,
                tabindex: !e.item.href && !l.value && !e.item.disabled ? 0 : void 0,
                onClick: m,
                onToggle: g[0] || (g[0] = (P) => e.navigation.setGroupExpanded(e.item.key, P)),
                onKeydown: [
                  En(tt(m, ["self"]), ["enter"]),
                  En(tt(m, ["prevent", "self"]), ["space"])
                ]
              }), St({
                default: S(() => [
                  e.item.icon && (e.depth === 0 || l.value || !e.compact) && !s.value ? (h(), R(f(Ki), {
                    key: 0,
                    icon: e.item.icon
                  }, null, 8, ["icon"])) : B("", !0),
                  V(f(Fa), null, {
                    default: S(() => [
                      e.item.loading ? (h(), R(f(zi), {
                        key: 0,
                        width: "90px"
                      })) : (h(), $(se, { key: 1 }, [
                        H(U(u.value), 1)
                      ], 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                o.value.length ? {
                  name: "actions",
                  fn: S(() => [
                    (h(!0), $(se, null, Pe(o.value, (P) => (h(), $("span", {
                      key: P.key,
                      class: Ke({ "hp-side-menu__action": P.hoverOnly && !e.compact })
                    }, [
                      V(Cp, {
                        extension: P,
                        context: { item: e.item, compact: e.compact }
                      }, null, 8, ["extension", "context"])
                    ], 2))), 128))
                  ]),
                  key: "0"
                } : void 0,
                !e.compact && l.value ? {
                  name: "children",
                  fn: S(() => [
                    (h(!0), $(se, null, Pe(n.value, (P) => (h(), R(y, {
                      key: P.key,
                      item: P,
                      navigation: e.navigation,
                      compact: e.compact,
                      depth: e.item.childrenPresentation === "flat" ? 0 : e.depth + 1,
                      "match-nested-routes": e.matchNestedRoutes,
                      "active-color": e.activeColor
                    }, null, 8, ["item", "navigation", "compact", "depth", "match-nested-routes", "active-color"]))), 128))
                  ]),
                  key: "1"
                } : void 0
              ]), 1040, ["link", "aria-label", "active", "disabled", "variant", "compact-icon", "compact-presentation", "dense", "is-open", "role", "tabindex", "onKeydown"]))
            ]),
            _: 1
          }, 8, ["text", "disabled"])
        ], 8, Ip)),
        e.compact && l.value && a.value === "parent-and-children" ? (h(!0), $(se, { key: 2 }, Pe(n.value, (P) => (h(), R(y, {
          key: P.key,
          item: P,
          navigation: e.navigation,
          compact: e.compact,
          depth: e.item.childrenPresentation === "flat" ? 0 : e.depth + 1,
          "match-nested-routes": e.matchNestedRoutes,
          "active-color": e.activeColor
        }, null, 8, ["item", "navigation", "compact", "depth", "match-nested-routes", "active-color"]))), 128)) : B("", !0)
      ], 64)) : B("", !0);
    };
  }
}), Pp = ["inert", "aria-busy"], Tp = /* @__PURE__ */ ue({
  __name: "SmartNavigationContent",
  props: {
    navigation: {},
    items: {},
    disabled: { type: Boolean },
    matchNestedRoutes: { type: Boolean },
    activeColor: {},
    compact: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (h(), $("div", {
      inert: e.disabled || void 0,
      "aria-busy": e.disabled
    }, [
      (h(!0), $(se, null, Pe(e.items, (l) => (h(), $(se, {
        key: l.key
      }, [
        l.label || l.divider ? (h(), R(f(Oi), { key: 0 })) : B("", !0),
        l.label ? (h(), $("div", {
          key: 1,
          class: "smart-navigation-section",
          style: et({ visibility: e.compact ? "hidden" : "visible" })
        }, U(l.label), 5)) : B("", !0),
        (h(!0), $(se, null, Pe(l.items, (o) => (h(), R(Rp, {
          key: o.key,
          item: o,
          navigation: e.navigation,
          compact: e.compact,
          "match-nested-routes": e.matchNestedRoutes,
          "active-color": e.activeColor
        }, null, 8, ["item", "navigation", "compact", "match-nested-routes", "active-color"]))), 128))
      ], 64))), 128))
    ], 8, Pp));
  }
}), Ep = /* @__PURE__ */ Ae(Tp, [["__scopeId", "data-v-a3cc9ea0"]]), Iw = /* @__PURE__ */ ue({
  __name: "SmartNavigation",
  props: {
    bordered: { type: [Boolean, String], default: void 0 },
    activeColor: {},
    matchNestedRoutes: { type: Boolean },
    navigation: {},
    disabled: { type: Boolean },
    items: {},
    size: {},
    width: {},
    label: {},
    showToggle: { type: Boolean, default: void 0 },
    showMobileClose: { type: Boolean, default: void 0 },
    closeDelay: {},
    controlsPlacement: {},
    dockFrom: {}
  },
  setup(e) {
    return (t, n) => (h(), R(f(Ai), {
      size: e.size,
      width: e.width,
      bordered: e.bordered,
      label: e.label,
      "show-toggle": e.showToggle,
      "show-mobile-close": e.showMobileClose,
      "close-delay": e.closeDelay,
      "controls-placement": e.controlsPlacement,
      "dock-from": e.dockFrom,
      open: e.navigation.open.value,
      "onUpdate:open": n[0] || (n[0] = (l) => e.navigation.open.value = l),
      pinned: e.navigation.pinned.value,
      "onUpdate:pinned": n[1] || (n[1] = (l) => e.navigation.pinned.value = l),
      hovered: e.navigation.hovered.value,
      "onUpdate:hovered": n[2] || (n[2] = (l) => e.navigation.hovered.value = l)
    }, St({
      default: S(({ expanded: l }) => [
        pe(t.$slots, "before-items", {
          expanded: l,
          compact: !l,
          navigation: e.navigation
        }),
        V(Ep, {
          items: e.items,
          navigation: e.navigation,
          disabled: e.disabled,
          compact: !l,
          "match-nested-routes": e.matchNestedRoutes,
          "active-color": e.activeColor
        }, null, 8, ["items", "navigation", "disabled", "compact", "match-nested-routes", "active-color"]),
        pe(t.$slots, "after-items", {
          expanded: l,
          compact: !l,
          navigation: e.navigation
        })
      ]),
      _: 2
    }, [
      t.$slots.footer ? {
        name: "footer",
        fn: S(({ expanded: l }) => [
          pe(t.$slots, "footer", {
            expanded: l,
            compact: !l,
            navigation: e.navigation
          })
        ]),
        key: "0"
      } : void 0,
      t.$slots.secondary ? {
        name: "secondary",
        fn: S(({ expanded: l }) => [
          pe(t.$slots, "secondary", {
            expanded: l,
            compact: !l,
            navigation: e.navigation
          })
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["size", "width", "bordered", "label", "show-toggle", "show-mobile-close", "close-delay", "controls-placement", "dock-from", "open", "pinned", "hovered"]));
  }
}), Rw = (e = {}) => {
  const t = Y(e.defaultOpen ?? !1), n = e.pinned ?? Y(e.defaultPinned ?? !1), l = Y(!1), o = Y(), a = b(() => e.activeKey === void 0 ? o.value : _(e.activeKey)), r = Y(new Set(e.defaultExpandedKeys)), s = (u) => {
    o.value = u;
  }, i = (u, d) => {
    const v = new Set(r.value);
    d ? v.add(u) : v.delete(u), r.value = v;
  };
  return { open: t, pinned: n, hovered: l, activeKey: a, expandedKeys: r, select: s, toggleGroup: (u) => i(u, !r.value.has(u)), setGroupExpanded: i };
};
export {
  gd as CheckboxControl,
  Tf as CompositeControl,
  yt as ControlInputGroup,
  hw as DEFAULT_SMART_RESOLUTION_STRATEGY,
  yd as DateControl,
  gw as MANUAL_SMART_RESOLUTION_STRATEGY_OPTION,
  Sd as NumberControl,
  Bg as PARENT_PRIORITY_SMART_RESOLUTION_STRATEGY,
  Qm as PERCENT_INPUT_MAX,
  Ym as PERCENT_INPUT_MIN,
  Pr as PERCENT_INPUT_PRECISION,
  No as SELECTED_CHIP_LABEL_SEPARATOR,
  Rl as SMART_CHART_COLOR_INDEXES,
  Lr as SMART_RESOLUTION_COLUMN_RELATION_MODULE_ID,
  Wr as SMART_RESOLUTION_KEEP_CURRENT_MODULE_ID,
  Zr as SMART_RESOLUTION_MANUAL_MODULE_ID,
  Qb as SMART_RESOLUTION_NUMBER_FLAT_TOTAL_MODULE_ID,
  ls as SMART_RESOLUTION_NUMBER_TREE_MODULE_ID,
  bw as SMART_RESOLUTION_STRATEGY_OPTIONS,
  mg as SMART_RESOLUTION_VALUE_SCHEMA_MODULE_ID,
  Rd as SelectControl,
  nf as SelectedChipLabel,
  jo as SmartBadgeListCell,
  Uo as SmartButtonsCell,
  Fp as SmartChart,
  Lt as SmartControl,
  jp as SmartControlField,
  Pl as SmartFilter,
  Up as SmartFilterBar,
  Sw as SmartFilterPanel,
  Wl as SmartForm,
  qf as SmartFormDialogBody,
  Wf as SmartFormField,
  Ho as SmartLinkCell,
  Iw as SmartNavigation,
  Ep as SmartNavigationContent,
  Dg as SmartResolutionCellPopover,
  xg as SmartResolutionColumnRelationPopoverContent,
  is as SmartResolutionOptions,
  mw as SmartResolutionPopover,
  Fg as SmartResolutionPopoverContent,
  cs as SmartResolutionPreviewTable,
  Ag as SmartResolutionValueFooter,
  Hp as SmartSelectionDrawer,
  Nm as SmartTable,
  Km as SmartTableCell,
  pm as SmartTableRowEditDialog,
  kr as SmartTableRowEditForm,
  nw as SmartTableRowEditor,
  Wo as SmartTextIconCell,
  Zo as SmartThumbnailCell,
  Pd as SwitchControl,
  Td as TagsControl,
  Ed as TextControl,
  Cf as TreeControl,
  vn as applySmartResolutionPatches,
  Wm as autofyTree,
  Gf as buildBulkFormDialogFn,
  Qf as buildSmartFormDialogFn,
  $r as buildSmartResolutionColumnRelationIssues,
  Sr as buildTree,
  uw as columnRelationResolutionModule,
  qt as composite,
  ql as computeCalculatorConstraints,
  $p as createSmartChart,
  Dp as createSmartChartKeyEvents,
  Hl as createSmartForm,
  ep as createSmartResolutionCalculatorValidation,
  pw as createSmartResolutionRuleRegistry,
  ms as createSmartResolutionStrategyRegistry,
  $y as createSmartResolutionTreeMathRules,
  ww as createSmartResolutionTreeProjectionValidator,
  Xy as createSmartResolutionValueSchemas,
  Yp as createSmartSchedule,
  iw as customTopology,
  Zp as defineDiscriminatedForm,
  Lp as defineSmartChart,
  Np as defineSmartChartKeyEvents,
  Xp as defineSmartColumns,
  qp as defineSmartFields,
  Bp as defineSmartFilterFacets,
  Cw as defineSmartNavigation,
  sw as defineSmartResolution,
  Gt as defineSmartResolutionModule,
  yw as defineSmartResolutionRules,
  Qp as defineSmartSchedule,
  Xo as dispatchEdit,
  aw as distributeEqual,
  Ne as field,
  Gh as flatTopology,
  Jp as getFormErrors,
  jr as getSmartResolutionColumnRelationRules,
  cw as hasSmartResolutionPercentModeScope,
  ar as isSmartChartColorIndex,
  Sb as keepCurrentValueResolutionModule,
  Rb as manualResolutionModule,
  qm as nullifyTree,
  dw as numberFlatTotalResolutionModule,
  fw as numberTreeResolutionModule,
  ph as recomputeNumberTree,
  kh as recomputeValueTree,
  fr as resolveCardClass,
  Er as resolveEditAbsolute,
  Rr as resolveParentCapacity,
  ow as resolvePercentInputRatio,
  Zm as runNullCascade,
  xr as runNumberCascade,
  wh as runValueCascade,
  gt as select,
  re as toCellKey,
  ge as toColumnId,
  lw as toPercentInputValue,
  ce as toRowId,
  re as toSmartCalcCellKey,
  Jh as treeTopology,
  Gp as useBulkFormDialog,
  Li as useFormFieldController,
  ew as useServerData,
  Nh as useSmartCalculator,
  jf as useSmartFilter,
  Wp as useSmartFilterField,
  _p as useSmartFormDialog,
  Rw as useSmartNavigation,
  pb as useSmartResolutionDialog,
  yy as useSmartResolutionPopover,
  kw as useSmartResolutionTable,
  vm as useSmartTable,
  rw as useSmartTableCalculator,
  tw as useSmartTableQueryBinding,
  or as useStandaloneFieldController,
  vw as valueSchemaResolutionModule
};
//# sourceMappingURL=hp-ui-smart-controls.es.js.map
